/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export interface ResponseDtoObject {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: object;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The destination geo-coordinates of the legal entity */
export interface GeoCoordinates {
  longitude?: number;
  latitude?: number;
}

/** The list of addresses associated with the legal entity */
export interface LegalEntityAddressDto {
  /**
   * id of the legal entity address
   * @format int64
   */
  id?: number;
  /**
   * id of the legal entity
   * @format int64
   */
  legalEntityId?: number;
  /** The address of the legal entity */
  address?: string;
  /** The city of the legal entity */
  city?: string;
  /** The state of the legal entity */
  state?: string;
  /** The zipcode of the legal entity */
  zipcode?: string;
  /** The country of the legal entity */
  country?: string;
  /** The email of the legal entity */
  email?: string;
  /** The fax number of the legal entity */
  fax?: string;
  /** The phone number of the legal entity */
  phone?: string;
  /** The location name of the legal entity */
  locationName?: string;
  /** The type of address */
  type: 'PICK_UP' | 'DELIVERY' | 'LEGAL' | 'BILLING' | 'OFFICE' | 'HEAD_OFFICE';
  /** Indicates if the address is active */
  active: boolean;
  /** The destination geo-coordinates of the legal entity */
  origin?: GeoCoordinates;
  /** The destination geo-coordinates of the legal entity */
  destination?: GeoCoordinates;
}

/**
 * Represents a legal entity that participates in shipping transactions or contractual relationships.
 *
 * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
 * or external to the organization:
 *
 * Internal Legal Entities:
 * - The organization itself or its subsidiaries
 * - Parent or child entities within the corporate structure
 * - Entities that sign contracts with service providers
 * - Billing entities responsible for transportation costs
 *
 * External Legal Entities:
 * - Business partners and clients
 * - Third-party shippers sending goods
 * - Consignees receiving shipments
 * - Any other external party involved in the supply chain
 *
 * The same legal entity can play different roles in different transactions (e.g., sometimes
 * as a shipper, other times as a consignee, or as the contracting party with service providers).
 */
export interface LegalEntityDto {
  /**
   * Unique identifier for the legal entity
   * @format int64
   */
  id?: number;
  /** Full legal name of the entity */
  name: string;
  /** Short internal name, code or acronym as unique identifier for the legal entity, used for concise display and quick reference */
  code: string;
  /** Indicates if the legal entity is active */
  active?: boolean;
  /** National currency of the legal entity (e.g., SGD, USD) */
  nationalCurrency?: string;
  /**
   * Identifier for the parent legal entity
   * @format int64
   */
  parentId?: number;
  /** Indicates if the legal entity is a billed entity */
  isBilledEntity?: boolean;
  /** The list of addresses associated with the legal entity */
  addresses?: LegalEntityAddressDto[];
  /** List of name aliases for the legal entity */
  nameAliases?: LegalEntityNameAliasDto[];
  /** List of sub-entities under the legal entity */
  subEntities?: LegalEntityDto[];
}

/** Legal entity alias Data Transfer Object. Represents alternative names or identifiers for a legal entity. Aliases are used to handle variations in how legal entity names appear on invoices and documents, allowing multiple name variations to be mapped to one official legal entity. */
export interface LegalEntityNameAliasDto {
  /**
   * Unique identifier for the legal entity alias record
   * @format int64
   * @example 1001
   */
  id?: number;
  /**
   * The alternative name or identifier value for the legal entity. For NAME type: contains alternative spellings, abbreviations, or variations of the legal entity name as they appear on invoices. For ACCOUNT_NUMBER type: contains account numbers, customer codes, or other numerical identifiers associated with this legal entity.
   * @example "Tetrixx SG Pte Ltd"
   */
  name?: string;
  /**
   * Type of alias that determines how the 'name' field should be interpreted. NAME: Used for alternative names, abbreviations, or spelling variations of the legal entity (e.g., 'Tetrixx Singapore' vs 'Tetrixx SG Pte Ltd'). ACCOUNT_NUMBER: Used for storing account numbers, customer codes, or numerical identifiers associated with this legal entity (e.g., '12345678', 'CUST-001').
   * @example "NAME"
   */
  type?: 'ACCOUNT_NUMBER' | 'NAME' | 'CITY';
}

/** Representing a user in the system. */
export interface UserDto {
  /**
   * Unique identifier of the user.
   * @format uuid
   */
  id?: string;
  /** First name of the user. */
  firstName?: string;
  /** Middle name of the user. */
  middleName?: string;
  /** Last name of the user. */
  lastName?: string;
  /** Email address of the user. */
  email?: string;
  /** Cognito ID associated with the user. */
  cognitoId?: string;
  /** Indicates whether the user is active. */
  active?: boolean;
  /**
   * Set of roles assigned to the user.
   * @uniqueItems true
   */
  roles?: (
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'FINANCE'
    | 'SUPPLY_CHAIN'
    | 'MANAGEMENT'
    | 'ADMIN'
    | 'SYSTEM_ADMIN'
    | 'RATE_CARD_VIEWER'
    | 'CREDIT_VIEWER'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2'
  )[];
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  legalEntity?: LegalEntityDto;
  /** List of permissions assigned to the user. */
  userPermissionList?: UserPermissionDto[];
  /**
   * Timestamp when the user was created.
   * @format date-time
   */
  createdOn?: string;
  /**
   * Timestamp when the user was last updated.
   * @format date-time
   */
  updatedOn?: string;
}

/** User permission Data Transfer Object DTO. */
export interface UserPermissionDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /**
   * User Unique identifier.
   * @format uuid
   */
  userId?: string;
  /** Legal Entity Unique code. */
  billedEntityCode?: string;
  /** Shipper Unique code. */
  shipperCode?: string;
  /** Consignee Unique code. */
  consigneeCode?: string;
  /** Service Provider Unique code. */
  serviceProviderCode?: string;
  /**
   * Shipping Service Unique identifier.
   * @format uuid
   */
  shippingServiceId?: string;
  /**
   * Permissions.
   * @uniqueItems true
   */
  permissions?: (
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'SUPPLY_CHAIN'
    | 'DISPUTE'
    | 'FINANCE'
    | 'AUDIT'
    | 'REPORT'
    | 'PERFORMANCE'
    | 'RATECARD'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2'
  )[];
  /** Allowed. */
  allowed?: boolean;
  /** Email of the setting user. */
  email?: string;
}

export interface ResponseDtoUserDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Representing a user in the system. */
  data?: UserDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoUserPermissionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** User permission Data Transfer Object DTO. */
  data?: UserPermissionDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface UnlocodeMappingDto {
  /**
   * The unique identifier of the unlocode mapping
   * @format int64
   */
  id?: number;
  /** The UN/LOCODE (United Nations Code for Trade and Transport Locations) */
  unlocode?: string;
  /** The port name associated with the unlocode */
  portName?: string;
}

export interface ResponseDtoUnlocodeMappingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: UnlocodeMappingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface SystemConfigurationDto {
  /** The type of the system configuration */
  type?: string;
  /** The value of the system configuration */
  value?: string;
  /** The billed entity associated with the configuration, if applicable */
  billedEntity?: string;
}

export interface ResponseDtoVoid {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: object;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Replace all user assignments for a SIC code */
export interface BulkReplaceSicCodeAssignmentRequest {
  /** SIC code to replace assignments for */
  sicCode: string;
  /** List of user emails to assign. Empty list removes all assignments for this SIC code. */
  userEmails: string[];
}

export interface ResponseDtoListSicCodeManagerAssignmentDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: SicCodeManagerAssignmentDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** SIC code to user assignment */
export interface SicCodeManagerAssignmentDto {
  /**
   * Assignment ID
   * @format uuid
   */
  id?: string;
  /** SIC code */
  sicCode?: string;
  /** Assigned user's email */
  userEmail?: string;
  /**
   * When the assignment was created
   * @format date-time
   */
  createdOn?: string;
  /** Who created the assignment */
  createdBy?: string;
}

export interface CreatingAndUpdatingShippingServiceReq {
  code?: string;
  /** @format int64 */
  serviceProviderId: number;
  shipperCode?: string;
  consigneeCode?: string;
  /** @format int64 */
  billingPartyId?: number;
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  dominantModality: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  route: string;
  service?: string;
  type?: string;
  carrier?: string;
  totalLeadTime?: number;
}

export interface ResponseDtoShippingServiceDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents a transportation service offered by a service provider with specific parameters and pricing.
   *
   * A shipping service defines a transportation offering with a specific set of characteristics that
   * determines the applicable charges and rates. It serves as a mapping mechanism to match shipments
   * with their corresponding service level and associated costs for transportation.
   *
   * Key Concepts:
   * - Each service is linked to specific charges and rates in the system
   * - Used to map shipments to services to determine transportation costs
   * - Optional fields act as wildcards - empty values match any shipment value
   * - Provides granular control over service categorization and pricing
   *
   * Route Architecture:
   * The route field uses a Union type to support two different routing models:
   *
   * 1. Route (Point-to-Point): Specific origin-destination pairs using UN/LOCODE identifiers
   *    - Used when pricing/service is specific to exact location combinations
   *    - Provides precise geographic control over service definitions
   *    - Example: USNYC (New York) to DEHAM (Hamburg)
   *
   * 2. ZoneRoute (Zone-Based): Geographic zones covering multiple location pairs
   *    - Used when same pricing applies to multiple origin-destination combinations
   *    - Simplifies rate management for regional or area-based services
   *    - Example: "EU-WEST" zone covering multiple European city combinations
   *
   * Carrier vs Service Provider:
   * - Service Provider: The entity with whom the contract is signed
   * - Carrier: The actual transportation company handling the international freight leg
   *           (e.g., airline for air, shipping line for sea, trucking company for road)
   */
  data?: ShippingServiceDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/**
 * Represents a transportation service offered by a service provider with specific parameters and pricing.
 *
 * A shipping service defines a transportation offering with a specific set of characteristics that
 * determines the applicable charges and rates. It serves as a mapping mechanism to match shipments
 * with their corresponding service level and associated costs for transportation.
 *
 * Key Concepts:
 * - Each service is linked to specific charges and rates in the system
 * - Used to map shipments to services to determine transportation costs
 * - Optional fields act as wildcards - empty values match any shipment value
 * - Provides granular control over service categorization and pricing
 *
 * Route Architecture:
 * The route field uses a Union type to support two different routing models:
 *
 * 1. Route (Point-to-Point): Specific origin-destination pairs using UN/LOCODE identifiers
 *    - Used when pricing/service is specific to exact location combinations
 *    - Provides precise geographic control over service definitions
 *    - Example: USNYC (New York) to DEHAM (Hamburg)
 *
 * 2. ZoneRoute (Zone-Based): Geographic zones covering multiple location pairs
 *    - Used when same pricing applies to multiple origin-destination combinations
 *    - Simplifies rate management for regional or area-based services
 *    - Example: "EU-WEST" zone covering multiple European city combinations
 *
 * Carrier vs Service Provider:
 * - Service Provider: The entity with whom the contract is signed
 * - Carrier: The actual transportation company handling the international freight leg
 *           (e.g., airline for air, shipping line for sea, trucking company for road)
 */
export interface ShippingServiceDto {
  /**
   * Unique identifier for the shipping service
   * @format uuid
   */
  id?: string;
  /** Unique internal identifier for the shipping service (integer, letters, or mixed) */
  code?: string;
  /**
   * Identifier of the associated service provider
   * @format int64
   */
  serviceProviderId?: number;
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  shipperInfo?: LegalEntityDto;
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  consigneeInfo?: LegalEntityDto;
  /**
   * Identifier for the billing party associated with this shipping service
   * @format int64
   */
  billingPartyId?: number;
  /** Trade terms for this service (None = matches any incoterm) */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  /** Indicates whether the shipping service is active */
  active?: boolean;
  /** The dominant modality (e.g., SEA, AIR) for this shipping service */
  dominantModality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Identifier for the data pipeline configuration */
  dataPipelineConfigId?: string;
  /** List of zones associated with the shipping service */
  listZone?: ZoneDto[];
  /** Service route definition: either point-to-point (Route with UN/LOCODE pairs) or zone-based coverage (ZoneRoute with geographic zone identifier) */
  route?: string;
  /** Main service category (None = matches any services) */
  service?: string;
  /** The type of the shipping service */
  type?: string;
  /** Transportation company handling the international freight leg (None = matches any carrier)(airline, shipping line, trucking company, or courier service) */
  carrier?: string;
  /** Expected transit time for this service in days */
  totalLeadTime?: number;
  /** The timestamp when this shipping service was created */
  createdOn?: string;
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  billingPartyInfo?: LegalEntityDto;
}

/** Zone Data Transfer Object DTO. */
export interface ZoneDto {
  /** Pol. */
  pol: string;
  /** Pod. */
  pod: string;
}

export interface ResponseDtoString {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: string;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface Container {
  /** @format int32 */
  size: number;
  /** @format int32 */
  quantity: number;
  type?: 'STANDARD' | 'HIGH_CUBE' | 'OPEN_TOP' | 'FLAT_RACK';
}

export interface RawShipmentDto {
  /**
   * Unique identifier for the shipment.
   * @format uuid
   */
  id?: string;
  /**
   * id of the contract associated with the shipment.
   * @format uuid
   */
  contractId?: string;
  /**
   * id of the shipping service associated with the shipment.
   * @format uuid
   */
  shippingServiceId?: string;
  /** Shipment number from extracted data. */
  shipmentNumber?: string;
  /** Total CO2 emission in grams. */
  totalCo2EmissionInGram?: number;
  /** Indicates if CO2 was calculated with the default option. */
  co2CalculatedWithDefaultOption?: boolean;
  /** Reason for CO2 calculation failure. */
  co2CalculationFailureReason?: string;
  /** Container details of the shipment. */
  shipmentContainer?: ShipmentContainer;
  /** Transportation reference number. Ex: Flight Number, Vessel Name, Truck Plaque */
  transportationReferenceNumber?: string;
  /** Carrier of the shipment. Ex: Airline Name, Shipping Line Name, Trucking Company Name */
  carrier?: string;
  /**
   * Number of packages in the shipment. Number of Packages whatever the type
   * @format int32
   */
  numberOfPackages?: number;
  /** Description of the number of packages per type. Ex: 10 pallets, 20 cartons */
  numberOfPackagesDescription?: string;
  /** Commodity of the shipment or goods description of the shipment */
  commodity?: string;
  /** Modality of the shipment. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Gross weight of the shipment in kilograms. */
  grossWeightInKg?: number;
  /** Gross weight of the shipment. */
  grossWeight?: string;
  /** Chargeable weight of the shipment in kilograms. */
  chargeableWeightInKg?: number;
  /** Chargeable weight of the shipment. */
  chargeableWeight?: string;
  /** Net weight of the shipment in kilograms. */
  netWeightInKg?: number;
  /** Net weight of the shipment. */
  netWeight?: string;
  /** Volume of the shipment in cubic meters. */
  volumeInCbm?: number;
  /**
   * Estimated departure date of the shipment.
   * @format date
   */
  estimatedDepartureDate?: string;
  /**
   * Estimated arrival date of the shipment.
   * @format date
   */
  estimatedArrivalDate?: string;
  /** Master bill of lading for the shipment. */
  masterBillOfLading?: string;
  /** House bill of lading for the shipment. */
  houseBillOfLading?: string;
  /** List of container numbers for the shipment. */
  containerNumbers?: string[];
  /** Place of loading for the shipment. */
  placeOfLoading?: string;
  /** Place of discharge for the shipment. */
  placeOfDischarge?: string;
  /** Service type of the shipment. */
  serviceType?: string;
  /** Special type of the shipment. */
  specialType?: string;
  /**
   * ID of the service provider.
   * @format int64
   */
  serviceProviderId?: number;
  /**
   * ID of the billing party.
   * @format int64
   */
  billingPartyId?: number;
  /**
   * ID of the shipper.
   * @format int64
   */
  shipperId?: number;
  /**
   * ID of the consignee.
   * @format int64
   */
  consigneeId?: number;
  /** Internal tracking number for the shipment. */
  internalTrackingNumber?: string;
  /**
   * Creation timestamp of the shipment.
   * @format date-time
   */
  createdOn?: string;
  /** Creator of the shipment. */
  createdBy?: string;
  /**
   * Last modification timestamp of the shipment.
   * @format date-time
   */
  updatedOn?: string;
  /** Last modifier of the shipment. */
  updatedBy?: string;
}

/** Container details of the shipment. */
export interface ShipmentContainer {
  /** @uniqueItems true */
  containerNumbers?: string[];
  /** @uniqueItems true */
  containers?: Container[];
}

export interface ResponseDtoRawShipmentDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: RawShipmentDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Deviation Workflow action body Data Transfer Object DTO. */
export interface DeviationWorkflowActionBodyDto {
  /** Reason to perform the action. */
  reason?: string;
  /** List of charges for Spot shipment. */
  spotShipmentCharges?: SpotShipmentChargeDto[];
  /**
   * Attachment ID of the support document.
   * @format uuid
   */
  supportDocumentId?: string;
  /** Reason category for rejection actions. */
  rejectReason?: 'WRONG_DOCUMENT' | 'WRONG_AMOUNT' | 'OTHER';
}

/** Spot Shipment Charge Data Transfer Object DTO. */
export interface SpotShipmentChargeDto {
  /**
   * The ID of the spot shipment charge to be updated
   * @format uuid
   */
  id?: string;
  /** The category of the spot shipment charge */
  chargeCategory?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** The leg type of the spot shipment charge */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** Indicates whether the spot shipment charge is accepted or not */
  accepted?: boolean;
}

export interface AffectedInvoiceInfo {
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Invoice Number. */
  invoiceNumber?: string;
  /** Invoice Status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Current deviation Workflow. */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Final resolution. */
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
}

/** Affected Shipment and Invoice. */
export interface AffectedShipmentAndInvoice {
  affectedInvoices?: AffectedInvoiceInfo[];
  resolvedShipmentInvoices?: AffectedShipmentInfo[];
  flaggedShipmentInvoices?: AffectedShipmentInfo[];
}

export interface AffectedShipmentInfo {
  /**
   * Shipment Invoice Unique identifier.
   * @format uuid
   */
  shipmentInvoiceId?: string;
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Shipment Number. */
  shipmentNumber?: string;
  /** Status. */
  status?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /** Current deviation Workflow. */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Integer. */
  deviationTypeCountMap?: Record<string, number>;
  /** Invoice Number. */
  invoiceNumber?: string;
  /** Final resolution. */
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
}

/** Amount DTO. */
export interface Amount {
  /** Before tax. */
  beforeTax?: number;
  /** After tax. */
  afterTax?: number;
  /** Currency. */
  currency?: string;
}

/** Background Shipment perform result Data Transfer Object DTO. */
export interface BackgroundShipmentPerformResultDto {
  /** Type of Background Shipment Perform Result. */
  type?: 'RECALCULATION' | 'SEND_TO_ROLE';
  /** Affected Shipment and Invoice. */
  affectedShipmentAndInvoice?: AffectedShipmentAndInvoice;
}

/** The list of invoice charges. */
export interface ChargeDto {
  /**
   * The unique identifier of the charge.
   * @format uuid
   */
  id?: string;
  /** The name of the charge. */
  chargeName?: string;
  /** The quantity associated with the charge. */
  quantity?: number;
  /** the amount before tax in the original currency. */
  amountBeforeTaxInOriginalCurrency?: number;
  /** the amount after tax in the original currency. */
  amountAfterTaxInOriginalCurrency?: number;
  /** The original currency of the charge. */
  originalCurrency?: string;
  /** The exchange rate applied to convert the original currency to the total amount currency. */
  exchangeRate?: number;
  /** The total amount of the charge. */
  totalAmount?: number;
  /** The currency of the total amount. */
  totalAmountCurrency?: string;
  /** The type of leg associated with the charge. */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** The domain of the charge. */
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Sub-domain of the charge. */
  chargeSubDomain?: string;
  /** Indicates if the charge is accessorial. */
  accessorial?: boolean;
  /** Indicates if the charge requires approval. */
  approval?: boolean;
  /** Indicates if the charge is an outlay. */
  outlay?: boolean;
  /** Discount amount for the charge in the original currency of the invoice. */
  discountAmount?: number;
  /** The shipment number associated with the charge. */
  shipmentNumber?: string;
  /** The status of the charge. */
  status?: string;
  /** The reason for the charge status. */
  statusReason?: string;
  /** Whether the charge was excluded from deviation calculation based on contract charge configuration. */
  deviationExcluded?: boolean;
}

/**
 * Represents charges based on container usage with size-specific pricing.
 *
 * This class handles container-based pricing structures commonly used in ocean
 * freight and intermodal transportation. Charges vary by container type and size,
 * reflecting the different operational costs and capacity utilization.
 *
 * The dual pricing structure (20ft vs 40ft) accommodates the standard container
 * sizes used in international shipping, allowing for accurate cost calculation
 * based on actual container utilization.
 */
export type ContainerChargeDto = UtilRequiredKeys<ContractChargeDto, 'chargeName' | 'chargeCategory' | 'legType' | 'accessorial' | 'approval' | 'outlay'> & {
  /** The unit price for 20-foot containers */
  unitPrice20?: number;
  /** The unit price for 40-foot containers */
  unitPrice40?: number;
  /** Currency code for the charge (e.g., USD, EUR) */
  currency?: string;
  /** Type of container for this charge */
  containerType?: 'STANDARD' | 'HIGH_CUBE' | 'OPEN_TOP' | 'FLAT_RACK';
};

/** Base class for contract charges */
export interface ContractChargeDto {
  /**
   * Unique identifier for the contract charge
   * @format uuid
   */
  id?: string;
  /** Code representing the contract charge */
  code?: string;
  /** Type of charge unit */
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  /**
   * Sequential number for ordering charges
   * @format int32
   */
  number?: number;
  /** Name of the charge */
  chargeName: string;
  /** Domain of the charge */
  chargeCategory:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Leg type applicable for the charge */
  legType: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** Indicates if the charge is active */
  active?: boolean;
  /** Indicates if the charge is accessorial */
  accessorial: boolean;
  /** Indicates if the charge requires approval */
  approval: boolean;
  /** Indicates if the charge is an outlay */
  outlay: boolean;
  /** Indicates if deviation calculation is excluded for this charge */
  deviationExcluded?: boolean;
}

/**
 * Represents charges related to customs declarations and regulatory filings.
 *
 * These charges cover the costs associated with preparing, submitting, and
 * processing customs declarations and other regulatory documentation required
 * for international shipments.
 *
 * Examples: Customs filing fees, declaration processing charges, regulatory
 * compliance fees.
 */
export type DeclarationChargeDto = UtilRequiredKeys<ContractChargeDto, 'chargeName' | 'chargeCategory' | 'legType' | 'accessorial' | 'approval' | 'outlay'> & {
  /** Fixed price per unit for this charge */
  unitPrice: number;
  /** Currency code for the charge (e.g., USD, EUR) */
  currency: string;
};

/** The list of deviations associated with the invoice. */
export interface DeviationDto {
  /**
   * The unique identifier of the deviation.
   * @format uuid
   */
  id?: string;
  /**
   * The unique identifier of the charge associated with the deviation.
   * @format uuid
   */
  chargeId?: string;
  /** The name of the deviation. */
  name?: string;
  /** The shipment number associated with the deviation. */
  shipmentNumber?: string;
  /** The type of the deviation. */
  type?: 'UNIT_PRICE' | 'QUANTITY' | 'NEW_CHARGE' | 'DOUBLE_CHARGE' | 'APPROVAL_CHECK' | 'DISCOUNT';
  /** The subtype of the deviation. */
  subType?:
    | 'NO_MAPPING_FOUND'
    | 'CURRENCY_NOT_MATCHED'
    | 'CONTAINER_TYPE_NOT_MATCHED'
    | 'WEIGHT_RANGE_NOT_MATCHED'
    | 'DATE_RANGE_NOT_MATCHED'
    | 'TIME_RANGE_NOT_MATCHED'
    | 'SPOT_CHARGE'
    | 'NO_RATE_CARD_FOUND'
    | 'DISCOUNT_VALIDITY_MISMATCH'
    | 'DISCOUNT_NOT_CONFIGURED'
    | 'DISCOUNT_AMOUNT_MISMATCH';
  /** The status of the deviation in the workflow. */
  status?: 'UNFILLED' | 'APPROVED_UNDONE' | 'REJECTED_UNDONE' | 'REJECTED_DONE' | 'DONE';
  /** The type of leg associated with the deviation. */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** The type of leg for the charge associated with the deviation. */
  chargeLegType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** The domain of the charge associated with the deviation. */
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** The subdomain of the charge associated with the deviation. */
  chargeSubDomain?: string;
  /** The description of the charge associated with the deviation. */
  chargeDescription?: string;
  /** The currency of the leg associated with the deviation. */
  legCurrency?: string;
  /** The currency of the deviation. */
  deviationCurrency?: string;
  /** The contract charge unit associated with the deviation. */
  contractChargeUnit?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  /** The invoice charge unit associated with the deviation. */
  invoiceChargeUnit?: string;
  /** The unit price in the contract for the deviation. */
  contractUnitPrice?: number;
  /** The unit price in the invoice for the deviation. */
  invoiceUnitPrice?: number;
  /** The quantity in the invoice for the deviation. */
  invoiceQuantity?: number;
  /** The quantity of the deviation. */
  deviationQuantity?: number;
  /** The amount per unit of the deviation. */
  deviationAmountPerUnit?: number;
  /** The total amount of the deviation. */
  deviationAmount?: number;
  /** The amount of the deviation before tax. */
  deviationAmountBeforeTax?: number;
  /** The amount of the deviation after tax. */
  deviationAmountAfterTax?: number;
  /** Indicates if the deviation is accessorial. */
  accessorial?: boolean;
  /** Indicates if the deviation requires approval. */
  approval?: boolean;
  /** Indicates if the deviation is an outlay. */
  outlay?: boolean;
  /** The quantity of the charge associated with the deviation. */
  chargeQuantity?: number;
  /** The unit price of the charge associated with the deviation. */
  chargeUnitPrice?: number;
  /** The list of matching rate cards for the deviation. */
  matchingRateCards?: (ContainerChargeDto | DeclarationChargeDto | PercentageChargeDto | ShipmentChargeDto | WeightChargeDto)[];
  /** Indicates if the deviation amount is greater than the threshold. */
  isGreaterThanThreshold?: boolean;
  /** Indicates if the deviation status is assigned to the main role of the current user. */
  isStatusAssignedToCurrentUser?: boolean;
  /** Indicates if the current user is required to fill in information for the deviation. */
  isCurrentUserRequiredToFill?: boolean;
  /** Indicates if the deviation was auto-approved by the system. */
  autoApproved?: boolean;
  rejectedByOperation?: boolean;
}

/** The deviation threshold configuration. */
export interface DeviationThresholdConfigDto {
  /** Threshold value for deviation */
  threshold?: number;
  /** Currency for the threshold value */
  currency?: string;
}

/** The list of invoices associated with the leg. */
export interface InvoiceDto {
  /**
   * The unique identifier of the invoice.
   * @format uuid
   */
  id?: string;
  /** The invoice number. */
  invoiceNumber?: string;
  /** The date of the invoice. */
  invoiceDate?: string;
  /** The payment date of the invoice. */
  paymentDate?: string;
  /** The submission date of the invoice. */
  submissionDate?: string;
  /** The pickup date of the invoice. */
  pickupDate?: string;
  /** The delivery date of the invoice. */
  deliveryDate?: string;
  /** The due date of the invoice. */
  invoiceDueDate?: string;
  /** The resolution date of the invoice. */
  resolutionDate?: string;
  /** The estimated time of arrival at the port. */
  portArrivalDateEta?: string;
  /** The freight forwarder associated with the invoice. */
  freightForwarder?: string;
  /**
   * The trade lanes associated with the invoice.
   * @uniqueItems true
   */
  tradeLanes?: string[];
  /** The list of deviations associated with the invoice. */
  deviations?: DeviationDto[];
  /** The Master Bill of Lading (MBL) or House Bill of Lading (HBL) related to the invoice. */
  mblHbl?: string;
  /**
   * The set of shipment identifiers associated with the invoice.
   * @uniqueItems true
   */
  shipments?: string[];
  /**
   * The set of service identifiers associated with the invoice.
   * @uniqueItems true
   */
  services?: string[];
  /** The current status of the invoice. */
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Invoice Status overview Data Transfer Object DTO. */
  invoiceStatusOverview?: InvoiceStatusOverviewDto;
  /** The modality of the invoice. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /**
   * The total amount of the invoice.
   * @format double
   */
  totalAmount?: number;
  /** The aggregate shipment type of the invoice. */
  aggregateShipmentType?: 'IMPORT' | 'EXPORT' | 'MULTI';
  /** Indicates if the invoice has a responsible workflow. */
  hasResponsibleWorkflow?: boolean;
  /** Indicates if the invoice is under review. */
  isUnderReview?: boolean;
}

/** Invoice Status overview Data Transfer Object DTO. */
export interface InvoiceStatusOverviewDto {
  /** Overview. */
  overview?: string;
  /** Details. */
  details?: string[];
}

/** The list of leg details related to the deviation. */
export interface LegDetail {
  /** The type of the leg. */
  type?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** The transport medium used for the leg. */
  transportMedium?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** The modality of the leg. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** The currency used for payment. */
  paymentCurrency?: string;
  /** The exchange rate for the payment currency. */
  paymentCurrencyExchangeRate?: number;
  /** The currency used for the leg. */
  legCurrency?: string;
  /** The amount after tax for the leg. */
  legAmountAfterTax?: number;
  /** The payment amount after tax. */
  paymentAmountAfterTax?: number;
  /** The deviation amount after tax for the leg. */
  legDeviationAmountAfterTax?: number;
  /** The deviation amount after tax for the payment. */
  paymentDeviationAmountAfterTax?: number;
  /** The CO2 emissions for the leg. */
  co2Emission?: number;
  /** The list of invoices associated with the leg. */
  invoices?: InvoiceDto[];
}

/** Leg transport detail Data Transfer Object DTO. */
export interface LegTransportDetailDto {
  /** Start location. */
  startLocation?: string;
  /**
   * Start Date.
   * @format date
   */
  startDate?: string;
  /** Transport medium. */
  transportMedium?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Delivery location. */
  deliveryLocation?: string;
  /**
   * Delivery Date.
   * @format date
   */
  deliveryDate?: string;
  /** Route. */
  route?: string;
  /** Zones. */
  zones?: ZoneDto[];
}

/** Linked Shipment Invoice Data Transfer Object DTO. */
export interface LinkedShipmentInvoiceDto {
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Invoice Number. */
  invoiceNumber?: string;
  /**
   * Shipment Invoice Unique identifier.
   * @format uuid
   */
  shipmentInvoiceId?: string;
}

/** End time for this weight charge order */
export interface LocalTime {
  /** @format int32 */
  hour?: number;
  /** @format int32 */
  minute?: number;
  /** @format int32 */
  second?: number;
  /** @format int32 */
  nano?: number;
}

/**
 * Represents charges calculated as a percentage of other eligible charges.
 *
 * This class handles percentage-based charges that are derived from other charges
 * in the shipment. Common examples include insurance premiums, broker fees, or
 * administrative charges calculated as a percentage of freight costs.
 *
 * The eligibility system allows precise control over which charges serve as the
 * basis for percentage calculations, enabling complex pricing structures that
 * reflect real-world business relationships.
 */
export type PercentageChargeDto = UtilRequiredKeys<ContractChargeDto, 'chargeName' | 'chargeCategory' | 'legType' | 'accessorial' | 'approval' | 'outlay'> & {
  /** The percentage value to be applied as a charge */
  value: number;
  /** The minimum price for the percentage charge */
  minimumPrice?: number;
  /** Currency code for the charge (e.g., USD, EUR) */
  currency: string;
  /** Charge domain that serves as basis for percentage calculation */
  eligibleChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** The eligible charge sub-domain for percentage calculation */
  eligibleChargeSubDomain?: string;
  /**
   * Start date for this percentage charge validity
   * @format date
   */
  startDate?: string;
  /**
   * End date for this percentage charge validity
   * @format date
   */
  endDate?: string;
};

export interface ResponseDtoShipmentInActionDetailDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ShipmentInActionDetailDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Service Type Data Transfer Object DTO. */
export interface ServiceTypeDto {
  /** Name. */
  name?: string;
  /** Special Type. */
  specialType?: string;
  /** Import export Type. */
  importExportType?: 'IMPORT' | 'EXPORT' | 'MULTI';
  /** Modality. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Approval. */
  approval?: boolean;
}

/**
 * Represents charges applied per shipment regardless of size or weight.
 *
 * These are flat-rate charges that apply once per shipment, providing a
 * predictable cost structure for services that don't scale with cargo
 * quantity or weight.
 *
 * Examples: Documentation fees, booking charges, administrative fees,
 * shipment processing charges.
 */
export type ShipmentChargeDto = UtilRequiredKeys<ContractChargeDto, 'chargeName' | 'chargeCategory' | 'legType' | 'accessorial' | 'approval' | 'outlay'> & {
  /** Fixed price per unit for this charge */
  unitPrice: number;
  /** Currency code for the charge (e.g., USD, EUR) */
  currency: string;
};

/** Shipment Container Data Transfer Object DTO. */
export interface ShipmentContainerDto {
  /**
   * Size.
   * @format int32
   */
  size?: number;
  /**
   * Quantity.
   * @format int32
   */
  quantity?: number;
  /** Type. */
  type?: string;
}

/** The shipment detail related to the deviation. */
export interface ShipmentDetailDto {
  /**
   * The number of invoices associated with the shipment.
   * @format int64
   */
  numberOfInvoices?: number;
  /** Amount DTO. */
  shipmentAmount?: Amount;
  /** Amount DTO. */
  deviationAmount?: Amount;
  /**
   * The number of containers in the shipment, if any.
   * @format int32
   */
  containersCount?: number;
  /** The list of containers in the shipment. */
  containers?: ShipmentContainerDto[];
  /** The Incoterm for the shipment, if any. */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  /** Service Type Data Transfer Object DTO. */
  serviceType?: ServiceTypeDto;
  /** The description of the number of packages in the shipment, if any. */
  numberOfPackagesDescription?: string;
  /**
   * The number of packages in the shipment, if any.
   * @format int32
   */
  numberOfPackages?: number;
  /** The shipment number. */
  shipmentNumber?: string;
  /** The name of the shipper. */
  shipper?: string;
  /** The code of the shipper. */
  shipperCode?: string;
  /** The place where the shipment is to be picked up. */
  placeToPickup?: string;
  /** The name of the consignee. */
  consignee?: string;
  /** The code of the consignee. */
  consigneeCode?: string;
  /** The place where the shipment is to be delivered. */
  deliveryPlace?: string;
  /** The total gross weight of the shipment. */
  totalGrossWeight?: number;
  /** The total chargeable weight of the shipment. */
  totalChargeableWeight?: number;
  /** The description of the chargeable weight of the shipment. */
  chargeableWeightDescription?: string;
  /** The volume of the shipment. */
  volume?: number;
  /** The total CO2 emission of the shipment. */
  totalCo2Emission?: number;
  /** The list of linked shipment invoices. */
  linkedShipmentInvoices?: LinkedShipmentInvoiceDto[];
  /**
   * The order time of the shipment.
   * @format date-time
   */
  orderTime?: string;
}

/** The data returned by the operation, if any */
export interface ShipmentInActionDetailDto {
  /**
   * The unique identifier of the shipment in action detail.
   * @format uuid
   */
  id?: string;
  /**
   * The unique identifier of the shipment invoice.
   * @format uuid
   */
  shipmentInvoiceId?: string;
  /** The Master Bill of Lading (MBL) or House Bill of Lading (HBL) related to the shipment. */
  mblHbl?: string;
  /** The list of invoice charges. */
  invoiceCharges?: ChargeDto[];
  /** Indicates if approval is required. */
  approvalRequired?: boolean;
  /** The list of deviations related to the shipment. */
  deviations?: DeviationDto[];
  /** The shipment detail related to the deviation. */
  shipmentDetail?: ShipmentDetailDto;
  /** The list of leg details related to the deviation. */
  legDetails?: LegDetail[];
  /** The transport detail related to the deviation. */
  transportDetail?: ShipmentTransportDetailDto;
  /** The next workflow action for the deviation. */
  nextWorkflowAction?:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** The current deviation workflow. */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** The status of the invoice. */
  status?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /** The map of approval types to their corresponding approval statuses. */
  approvalTypeApprovalStatusMap?: Record<string, 'PENDING' | 'APPROVED' | 'REJECTED'>;
  /** Indicates if the shipment is being processed asynchronously. */
  asyncProcessing?: boolean;
  /** Background Shipment perform result Data Transfer Object DTO. */
  backgroundShipmentPerformResultDto?: BackgroundShipmentPerformResultDto;
  /**
   * The unique identifier of the shipping service.
   * @format uuid
   */
  shippingServiceId?: string;
  /**
   * The unique identifier of the contract.
   * @format uuid
   */
  contractId?: string;
  /** The deviation threshold configuration. */
  deviationThreshold?: DeviationThresholdConfigDto;
  /**
   * Permissions associated with the shipment
   * @uniqueItems true
   */
  permissions?: (
    | 'CAN_GIVE_PROCUREMENT_REVIEW'
    | 'CAN_GIVE_OPERATION_REVIEW'
    | 'CAN_GIVE_FINANCE_REVIEW'
    | 'CAN_GIVE_DISPUTE_REVIEW'
    | 'CAN_GIVE_NO_CONTRACT_REVIEW'
    | 'CAN_UPLOAD_INVOICE_FILE'
    | 'CAN_GIVE_SUPPLY_CHAIN_REVIEW'
    | 'CAN_GIVE_OPS_ADMIN_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L1_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L2_REVIEW'
  )[];
}

/** The transport detail related to the deviation. */
export interface ShipmentTransportDetailDto {
  /** Leg transport detail Data Transfer Object DTO. */
  legOne?: LegTransportDetailDto;
  /** Leg transport detail Data Transfer Object DTO. */
  legTwo?: LegTransportDetailDto;
  /** Leg transport detail Data Transfer Object DTO. */
  legThree?: LegTransportDetailDto;
}

/**
 * Represents charges calculated based on cargo weight with minimum/maximum constraints.
 *
 * This class handles weight-based pricing with sophisticated rate structures including
 * minimum charges and weight break points. It's commonly used for freight charges
 * where cost scales with weight but includes protections for both light and heavy shipments.
 *
 * Pricing Structure:
 * - Base rate per unit weight (e.g., per kg, per lb)
 * - Minimum price threshold to ensure viability
 * - Weight ranges that define applicability boundaries
 * - Currency specification for international operations
 */
export type WeightChargeDto = UtilRequiredKeys<ContractChargeDto, 'chargeName' | 'chargeCategory' | 'legType' | 'accessorial' | 'approval' | 'outlay'> & {
  /** Price per unit of weight */
  unitPrice?: number;
  /** Currency code for the charge (e.g., USD, EUR) */
  currency: string;
  /** The charge unit for weight calculation */
  chargeUnit: 'KG' | 'CBM' | 'PKG' | 'LBS' | 'REF';
  /** Minimum charge amount regardless of weight */
  minimumPrice?: number;
  /** The minimum chargeable weight threshold */
  minimumChargeableWeight?: number;
  /** The maximum chargeable weight threshold */
  maximumChargeableWeight?: number;
  /** The included quantity before charges apply */
  includedQuantity?: number;
  /** The calculation method for the weight charges */
  calculationMethod?:
    | 'MAX_OF_MIN_OR_UNIT_PRICE_UNIQUE'
    | 'MIN_AND_UNIT_PRICE_UNIQUE'
    | 'MAX_OF_MIN_OR_UNIT_PRICE_MAX_CHARGE_UNIT'
    | 'MIN_AND_UNIT_PRICE_MAX_CHARGE_UNIT';
  /**
   * Start date for this weight charge validity
   * @format date
   */
  startDate?: string;
  /**
   * End date for this weight charge validity
   * @format date
   */
  endDate?: string;
  /** End time for this weight charge order */
  startTime?: LocalTime;
  /** End time for this weight charge order */
  endTime?: LocalTime;
};

export interface ResponseDtoBoolean {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: boolean;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for resolving shipment containers based on modality and service provider ID. */
export interface ResolveShipmentContainersRequestDto {
  /** Modality of the shipment (e.g., AIR, SEA). */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /**
   * ID of the service provider associated with the shipment.
   * @format int64
   */
  serviceProviderId?: number;
  /** Type of service (e.g., FCL, LCL). */
  serviceType?: string;
}

/** Data Transfer Object for Service Provider Address */
export interface ServiceProviderAddressDto {
  /**
   * Unique identifier for the service provider address
   * @format int64
   */
  id?: number;
  /**
   * Unique identifier for the service provider
   * @format int64
   */
  serviceProviderId: number;
  /** The street address of the service provider */
  address?: string;
  /** The city of the service provider */
  city?: string;
  /** The state of the service provider */
  state?: string;
  /** The zipcode of the service provider */
  zipcode?: string;
  /** The country of the service provider */
  country?: string;
  /** The email address of the service provider */
  email?: string;
  /** The fax number of the service provider */
  fax?: string;
  /** The phone number of the service provider */
  phone?: string;
  /** The type of address (e.g., DELIVERY, PICK_UP, BILLING) */
  type: 'PICK_UP' | 'DELIVERY' | 'LEGAL' | 'BILLING' | 'OFFICE' | 'HEAD_OFFICE';
  /** Whether the address is active */
  active: boolean;
  /** @format date-time */
  createdOn?: string;
}

/** Service provider alias Data Transfer Object. Represents alternative names or identifiers for a service provider. Aliases are used to handle variations in how service provider names appear on invoices and documents, allowing multiple name variations to be mapped to one official service provider. */
export interface ServiceProviderNameAliasDto {
  /**
   * Unique identifier for the service provider alias record
   * @format int64
   * @example 1001
   */
  id?: number;
  /**
   * The alternative name or identifier value for the service provider. Contains alternative spellings, abbreviations, or variations of the service provider name as they appear on invoices and documents.
   * @example "DHL Express Pte Ltd"
   */
  name?: string;
  /**
   * Unique identifier for the service provider this alias belongs to
   * @format int64
   * @example 501
   */
  serviceProviderId?: number;
  /** @format date-time */
  createdOn?: string;
}

/** Service Provider over view Data Transfer Object DTO. */
export interface ServiceProviderOverViewDto {
  /**
   * Unique identifier.
   * @format int64
   */
  id?: number;
  /**
   * Parent Service Provider Unique identifier.
   * @format int64
   */
  parentServiceProviderId?: number;
  /** Name. */
  name: string;
  /** Code. */
  code: string;
  /** Indicates if active. */
  active?: boolean;
  /** Indicates if the service provider has any discount rate card. */
  hasDiscount?: boolean;
  /** Email. */
  email?: string;
  /**
   * Phone number.
   * @format date-time
   */
  updatedOn?: string;
  /** The list of addresses associated with the service provider */
  addresses?: ServiceProviderAddressDto[];
  /** List of name aliases for the service provider */
  nameAliases?: ServiceProviderNameAliasDto[];
}

export interface ResponseDtoListServiceProviderOverViewDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ServiceProviderOverViewDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoServiceProviderNameAliasDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Service provider alias Data Transfer Object. Represents alternative names or identifiers for a service provider. Aliases are used to handle variations in how service provider names appear on invoices and documents, allowing multiple name variations to be mapped to one official service provider. */
  data?: ServiceProviderNameAliasDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoServiceProviderAddressDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object for Service Provider Address */
  data?: ServiceProviderAddressDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/**
 * Represents a percentage discount configured in a contract flow.
 *
 * This discount is applied to charges matching the eligible charge domain and sub-domain.
 * The discount rate is a decimal value (e.g., 0.05 for 5% discount) and can have
 * an optional validity period.
 */
export interface PercentageDiscountDto {
  /**
   * Unique identifier. Null for create, set for update.
   * @format uuid
   */
  id?: string;
  /** The charge domain this discount applies to. Null means it applies to all charge domains. */
  eligibleChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** The charge sub-domain this discount applies to. Null means it applies to all charge sub-domains. */
  eligibleChargeSubDomain?: string;
  /** The discount rate as a decimal (e.g., 0.05 for 5%) */
  rate: number;
  /**
   * Start date for this discount validity period
   * @format date
   */
  validityStartDate?: string;
  /**
   * End date for this discount validity period
   * @format date
   */
  validityEndDate?: string;
  /** Weight unit for weight-range matching. Null means no weight-range filter applies. */
  chargeUnit?: 'KG' | 'CBM' | 'PKG' | 'LBS' | 'REF';
  /** Minimum chargeable weight (inclusive). Null defaults to 0. */
  minimumChargeableWeight?: number;
  /** Maximum chargeable weight (exclusive). Null means no upper bound. */
  maximumChargeableWeight?: number;
  /** Name identifying the discount category (e.g. 'Incentive Discount') */
  discountName: string;
}

export interface ResponseDtoPercentageDiscountDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents a percentage discount configured in a contract flow.
   *
   * This discount is applied to charges matching the eligible charge domain and sub-domain.
   * The discount rate is a decimal value (e.g., 0.05 for 5% discount) and can have
   * an optional validity period.
   */
  data?: PercentageDiscountDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoWeightChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents charges calculated based on cargo weight with minimum/maximum constraints.
   *
   * This class handles weight-based pricing with sophisticated rate structures including
   * minimum charges and weight break points. It's commonly used for freight charges
   * where cost scales with weight but includes protections for both light and heavy shipments.
   *
   * Pricing Structure:
   * - Base rate per unit weight (e.g., per kg, per lb)
   * - Minimum price threshold to ensure viability
   * - Weight ranges that define applicability boundaries
   * - Currency specification for international operations
   */
  data?: WeightChargeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoShipmentChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents charges applied per shipment regardless of size or weight.
   *
   * These are flat-rate charges that apply once per shipment, providing a
   * predictable cost structure for services that don't scale with cargo
   * quantity or weight.
   *
   * Examples: Documentation fees, booking charges, administrative fees,
   * shipment processing charges.
   */
  data?: ShipmentChargeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoPercentageChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents charges calculated as a percentage of other eligible charges.
   *
   * This class handles percentage-based charges that are derived from other charges
   * in the shipment. Common examples include insurance premiums, broker fees, or
   * administrative charges calculated as a percentage of freight costs.
   *
   * The eligibility system allows precise control over which charges serve as the
   * basis for percentage calculations, enabling complex pricing structures that
   * reflect real-world business relationships.
   */
  data?: PercentageChargeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoDeclarationChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents charges related to customs declarations and regulatory filings.
   *
   * These charges cover the costs associated with preparing, submitting, and
   * processing customs declarations and other regulatory documentation required
   * for international shipments.
   *
   * Examples: Customs filing fees, declaration processing charges, regulatory
   * compliance fees.
   */
  data?: DeclarationChargeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoContainerChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents charges based on container usage with size-specific pricing.
   *
   * This class handles container-based pricing structures commonly used in ocean
   * freight and intermodal transportation. Charges vary by container type and size,
   * reflecting the different operational costs and capacity utilization.
   *
   * The dual pricing structure (20ft vs 40ft) accommodates the standard container
   * sizes used in international shipping, allowing for accurate cost calculation
   * based on actual container utilization.
   */
  data?: ContainerChargeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Configuration for ranking algorithm score used in matching shipments to shipping services. Each entry represents a single match factor and its associated score in the scoring algorithm. */
export interface MatchScoreConfigDto {
  /**
   * Unique identifier for the match factor. This key corresponds to a specific element in the matching algorithm.
   * @example "SHIPPING_ZONE_MATCH"
   */
  matchFactor: string;
  /**
   * Numerical score assigned to this match factor. Higher values indicate greater importance in the ranking algorithm. A value of 0 effectively disables this match factor.
   * @example 3
   */
  score: number;
  /**
   * Description of what this match factor means
   * @example "Priority score for exact shipping zone match"
   */
  description?: string;
}

export interface ResponseDtoListMatchScoreConfigDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: MatchScoreConfigDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Geographical coordinates with latitude and longitude */
export interface LatLng {
  /**
   * Latitude coordinate (eg, 47.266667)
   * @format double
   */
  lat?: number;
  /**
   * Longitude coordinate (eg, -91.183333)
   * @format double
   */
  lng?: number;
}

/** Data Transfer Object representing a location, such as a city or port, with geographical coordinates and UN/LOCODE. */
export interface LocationDto {
  /**
   * Unique identifier for location
   * @format uuid
   */
  id?: string;
  /** Country code or name for the location (eg, US) */
  country?: string;
  /** Location name, typically a city or port (eg, Silver Bay) */
  location?: string;
  /** Geographical coordinates with latitude and longitude */
  latlng?: LatLng;
  /** UN/LOCODE (5-character unique code) for the location (eg, USSIB) */
  unlocode?: string;
  /** List of types describing the location (eg, ['port', 'road_terminal']) */
  types?: string[];
}

export interface ResponseDtoLocationDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object representing a location, such as a city or port, with geographical coordinates and UN/LOCODE. */
  data?: LocationDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListLegalEntityDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: LegalEntityDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface UpsertLegalEntityAliasRequest {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  legalEntityId: number;
  name: string;
  type: 'ACCOUNT_NUMBER' | 'NAME' | 'CITY';
}

export interface ResponseDtoLegalEntityNameAliasDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Legal entity alias Data Transfer Object. Represents alternative names or identifiers for a legal entity. Aliases are used to handle variations in how legal entity names appear on invoices and documents, allowing multiple name variations to be mapped to one official legal entity. */
  data?: LegalEntityNameAliasDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoLegalEntityAddressDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The list of addresses associated with the legal entity */
  data?: LegalEntityAddressDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Attachments associated with the invoice */
export interface Attachment {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  invoiceId?: string;
  attachmentType?: 'APPROVAL' | 'RATE_CARD' | 'CREDIT_NOTE' | 'ADDITIONAL_ATTACHMENT' | 'PURCHASE_ORDER' | 'QUOTATION';
  filePath?: string;
  fileName?: string;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string;
}

/** Credit note file Data Transfer Object DTO. */
export interface CreditNoteFileDto {
  /** File Name. */
  fileName?: string;
  /**
   * Uploaded Time.
   * @format date-time
   */
  uploadedTime?: string;
}

/** Dispute deviation resolution Data Transfer Object DTO. */
export interface DisputeDeviationResolutionDto {
  /**
   * Deviation Unique identifier.
   * @format uuid
   */
  deviationId?: string;
  /**
   * End period.
   * @format date
   */
  endPeriod?: string;
  /**
   * Start period.
   * @format date
   */
  startPeriod?: string;
  /** Expected Amount. */
  expectedAmount?: number;
  /** Exchange rate. */
  exchangeRate?: number;
  /** Period Type. */
  periodType?: 'ONE_OFF' | 'RECURRING';
}

/** Details of the freight forwarder */
export interface FreightForwarderDto {
  /** Name of the freight forwarder */
  name?: string;
  /** Code representing the freight forwarder */
  code?: string;
  /** Country where the freight forwarder is located */
  country?: string;
}

/** Invoice dispute Data Transfer Object DTO. */
export interface InvoiceDisputeDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Currency. */
  currency?: string;
  /** Lump sum Amount. */
  lumpSumAmount?: number;
  /** Lump sum Amount before tax. */
  lumpSumAmountBeforeTax?: number;
  /** Amount DTO. */
  expectedTotalAmount?: Amount;
  /** Amount DTO. */
  creditNoteAmount?: Amount;
  /** Resolution description. */
  resolutionDescription?: string;
  /** Status. */
  status?: 'DRAFT' | 'PENDING_DOCUMENT' | 'DONE' | 'CANCELED';
  /** Credit note file Data Transfer Object DTO. */
  creditNoteFile?: CreditNoteFileDto;
  /** Rejected deviations. */
  rejectedDeviations?: DeviationDto[];
  /** Deviations. */
  deviations?: DeviationDto[];
  /** Next Workflow action. */
  nextWorkflowAction?:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** Agreement resolution. */
  agreementResolution?:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE';
  /** Deviation resolution Type. */
  deviationResolutionType?: 'BREAK_DOWN_PER_DEVIATION' | 'LUMP_SUM';
  /** Deviation resolutions. */
  deviationResolutions?: DisputeDeviationResolutionDto[];
  /** Can continue dispute. */
  canContinueDispute?: boolean;
}

/** Metadata associated with the invoice */
export interface InvoiceMeta {
  rejectReason?: string;
}

/** The data returned by the operation, if any */
export interface InvoiceSummaryDto {
  /**
   * Unique identifier for the invoice
   * @format uuid
   */
  id?: string;
  /** Invoice number */
  invoiceNumber?: string;
  /**
   * Identifier for the invoice dispute, if any
   * @format uuid
   */
  invoiceDisputeId?: string;
  /** Name of the service provider */
  serviceProvider?: string;
  /** Details of the freight forwarder */
  freightForwarder?: FreightForwarderDto;
  /** Current status of the invoice */
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /**
   * Permissions associated with the invoice
   * @uniqueItems true
   */
  permissions?: (
    | 'CAN_GIVE_PROCUREMENT_REVIEW'
    | 'CAN_GIVE_OPERATION_REVIEW'
    | 'CAN_GIVE_FINANCE_REVIEW'
    | 'CAN_GIVE_DISPUTE_REVIEW'
    | 'CAN_GIVE_NO_CONTRACT_REVIEW'
    | 'CAN_UPLOAD_INVOICE_FILE'
    | 'CAN_GIVE_SUPPLY_CHAIN_REVIEW'
    | 'CAN_GIVE_OPS_ADMIN_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L1_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L2_REVIEW'
  )[];
  /** Current main role associated with the invoice */
  currentMainRole?:
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'FINANCE'
    | 'SUPPLY_CHAIN'
    | 'MANAGEMENT'
    | 'ADMIN'
    | 'SYSTEM_ADMIN'
    | 'RATE_CARD_VIEWER'
    | 'CREDIT_VIEWER'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2';
  /** Next workflow action for the invoice */
  nextWorkflowAction?:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** Current deviation workflow for the invoice */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /**
   * Date of the invoice
   * @format date
   */
  invoiceDate?: string;
  /**
   * Payment date for the invoice
   * @format date
   */
  paymentDate?: string;
  /** Party to whom the invoice is issued */
  invoicedParty?: string;
  /**
   * Identifier for the billed entity
   * @format int64
   */
  billedPartyId?: number;
  /** Amount DTO. */
  invoiceAmount?: Amount;
  /** Amount DTO. */
  amountToBePaid?: Amount;
  /** Deviations associated with the invoice */
  deviations?: Record<string, number>;
  /** Amount DTO. */
  invoiceAmountDeviation?: Amount;
  /** Services and shipments associated with the invoice */
  servicesAndShipments?: Record<string, number>;
  /** Total chargeable weight for the invoice */
  totalChargeableWeight?: number;
  /** Volume of the shipment */
  volume?: number;
  /**
   * Number of packages in the shipment
   * @format int32
   */
  packageCount?: number;
  /** Total CO2 emissions for the shipment */
  totalCo2Emission?: number;
  /** Modality of the shipment */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Attachments associated with the invoice */
  invoiceAttachments?: Attachment[];
  /** Service types associated with the invoice */
  serviceTypes?: ServiceTypeDto[];
  /** Metadata associated with the invoice */
  meta?: InvoiceMeta;
  /** Final resolution for the invoice */
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  /** Indicates if approval is required for the invoice */
  approvalRequired?: boolean;
  /** Invoice dispute Data Transfer Object DTO. */
  invoiceDispute?: InvoiceDisputeDto;
  /** Amount DTO. */
  creditNoteAmount?: Amount;
  /** FAP reference for the invoice */
  fapRef?: string;
  /** Account number associated with the invoice */
  accountNumber?: string;
  /** Type of the invoice */
  invoiceType?: 'UNKNOWN' | 'FREIGHT' | 'PARCELS' | 'TAX';
  /** Type of credit associated with the invoice */
  creditType?: 'INVOICE_UPLOAD_CREDIT' | 'SHIPMENT_CREDIT';
  /** List of shipments associated with the invoice */
  shipmentList?: Record<string, Shipment[]>;
  /** Indicates if the invoice is being processed asynchronously */
  asyncProcessing?: boolean;
  /** Background Shipment perform result Data Transfer Object DTO. */
  backgroundShipmentPerformResultDto?: BackgroundShipmentPerformResultDto;
  /** Role to which flagged invoices should be sent */
  sendFlaggedToRole?:
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'FINANCE'
    | 'SUPPLY_CHAIN'
    | 'MANAGEMENT'
    | 'ADMIN'
    | 'SYSTEM_ADMIN'
    | 'RATE_CARD_VIEWER'
    | 'CREDIT_VIEWER'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2';
  fileProcessing?: boolean;
}

export interface ResponseDtoInvoiceSummaryDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceSummaryDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** List of shipments associated with the invoice */
export interface Shipment {
  /**
   * Unique identifier for the shipment
   * @format uuid
   */
  id?: string;
  /** Shipment number associated with the invoice */
  shipmentNumber?: string;
  /**
   * Identifier for the shipment invoice
   * @format uuid
   */
  shipmentInvoiceId?: string;
  /** Current status of the shipment */
  status?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /** Current deviation workflow for the shipment */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Final resolution for the shipment */
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  /**
   * Number of deviations in the shipment
   * @format int32
   */
  numberOfDeviations?: number;
  /**
   * Number of approvals for the shipment
   * @format int32
   */
  numberOfApprovals?: number;
  /** File resolution status for the shipment */
  fileResolutionStatus?: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
  /** Overall audit outcome: APPROVED, REJECTED, or PENDING */
  auditStatus?: 'APPROVED' | 'REJECTED' | 'PENDING';
}

/** Deviation question User Response Data Transfer Object DTO. */
export interface DeviationQuestionUserResponseDto {
  /**
   * Question Unique identifier.
   * @format uuid
   */
  questionId?: string;
  /** Question Type. */
  questionType?: 'TEXT' | 'SELECT' | 'RADIO' | 'DATE' | 'DATE_RANGE' | 'DATE_TIME' | 'DATE_TIME_RANGE' | 'MULTIPLE_SELECT';
  /** Question Name. */
  questionName?: string;
  /**
   * Answer option Unique identifier.
   * @format uuid
   */
  answerOptionId?: string;
  /** Answer text. */
  answerText?: string;
  /** Answer Type. */
  answerType?:
    | 'YES'
    | 'NO'
    | 'RECURRING'
    | 'ONE_OFF'
    | 'YES_BUT_WITH_CHANGE_RECURRENCE'
    | 'LEG_ONE'
    | 'LEG_TWO'
    | 'LEG_THREE'
    | 'NOT_REQUIRED'
    | 'OTHER'
    | 'RESOLVE_ALL';
  /** Answer Name. */
  answerName?: string;
  /** Approval Type. */
  approvalType?: 'ACCESSORIAL_CHARGE' | 'SERVICE_TYPE';
  /** Domain type of the question. */
  questionDomainType?:
    | 'WAS_SHIPMENT_SPECIAL_INSTRUCTION_GIVEN'
    | 'WHAT_WAS_THE_SHIPMENT_SPECIAL_INSTRUCTION'
    | 'IS_THIS_RECURRING_CHARGE'
    | 'IS_THIS_DUE_TO_MARKET_CONDITION'
    | 'WHAT_IS_THE_NEW_MARKET_CONDITION'
    | 'PERIOD_OF_EXPECTED_RECURRENCE'
    | 'DO_YOU_ACCEPT_THIS_CHARGE_AS_IS'
    | 'CHARGE_REJECTED_REASON_TEXT'
    | 'DO_YOU_ACCEPT_THIS_QUANTITY'
    | 'WHY_DO_YOU_ACCEPT_THIS_QUANTITY'
    | 'WHY_DO_YOU_REJECT_THIS_QUANTITY'
    | 'IS_THERE_REASON_FOR_DOUBLE_CHARGE'
    | 'WHAT_IS_THE_REASON_FOR_DOUBLE_CHARGE'
    | 'DO_YOU_ACCEPT_THIS_DOUBLE_CHARGE'
    | 'WHY_DO_YOU_REJECT_THIS_DOUBLE_CHARGE'
    | 'DO_YOU_ACCEPT_THIS_DEVIATION_FROM_OPERATION'
    | 'DO_YOU_ACCEPT_THIS_DEVIATION'
    | 'WHY_DO_YOU_ACCEPT_THIS_DEVIATION'
    | 'WHY_DO_YOU_ACCEPT_THIS_DEVIATION_WITH_RECURRENCE_CHANGE'
    | 'WHY_DO_YOU_REJECT_THIS_CHARGE'
    | 'MODIFY_RECURRENCE'
    | 'WHY_DO_YOU_REJECT_THIS_DEVIATION'
    | 'CHANGE_LEG_OF_INVOICE_CHARGE'
    | 'DO_YOU_HAVE_ALL_REQUIRED_APPROVALS_FOR_THE_ACCESSORIAL_CHARGES'
    | 'DO_YOU_HAVE_ALL_THE_REQUIRED_APPROVALS_FOR_THIS_SERVICE'
    | 'DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_IT'
    | 'WHY_DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_ONE_OFF'
    | 'WHY_DO_YOU_REJECT_THIS_CHARGE_AS_IT'
    | 'WHY_DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_RECURRING'
    | 'WHAT_ARE_YOU_MISSING_FOR_THE_APPROVAL_OF_THE_ACCESSORIAL_CHARGES'
    | 'WHAT_ARE_YOU_MISSING_FOR_THE_APPROVAL_OF_THIS_SERVICE'
    | 'WHY_IS_NOT_REQUIRED'
    | 'SELECT_A_CHARGE_NAME'
    | 'WHY_DO_YOU_ACCEPT_REJECT_THESE_CHARGES';
}

export interface ResponseDtoListDeviationQuestionUserResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: DeviationQuestionUserResponseDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice dispute update Request Data Transfer Object DTO. */
export interface InvoiceDisputeUpdateRequestDto {
  /**
   * The ID of the invoice dispute.
   * @format uuid
   */
  id?: string;
  /** Lump sum amount. */
  lumpSumAmount?: number;
  /** Resolution description. */
  resolutionDescription?: string;
  /** Agreement resolution. */
  agreementResolution?:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE';
  /** Deviation resolution Type. */
  deviationResolutionType?: 'BREAK_DOWN_PER_DEVIATION' | 'LUMP_SUM';
  /** Deviation resolutions. */
  deviationResolutions?: DisputeDeviationResolutionDto[];
}

export interface ResponseDtoInvoiceDisputeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice dispute Data Transfer Object DTO. */
  data?: InvoiceDisputeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Credit note Data Transfer Object DTO. */
export interface CreditNoteDto {
  /** Total credit Amount after tax. */
  totalCreditAmountAfterTax?: number;
  /** Big decimal. */
  currencyExchangeRates?: Record<string, number>;
  /** Credit note Number. */
  creditNoteNumber: string;
}

export interface ResponseDtoCreditNoteDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Credit note Data Transfer Object DTO. */
  data?: CreditNoteDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Upload credit note URL Request Data Transfer Object DTO. */
export interface UploadCreditNoteUrlRequestDto {
  /** Credit note file URL. */
  creditNoteFileUrl: string;
}

export interface ResponseDtoCreditNoteFileDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Credit note file Data Transfer Object DTO. */
  data?: CreditNoteFileDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The list of consignee addresses */
export interface AddressDto {
  /** The address of the legal entity */
  address?: string;
  /** The city of the legal entity */
  city?: string;
  /** The state of the legal entity */
  state?: string;
  /** The zipcode of the legal entity */
  zipcode?: string;
  /** The country of the legal entity */
  country?: string;
  /** The email of the legal entity */
  email?: string;
  /** The fax number of the legal entity */
  fax?: string;
  /** The phone number of the legal entity */
  phone?: string;
  /** The location name of the legal entity */
  locationName?: string;
}

/** Average revenue per period used to auto-configure contract percentage discounts */
export interface AverageRevenueDto {
  amount?: number;
  /** @format date */
  from?: string;
  /** @format date */
  to?: string;
}

/** The list of charges associated with the shipment */
export interface ChargeMessageDto {
  /** The name of the charge */
  name?: string;
  /** The quantity associated with the charge */
  quantity?: number;
  /** The currency of the charge */
  currency?: string;
  /** The unit price of the charge */
  unitPrice?: number;
  /** The exchange rate used for currency conversion */
  exchangeRate?: number;
  /** The amount before tax is applied */
  amountBeforeTax?: number;
  /** The amount after tax is applied */
  amountAfterTax?: number;
  /** The tax amount for the charge */
  taxAmount?: number;
  /** The discount amount for the charge */
  discountAmount?: number;
  /** The tax percentage applied to the charge */
  taxPercentage?: number;
  /** The code identifier for the charge */
  code?: string;
  /** The unit of measurement for the charge */
  chargeUnit?: string;
}

/** The list of bank details for payment */
export interface InvoiceBankDetailMessageDto {
  /** The name of the bank */
  bankName?: string;
  /** The branch of the bank */
  bankBranch?: string;
  /** The SWIFT code of the bank */
  swiftCode?: string;
  /** The name of the account holder */
  accountName?: string;
  /** The bank account number */
  accountNumber?: string;
}

export interface InvoiceMessageDto {
  /** The invoice number */
  invoiceNumber?: string;
  /**
   * The date of the invoice
   * @format date
   */
  invoiceDate?: string;
  /**
   * The due date of the invoice
   * @format date
   */
  dueDate?: string;
  /** The payment terms for the invoice */
  terms?: string;
  /** The account number */
  accountNo?: string;
  /** The job number associated with the invoice */
  jobNumber?: string;
  /** The business unit identifier */
  businessUnit?: string;
  /** The modality of the invoice */
  modality?: string;
  /** The customer code */
  customerCode?: string;
  /** The name of the service provider */
  serviceProviderName?: string;
  /** The list of service provider addresses */
  serviceProviderAddresses?: AddressDto[];
  /** The name of the billed party */
  billedPartyName?: string;
  /** The list of billed party addresses */
  billedPartyAddresses?: AddressDto[];
  /** The person who prepared the invoice */
  preparedBy?: string;
  /** Additional notes for the invoice */
  notes?: string;
  important?: string;
  /** Remarks for the invoice */
  remarks?: string;
  /** The currency of the invoice */
  invoiceCurrency?: string;
  /** The total amount before tax is applied */
  totalAmountBeforeTax?: number;
  /** The total tax amount */
  totalTaxAmount?: number;
  /** The total amount after tax is applied */
  totalAmountAfterTax?: number;
  /** The total amount after tax expressed in words */
  totalAmountAfterTaxInWords?: string;
  /** The list of bank details for payment */
  bankDetails?: InvoiceBankDetailMessageDto[];
  /**
   * The unique identifier of the pipeline
   * @format uuid
   */
  pipelineId?: string;
  /** The configuration identifier */
  configId?: string;
  /** The Incoterm for the shipment */
  incoterm?: string;
  /** The pickup point for the shipment */
  pickUpPoint?: string;
  /** The delivery point for the shipment */
  deliveryPoint?: string;
  /** The total discount amount */
  totalAmountDiscount?: number;
  /** The list of shipments associated with the invoice */
  shipments?: ShipmentMessageDto[];
  /** The sales person responsible for the invoice */
  salesPerson?: string;
  /** The customer reference number */
  customerReference?: string;
  /** The purchase order number */
  poNumber?: string;
  /** The FAP number */
  fapNumber?: string;
  /** The company registration number */
  companyRegistrationNumber?: string;
  /** The GST registration number */
  gstRegistrationNumber?: string;
  /** The lot number */
  lotNumber?: string;
  /**
   * The data coverage percentage
   * @format int32
   */
  dataCoverage?: number;
  /** The type of the invoice */
  invoiceType?: string;
  /** Average revenue per period used to auto-configure contract percentage discounts */
  averageRevenues?: AverageRevenueDto[];
  /** The SIC (Standard Industrial Classification) code for the invoice */
  sicCode?: string;
}

/** The list of shipments associated with the invoice */
export interface ShipmentMessageDto {
  /** Internal tracking number for the shipment */
  internalTrackingNumber?: string;
  /** Shipment number from extracted data */
  shipmentNumber?: string;
  /** The name of the shipper */
  shipperName?: string;
  /** The list of shipper addresses */
  shipperAddresses?: AddressDto[];
  /** The name of the consignee */
  consigneeName?: string;
  /** The list of consignee addresses */
  consigneeAddresses?: AddressDto[];
  /** Place of loading for the shipment */
  placeOfLoading?: string;
  /** Place of discharge for the shipment */
  placeOfDischarge?: string;
  /** Alias for the pol with the shipment */
  polAlias?: string;
  /** Alias for the pod with the shipment */
  podAlias?: string;
  /** Shipping zone of the shipment */
  shippingZone?: string;
  /** Transportation reference number. Ex: Flight Number, Vessel Name, Truck Plaque */
  transportationReferenceNumber?: string;
  /** Carrier of the shipment. Ex: Airline Name, Shipping Line Name, Trucking Company Name */
  carrier?: string;
  /**
   * Number of packages in the shipment. Number of Packages whatever the type
   * @format int32
   */
  numberOfPackages?: number;
  /** Description of the number of packages per type. Ex: 10 pallets, 20 cartons */
  numberOfPackagesDescription?: string;
  /** Service type of the shipment */
  serviceType?: string;
  /** Special type of the shipment */
  specialType?: string;
  /** Commodity of the shipment or goods description of the shipment */
  commodity?: string;
  /** List of container numbers for the shipment */
  containerNumbers?: string[];
  /**
   * Estimated departure date of the shipment
   * @format date
   */
  estimatedDepartureDate?: string;
  /**
   * Estimated arrival date of the shipment
   * @format date
   */
  estimatedArrivalDate?: string;
  /**
   * Order time of the shipment
   * @format date-time
   */
  orderTime?: string;
  /** Master bill of lading for the shipment */
  masterBillOfLading?: string;
  /** House bill of lading for the shipment */
  houseBillOfLading?: string;
  /** Gross weight of the shipment in kilograms */
  grossWeightInKg?: number;
  /** Gross weight of the shipment */
  grossWeight?: string;
  /** Chargeable weight of the shipment in kilograms */
  chargeableWeightInKg?: number;
  /** Chargeable weight of the shipment */
  chargeableWeight?: string;
  /** Volume of the shipment in cubic meters */
  volumeInCbm?: number;
  /** Net weight of the shipment in kilograms */
  netWeightInKg?: number;
  /** Net weight of the shipment */
  netWeight?: string;
  /** The list of charges associated with the shipment */
  charges?: ChargeMessageDto[];
  /** Modality of the shipment */
  modality?: string;
}

/** Invoice ocr message Data Transfer Object DTO. */
export interface InvoiceOcrMessageDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /**
   * Invoice file processing Unique identifier.
   * @format uuid
   */
  invoiceFileProcessingId?: string;
  message?: InvoiceMessageDto;
}

export interface ResponseDtoInvoiceOcrMessageDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice ocr message Data Transfer Object DTO. */
  data?: InvoiceOcrMessageDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface InvoiceFileProcessingStatusUpdateReq {
  message?: string;
  dataPipelineConfigId?: string;
  fileLink?: string;
  pipelineData?: JsonNode;
}

export type JsonNode = object;

/** Invoice file processing Data Transfer Object DTO. */
export interface InvoiceFileProcessingDto {
  modality?: string;
  extractedPage?: string;
  modelUsed?: string;
  transformerUsed?: string;
  invoiceNumber?: string;
  serviceProviderName?: string;
  billedEntity?: string;
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** File Name. */
  fileName?: string;
  /**
   * Invoice Data pipeline Configuration Unique identifier.
   * @format uuid
   */
  invoiceDataPipelineConfigId?: string;
  /** Status. */
  status?:
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE';
  /** Status details. */
  statusDetails?: string;
  /**
   * Creation timestamp on.
   * @format date-time
   */
  createdOn?: string;
  /** Creation timestamp by. */
  createdBy?: string;
  /**
   * Last update timestamp on.
   * @format date-time
   */
  updatedOn?: string;
  /** Message. */
  message?: string;
  /**
   * Batch Unique identifier.
   * @format uuid
   */
  batchId?: string;
  /** Is billed. */
  isBilled?: boolean;
  /** Invoice Status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /**
   * Last approval email sent on.
   * @format date-time
   */
  lastApprovalEmailSentOn?: string;
  resolutionStatus?: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
}

export interface ResponseDtoInvoiceFileProcessingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice file processing Data Transfer Object DTO. */
  data?: InvoiceFileProcessingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface BillInvoiceFileProcessingRequestDto {
  invoiceFileProcessingIds: string[];
}

/** The data returned by the operation, if any */
export interface BillInvoiceFileProcessingResultDto {
  /** @format int32 */
  totalRequested?: number;
  /** @format int32 */
  totalBilled?: number;
  /** @format int32 */
  totalSkipped?: number;
}

export interface ResponseDtoBillInvoiceFileProcessingResultDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: BillInvoiceFileProcessingResultDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface UpsertInvoiceChargeDomainMappingReq {
  /** @format int64 */
  id?: number;
  invoiceChargeName: string;
  chargeDomain:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain: string;
  /** @format int64 */
  serviceProviderId: number;
  legType: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  contractChargeUnit: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
}

/** The data returned by the operation, if any */
export interface InvoiceChargeDomainMappingDto {
  /**
   * The unique identifier of the invoice charge domain mapping.
   * @format int64
   */
  id?: number;
  /** The name of the invoice charge. */
  invoiceChargeName?: string;
  /** The domain of the charge. */
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** The sub-domain of the charge. */
  chargeSubDomain?: string;
  /**
   * The ID of the service provider.
   * @format int64
   */
  serviceProviderId?: number;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** The unit of the contract charge. */
  contractChargeUnit?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  /**
   * The date when the invoice charge domain mapping was created.
   * @format date-time
   */
  createdOn?: string;
  /** Indicates whether the invoice charge domain mapping is active. */
  active?: boolean;
}

export interface ResponseDtoListInvoiceChargeDomainMappingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceChargeDomainMappingDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Deviation questionnaire question User Response Data Transfer Object DTO. */
export interface DeviationQuestionnaireQuestionUserResponseDto {
  /** Questionnaire answer. */
  questionnaireAnswer?: DeviationQuestionUserResponseDto[];
  /** Leg Charge Data Transfer Object DTO. */
  newChargeAnswer?: LegChargeDto;
  /** Per-line accept/reject decisions for RESOLVE_ALL double charge resolution. */
  doubleChargeLineDecisions?: DoubleChargeLineDecisionDto[];
}

/** Per-line accept/reject decision for a double charge resolution. */
export interface DoubleChargeLineDecisionDto {
  /**
   * The deviation ID of the charge line being decided on.
   * @format uuid
   */
  deviationId?: string;
  /** Whether this charge line is accepted (true) or rejected (false). */
  accepted?: boolean;
}

/** Leg Charge Data Transfer Object DTO. */
export interface LegChargeDto {
  /** Leg Type. */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** Charge domain. */
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
}

export interface InvoiceReTriggerRequest {
  invoiceIds?: string[];
}

export interface ContractUpsertRequestDto {
  /**
   * Unique identifier for the contract
   * @format uuid
   */
  id?: string;
  /**
   * Identifier for the service provider associated with this contract
   * @format int64
   */
  serviceProviderId: number;
  /** Flag indicating if the contract is active */
  active?: boolean;
  /** File path where the contract document is stored */
  filePath?: string;
  /**
   * Contract start date when terms become effective
   * @format date
   */
  startDate: string;
  /**
   * Contract end date when terms expire
   * @format date
   */
  endDate: string;
  /** Code identifying the contract */
  code?: string;
  /** @format uuid */
  contractFlowId?: string;
}

/** Overview of charge counts associated with the contract flow. It helps the user identified how many contract charges are associated with the contract flow per category. . */
export interface ChargeCountOverview {
  /**
   * Number of container charges associated with the contract flow
   * @format int32
   */
  contractContainerChargeCount?: number;
  /**
   * Number of shipment charges associated with the contract flow
   * @format int32
   */
  contractShipmentChargeCount?: number;
  /**
   * Number of unit price charges associated with the contract flow
   * @format int32
   */
  contractPercentageChargeCount?: number;
  /**
   * Number of declaration charges associated with the contract flow
   * @format int32
   */
  contractDeclarationChargeCount?: number;
  /**
   * Number of weight charges associated with the contract flow
   * @format int32
   */
  contractWeightChargeCount?: number;
}

/**
 * Represents a contractual agreement between parties with defined validity period.
 * This class defines the temporal boundaries of a contract, establishing when
 * the agreed terms and conditions are valid and enforceable. All rates and
 * charges within the contract are bound by these dates.
 */
export interface ContractDto {
  /**
   * Unique identifier for the contract
   * @format uuid
   */
  id?: string;
  /**
   * Identifier for the service provider associated with this contract
   * @format int64
   */
  serviceProviderId?: number;
  /** Flag indicating if the contract is active */
  active?: boolean;
  /** File path where the contract document is stored */
  filePath?: string;
  /**
   * Contract start date when terms become effective
   * @format date
   */
  startDate?: string;
  /**
   * Contract end date when terms expire
   * @format date
   */
  endDate?: string;
  /**
   * Timestamp when the contract was created
   * @format date-time
   */
  createdOn?: string;
  /** User who created the contract */
  createdBy?: string;
  /**
   * Timestamp when the contract was last updated
   * @format date-time
   */
  updatedOn?: string;
  /** User who last updated the contract */
  updatedBy?: string;
  /** Code identifying the contract */
  code?: string;
  /**
   * ID of the contract flow
   * @format uuid
   */
  contractFlowId?: string;
  /**
   * Number of invoices associated with the contract
   * @format int64
   */
  invoiceCount?: number;
  /**
   * Number of zones mapped to this contract
   * @format int64
   */
  zoneMappingCount?: number;
  /**
   * Number of routes mapped to this contract
   * @format int64
   */
  routeMappingCount?: number;
  /**
   * Number of rate cards (contract flows) under this contract
   * @format int64
   */
  contractFlowCount?: number;
  /**
   * Number of shipments associated with this contract
   * @format int64
   */
  shipmentCount?: number;
  /** Overview of charge counts associated with the contract flow. It helps the user identified how many contract charges are associated with the contract flow per category. . */
  chargeCountOverview?: ChargeCountOverview;
}

export interface ResponseDtoContractDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents a contractual agreement between parties with defined validity period.
   * This class defines the temporal boundaries of a contract, establishing when
   * the agreed terms and conditions are valid and enforceable. All rates and
   * charges within the contract are bound by these dates.
   */
  data?: ContractDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object representing a contract zone mapping */
export interface ContractZoneDto {
  /**
   * Unique identifier for the contract zone
   * @format uuid
   */
  id?: string;
  /**
   * Contract ID associated with the zone mapping
   * @format uuid
   */
  contractId: string;
  /** Location mapped to a zone code */
  location: string;
  /** Zone code associated with the location */
  zoneCode: string;
  /**
   * Timestamp when the contract zone was created
   * @format date-time
   */
  createdOn?: string;
  /** User who created the contract zone */
  createdBy?: string;
  /**
   * Timestamp when the contract zone was last updated
   * @format date-time
   */
  updatedOn?: string;
  /** User who last updated the contract zone */
  updatedBy?: string;
}

export interface ResponseDtoContractZoneDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object representing a contract zone mapping */
  data?: ContractZoneDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object representing a contract route mapping */
export interface ContractRouteDto {
  /**
   * Unique identifier of the contract route record. Null on create.
   * @format uuid
   */
  id?: string;
  /**
   * Contract ID this route belongs to.
   * @format uuid
   */
  contractId: string;
  /** Route name (e.g. "SEA-FCL"). */
  route: string;
  /** Zone code for the port of loading. */
  polZoneCode: string;
  /** Zone code for the port of discharge. */
  podZoneCode: string;
  /**
   * Timestamp when this contract route was created.
   * @format date-time
   */
  createdOn?: string;
  /** User who created this contract route. */
  createdBy?: string;
  /**
   * Timestamp when this contract route was last updated.
   * @format date-time
   */
  updatedOn?: string;
  /** User who last updated this contract route. */
  updatedBy?: string;
}

export interface ResponseDtoContractRouteDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object representing a contract route mapping */
  data?: ContractRouteDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface CreatingAndUpdatingContractFlowReq {
  /** @format uuid */
  shippingServiceId: string;
  /** @format uuid */
  contractId: string;
  code?: string;
  leg1Currency?: string;
  leg2Currency?: string;
  leg3Currency?: string;
}

/** Pricing structure within a contract for a specific shipping service, containing all charge types (container, shipment, declaration, weight, percentage). */
export interface ContractFlowInfoViewDto {
  /**
   * Unique identifier of the contract flow
   * @format uuid
   */
  id?: string;
  /** Contract flow code */
  code?: string;
  /**
   * ID of the parent contract
   * @format uuid
   */
  contractId?: string;
  /**
   * ID of the associated shipping service
   * @format uuid
   */
  shippingServiceId?: string;
  /** Whether this contract flow is active */
  active?: boolean;
  /** Default currency for leg 1 (origin) charges */
  leg1Currency?: string;
  /** Default currency for leg 2 (main carriage) charges */
  leg2Currency?: string;
  /** Default currency for leg 3 (destination) charges */
  leg3Currency?: string;
  /**
   * Timestamp when this contract flow was created
   * @format date-time
   */
  createdOn?: string;
  /** User who created this contract flow */
  createdBy?: string;
  /**
   * Timestamp when this contract flow was last updated
   * @format date-time
   */
  updatedOn?: string;
  /** User who last updated this contract flow */
  updatedBy?: string;
  /** Charges based on container type and size (e.g., 20ft, 40ft) */
  containerCharges?: ContainerChargeDto[];
  /** Charges calculated as a percentage of other eligible charges */
  percentageCharges?: PercentageChargeDto[];
  /** Flat-rate charges applied per shipment */
  shipmentCharges?: ShipmentChargeDto[];
  /** Charges related to customs declarations and regulatory filings */
  declarationCharges?: DeclarationChargeDto[];
  /** Charges calculated based on cargo weight */
  weightCharges?: WeightChargeDto[];
  /** Percentage discounts applied to charges in this contract flow. */
  percentageDiscounts?: PercentageDiscountDto[];
}

export interface ResponseDtoContractFlowInfoViewDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Pricing structure within a contract for a specific shipping service, containing all charge types (container, shipment, declaration, weight, percentage). */
  data?: ContractFlowInfoViewDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface AddingOrRemovingRateCardToContractFlowReq {
  /** @format uuid */
  id: string;
  contractChargeUnit: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
}

/** Chart report Request Data Transfer Object DTO. */
export interface ChartReportRequestDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** Name. */
  name?: string;
  /** Description. */
  description?: string;
  /** Type. */
  type: 'REPORT_ANALYTIC' | 'PERFORMANCE_ASSESSMENT';
  /** Hashed filters. */
  hashedFilters?: string;
}

/** Chart report Data Transfer Object DTO. */
export interface ChartReportDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** Name. */
  name?: string;
  /** Description. */
  description?: string;
  /** Hashed filters. */
  hashedFilters?: string;
  /** Type. */
  type?: 'REPORT_ANALYTIC' | 'PERFORMANCE_ASSESSMENT';
  /**
   * Update Date.
   * @format date-time
   */
  updateDate?: string;
  /** Creation timestamp by. */
  createdBy?: string;
}

export interface ResponseDtoChartReportDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Chart report Data Transfer Object DTO. */
  data?: ChartReportDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface MigrationBatchSizeRequest {
  /** @format int32 */
  size?: number;
}

export interface WorkflowDto {
  /**
   * Unique identifier of the workflow, leave empty for new workflow
   * @format uuid
   */
  id?: string;
  /** Name of the workflow */
  name?: string;
  /** Description of the workflow */
  description?: string;
  /** Indicates whether the workflow is enabled */
  enabled?: boolean;
  /** List of workflow rules associated with the workflow */
  workflowRules?: WorkflowRuleDto[];
}

/** List of workflow rules associated with the workflow */
export interface WorkflowRuleDto {
  /**
   * ID of the workflow rule, leave empty for new rule
   * @format int64
   */
  id?: number;
  /** Description of the workflow rule */
  description?: string;
  /** Type of the workflow rule */
  type: 'INVOICE' | 'SHIPMENT';
  /** List of user roles associated with the rule */
  userRoles?: string[];
  /** Current workflow state */
  currentWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Action to be performed in the workflow */
  workflowAction:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** Condition for the rule to be applied */
  condition?: string;
  /** Next workflow state after the rule is applied */
  nextWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Next invoice status after the rule is applied */
  nextInvoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Next shipment status after the rule is applied */
  nextShipmentStatus?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /** Post action to be executed after the rule */
  postAction?: string;
  /** Type of activity log to be created */
  activityLogType?: string;
  /**
   * Priority of the workflow rule
   * @format int32
   */
  priority?: number;
  /** Version of the workflow rule */
  version?: string;
  /** Indicates if the rule is enabled */
  enabled?: boolean;
}

export interface ResponseDtoWorkflowDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: WorkflowDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface WorkflowRulePostRequestDto {
  /**
   * ID of the workflow rule, leave empty for new rule
   * @format int64
   */
  id?: number;
  /** Description of the workflow rule */
  description?: string;
  /** Type of the workflow rule */
  type: 'INVOICE' | 'SHIPMENT';
  /** List of user roles associated with the rule */
  userRoles?: string[];
  /** Current workflow state */
  currentWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Action to be performed in the workflow */
  workflowAction:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** Condition for the rule to be applied */
  condition?: string;
  /** Next workflow state after the rule is applied */
  nextWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Next invoice status after the rule is applied */
  nextInvoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Next shipment status after the rule is applied */
  nextShipmentStatus?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /** Post action to be executed after the rule */
  postAction?: string;
  /** Type of activity log to be created */
  activityLogType?: string;
  /**
   * Priority of the workflow rule
   * @format int32
   */
  priority?: number;
  /** Version of the workflow rule */
  version?: string;
  /** Indicates if the rule is enabled */
  enabled?: boolean;
  /**
   * ID of the associated workflow
   * @format uuid
   */
  workflowId?: string;
}

export interface ResponseDtoWorkflowRuleDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** List of workflow rules associated with the workflow */
  data?: WorkflowRuleDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Workflow rule query Request Data Transfer Object DTO. */
export interface WorkflowRuleQueryRequestDto {
  /** Type of the workflow rule */
  workflowRuleType?: string;
  /** Current workflow state */
  currentWorkflow?: string;
  /** Action to be performed in the workflow */
  workflowAction?: string;
  /** Next workflow state after the action */
  nextWorkflow?: string;
  /** Next invoice status after the action */
  nextInvoiceStatus?: string;
  /** Next shipment status after the action */
  nextShipmentStatus?: string;
  /** Post-action function to be executed */
  postAction?: string;
  /** Type of activity log to be recorded */
  activityLogType?: string;
  /** Version of the workflow rule */
  version?: string;
  /** Whether to include disabled workflow rules */
  includeDisabled?: boolean;
}

export interface ResponseDtoListWorkflowRule {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: WorkflowRule[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Configurable workflow rule defining state transitions and actions for invoice processing */
export interface WorkflowRule {
  /**
   * Unique identifier for the workflow rule
   * @format int64
   * @example 1
   */
  id?: number;
  /**
   * Human-readable description explaining the purpose and behavior of this workflow rule
   * @example "Auto-approve invoices under $1000 for trusted suppliers"
   */
  description?: string;
  /** Type/category of the workflow rule for classification purposes */
  type?: 'INVOICE' | 'SHIPMENT';
  /**
   * List of user roles authorized to execute this workflow rule
   * @example ["APPROVER","FINANCE_MANAGER"]
   */
  userRoles?: string[];
  /** Current deviation workflow state that this rule applies to */
  currentWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Workflow action that triggers the execution of this rule */
  workflowAction?:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /**
   * Custom condition expression that must evaluate to true for rule execution
   * @example "invoice.amount < 1000 && supplier.trustLevel == 'HIGH'"
   */
  condition?: string;
  /** Target deviation workflow state after successful rule execution */
  nextWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Target invoice status after successful rule execution */
  nextInvoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Target shipment invoice status after successful rule execution */
  nextShipmentStatus?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  /**
   * Custom post-action script or identifier for additional processing after rule execution
   * @example "sendNotificationToApprover"
   */
  postAction?: string;
  /**
   * Activity log type identifier for audit trail when rule is executed
   * @example "AUTO_APPROVAL"
   */
  activityLogType?: string;
  /**
   * Review action type for auto-determination: CONFIRM (yes) or REJECT (no). Null means explicit action only.
   * @example "CONFIRM"
   */
  reviewAction?: 'CONFIRM' | 'REJECT';
  /**
   * Execution priority (lower numbers = higher priority) for rule ordering
   * @format int32
   * @min 1
   * @example 1
   */
  priority?: number;
  /**
   * Version identifier for rule change management and tracking
   * @example "1.0.0"
   */
  version?: string;
  /**
   * Flag indicating whether this rule is currently active and should be evaluated
   * @default true
   */
  enabled?: boolean;
  /**
   * Timestamp when this workflow rule was created
   * @format date-time
   */
  createdOn?: string;
  /**
   * Identifier of the user who created this workflow rule
   * @example "admin@tetrixx.com"
   */
  createdBy?: string;
  /**
   * Timestamp when this workflow rule was last modified
   * @format date-time
   */
  updatedOn?: string;
  /**
   * Identifier of the user who last modified this workflow rule
   * @example "manager@tetrixx.com"
   */
  updatedBy?: string;
}

/** List of entity permissions. */
export interface EntityPermissionAttributes {
  /** List of billed entities. */
  billedEntities?: string[];
  /** List of service providers. */
  serviceProvider?: string[];
  /** List of shipping services. */
  shippingService?: string[];
}

/** List of entity permissions. */
export interface EntityPermissionDto {
  /** List of entity permissions. */
  entityPermission?: EntityPermissionAttributes[];
  /** Indicates whether the permissions are allowed. */
  allowed?: boolean;
  /**
   * Set of permission types.
   * @uniqueItems true
   */
  permissions?: (
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'SUPPLY_CHAIN'
    | 'DISPUTE'
    | 'FINANCE'
    | 'AUDIT'
    | 'REPORT'
    | 'PERFORMANCE'
    | 'RATECARD'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2'
  )[];
}

export interface UserCreateRequestDto {
  /**
   * The unique identifier of the user.
   * @format uuid
   */
  id?: string;
  /** The first name of the user. */
  firstName?: string;
  /** The middle name of the user. */
  middleName?: string;
  /** The last name of the user. */
  lastName?: string;
  /** The email address of the user. */
  email?: string;
  /** The Cognito ID of the user. */
  cognitoId?: string;
  /** Indicates whether the user is active. */
  active?: boolean;
  /**
   * The roles assigned to the user.
   * @uniqueItems true
   */
  roles?: (
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'FINANCE'
    | 'SUPPLY_CHAIN'
    | 'MANAGEMENT'
    | 'ADMIN'
    | 'SYSTEM_ADMIN'
    | 'RATE_CARD_VIEWER'
    | 'CREDIT_VIEWER'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2'
  )[];
  /** The legal entity code associated with the user. */
  legalEntityCode?: string;
  /** The permissions to be upserted for the user. */
  userEntityPermission?: UserEntityPermissionDto;
}

/** The permissions to be upserted for the user. */
export interface UserEntityPermissionDto {
  /** The Cognito ID of the user. */
  cognitoId?: string;
  /** List of entity permissions. */
  entityPermissions?: EntityPermissionDto[];
}

/** Request object for pagination, sorting, and filtering of API responses */
export interface PaginationRequest {
  /**
   * Page number (0-based indexing)
   * @format int32
   * @min 0
   * @default 0
   * @example 0
   */
  page?: number;
  /**
   * Number of items to return per page
   * @format int32
   * @min 1
   * @default 1000
   * @example 10
   */
  size?: number;
  /**
   * Column name/field to sort the results by
   * @example "createdDate"
   */
  sortingColum?: string;
  /**
   * Direction of sorting (ASC or DESC)
   * @example "ASC"
   */
  sortingDirection?: 'ASC' | 'DESC';
}

/** Request for legal entities, containing metadata and pagination information. */
export interface UserDetailsRequestDto {
  /** First names of users */
  firstNames?: string[];
  /** Last names of users */
  lastNames?: string[];
  /** Email addresses of users */
  emails?: string[];
  /** Legal entity codes associated with users */
  legalEntityCodes?: string[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageUserDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: UserDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject[];
  /** @format int32 */
  pageNumber?: number;
  paged?: boolean;
  /** @format int32 */
  pageSize?: number;
  unpaged?: boolean;
}

export interface ResponseDtoPageUserDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageUserDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

export interface ResponseDtoListUserPermissionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: UserPermissionDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoUserDetailsMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Metadata for user details, containing frequency counts of first names, last names, emails, and legal entity codes. */
  data?: UserDetailsMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Metadata for user details, containing frequency counts of first names, last names, emails, and legal entity codes. */
export interface UserDetailsMetadataDto {
  /** Map of first names and their frequency counts. */
  firstNames?: Record<string, number>;
  /** Map of last names and their frequency counts. */
  lastNames?: Record<string, number>;
  /** Map of email addresses and their frequency counts. */
  emails?: Record<string, number>;
  /** Map of legal entity codes and their frequency counts. */
  legalEntityCodes?: Record<string, number>;
}

export interface UserIssueRequest {
  /** @format uuid */
  invoiceId?: string;
  message?: string;
  /** @format uuid */
  shipmentInvoiceId?: string;
}

export interface ResponseDtoUserIssueDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** User issue Data Transfer Object DTO. */
  data?: UserIssueDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** User issue Data Transfer Object DTO. */
export interface UserIssueDto {
  /** Status. */
  status?: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
  /** Issue Unique identifier. */
  issueId?: string;
}

/** Request to assign a user to a SIC code */
export interface CreateSicCodeManagerAssignmentRequest {
  /** SIC code to assign */
  sicCode: string;
  /** Email of the user to assign */
  userEmail: string;
}

export interface ResponseDtoSicCodeManagerAssignmentDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** SIC code to user assignment */
  data?: SicCodeManagerAssignmentDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Represents the priority settings for a shipping service request. Contains a list of UUIDs identifying prioritized shipping services. */
export interface ShippingServicePriority {
  /** List of UUIDs representing the prioritized shipping services */
  ids?: string[];
}

export interface ShippingServiceRequestDto {
  /**
   * List of Service Provider Codes to filter by.
   * If provided, results will be limited to these specific service providers.
   * If null or empty, no service provider filtering is applied.
   */
  serviceProviderCodes?: string[];
  /** List of modalities to filter by */
  modalities?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT' | null)[];
  /**
   * List of Legal Entity Codes that represent entities sending the good, also called shipper codes to filter by.
   * If provided, results will be limited to these specific shippers.
   * If null or empty, no shipper filtering is applied.
   */
  shipperCodes?: string[];
  /**
   * List of Legal Entity Codes that represent entities receiving the good, also called consignee codes to filter by.
   * If provided, results will be limited to these specific consignees.
   * If null or empty, no consignee filtering is applied.
   */
  consigneeCodes?: string[];
  /** List of billing party codes to filter by */
  billingPartyCodes?: string[];
  /**
   * An optional list of route strings to filter by.
   * If provided, results will be limited to these specific routes.
   * If null or empty, no route filtering is applied.
   * Each route is in the format 'ORIGIN:DESTINATION', using UNLOCODES.
   * @example ["HKHKG:SGSIN","CNSHA:USLAX"]
   */
  routes?: (string | null)[];
  /**
   * An optional list of service levels to filter by.
   * If provided, results will be limited to matching services.
   * If null or empty, no service filtering is applied.
   * @example ["EXPRESS","STANDARD"]
   */
  services?: (string | null)[];
  /** List of types to filter by */
  types?: string[];
  /** List of carriers to filter by */
  carriers?: string[];
  /**
   *     An optional list of Incoterms (International Commercial Terms) codes to filter by.
   *     If provided, results will be limited to these specific terms.
   *     If null or empty, no Incoterm filtering is applied.
   *     Each item is a single, 3-letter Incoterm code and
   *     must be one of the allowed enum values representing a standardized trade term.
   */
  incoterms?: ('EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP' | null)[];
  /** List of total lead times to filter by */
  totalLeadTimes?: number[];
  /** Represents the priority settings for a shipping service request. Contains a list of UUIDs identifying prioritized shipping services. */
  priority?: ShippingServicePriority;
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageShippingServiceDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: ShippingServiceDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageShippingServiceDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageShippingServiceDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoShippingServiceMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ShippingServiceMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface ShippingServiceMetadataDto {
  /** Map of service provider codes to their corresponding IDs */
  serviceProviderCodes?: Record<string, number>;
  /** Map of modalities to their corresponding IDs */
  modalities?: Record<string, number>;
  /** Map of shipper codes to their corresponding IDs */
  shipperCodes?: Record<string, number>;
  /** Map of consignee codes to their corresponding IDs */
  consigneeCodes?: Record<string, number>;
  /** Map of billing party codes to their corresponding IDs */
  billingPartyCodes?: Record<string, number>;
  /** Map of route identifiers to their corresponding IDs */
  routes?: Record<string, number>;
  /** Map of service names to their corresponding IDs */
  services?: Record<string, number>;
  /** Map of type names to their corresponding IDs */
  types?: Record<string, number>;
  /** Map of carrier names to their corresponding IDs */
  carriers?: Record<string, number>;
  /** Map of incoterms to their corresponding IDs */
  incoterms?: Record<string, number>;
  /** Map of total lead times to their corresponding IDs */
  totalLeadTimes?: Record<string, number>;
}

export interface GetMatchingShippingServiceRequest {
  /**
   * ID of the billing party
   * @format int64
   */
  billingPartyId?: number;
  /**
   * ID of the service provider
   * @format int64
   */
  serviceProviderId?: number;
  /** Modality of the shipping service */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Port of loading */
  pol?: string;
  /** Port of discharge */
  pod?: string;
  /**
   * Estimated time of departure
   * @format date
   */
  etd?: string;
  /** Alias for the port of loading */
  polAlias?: string;
  /** Alias for the port of discharge */
  podAlias?: string;
  /** Shipping zone */
  shippingZone?: string;
  /**
   * ID of the shipper
   * @format int64
   */
  shipperId?: number;
  /**
   * ID of the consignee
   * @format int64
   */
  consigneeId?: number;
  /** Service type */
  service?: string;
  /** Type of the shipping service */
  type?: string;
  /** Carrier of the shipping service */
  carrier?: string;
  /** Incoterm of the shipping service */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
}

/** Co2 emission DTO. */
export interface Co2Emission {
  /** Total. */
  total?: number;
  /** Wtt. */
  wtt?: number;
  /** Ttw. */
  ttw?: number;
  /** Intensity. */
  intensity?: number;
}

/** Date and time details for the transport leg. */
export interface DateTime {
  /** The departure date and time in ISO 8601 format. */
  departure?: string;
  /** The arrival date and time in ISO 8601 format. */
  arrival?: string;
}

/** Details. */
export interface Details {
  /** Vessel DTO. */
  vessel?: Vessel;
  /** Details of the flight used in the transport leg. Only applicable for air transport. */
  flight?: Flight;
  /** Date and time details for the transport leg. */
  dateTime?: DateTime;
  /** The type of fuel used in the transport leg. */
  fuelType?: string;
}

/** Details of the flight used in the transport leg. Only applicable for air transport. */
export interface Flight {
  /** The flight number. */
  number?: string;
}

/** The location details of the transport chain element */
export interface Location {
  /** The location code (UN/LOCODE) */
  locode?: string;
}

/** Orders. */
export interface Order {
  /** The type of the order, representing its nature or category */
  type?: string;
  /** The size and type code of the container, specifying its dimensions and type */
  containerSizeTypeCode?: string;
  /** The weight of the container */
  weight?: number;
  /**
   * The number of containers in the order
   * @format int32
   */
  nContainers?: number;
}

/** Parameters DTO. */
export interface Parameters {
  /** Orders. */
  orders?: Order[];
  /** Details. */
  details?: Details;
}

export interface ResponseDtoSeaRoutesResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Sea routes Response Data Transfer Object DTO. */
  data?: SeaRoutesResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Sea routes error DTO. */
export interface SeaRoutesError {
  /**
   * Timestamp.
   * @format int64
   */
  timestamp?: number;
  /**
   * Status.
   * @format int32
   */
  status?: number;
  /** Error. */
  error?: string;
  /** Error codes. */
  errorCodes?: string[];
  /** Messages. */
  messages?: string[];
}

/** Sea routes Response. */
export interface SeaRoutesResponse {
  /** Parameters DTO. */
  parameters?: Parameters;
  /** Co2 emission DTO. */
  co2e?: Co2Emission;
  /** The list of transport chain elements representing the route */
  transportChainElements?: TransportChainElement[];
}

/** Sea routes Response Data Transfer Object DTO. */
export interface SeaRoutesResponseDto {
  /** Sea routes Response. */
  seaRoutesResponse?: SeaRoutesResponse;
  /** Sea routes error DTO. */
  seaRoutesError?: SeaRoutesError;
}

/** The list of transport chain elements representing the route */
export interface TransportChainElement {
  /** Co2 emission DTO. */
  co2e?: Co2Emission;
  /** Metadata providing additional information about the transport chain element */
  metadata?: Record<string, string>;
  /** The type of the transport chain element */
  type?: string;
  /** The location details of the transport chain element */
  from?: Location;
  /** The location details of the transport chain element */
  to?: Location;
  /** The location details of the transport chain element */
  location?: Location;
  /** The trade lane associated with the transport chain element */
  tradeLane?: string;
  /** The mode of transport used in the transport chain element */
  mode?: string;
  parameters?: JsonNode;
  properties?: JsonNode;
}

/** Vessel DTO. */
export interface Vessel {
  /** Name. */
  name?: string;
}

/** Contract Charge lists Data Transfer Object DTO. */
export interface ContractChargeListsDto {
  /** Container charges. */
  containerCharges?: ContainerChargeDto[];
  /** Shipment charges. */
  shipmentCharges?: ShipmentChargeDto[];
  /** Declaration charges. */
  declarationCharges?: DeclarationChargeDto[];
  /** Weight charges. */
  weightCharges?: WeightChargeDto[];
  /** Percentage charges. */
  percentageCharges?: PercentageChargeDto[];
}

/** New shipping Service and contract Request Data Transfer Object DTO. */
export interface NewShippingServiceAndContractRequestDto {
  /** New shipping Service Data Transfer Object DTO. */
  newShippingService?: NewShippingServiceDto;
  /** Contract Charge lists Data Transfer Object DTO. */
  contractCharges?: ContractChargeListsDto;
}

/** New shipping Service Data Transfer Object DTO. */
export interface NewShippingServiceDto {
  /** Name of the shipper */
  shipperName?: string;
  /** Route of the shipping service */
  route?: string;
  /** Name of the consignee */
  consigneeName?: string;
  /** Billing party code */
  billingPartyCode?: string;
  /** Modality of the shipping service */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Service type */
  service?: string;
  /** Type of shipping */
  type?: string;
  /** Carrier name */
  carrier?: string;
  /** Incoterm of the shipping service */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  /**
   * ID of the contract flow
   * @format uuid
   */
  contractFlowId?: string;
  /** List of zones associated with the shipping service */
  listZone?: ZoneDto[];
  /**
   * Start date of the contract period
   * @format date
   * @example "2024-01-01"
   */
  startDate: string;
  /**
   * End date of the contract period
   * @format date
   * @example "2024-12-31"
   */
  endDate: string;
}

/** The data returned by the operation, if any */
export interface Deviation {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  chargeId?: string;
  type?: 'UNIT_PRICE' | 'QUANTITY' | 'NEW_CHARGE' | 'DOUBLE_CHARGE' | 'APPROVAL_CHECK' | 'DISCOUNT';
  subType?:
    | 'NO_MAPPING_FOUND'
    | 'CURRENCY_NOT_MATCHED'
    | 'CONTAINER_TYPE_NOT_MATCHED'
    | 'WEIGHT_RANGE_NOT_MATCHED'
    | 'DATE_RANGE_NOT_MATCHED'
    | 'TIME_RANGE_NOT_MATCHED'
    | 'SPOT_CHARGE'
    | 'NO_RATE_CARD_FOUND'
    | 'DISCOUNT_VALIDITY_MISMATCH'
    | 'DISCOUNT_NOT_CONFIGURED'
    | 'DISCOUNT_AMOUNT_MISMATCH';
  status?:
    | 'OPERATION_UNFILLED'
    | 'OPERATION_REJECTED'
    | 'OPERATION_APPROVED'
    | 'PROCUREMENT_REJECTED'
    | 'PROCUREMENT_APPROVED'
    | 'SUPPLY_CHAIN_APPROVED'
    | 'SUPPLY_CHAIN_REJECTED'
    | 'FINANCE_APPROVED'
    | 'FINANCE_REJECTED'
    | 'FINANCE_UNFILLED'
    | 'OPS_ADMIN_UNFILLED'
    | 'OPS_ADMIN_APPROVED'
    | 'OPS_ADMIN_REJECTED'
    | 'OPS_MANAGER_APPROVED'
    | 'OPS_MANAGER_REJECTED';
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  chargeDescription?: string;
  deviatedCurrency?: string;
  /** @format uuid */
  matchingContractChargeId?: string;
  contractChargeUnit?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  invoiceChargeUnit?: string;
  contractUnitPrice?: number;
  invoiceUnitPrice?: number;
  deviationAmountPerUnit?: number;
  taxPercentage?: number;
  exchangeRates?: number;
  deviationAmountBeforeTax?: number;
  deviationAmountAfterTax?: number;
  invoiceQuantity?: number;
  deviationQuantity?: number;
  autoApproved?: boolean;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string;
  /** @format date-time */
  updatedOn?: string;
  updatedBy?: string;
}

export interface ResponseDtoListDeviation {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Deviation[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Validity Period Data Transfer Object DTO. */
export interface ContractInfoDto {
  /**
   * ID of the contract flow
   * @format uuid
   */
  contractFlowId?: string;
  /** List of zones associated with the shipping service and contract */
  listZone?: ZoneDto[];
  /**
   * Start date of the contract period
   * @format date
   */
  startDate: string;
  /**
   * End date of the contract period
   * @format date
   */
  endDate: string;
  /**
   * Set of fields that do not match between the existing shipping service and the current one
   * @uniqueItems true
   */
  mismatchedFields?: string[];
}

/** Existing shipping Service Data Transfer Object DTO. */
export interface ExistingShippingServiceDto {
  /** Name of the shipper */
  shipperName?: string;
  /** Route of the shipping service */
  route?: string;
  /** Name of the consignee */
  consigneeName?: string;
  /** Billing party code */
  billingPartyCode?: string;
  /** Modality of the shipping service */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Service type */
  service?: string;
  /** Type of shipping */
  type?: string;
  /** Carrier name */
  carrier?: string;
  /** Incoterm of the shipping service */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
}

/** Matching Service Data Transfer Object DTO. */
export interface MatchingServiceDto {
  /** List of zones associated with the service */
  listZone?: ZoneDto[];
  /** Shipping zone identifier */
  shippingZone?: string;
  /** Port of Loading alias */
  polAlias?: string;
  /** Port of Discharge alias */
  podAlias?: string;
  /** Name of the shipper */
  shipperName?: string;
  /** Name of the consignee */
  consigneeName?: string;
  /** Billing party code */
  billingPartyCode?: string;
  /** Transport modality */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Service name or code */
  service?: string;
  /** Type of service */
  type?: string;
  /** Carrier name or code */
  carrier?: string;
  /** Incoterm for the shipment */
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  /**
   * Estimated date of departure
   * @format date
   */
  estimatedDepartureDate?: string;
}

/** No contract draft Data DTO. */
export interface NoContractDraftData {
  /**
   * Current step.
   * @format int32
   */
  currentStep?: number;
  /** Matching Service Data Transfer Object DTO. */
  unrecognisedShippingService?: MatchingServiceDto;
  /** Partial matching services. */
  partialMatchingServices?: PartialMatchingServiceDto[];
  /** Partial matching Service Data Transfer Object DTO. */
  selectedPartialMatchingService?: PartialMatchingServiceDto;
  /** Selected resolution option. */
  selectedResolutionOption?: string;
  /** Contract Charge lists Data Transfer Object DTO. */
  contractCharges?: ContractChargeListsDto;
  /** Rejected reason. */
  rejectedReason?: string;
}

/** No contract draft Request Data Transfer Object DTO. */
export interface NoContractDraftRequestDto {
  /** No contract draft Data DTO. */
  data?: NoContractDraftData;
}

/** Partial matching Service Data Transfer Object DTO. */
export interface PartialMatchingServiceDto {
  /** Existing shipping Service Data Transfer Object DTO. */
  existingShippingService?: ExistingShippingServiceDto;
  /** List of contract information associated with the existing shipping service */
  contractInfos?: ContractInfoDto[];
  /**
   * Set of fields that do not match between the existing shipping service and the current one
   * @uniqueItems true
   */
  mismatchedFields?: string[];
}

/** The data returned by the operation, if any */
export interface NoContractDraft {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  shipmentInvoiceId?: string;
  /** No contract draft Data DTO. */
  data?: NoContractDraftData;
  status?: 'ACTIVE' | 'DISCARDED';
  /** @format date-time */
  createdOn?: string;
  createdBy?: string;
  /** @format date-time */
  updatedOn?: string;
  updatedBy?: string;
}

export interface ResponseDtoNoContractDraft {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: NoContractDraft;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for querying service providers with filtering and pagination */
export interface ServiceProviderRequestDto {
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest?: PaginationRequest;
  /**
   * Filter by service provider IDs
   * @uniqueItems true
   */
  ids?: number[];
  /**
   * Filter by service provider names
   * @uniqueItems true
   */
  names?: string[];
  /**
   * Filter by service provider codes
   * @uniqueItems true
   */
  codes?: string[];
  /**
   * Filter by parent service provider IDs
   * @uniqueItems true
   */
  parentServiceProviderIds?: number[];
}

/** The data returned by the operation, if any */
export interface PageServiceProviderOverViewDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: ServiceProviderOverViewDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageServiceProviderOverViewDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageServiceProviderOverViewDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoServiceProviderMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ServiceProviderMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface ServiceProviderMetadataDto {
  /** Unique identifiers for service providers */
  ids?: Record<string, number>;
  /** Names of service providers */
  names?: Record<string, number>;
  /** Codes of service providers */
  codes?: Record<string, number>;
  /** Parent service provider IDs */
  parentServiceProviderIds?: Record<string, number>;
}

/** Request object for searching the universe */
export interface UniversalSearchRequest {
  /**
   * The search key to filter the results
   * @minLength 3
   * @example "INV123"
   */
  searchKey?: string;
  /**
   * Flag indicating if only approved invoices should be included, be null if user does not want to filter by invoice status
   * @example true
   */
  isApprovedInvoice?: boolean;
  /**
   * The page number for pagination
   * @format int32
   * @default 1
   * @example 1
   */
  pageNumber?: number;
  /**
   * The number of records per page for pagination, minimum is 1
   * @format int32
   * @example 10
   */
  pageSize?: number;
}

/** Page. */
export interface PageDto {
  /**
   * The page number to retrieve, starting from 0
   * @format int32
   */
  pageNumber?: number;
  /**
   * The number of items per page, must be at least 1
   * @format int32
   */
  pageSize?: number;
}

export interface ResponseDtoUniversalSearchResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Universal search Response Data Transfer Object DTO. */
  data?: UniversalSearchResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Results. */
export interface ResultRecord {
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Invoice Number. */
  invoiceNumber?: string;
  /** Invoice Status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Service Provider Name. */
  serviceProviderName?: string;
  /** Service Provider Code. */
  serviceProviderCode?: string;
  /** Modality. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /**
   * Shipment Invoice Unique identifier.
   * @format uuid
   */
  shipmentInvoiceId?: string;
  /** Shipment Number. */
  shipmentNumber?: string;
}

/** Universal search Response Data Transfer Object DTO. */
export interface UniversalSearchResponseDto {
  /**
   * Total record.
   * @format int64
   */
  totalRecord?: number;
  /** Page. */
  page?: PageDto;
  /** Results. */
  results?: ResultRecord[];
}

/** Response DTO for export job status. */
export interface ExportJobResponse {
  /** ID of the export job. */
  id?: string;
  /** Current status of the export job. */
  status?: 'PENDING' | 'GENERATING' | 'COMPLETED' | 'FAILED';
  /** File path of the exported file in cloud storage. */
  filePath?: string;
  /** Error message if the export job failed. */
  error?: string;
  /**
   * Timestamp when the export job was created.
   * @format date-time
   */
  createdOn?: string;
  /**
   * Timestamp when the export job was last updated.
   * @format date-time
   */
  updatedOn?: string;
}

export interface ResponseDtoExportJobResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response DTO for export job status. */
  data?: ExportJobResponse;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface RateCostAnalysisRequestDto {
  /** Array of shipping service IDs to filter shipments. */
  shippingServiceIds?: string[];
  /** Shipment period to analyze. All shipments with departure dates within this period will be included in the analysis. */
  shipmentPeriod: ShipmentPeriod;
  /**
   * Start date of the scenario period.
   * @format date
   */
  rateStartDate: string;
  /** Webhook URL to receive the analysis results when computation completes. If provided, the analysis will be processed asynchronously. */
  webhookUrl?: string;
}

/** Shipment period to analyze. All shipments with departure dates within this period will be included in the analysis. */
export interface ShipmentPeriod {
  /**
   * Start date of the shipment period for baseline calculations.
   * @format date
   */
  startDate: string;
  /**
   * End date of the shipment period for baseline calculations.
   * @format date
   */
  endDate: string;
}

export interface ExpectedShipmentInvoiceRequestDto {
  /**
   * ID of the invoice for which to calculate the expected charge amount.
   * @format uuid
   * @example "048439e6-1466-40a0-911b-b70504a8b036"
   */
  invoiceId: string;
  /**
   * Date to use for expected charge calculation.
   * @format date
   * @example "2024-06-01"
   */
  rateDate: string;
}

/** The data returned by the operation, if any */
export interface ExpectedShipmentInvoiceResponseDto {
  /**
   * Summary message indicating how many charges were processed without errors.
   * @example "5 out of 7 charges processed without errors."
   */
  summaryMessage?: string;
  /** Total expected shipment invoice amount before tax, in the invoice's currency, calculated based on the selected rate date and including only charges with a matching contract. */
  totalExpectedAmountBeforeTax?: number;
  /** Total expected shipment invoice amount after tax, in the invoice's currency, calculated based on the selected rate date and including only charges with a matching contract. */
  totalExpectedAmountAfterTax?: number;
  /**
   * Total estimated amount before tax for this invoice currency. This is the sum of all matched charges (expected) plus any unmatched charges (using their actual invoice amounts).
   * @example 1500
   */
  totalEstimatedAmountBeforeTax?: number;
  /**
   * Total estimated amount after tax for this invoice currency. This includes matched and unmatched charges plus applicable taxes.
   * @example 1520
   */
  totalEstimatedAmountAfterTax?: number;
  /**
   * The shipment invoice currency.
   * @example "USD"
   */
  currency?: string;
  /** List of charges without errors and expected values calculated. */
  matchedCharges?: MatchedChargeDto[];
  /** List of charges with errors (eg, contract not found), showing original charge values from shipment invoice and it's original charge currency. */
  unmatchedCharges?: UnmatchedChargeDto[];
}

/** List of charges without errors and expected values calculated. */
export interface MatchedChargeDto {
  /**
   * Unique identifier for the shipment invoice associated with this charge.
   * @example "123e4567-e89b-12d3-a456-426614174001"
   */
  shipmentInvoiceId?: string;
  /**
   * Name of the charge.
   * @example "Freight Charge"
   */
  chargeName?: string;
  /**
   * Unique identifier for the charge.
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  chargeId?: string;
  /**
   * Expected amount before tax for this charge.
   * @example 1000
   */
  expectedAmountBeforeTax?: number;
  /**
   * Expected amount after tax for this charge. If there is no exchange rate found, it will default to 0
   * @example 1070
   */
  expectedAmountAfterTax?: number;
  /**
   * Currency for this charge.
   * @example "USD"
   */
  currency?: string;
}

export interface ResponseDtoExpectedShipmentInvoiceResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ExpectedShipmentInvoiceResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** List of charges with errors (eg, contract not found), showing original charge values from shipment invoice and it's original charge currency. */
export interface UnmatchedChargeDto {
  /**
   * Unique identifier for the shipment invoice associated with this charge.
   * @example "123e4567-e89b-12d3-a456-426614174001"
   */
  shipmentInvoiceId?: string;
  /**
   * Name of the charge.
   * @example "Freight Charge"
   */
  chargeName?: string;
  /**
   * Unique identifier for the charge.
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  chargeId?: string;
  /**
   * Actual amount before tax stated in the invoice in charge currency.
   * @example 1000
   */
  actualAmountBeforeTax?: number;
  /**
   * Actual amount after tax stated in the invoice in charge currency.
   * @example 1070
   */
  actualAmountAfterTax?: number;
  /**
   * Exchange rate from charge currency to invoice currency.
   * @example 1.35
   */
  exchangeRate?: number;
  /**
   * Invoice currency for this shipment.
   * @example "EUR"
   */
  invoiceCurrency?: string;
  /**
   * Reason why this charge is unmatched, e.g. contract not found.
   * @example "Rate card not found for this charge"
   */
  reason?: string;
}

export interface ExpectedChargeForShipmentRequestDto {
  /**
   * ID of the shipment for which to calculate the expected charge amount.
   * @format uuid
   * @example "048439e6-1466-40a0-911b-b70504a8b036"
   */
  shipmentId: string;
  /**
   * Date to use for expected charge calculation which determines the rate card to be used.
   * @format date
   * @example "2024-06-01"
   */
  rateDate: string;
}

/** The data returned by the operation, if any */
export interface ExpectedChargeForShipmentResponseDto {
  /**
   * Summary message indicating how many charges were processed without errors.
   * @example "5 out of 7 charges processed without errors."
   */
  summaryMessage?: string;
  /** List of total expected amounts grouped by currency as one shipment can have multiple shipment with different shipment invoice currencies. */
  totalsByCurrency?: TotalByCurrency[];
  /** List of charges that were successfully matched with a valid rate card. */
  matchedCharges?: MatchedCharge[];
  /** List of charges that encountered errors during processing such as no rate card found or unknown charge. */
  unmatchedCharges?: UnmatchedCharge[];
}

/** List of charges that were successfully matched with a valid rate card. */
export interface MatchedCharge {
  /**
   * Unique identifier for the shipment invoice associated with this charge.
   * @example "123e4567-e89b-12d3-a456-426614174001"
   */
  shipmentInvoiceId?: string;
  /**
   * Name of the charge.
   * @example "Freight Charge"
   */
  chargeName?: string;
  /**
   * Unique identifier for the charge.
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  chargeId?: string;
  /**
   * Expected amount before tax for this charge in charge currency.
   * @example 1000
   */
  expectedAmountBeforeTax?: number;
  /**
   * Expected amount after tax for this charge in charge currency.
   * @example 1070
   */
  expectedAmountAfterTax?: number;
  /**
   * Currency for this charge.
   * @example "USD"
   */
  currency?: string;
  /**
   * Exchange rate from charge currency to invoice currency.
   * @example 1.35
   */
  exchangeRate?: number;
  /**
   * Invoice currency for this shipment.
   * @example "EUR"
   */
  invoiceCurrency?: string;
}

export interface ResponseDtoExpectedChargeForShipmentResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ExpectedChargeForShipmentResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** List of total expected amounts grouped by currency as one shipment can have multiple shipment with different shipment invoice currencies. */
export interface TotalByCurrency {
  /**
   * Total expected amount before tax for this invoice currency. This is the sum of all matched charges.
   * @example 1000
   */
  totalExpectedAmountBeforeTax?: number;
  /**
   * Total expected amount after tax for this invoice currency. This is the sum of all matched charges plus applicable taxes.
   * @example 1070
   */
  totalExpectedAmountAfterTax?: number;
  /**
   * Total estimated amount before tax for this invoice currency. This is the sum of all matched charges (expected) plus any unmatched charges (using their actual invoice amounts).
   * @example 1500
   */
  totalEstimatedAmountBeforeTax?: number;
  /**
   * Total estimated amount after tax for this invoice currency. This includes matched and unmatched charges plus applicable taxes.
   * @example 1520
   */
  totalEstimatedAmountAfterTax?: number;
  /**
   * Currency for the total amounts.
   * @example "USD"
   */
  currency?: string;
}

/** List of charges that encountered errors during processing such as no rate card found or unknown charge. */
export interface UnmatchedCharge {
  /**
   * Unique identifier for the shipment invoice associated with this charge.
   * @example "123e4567-e89b-12d3-a456-426614174001"
   */
  shipmentInvoiceId?: string;
  /**
   * Name of the charge.
   * @example "Freight Charge"
   */
  chargeName?: string;
  /**
   * Unique identifier for the charge.
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  chargeId?: string;
  /**
   * Actual amount before tax stated in the invoice in charge currency.
   * @example 1000
   */
  actualAmountBeforeTax?: number;
  /**
   * Actual amount after tax stated in the invoice in charge currency.
   * @example 1070
   */
  actualAmountAfterTax?: number;
  /**
   * Exchange rate from charge currency to invoice currency.
   * @example 1.35
   */
  exchangeRate?: number;
  /**
   * Invoice currency for this shipment.
   * @example "EUR"
   */
  invoiceCurrency?: string;
  /**
   * Reason why this charge is unmatched, e.g. contract not found.
   * @example "Rate card not found for this charge"
   */
  reason?: string;
}

export interface ExpectedChargeForUnitRequestDto {
  /**
   * ID of the charge for which to calculate the expected charge amount.
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  chargeId: string;
  /**
   * Date to use for expected charge calculation which determines the rate card to be used.
   * @format date
   * @example "2024-06-01"
   */
  rateDate: string;
}

/** The data returned by the operation, if any */
export interface ExpectedChargeForUnitResponseDto {
  /** Expected charge amount before tax in charge currency based on rate date selected. */
  expectedAmountBeforeTax?: number;
  /** Expected charge amount after tax in charge currency based on rate date selected. */
  expectedAmountAfterTax?: number;
  /**
   * The charge currency.
   * @example "USD"
   */
  currency?: string;
}

export interface ResponseDtoExpectedChargeForUnitResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ExpectedChargeForUnitResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Filters for charge and specifying the granularity: leg type, charge domain and charge name */
export interface ChargeFiltersDto {
  /**
   * Set of Leg Types to filter charges
   * @uniqueItems true
   */
  legTypeSet?: string[];
  /**
   * Set of Charge Domains to filter charges
   * @uniqueItems true
   */
  chargeDomainSet?: string[];
  /**
   * Set of Charge Names to filter charges
   * @uniqueItems true
   */
  chargeNameSet?: string[];
  /**
   * Set of Quantity Units to filter charges
   * @uniqueItems true
   */
  quantityUnitSet?: string[];
  /**
   * Set of Charge Statuses to filter charges
   * @uniqueItems true
   */
  chargeStatusSet?: string[];
  /**
   * Set of Charge Status Reasons to filter charges
   * @uniqueItems true
   */
  chargeStatusReasonSet?: string[];
}

/** Filters for selecting a date range and specifying the granularity: day, week, month, quarter, or year. */
export interface DateFiltersDto {
  /** @uniqueItems true */
  years?: string[];
  /** @uniqueItems true */
  quarters?: string[];
  /** @uniqueItems true */
  months?: string[];
  /** @uniqueItems true */
  weeks?: string[];
  /** @uniqueItems true */
  days?: string[];
}

/** The filters applied to the analytic search: date, trade lane, shipements details or billing reference */
export interface FiltersDto {
  /** Filters for selecting a date range and specifying the granularity: day, week, month, quarter, or year. */
  dateFilters?: DateFiltersDto;
  /** DTO for filtering shipments based on service provider, modality, vehicle ID, and service type */
  shipmentFilters?: ShipmentFiltersDto;
  /** Filters for trade lane and specifying the granularity: trade lane company, city hub and country */
  tradeLaneFilters?: TradeLaneFiltersDto;
  /** A list of service providers to filter the data */
  serviceProviders?: ServiceProviderDto[];
  /** Filters for charge and specifying the granularity: leg type, charge domain and charge name */
  chargeFilters?: ChargeFiltersDto;
}

/** The filters request details for the performance assessment */
export interface FiltersRequestDto {
  /** The currency reference for the invoice filters: USD, SGD or MYR */
  currencyReference?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** The invoice number to filter by */
  invoiceNumber?: string;
  /** The date reference for filtering the analytic search: pickup, delivery, invoice, invoice due or submission date */
  dateReference?: 'PICKUP_DATE' | 'DELIVERY_DATE' | 'INVOICE_DATE' | 'INVOICE_DUE_DATE' | 'SUBMISSION_DATE';
  /** The filters applied to the analytic search: date, trade lane, shipements details or billing reference */
  filters?: FiltersDto;
  /**
   * The set of invoice statuses for the analytic search: rejected, ready for payment or flagged
   * @uniqueItems true
   */
  invoiceStatusSet?: ('FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL')[];
  /**
   * The set of billed entities for the analytic search
   * @uniqueItems true
   */
  billedEntityCodeSet?: string[];
  /** DTO for filtering invoices based on various criteria such as invoice numbers, account numbers, FAP references, billed entities, and invoice reasons */
  invoiceFilters?: InvoiceFiltersDto;
}

/** DTO for filtering invoices based on various criteria such as invoice numbers, account numbers, FAP references, billed entities, and invoice reasons */
export interface InvoiceFiltersDto {
  /**
   * The set of invoice numbers for the analytic search
   * @uniqueItems true
   */
  invoiceNumberSet?: string[];
  /**
   * The set of account numbers for the analytic search
   * @uniqueItems true
   */
  accountNumberSet?: string[];
  /**
   * The set of FAP references for the analytic search
   * @uniqueItems true
   */
  fapRefSet?: string[];
  /**
   * The set of invoice reasons for the analytic search
   * @uniqueItems true
   */
  invoiceReasonSet?: string[];
  /**
   * The set of charge count for the analytic search
   * @uniqueItems true
   */
  chargeCountSet?: number[];
}

/** Filter criteria for the performance assessment savings metrics */
export interface PerformanceAssessmentKeyMetricRequestDto {
  /** The filters request details for the performance assessment */
  filtersRequest?: FiltersRequestDto;
  /** The service provider for the performance assessment */
  serviceProvider?: string;
  /** The modality for the performance assessment */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
}

/** Request containing filter criteria for volumetric table data export */
export interface PerformanceAssessmentVolumetricTableRequestDto {
  /** Filter criteria for the performance assessment savings metrics */
  performanceAssessmentRequest?: PerformanceAssessmentKeyMetricRequestDto;
  /** Page. */
  page?: PageDto;
  /** The sorting criteria for the volumetric table request */
  sort?: VolumetricSortDto;
}

/**
 * Represents a logistics or transportation service provider with which contracts are established.
 *
 * A service provider is any entity that offers transportation services and with whom rate cards
 * are negotiated for shipping goods from point A to point B. This can include various types of
 * logistics entities across the transportation hierarchy:
 *
 * - Logistics/shipping companies (e.g., DHL, FedEx, UPS)
 * - Freight forwarders who arrange transportation services
 * - Carriers who physically transport goods
 * - Third-party logistics providers (3PLs)
 * - Any other transportation service provider
 *
 * The key characteristic is that these are external entities with whom contractual agreements
 * exist for transportation services, regardless of their specific role in the supply chain.
 */
export interface ServiceProviderDto {
  /** Full legal or commercial name of the service provider */
  serviceProviderName?: string;
  /** Short internal name, code or acronym as unique identifier for the service provider, used for concise display and quick reference */
  serviceProviderCode?: string;
  /** The dominant modality (e.g., SEA, AIR) for this shipping service */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
}

/** DTO for filtering shipments based on service provider, modality, vehicle ID, and service type */
export interface ShipmentFiltersDto {
  /**
   * Set of service provider names to filter shipments
   * @uniqueItems true
   */
  serviceProviderName?: string[];
  /**
   * Set of service provider codes to filter shipments
   * @uniqueItems true
   */
  serviceProviderCode?: string[];
  /**
   * Set of modalities to filter shipments
   * @uniqueItems true
   */
  modality?: string[];
  /**
   * Set of vehicle IDs to filter shipments
   * @uniqueItems true
   */
  vehicleID?: string[];
  /**
   * Set of service types to filter shipments
   * @uniqueItems true
   */
  serviceType?: string[];
  /**
   * Set of MBLs to filter shipments
   * @uniqueItems true
   */
  mbl?: string[];
  /**
   * Set of shipper code to filter shipments
   * @uniqueItems true
   */
  shipperCodeSet?: string[];
  /**
   * Set of shipper countries to filter shipments
   * @uniqueItems true
   */
  shipperCountrySet?: string[];
  /**
   * Set of consignee code to filter shipments
   * @uniqueItems true
   */
  consigneeCodeSet?: string[];
  /**
   * Set of consignee countries to filter shipments
   * @uniqueItems true
   */
  consigneeCountrySet?: string[];
  /**
   * Set of POLs to filter shipments
   * @uniqueItems true
   */
  polSet?: string[];
  /**
   * Set of PODs to filter shipments
   * @uniqueItems true
   */
  podSet?: string[];
  /**
   * Set of shipment current deviation workflows to filter shipments
   * @uniqueItems true
   */
  shipmentCurrentDeviationWorkflowSet?: (
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW'
  )[];
  /**
   * Set of goods name to filter shipments
   * @uniqueItems true
   */
  goodsNameSet?: string[];
  /**
   * Set of shipment numbers to filter shipments
   * @uniqueItems true
   */
  shipmentNumberSet?: string[];
  /**
   * Set of shipment statuses to filter shipments
   * @uniqueItems true
   */
  shipmentStatusSet?: string[];
  /**
   * Set of shipment status reasons to filter shipments
   * @uniqueItems true
   */
  shipmentStatusReasonSet?: string[];
  /**
   * Set of charge counts for invoices and shipments to filter shipments
   * @uniqueItems true
   */
  chargeCountSet?: number[];
}

/** Filters for trade lane and specifying the granularity: trade lane company, city hub and country */
export interface TradeLaneFiltersDto {
  /** @uniqueItems true */
  tradeLaneCompany?: string[];
  /** @uniqueItems true */
  tradeLaneCityHub?: string[];
  /** @uniqueItems true */
  tradeLaneCountry?: string[];
}

/** The sorting criteria for the volumetric table request */
export interface VolumetricSortDto {
  field?:
    | 'VOLUMETRIC_MONTH'
    | 'VOLUMETRIC_TOTAL_AMOUNT'
    | 'GROSS_WEIGHT'
    | 'CHARGEABLE_WEIGHT'
    | 'VOLUME'
    | 'CO2_EMISSIONS'
    | 'VOLUMETRIC_SHIPMENTS_COUNT'
    | 'VOLUMETRIC_AUDITED';
  direction?: 'ASC' | 'DESC';
}

/** Monthly volumetric performance data containing weights, volumes, and emission information */
export interface PerformanceVolumetricTableDto {
  /** The month for which the volumetric data is provided (e.g., 'January 2024') */
  month?: string;
  /** Total amount processed during the month */
  totalAmount?: number;
  /** Total gross weight processed during the month (in kg) */
  grossWeight?: number;
  /** Total chargeable weight processed during the month (in kg) */
  chargeableWeight?: number;
  /** Total volume processed during the month (in cubic meters) */
  volume?: number;
  /** Total CO2 emissions generated during the month (in kg) */
  co2Emissions?: number;
  /**
   * Number of shipments processed during the month
   * @format int64
   */
  shipmentsCount?: number;
  /** Percentage of audited records for the month */
  audited?: number;
}

/** Response DTO containing paginated volumetric performance data organized by month */
export interface PerformanceVolumetricTableResponseDto {
  /** Page. */
  page?: PageDto;
  /**
   * Total count of volumetric records available
   * @format int64
   */
  total?: number;
  /** List of volumetric performance data organized by month */
  volumetricMonthWiseData?: PerformanceVolumetricTableDto[];
}

export interface ResponseDtoPerformanceVolumetricTableResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response DTO containing paginated volumetric performance data organized by month */
  data?: PerformanceVolumetricTableResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoVolumetricResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response DTO containing volumetric performance metrics */
  data?: VolumetricResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Generic volumetric data container with total value, price per unit, and unit per shipment */
export interface VolumetricAmount {
  /** Amount DTO. */
  totalValue?: Amount;
  /** Amount DTO. */
  pricePerUnit?: Amount;
  /** Amount DTO. */
  unitPerShipment?: Amount;
}

/** Generic volumetric data container with total value, price per unit, and unit per shipment */
export interface VolumetricBigDecimal {
  /** Total aggregated value for the volumetric metric */
  totalValue?: number;
  /** Price or cost per unit of the volumetric metric */
  pricePerUnit?: number;
  /** Number of units per shipment for the volumetric metric */
  unitPerShipment?: number;
}

/** Response DTO containing volumetric performance metrics */
export interface VolumetricResponseDto {
  /** Generic volumetric data container with total value, price per unit, and unit per shipment */
  totalCo2Emissions?: VolumetricBigDecimal;
  /** Generic volumetric data container with total value, price per unit, and unit per shipment */
  chargeableWeight?: VolumetricBigDecimal;
  /** Generic volumetric data container with total value, price per unit, and unit per shipment */
  grossWeight?: VolumetricBigDecimal;
  /** Generic volumetric data container with total value, price per unit, and unit per shipment */
  volume?: VolumetricBigDecimal;
  /** Generic volumetric data container with total value, price per unit, and unit per shipment */
  askedAmount?: VolumetricAmount;
}

/** Filter criteria for the performance assessment savings metrics */
export interface PerformanceAssessmentKeyMetricForAllRequestDto {
  /** The filters request details for the performance assessment */
  filtersRequest?: FiltersRequestDto;
  /** The modality for the performance assessment */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
}

export interface ResponseDtoListServiceProviderVolumetricResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ServiceProviderVolumetricResponseDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Response DTO containing service provider code and volumetric performance metrics */
export interface ServiceProviderVolumetricResponseDto {
  /** Service provider code */
  serviceProvider?: string;
  /** Response DTO containing volumetric performance metrics */
  volumetricResponseDto?: VolumetricResponseDto;
}

/** Request containing filter criteria for savings table data export */
export interface PerformanceAssessmentSavingsTableRequestDto {
  /** Filter criteria for the performance assessment savings metrics */
  performanceAssessmentRequest?: PerformanceAssessmentKeyMetricRequestDto;
  /** Page. */
  page?: PageDto;
  /** The sorting criteria for the savings table request */
  sort?: SavingsSortDto;
}

/** The sorting criteria for the savings table request */
export interface SavingsSortDto {
  /** The field to sort by */
  field?: 'MONTH' | 'TOTAL_AMOUNT' | 'DEVIATIONS' | 'SAVINGS' | 'SHIPMENTS_COUNT' | 'INVOICES_COUNT' | 'CHARGE_LINES_COUNT' | 'AUDITED';
  /** The direction of sorting */
  direction?: 'ASC' | 'DESC';
}

/** Monthly savings performance data containing amounts, counts, and audit information */
export interface PerformanceSavingsTableDto {
  /** The month for which the savings data is provided (e.g., 'January 2024') */
  month?: string;
  /** Total amount processed during the month */
  totalAmount?: number;
  /** Total deviations identified during the month */
  deviations?: number;
  /** Total savings achieved during the month */
  savings?: number;
  /**
   * Number of shipments processed during the month
   * @format int64
   */
  shipmentsCount?: number;
  /**
   * Number of invoices processed during the month
   * @format int64
   */
  invoicesCount?: number;
  /**
   * Number of charge lines processed during the month
   * @format int64
   */
  chargeLinesCount?: number;
  /** Percentage of audited records for the month */
  audited?: number;
}

/** Response DTO containing paginated savings performance data organized by month */
export interface PerformanceSavingsTableResponseDto {
  /** Page. */
  page?: PageDto;
  /**
   * Total count of savings records available
   * @format int64
   */
  total?: number;
  /** List of savings performance data organized by month */
  savingsMonthWiseData?: PerformanceSavingsTableDto[];
}

export interface ResponseDtoPerformanceSavingsTableResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response DTO containing paginated savings performance data organized by month */
  data?: PerformanceSavingsTableResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSavingsMetricResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response DTO containing savings metrics */
  data?: SavingsMetricResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Savings metric data with before/after audit comparison and percentage calculations */
export interface SavingMetricAmountBigDecimal {
  /** Amount DTO. */
  beforeAudit?: Amount;
  /** Amount DTO. */
  afterAudit?: Amount;
  /** Amount DTO. */
  deviations?: Amount;
  /** Amount DTO. */
  savings?: Amount;
  /** Percentage change in amount after audit */
  amountPercentage?: number;
  /** Percentage of deviations relative to total */
  deviationPercentage?: number;
  /** Percentage of savings achieved relative to total */
  savingsPercentage?: number;
}

/** Savings metric data with before/after audit comparison and percentage calculations */
export interface SavingMetricLongBigDecimal {
  /**
   * Value before audit was conducted
   * @format int64
   */
  beforeAudit?: number;
  /**
   * Value after audit was conducted
   * @format int64
   */
  afterAudit?: number;
  /**
   * Total deviations identified during audit
   * @format int64
   */
  deviations?: number;
  /**
   * Total savings achieved through audit process
   * @format int64
   */
  savings?: number;
  /** Percentage change in amount after audit */
  amountPercentage?: number;
  /** Percentage of deviations relative to total */
  deviationPercentage?: number;
  /** Percentage of savings achieved relative to total */
  savingsPercentage?: number;
}

/** Response DTO containing savings metrics */
export interface SavingsMetricResponseDto {
  /** Savings metric data with before/after audit comparison and percentage calculations */
  amount?: SavingMetricAmountBigDecimal;
  /** Savings metric data with before/after audit comparison and percentage calculations */
  shipments?: SavingMetricLongBigDecimal;
  /** Savings metric data with before/after audit comparison and percentage calculations */
  invoices?: SavingMetricLongBigDecimal;
  /** Savings metric data with before/after audit comparison and percentage calculations */
  chargeLines?: SavingMetricLongBigDecimal;
}

export interface ResponseDtoListServiceProviderSavingsMetricResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ServiceProviderSavingsMetricResponseDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Response DTO containing service provider and savings metrics */
export interface ServiceProviderSavingsMetricResponseDto {
  /** Service provider code */
  serviceProvider?: string;
  /** Response DTO containing savings metrics */
  savingsMetricResponseDto?: SavingsMetricResponseDto;
}

export interface ResponseDtoLegalEntityDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  data?: LegalEntityDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request Object for retrieving filtered legal entities with multiple filtering options and pagination support */
export interface LegalEntityRequestDto {
  /**
   * Filter by specific legal entity unique identifiers. Use this to retrieve specific legal entities by their database IDs.
   * @uniqueItems true
   * @example [1001,1002,1003]
   */
  ids?: number[];
  /**
   * Filter by legal entity names. Supports multiple names for batch filtering. Case-sensitive matching.
   * @uniqueItems true
   * @example ["Tetrixx Singapore Pte Ltd","Tetrixx Malaysia Sdn Bhd","Tetrixx Holdings Corp"]
   */
  names?: string[];
  /**
   * Filter by legal entity codes. These are typically short alphanumeric identifiers assigned to each legal entity.
   * @uniqueItems true
   * @example ["SG001","MY002","US003"]
   */
  codes?: string[];
  /**
   * Search by name or code using case-insensitive partial match (LIKE). Matches any legal entity whose name OR code contains this value.
   * @example "Tetrixx"
   */
  nameOrCode?: string;
  /**
   * Filter by national currencies associated with the legal entities. Use standard ISO 4217 currency codes.
   * @uniqueItems true
   * @example ["SGD","MYR","USD"]
   */
  nationalCurrencies?: string[];
  /**
   * Filter by billing status. True indicates entities that are actively billed, false for non-billed entities.
   * @uniqueItems true
   * @example [true,false]
   */
  isBilledEntities?: boolean[];
  /**
   * Filter by parent entity IDs. Use this to find all subsidiaries or child entities under specific parent legal entities.
   * @uniqueItems true
   * @example [500,501,502]
   */
  parentIds?: number[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageLegalEntityDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: LegalEntityDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageLegalEntityDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageLegalEntityDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface LegalEntityMetadataDto {
  /** Unique identifiers for legal entities */
  ids?: Record<string, number>;
  /** Names of legal entities */
  names?: Record<string, number>;
  /** Codes of legal entities */
  codes?: Record<string, number>;
  /** National currencies of legal entities */
  nationalCurrencies?: Record<string, number>;
  /** Indicates if the legal entities are billed */
  isBilledEntities?: Record<string, number>;
  /** Parent entity IDs of legal entities */
  parentIds?: Record<string, number>;
}

export interface ResponseDtoLegalEntityMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: LegalEntityMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for analytic search queries */
export interface AnalyticSearchRequestDto {
  /** The currency reference for the analytic search: USD, SGD or MYR */
  currencyReference?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** The granularity level for the analytic search: daily, weekly, monthly, quaterly or yearly */
  granularity:
    | 'QUARTERLY'
    | 'MONTHLY'
    | 'WEEKLY'
    | 'DAILY'
    | 'YEARLY'
    | 'SERVICE_PROVIDER_NAME'
    | 'SERVICE_PROVIDER_CODE'
    | 'MODALITY'
    | 'VEHICLE_ID'
    | 'COUNTRY'
    | 'CITY_HUB'
    | 'COMPANY'
    | 'LEG_TYPE'
    | 'CHARGE_DOMAIN';
  /** The sorting order for the analytic search results: ascending or descending */
  sortingOrder?: 'ASC' | 'DESC';
  /** The date reference for filtering the analytic search: pickup, delivery, invoice, invoice due or submission date */
  dateReference?: 'PICKUP_DATE' | 'DELIVERY_DATE' | 'INVOICE_DATE' | 'INVOICE_DUE_DATE' | 'SUBMISSION_DATE';
  /** The filters applied to the analytic search: date, trade lane, shipements details or billing reference */
  filters?: FiltersDto;
  /**
   * The set of invoice statuses for the analytic search: rejected, ready for payment or flagged
   * @uniqueItems true
   */
  invoiceStatusSet?: ('FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL')[];
  /**
   * The set of invoice numbers for the analytic search
   * @uniqueItems true
   */
  invoiceNumberSet?: string[];
  /**
   * The set of account numbers for the analytic search
   * @uniqueItems true
   */
  accountNumberSet?: string[];
  /**
   * The set of FAP references for the analytic search
   * @uniqueItems true
   */
  fapRefSet?: string[];
  /**
   * The set of billed entities for the analytic search
   * @uniqueItems true
   */
  billedEntityCodeSet?: string[];
  /**
   * The set of invoice reasons for the analytic search
   * @uniqueItems true
   */
  invoiceReasonSet?: string[];
  /**
   * The set of charge counts for invoices
   * @uniqueItems true
   */
  chargeCountSet?: number[];
}

/** The aggregated key metrics data provided base on the filters applied by the user */
export interface KeyMetricsAggregatedDto {
  /** Amount DTO. */
  totalAmount?: Amount;
  /** Amount DTO. */
  totalDeviationAmount?: Amount;
  /** Total CO2 emissions (in tons) for the aggregated data */
  totalCo2Emissions?: number;
  /** Total chargeable weight (in kg) for the aggregated data, used to calculate freight charges */
  chargeableWeight?: number;
  /** Total gross weight (in kg) for the aggregated data, including all packaging and contents */
  grossWeight?: number;
  /** Total cargo volume (in m3) for the aggregated data */
  volume?: number;
  /**
   * Total number of shipments in the aggregated data
   * @format int64
   */
  noShipments?: number;
  /**
   * Total number of charges in the aggregated data
   * @format int64
   */
  noCharges?: number;
  /**
   * Total number of invoices in the aggregated data
   * @format int64
   */
  noInvoices?: number;
  /**
   * Total numbers of deviations in the aggregated data
   * @format int64
   */
  noDeviations?: number;
  /**
   * Total number of NRCF shipments in the aggregated data
   * @format int64
   */
  nrcfShipmentCount?: number;
  /** Amount DTO. */
  nrcfShipmentAmount?: Amount;
  /**
   * Total number of unit price deviations in the aggregated data
   * @format int64
   */
  unitPriceDeviationCount?: number;
  /** Amount DTO. */
  unitPriceDeviationAmount?: Amount;
  /**
   * Total number of quantity deviations in the aggregated data
   * @format int64
   */
  quantityDeviationCount?: number;
  /** Amount DTO. */
  quantityDeviationAmount?: Amount;
  /**
   * Total number of unknown charge deviations in the aggregated data
   * @format int64
   */
  unknownChargeDeviationCount?: number;
  /** Amount DTO. */
  unknownChargeDeviationAmount?: Amount;
  /**
   * Total number of accessorial approvals in the aggregated data
   * @format int64
   */
  accessorialApprovalCount?: number;
  /**
   * Total number of service type approvals in the aggregated data
   * @format int64
   */
  serviceTypeApprovalCount?: number;
}

/** The metadata for the key metrics */
export interface KeyMetricsMetaDto {
  currency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  grossWeightUnit?: string;
  chargeableWeightUnit?: string;
  co2EmissionUnit?: string;
  volumeUnit?: string;
}

/** The data returned by the operation, if any */
export interface KeyMetricsResponseDto {
  /** The aggregated key metrics data provided base on the filters applied by the user */
  keymetrics?: KeyMetricsAggregatedDto;
  /** The metadata for the key metrics */
  meta?: KeyMetricsMetaDto;
}

export interface ResponseDtoKeyMetricsResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: KeyMetricsResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice search Request Data Transfer Object DTO. */
export interface InvoiceSearchRequestDto {
  /**
   * Invoice number to filter the search results.
   * @uniqueItems true
   */
  invoiceNumber?: string[];
  /** Enumeration representing different categories of invoice statuses for filtering and organization. */
  invoiceStatusCategory?: 'ALL' | 'ACTION_NEEDED';
  /** Reference enum for filtering by date. */
  dateReference?: 'PICKUP_DATE' | 'DELIVERY_DATE' | 'INVOICE_DATE' | 'INVOICE_DUE_DATE' | 'SUBMISSION_DATE';
  /** The filters applied to the analytic search: date, trade lane, shipements details or billing reference */
  searchFilters?: FiltersDto;
  /**
   * Set of possible invoice statuses to filter by.
   * @uniqueItems true
   */
  invoiceStatusSet?: ('FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL')[];
  /**
   * Set of shipment types to filter by.
   * @uniqueItems true
   */
  shipmentType?: string[];
  /**
   * Set of shipment numbers to filter by.
   * @uniqueItems true
   */
  shipmentNumber?: string[];
  /**
   * Set of trade lanes to filter by.
   * @uniqueItems true
   */
  tradeLane?: string[];
  /**
   * Set of billed entities to filter by.
   * @uniqueItems true
   */
  billedEntity?: string[];
  /**
   * Set of incoterms to filter by.
   * @uniqueItems true
   */
  incoterm?: ('EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP')[];
  /**
   * Set of shippers to filter by.
   * @uniqueItems true
   */
  shipper?: string[];
  /**
   * Set of consignees to filter by.
   * @uniqueItems true
   */
  consignee?: string[];
  /**
   * Set of services to filter by.
   * @uniqueItems true
   */
  service?: string[];
  /**
   * Set of dates to filter by.
   * @uniqueItems true
   */
  date?: string[];
  /**
   * Set of invoice IDs to filter by.
   * @uniqueItems true
   */
  invoiceId?: string[];
  /** Reference to the currency used in the invoice. */
  currencyReference?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** Page. */
  page?: PageDto;
  /** Sort Data Transfer Object DTO. */
  sorting?: SortDto;
}

/** Sort Data Transfer Object DTO. */
export interface SortDto {
  /** Field. */
  field?:
    | 'INVOICE_STATUS'
    | 'INVOICE_NUMBER'
    | 'INVOICE_DATE'
    | 'INVOICE_DUE_DATE'
    | 'PICKUP_DATE'
    | 'DELIVERY_DATE'
    | 'SUBMISSION_DATE'
    | 'SHIPMENTS'
    | 'TRADE_LANES'
    | 'SERVICES'
    | 'TOTAL_AMOUNT'
    | 'MBL_HBL'
    | 'SHIPMENT_TYPE'
    | 'DEVIATION_AMOUNT'
    | 'INCOTERM'
    | 'BILLED_ENTITY'
    | 'SHIPPER'
    | 'CONSIGNEE';
  /** Sorting direction. */
  sortingDirection?: 'ASC' | 'DESC';
}

export interface ResponseDtoMapStringBoolean {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, boolean>;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice search Response Data Transfer Object DTO. */
export interface InvoiceSearchResponse {
  /** Enumeration representing different categories of invoice statuses for filtering and organization. */
  invoiceStatusCategory?: 'ALL' | 'ACTION_NEEDED';
  /**
   * Total record.
   * @format int64
   */
  totalRecord?: number;
  /** Page. */
  page?: PageDto;
  /** Invoices. */
  invoices?: InvoiceSearchResult[];
}

/** Invoice search result containing comprehensive invoice details */
export interface InvoiceSearchResult {
  /**
   * Unique identifier for the invoice
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id?: string;
  /** The aggregate shipment type of the invoice. */
  aggregateShipmentType?: 'IMPORT' | 'EXPORT' | 'MULTI';
  /**
   * Unique invoice number identifier
   * @example "INV-2024-001"
   */
  invoiceNumber?: string;
  /**
   * Shipment number for tracking or shipment counter
   * @example "SHIP-001"
   */
  shipmentNumber?: string;
  /**
   * Trade lane display information, such as origin and destination
   * @example "SG / MY"
   */
  tradeLane?: string;
  /**
   * Service provider information, such as freight forwarder
   * @example "Freight Forwarder Inc."
   */
  service?: string;
  /** Incoterm information, shows counter if multiple. */
  incoterm?: string;
  /** Billed entity information, shows counter if multiple. */
  billedEntity?: string;
  /** Shipper information, shows counter if multiple. */
  shipper?: string;
  /** Consignee information, shows counter if multiple. */
  consignee?: string;
  /** Total deviation amount for the invoice. */
  deviationAmount?: number;
  /**
   * Total invoice amount
   * @example 1250.75
   */
  totalAmount?: number;
  /**
   * Current status of the invoice
   * @example "PENDING_APPROVAL"
   */
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Indicates if the invoice file is currently under processing. */
  isFileProcessing?: boolean;
  /** Indicates if the invoice has a responsible workflow. */
  hasResponsibleWorkflow?: boolean;
  /** Indicates if any shipment invoice has SPOT_SHIPMENT status. */
  hasSpotShipment?: boolean;
  /** Invoice Status overview Data Transfer Object DTO. */
  invoiceStatusOverview?: InvoiceStatusOverviewDto;
  /**
   * Service provider ID associated with the invoice.
   * @format int64
   */
  serviceProviderId?: number;
  /** List of modalities associated with the invoice. */
  modalities?: string[];
  /**
   * Date associated with the invoice, such as creation date or shipment date
   * @format date
   */
  date?: string;
}

export interface ResponseDtoInvoiceSearchResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice search Response Data Transfer Object DTO. */
  data?: InvoiceSearchResponse;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice metadata response containing statistical information and allowed currencies */
export interface InvoiceMetadataResponseDto {
  /** Invoice Status category stats Data Transfer Object DTO. */
  stats?: InvoiceStatusCategoryStatsDto;
  /**
   * Set of currencies allowed for invoice operations
   * @uniqueItems true
   */
  allowedCurrencies?: (
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW'
  )[];
}

/** Invoice Status category stats Data Transfer Object DTO. */
export interface InvoiceStatusCategoryStatsDto {
  /**
   * Action needed.
   * @format int64
   */
  actionNeeded?: number;
  /**
   * All.
   * @format int64
   */
  all?: number;
}

export interface ResponseDtoInvoiceMetadataResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice metadata response containing statistical information and allowed currencies */
  data?: InvoiceMetadataResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Metadata for invoice search results, including counts by various fields. */
export interface InvoiceSearchMetadataDto {
  /** Counts by shipment type. */
  shipmentTypeCounts?: Record<string, number>;
  /** Counts by invoice number. */
  invoiceNumberCounts?: Record<string, number>;
  /** Counts by shipment number with spot shipment metadata. */
  shipmentNumberCounts?: ShipmentNumberCounter[];
  /** Counts by trade lane. */
  tradeLaneCounts?: Record<string, number>;
  /** Counts by invoice status. */
  statusCounts?: Record<string, number>;
  /** Counts by billed entity. */
  billedEntityCounts?: Record<string, number>;
  /** Counts by incoterm. */
  incotermCounts?: Record<string, number>;
  /** Counts by shipper. */
  shipperCounts?: Record<string, number>;
  /** Counts by consignee. */
  consigneeCounts?: Record<string, number>;
  /** Counts by service. */
  serviceCounts?: Record<string, number>;
  /** Counts by date (e.g., invoice date). */
  dateCounts?: Record<string, number>;
}

export interface ResponseDtoInvoiceSearchMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Metadata for invoice search results, including counts by various fields. */
  data?: InvoiceSearchMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Shipment number counter with spot shipment metadata. */
export interface ShipmentNumberCounter {
  /** The filter value. */
  value?: string;
  /**
   * The count of items matching this filter value.
   * @format int64
   */
  count?: number;
  /** Indicates if any shipment invoice for this shipment has SPOT_SHIPMENT status. */
  hasSpotShipment?: boolean;
}

/** Generic filter value with its count. */
export interface FilterValueCounterObject {
  /** The filter value. */
  value?: object;
  /**
   * The count of items matching this filter value.
   * @format int64
   */
  count?: number;
}

/** Response containing metadata for a single invoice search column. */
export interface InvoiceSearchSingleColumnMetadataDto {
  /** Available metadata columns for invoice search filtering */
  column?:
    | 'INVOICE_NUMBER'
    | 'STATUS'
    | 'BILLED_ENTITY'
    | 'INCOTERM'
    | 'SHIPPER'
    | 'CONSIGNEE'
    | 'SERVICE'
    | 'SHIPMENT_TYPE'
    | 'TRADE_LANE'
    | 'SHIPMENT_NUMBER'
    | 'DATE';
  /** Counts by the specified column. For simple string-based columns. */
  counts?: Record<string, number>;
  /** Detailed counts with additional metadata. Used for columns that need extra information beyond just counts. */
  detailedCounts?: FilterValueCounterObject[];
}

export interface ResponseDtoInvoiceSearchSingleColumnMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response containing metadata for a single invoice search column. */
  data?: InvoiceSearchSingleColumnMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListInvoiceSearchResult {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceSearchResult[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice upload signed URL Request Data Transfer Object DTO. */
export interface InvoiceUploadSignedUrlRequestDto {
  /**
   * File names.
   * @uniqueItems true
   */
  fileNames: string[];
  /** Modality. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Service Provider Name. */
  serviceProviderName?: string;
  /** Service Provider Code. */
  serviceProviderCode?: string;
  /**
   * Batch Unique identifier.
   * @format uuid
   */
  batchId?: string;
}

/** Invoice upload signed URL Data Transfer Object DTO. */
export interface InvoiceUploadSignedUrlDto {
  /** File Name. */
  fileName?: string;
  /** Pre signed u r ls. */
  preSignedURLs?: string;
  /** String. */
  headers?: Record<string, string>;
  /**
   * Data pipeline processing Unique identifier.
   * @format uuid
   */
  dataPipelineProcessingId?: string;
}

/** The data returned by the operation, if any */
export interface InvoiceUploadSignedUrlResponseDto {
  uploadUrls?: InvoiceUploadSignedUrlDto[];
  /** @format uuid */
  batchId?: string;
}

export interface ResponseDtoInvoiceUploadSignedUrlResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceUploadSignedUrlResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice attachment upload signed URL Request Data Transfer Object DTO. */
export interface InvoiceAttachmentUploadSignedUrlRequestDto {
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId: string;
  /** File Name. */
  fileName: string;
  /** Attachment Type. */
  attachmentType: 'APPROVAL' | 'RATE_CARD' | 'CREDIT_NOTE' | 'ADDITIONAL_ATTACHMENT' | 'PURCHASE_ORDER' | 'QUOTATION';
}

/** Set fap ref Request DTO. */
export interface SetFapRefRequest {
  /** Invoice ids. */
  invoiceIds?: string[];
  /** Fap ref. */
  fapRef?: string;
}

/** Searching Invoice file processing Request DTO. */
export interface SearchingInvoiceFileProcessingRequest {
  /** Ids. */
  ids?: string[];
  /**
   * From.
   * @format date-time
   */
  from?: string;
  /**
   * To.
   * @format date-time
   */
  to?: string;
  /** Statuses. */
  statuses?: (
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE'
  )[];
  /** File resolution statuses. */
  fileResolutionStatuses?: ('REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED')[];
  /**
   * Page.
   * @format int32
   */
  page?: number;
  /**
   * Size.
   * @format int32
   */
  size?: number;
  /** Sorting colum. */
  sortingColum?: string;
  /** Sorting direction. */
  sortingDirection?: 'ASC' | 'DESC';
}

/** Internal dashboard table Response Data Transfer Object DTO. */
export interface InternalDashboardTableResponseDtoInvoiceFileProcessingDto {
  /** Internal dashboard table stats Data Transfer Object DTO. */
  tableStats?: InternalDashboardTableStatsDto;
  tableData?: PageInvoiceFileProcessingDto;
}

/** Internal dashboard table stats Data Transfer Object DTO. */
export interface InternalDashboardTableStatsDto {
  /**
   * Action needed.
   * @format int64
   */
  actionNeeded?: number;
  /**
   * All issues.
   * @format int64
   */
  allIssues?: number;
  /**
   * All files.
   * @format int64
   */
  allFiles?: number;
}

export interface PageInvoiceFileProcessingDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: InvoiceFileProcessingDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoInternalDashboardTableResponseDtoInvoiceFileProcessingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Internal dashboard table Response Data Transfer Object DTO. */
  data?: InternalDashboardTableResponseDtoInvoiceFileProcessingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface InvoiceDataPipelineConfigDto {
  /**
   * The unique identifier of the invoice data pipeline configuration.
   * @format uuid
   */
  id?: string;
  /** The ID of the data pipeline configuration. */
  dataPipelineConfigId?: string;
  /**
   * The timestamp when the configuration was last updated.
   * @format date-time
   */
  updatedOn?: string;
  /** The ID of the model associated with the configuration. */
  modelId?: string;
  /** Indicates whether the configuration is active. */
  active?: boolean;
}

export interface ResponseDtoInvoiceDataPipelineConfigDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: InvoiceDataPipelineConfigDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface InvoiceDataPipelineConfigRequestDto {
  /** The list of model IDs for the invoice data pipeline configuration request. */
  modelIds?: string[];
  /** The list of data pipeline configuration IDs for the invoice data pipeline configuration request. */
  dataPipelineConfigIds?: string[];
  /** The list of active statuses for the invoice data pipeline configuration request. */
  activeStatuses?: boolean[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest?: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageInvoiceDataPipelineConfigDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: InvoiceDataPipelineConfigDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageInvoiceDataPipelineConfigDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageInvoiceDataPipelineConfigDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface InvoiceDataPipelineConfigMetadataDto {
  /** The list of model IDs associated with the invoice data pipeline configuration. */
  modelIds?: Record<string, number>;
  /** The list of data pipeline configuration IDs associated with the invoice data pipeline configuration. */
  dataPipelineConfigIds?: Record<string, number>;
  /** The list of active configurations and non-active configurations associated with the invoice data pipeline configuration. */
  activeStatuses?: Record<string, number>;
}

export interface ResponseDtoInvoiceDataPipelineConfigMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceDataPipelineConfigMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface FilterInvoiceChargeDomainMappingReq {
  serviceProviderCodes?: string[];
  invoiceChargeNames?: string[];
  chargeDomains?: (
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE'
  )[];
  chargeSubDomains?: string[];
  legTypes?: ('LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB')[];
  contractChargeUnits?: ('SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE')[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageInvoiceChargeDomainMappingDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: InvoiceChargeDomainMappingDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageInvoiceChargeDomainMappingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageInvoiceChargeDomainMappingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object for invoice charge domain mapping metadata, containing aggregated counters for various invoice charge domain mapping properties. */
export interface InvoiceChargeDomainMappingMetadataDto {
  /** Map where keys are service provider codes and values are their respective counts. */
  serviceProviderCodes?: Record<string, number>;
  /** Map where keys are invoice charge names and values are their respective counts. */
  invoiceChargeNames?: Record<string, number>;
  /** Map where keys are charge domains and values are their respective counts. */
  chargeDomains?: Record<string, number>;
  /** Map where keys are charge sub domains and values are their respective counts. */
  chargeSubDomains?: Record<string, number>;
  /** Map where keys are leg types and values are their respective counts. */
  legTypes?: Record<string, number>;
  /** Map where keys are contract charge units and values are their respective counts. */
  contractChargeUnits?: Record<string, number>;
}

export interface ResponseDtoInvoiceChargeDomainMappingMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object for invoice charge domain mapping metadata, containing aggregated counters for various invoice charge domain mapping properties. */
  data?: InvoiceChargeDomainMappingMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface FiltersDataDto {
  /**
   * The currency reference for the invoice filters: USD, SGD or MYR
   * @uniqueItems true
   */
  allowedCurrencies?: (
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW'
  )[];
  /** The filters applied to the analytic search: date, trade lane, shipements details or billing reference */
  filters?: FiltersDto;
}

export interface ResponseDtoFiltersDataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: FiltersDataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface FilterFileResolutionRequest {
  invoiceFileProcessingIds?: string[];
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  fileResolutionStatuses?: ('REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED')[];
  isAssign?: boolean;
  assigneeIds?: string[];
  /** @format int32 */
  page?: number;
  /** @format int32 */
  size?: number;
  isUnresolvedStatus?: boolean;
  sortingColum?: string;
  sortingDirection?: 'ASC' | 'DESC';
}

/** Getting file resolution Data Transfer Object DTO. */
export interface GettingFileResolutionDto {
  modality?: string;
  extractedPage?: string;
  modelUsed?: string;
  transformerUsed?: string;
  invoiceNumber?: string;
  serviceProviderName?: string;
  billedEntity?: string;
  /**
   * Unique identifier.
   * @format int32
   */
  id?: number;
  /** Resolution Type. */
  resolutionType?: 'ISUSR' | 'ISSYS';
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Resolution Status. */
  resolutionStatus?: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
  /** Custom details of the current file processing status */
  statusDetails?: string;
  /** Resolution message. */
  resolutionMessage?: string;
  /** User message. */
  userMessage?: string;
  /**
   * Assignee Unique identifier.
   * @format uuid
   */
  assigneeId?: string;
  /** Assignee first Name. */
  assigneeFirstName?: string;
  /** Assignee last Name. */
  assigneeLastName?: string;
  /**
   * Resolution Creation timestamp on.
   * @format date-time
   */
  resolutionCreatedOn?: string;
  /** Resolution Creation timestamp by. */
  resolutionCreatedBy?: string;
  /**
   * Resolution Last update timestamp on.
   * @format date-time
   */
  resolutionUpdatedOn?: string;
  /**
   * Invoice file processing Unique identifier.
   * @format uuid
   */
  invoiceFileProcessingId?: string;
  /** File Name. */
  fileName?: string;
  /** Invoice file processing Status. */
  invoiceFileProcessingStatus?:
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE';
  /** Invoice file processing message. */
  invoiceFileProcessingMessage?: string;
  /**
   * Batch Unique identifier.
   * @format uuid
   */
  batchId?: string;
  /** Reporter first Name. */
  reporterFirstName?: string;
  /** Reporter last Name. */
  reporterLastName?: string;
  /** Invoice Status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Resolution Code. */
  resolutionCode?: string;
  /** Current deviation Workflow. */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /**
   * Shipment Invoice Unique identifier.
   * @format uuid
   */
  shipmentInvoiceId?: string;
}

/** Internal dashboard table Response Data Transfer Object DTO. */
export interface InternalDashboardTableResponseDtoGettingFileResolutionDto {
  /** Internal dashboard table stats Data Transfer Object DTO. */
  tableStats?: InternalDashboardTableStatsDto;
  tableData?: PageGettingFileResolutionDto;
}

export interface PageGettingFileResolutionDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: GettingFileResolutionDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoInternalDashboardTableResponseDtoGettingFileResolutionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Internal dashboard table Response Data Transfer Object DTO. */
  data?: InternalDashboardTableResponseDtoGettingFileResolutionDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface FileClassificationEmbeddingCreateRequest {
  /**
   * Unique identifier of the file classification embedding. This is optional and can be used for update functionality.
   * @format uuid
   */
  id?: string;
  /**
   * Unique identifier of the invoice file processing associated with this embedding
   * @format uuid
   */
  invoiceFileProcessingId: string;
  /** The text content extracted from the file page used to generate the embedding */
  textContent: string;
  /** The embedding vector representing the content of the file. This is a vector of floats with a fixed dimension defined by EMBEDDING_VECTOR_DIMENSION. */
  embeddingVector: number[];
  /** The name of the model used to generate the embedding */
  modelName: string;
  /** The name of the tokenizer used to preprocess the text before generating the embedding */
  tokenizerName: string;
  /**
   * The page number of the document from which this embedding was generated
   * @format int32
   */
  pageNumber: number;
  /** The classification label associated with this embedding */
  classificationLabel: string;
  /** The value of the classification label associated with this embedding */
  labelValue: string;
}

/** The data returned by the operation, if any */
export interface FileClassificationEmbeddingDto {
  /** @format uuid */
  id?: string;
  /**
   * Unique identifier of the invoice file processing associated with this embedding
   * @format uuid
   */
  invoiceFileProcessingId: string;
  /** The text content extracted from the file page used to generate the embedding */
  textContent: string;
  /** The embedding vector representing the content of the file. This is a vector of floats with a fixed dimension defined by EMBEDDING_VECTOR_DIMENSION. */
  embeddingVector: number[];
  /** The name of the model used to generate the embedding */
  modelName: string;
  /** The name of the tokenizer used to preprocess the text before generating the embedding */
  tokenizerName: string;
  /**
   * The page number of the document from which this embedding was generated
   * @format int32
   */
  pageNumber: number;
  /** The data pipeline config ID associated with this embedding */
  dataPipelineConfigId?: string;
  /** The document type associated with this embedding */
  documentType?: string;
  /** The sender name associated with this embedding */
  senderName?: string;
  /** The receiver name associated with this embedding */
  receiverName?: string;
  /**
   * Timestamp when the file classification embedding was created
   * @format date-time
   */
  createdOn?: string;
  /**
   * Timestamp when the file classification embedding was last updated
   * @format date-time
   */
  updatedOn?: string;
}

export interface ResponseDtoFileClassificationEmbeddingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: FileClassificationEmbeddingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for querying file classification embeddings with multiple filtering options and pagination support */
export interface FileClassificationEmbeddingRequestDto {
  /**
   * Filter by specific file classification embedding unique identifiers. Use this to retrieve specific embeddings by their database IDs.
   * @uniqueItems true
   */
  ids?: string[];
  /**
   * Filter by invoice file processing IDs. These are the file processing instances associated with the embeddings.
   * @uniqueItems true
   */
  invoiceFileProcessingIds?: string[];
  /**
   * Filter by model names used to generate the embeddings. These are typically machine learning model identifiers.
   * @uniqueItems true
   */
  modelNames?: string[];
  /**
   * Filter by tokenizer names used to preprocess text before generating embeddings.
   * @uniqueItems true
   */
  tokenizerNames?: string[];
  /**
   * Filter by page numbers of documents from which embeddings were generated. Useful for multi-page document processing.
   * @uniqueItems true
   */
  pageNumbers?: number[];
  /**
   * Filter by data pipeline configuration IDs. These define the type/template of the file page processing.
   * @uniqueItems true
   */
  dataPipelineConfigIds?: string[];
  /**
   * Filter by document types associated with the embeddings.
   * @uniqueItems true
   */
  documentTypes?: string[];
  /**
   * Filter by sender names associated with the embeddings.
   * @uniqueItems true
   */
  senderNames?: string[];
  /**
   * Filter by receiver names associated with the embeddings.
   * @uniqueItems true
   */
  receiverNames?: string[];
  /**
   * Filter by creation date range start. Include embeddings created on or after this timestamp.
   * @format date-time
   */
  createdOnStart?: string;
  /**
   * Filter by creation date range end. Include embeddings created on or before this timestamp.
   * @format date-time
   */
  createdOnEnd?: string;
  /**
   * Filter by last update date range start. Include embeddings last updated on or after this timestamp.
   * @format date-time
   */
  updatedOnStart?: string;
  /**
   * Filter by last update date range end. Include embeddings last updated on or before this timestamp.
   * @format date-time
   */
  updatedOnEnd?: string;
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest?: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageFileClassificationEmbeddingDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: FileClassificationEmbeddingDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageFileClassificationEmbeddingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageFileClassificationEmbeddingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface FileClassificationEmbeddingMetadataDto {
  /** Unique identifiers for file classification embeddings and their counts */
  ids?: Record<string, number>;
  /** Invoice file processing IDs associated with embeddings and their counts */
  invoiceFileProcessingIds?: Record<string, number>;
  /** Model names used to generate embeddings and their counts */
  modelNames?: Record<string, number>;
  /** Tokenizer names used for preprocessing and their counts */
  tokenizerNames?: Record<string, number>;
  /** Page numbers of documents and their counts */
  pageNumbers?: Record<string, number>;
  /** Data pipeline configuration IDs and their counts */
  dataPipelineConfigIds?: Record<string, number>;
  /** Document types associated with embeddings and their counts */
  documentTypes?: Record<string, number>;
  /** Sender names associated with embeddings and their counts */
  senderNames?: Record<string, number>;
  /** Receiver names associated with embeddings and their counts */
  receiverNames?: Record<string, number>;
  /** Creation dates (by day) and their counts */
  createdOnDates?: Record<string, number>;
  /** Last update dates (by day) and their counts */
  updatedOnDates?: Record<string, number>;
}

export interface ResponseDtoFileClassificationEmbeddingMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: FileClassificationEmbeddingMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Exchange rate Data Transfer Object DTO. */
export interface ExchangeRateDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** Base currency. */
  baseCurrency?: string;
  /** To currency. */
  toCurrency?: string;
  /** Exchange rate. */
  exchangeRate?: number;
  /** Day. */
  day?: string;
  /** Month. */
  month?: string;
  /** Quarter. */
  quarter?: string;
  /** Creation timestamp by. */
  createdBy?: string;
  /** Time base for the exchange rate, e.g., daily, monthly, quarterly. */
  timeBase?: string;
  /** Time when the exchange rate is applied, e.g., 2023-10-01T00:00:00Z. */
  time?: string;
}

export interface ResponseDtoExchangeRateDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Exchange rate Data Transfer Object DTO. */
  data?: ExchangeRateDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for legal entities, containing metadata and pagination information. */
export interface ExchangeRateRequestDto {
  /**
   * Base currencies of exchange rates
   * @uniqueItems true
   */
  baseCurrencies?: string[];
  /**
   * To currencies of exchange rates
   * @uniqueItems true
   */
  toCurrencies?: string[];
  /**
   * Exchange rates
   * @uniqueItems true
   */
  exchangeRates?: string[];
  /**
   * Time based on which exchange rates are applied
   * @uniqueItems true
   */
  timeBases?: string[];
  /**
   * Time which exchange rates are applied
   * @uniqueItems true
   */
  times?: string[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface PageExchangeRateDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: ExchangeRateDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageExchangeRateDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageExchangeRateDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object for exchange rate metadata, containing aggregated counters for various exchange rate properties. */
export interface ExchangeRateMetadataDto {
  /** Map where keys are base currencies and values are their respective counts. */
  baseCurrencies?: Record<string, number>;
  /** Map where keys are target currencies and values are their respective counts. */
  toCurrencies?: Record<string, number>;
  /** Map where keys are exchange rate values and values are their respective counts. */
  exchangeRates?: Record<string, number>;
  /** Map where keys are time bases (e.g., day, month, quarter) and values are their respective counts. */
  timeBases?: Record<string, number>;
  /** Map where keys are specific times and values are their respective counts. */
  times?: Record<string, number>;
}

export interface ResponseDtoExchangeRateMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object for exchange rate metadata, containing aggregated counters for various exchange rate properties. */
  data?: ExchangeRateMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request object for querying discount contract mappings with filter and pagination support. */
export interface DiscountContractMappingRequestDto {
  /**
   * Filter by contract IDs.
   * @uniqueItems true
   * @example ["uuid1","uuid2"]
   */
  contractIds?: string[];
  /**
   * Filter by shipping service type (e.g. SEA, AIR).
   * @uniqueItems true
   * @example ["SEA","AIR"]
   */
  services?: string[];
  /**
   * Filter by eligible charge domain.
   * @uniqueItems true
   * @example ["FREIGHT","HANDLING_CHARGE"]
   */
  eligibleChargeDomains?: (
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE'
  )[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** Discount contract mapping Data Transfer Object. */
export interface DiscountContractMappingDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /**
   * The contract this mapping belongs to.
   * @format uuid
   */
  contractId?: string;
  /** Shipping service type this mapping applies to (e.g. SEA, AIR). Null matches all services. */
  service?: string;
  /** Minimum average revenue amount (inclusive) required to qualify for the discount rate. */
  minimumAmountSpent?: number;
  /** Maximum average revenue amount (inclusive). Null means no upper bound. */
  maximumAmountSpent?: number;
  /** Discount rate as a whole percentage (e.g. 5 = 5%). */
  discountRate?: number;
  /** Eligible charge domain for the resulting ContractPercentageDiscount. Null = wildcard. */
  eligibleChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Eligible charge sub-domain for the resulting ContractPercentageDiscount. Null = wildcard. */
  eligibleChargeSubDomain?: string;
  /** Route prefix filter. Only shipping services whose route starts with this value are matched. Null or empty = match all routes. */
  routeStartWith?: string;
  /**
   * Timestamp when this mapping was created.
   * @format date-time
   */
  createdOn?: string;
  /** User who created this mapping. */
  createdBy?: string;
  /**
   * Timestamp when this mapping was last updated.
   * @format date-time
   */
  updatedOn?: string;
  /** User who last updated this mapping. */
  updatedBy?: string;
}

/** The data returned by the operation, if any */
export interface PageDiscountContractMappingDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: DiscountContractMappingDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageDiscountContractMappingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageDiscountContractMappingDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Charge mapping details. */
export interface ChargeMappingDto {
  /** Domain of the charge. */
  domain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Sub-domain of the charge. */
  subDomain?: string;
  /** Leg type associated with the charge. */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
}

/** Request to update charge mapping and recalculate deviations. */
export interface UpdateChargeMappingAndRecalculateDeviationsRequest {
  /**
   * ID of the service provider.
   * @format int64
   */
  serviceProviderId?: number;
  /** Name of the charge. */
  chargeName?: string;
  /** Charge mapping details. */
  currentChargeMapping?: ChargeMappingDto;
  /** Charge mapping details. */
  newChargeMapping?: ChargeMappingDto;
  /** Service type of the shipping service. */
  serviceType?: string;
  /** Special type of the shipping service. */
  specialType?: string;
}

/** Mock Invoice Data Request Data Transfer Object DTO. */
export interface MockInvoiceDataRequestDto {
  code?: string;
  /** @format int64 */
  serviceProviderId: number;
  shipperCode?: string;
  consigneeCode?: string;
  /** @format int64 */
  billingPartyId?: number;
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  dominantModality: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  route: string;
  service?: string;
  type?: string;
  carrier?: string;
  totalLeadTime?: number;
  /**
   * Number of invoices.
   * @format int32
   */
  numberOfInvoices?: number;
  /**
   * From.
   * @format date
   */
  from?: string;
  /**
   * To.
   * @format date
   */
  to?: string;
  /** Expected Invoice Status. */
  expectedInvoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Expected deviation Workflow. */
  expectedDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
}

export interface ResponseDtoListInvoiceMessageDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceMessageDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request DTO for adding credit with separate invoice and shipment amounts */
export interface AddCreditRequestDto {
  /**
   * The unique identifier of the credit account (optional)
   * @format uuid
   */
  creditId?: string;
  /**
   * The amount of invoice credit to add
   * @format int64
   */
  invoiceAmount?: number;
  /**
   * The expiration date for the invoice credit
   * @format date
   */
  invoiceExpirationDate?: string;
  /**
   * The amount of shipment credit to add
   * @format int64
   */
  shipmentAmount?: number;
  /**
   * The expiration date for the shipment credit
   * @format date
   */
  shipmentExpirationDate?: string;
  /** The purchase order number associated with the credit addition */
  poNumber: string;
  /**
   * The purchase order date associated with the credit addition
   * @format date
   */
  poDate: string;
  /**
   * The billed entity ID to add credit for (required when creditId is not provided)
   * @format int64
   */
  billedEntityId: number;
  /** Billing type for the credit account (PRE_PAID or POST_PAID). Required when creditId is not provided. Defaults to PRE_PAID. */
  billingType?: 'PRE_PAID' | 'POST_PAID';
}

/** Request Object for retrieving filtered credit transactions with multiple filtering options and pagination support */
export interface CreditTransactionRequestDto {
  /**
   * Filter by transaction types. These represent the type of transaction (e.g., DEBIT, CREDIT).
   * @uniqueItems true
   * @example ["DEBIT","CREDIT"]
   */
  transactionTypes?: ('ADD_CREDIT' | 'AMEND' | 'PROCESS_INVOICE')[];
  /**
   * Filter by billed entity IDs. Use this to find transactions for specific legal entities.
   * @uniqueItems true
   * @example [1001,1002,1003]
   */
  billedEntities?: string[];
  /**
   * Filter by invoice numbers associated with the transactions.
   * @uniqueItems true
   * @example ["INV-2023-001","INV-2023-002"]
   */
  invoiceNumbers?: string[];
  /**
   * Filter by shipment numbers associated with the transactions.
   * @uniqueItems true
   * @example ["SHP-2023-001","SHP-2023-002"]
   */
  shipmentCounts?: string[];
  /**
   * Filter by service provider names.
   * @uniqueItems true
   * @example ["DHL Express","FedEx Corporation"]
   */
  serviceProviders?: string[];
  /**
   * Filter by modalities (transportation modes).
   * @uniqueItems true
   * @example ["AIR","SEA","LAND"]
   */
  modalities?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT')[];
  /**
   * Filter by PO (Purchase Order) numbers.
   * @uniqueItems true
   * @example ["PO-2023-001","PO-2023-002"]
   */
  poNumbers?: string[];
  /**
   * Filter by specific months, quarters, or years in 'YYYY-MM', 'YYYY-QX', 'YYYY' or 'YYYY-MM-DD' format.
   * @uniqueItems true
   * @example ["2023-01","2023-Q1","2023","2023-01-15"]
   */
  dates?: string[];
  /**
   * Filter by a specific credit billable entity ID.
   * @format int64
   * @example 1001
   */
  creditBillableEntityId?: number;
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest?: PaginationRequest;
}

/** Credit Transaction DTO containing all required fields for credit transaction queries */
export interface CreditTransactionDto {
  /**
   * Unique identifier for the credit transaction
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id?: string;
  /**
   * Transaction type (DEBIT or CREDIT)
   * @example "CREDIT"
   */
  transactionType?: 'ADD_CREDIT' | 'AMEND' | 'PROCESS_INVOICE';
  /**
   * Date when the transaction was created
   * @format date-time
   * @example "2023-10-06T10:30:00Z"
   */
  transactionDatetime?: string;
  /**
   * Invoice number associated with the transaction
   * @example "INV-2023-001"
   */
  invoiceNumber?: string;
  /** Count of shipments in the transaction */
  shipmentCount?: string;
  /**
   * Service provider name
   * @example "DHL Express"
   */
  serviceProvider?: string;
  /**
   * Billed entity/legal entity name
   * @example "Tetrixx Singapore Pte Ltd"
   */
  billedEntity?: string;
  /** List of modalities of the invoice involved in the transaction */
  modalities?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT')[];
  /**
   * Credit amount for the invoice
   * @format int64
   */
  invoiceCreditAmount?: number;
  /**
   * Credit amount for the shipment
   * @format int64
   */
  shipmentCreditAmount?: number;
  /**
   * Expiration date of the credit
   * @format date
   */
  creditExpirationDate?: string;
  /**
   * Purchase Order number from shipment or invoice
   * @example "PO-2023-001"
   */
  poNumber?: string;
  /**
   * Purchase Order date from the credit transaction
   * @format date
   * @example "2023-01-15"
   */
  poDate?: string;
  /**
   * Batch identifier to group related transactions together
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440001"
   */
  batchId?: string;
  /**
   * Name of the file associated with the transaction, if applicable
   * @example "invoice_2023_001.pdf"
   */
  fileName?: string;
  /** Whether this transaction has been settled (paid for) */
  settled?: boolean;
}

/** The data returned by the operation, if any */
export interface PageCreditTransactionDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: CreditTransactionDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageCreditTransactionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageCreditTransactionDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Metadata DTO containing aggregated statistics and counters for credit transactions */
export interface CreditTransactionMetadataDto {
  /**
   * Counter of transaction types grouped by type
   * @example {"CREDIT":20,"DEBIT":6}
   */
  transactionTypesCounter?: Record<string, number>;
  /**
   * Counter of billed entities grouped by entity name
   * @example {"Tetrixx Singapore Pte Ltd":12,"Tetrixx Malaysia Sdn Bhd":8,"Tetrixx Holdings Corp":6}
   */
  billedEntitiesCounter?: Record<string, number>;
  /**
   * Counter of invoice numbers grouped by invoice number
   * @example {"INV-2023-001":3,"INV-2023-002":2,"INV-2023-003":1}
   */
  invoiceNumbersCounter?: Record<string, number>;
  /**
   * Counter of shipment counts grouped by shipment count
   * @example {"SHP-2023-001":2,"SHP-2023-002":1,"SHP-2023-003":1,"1 Shipment":1,"3 Shipments":1}
   */
  shipmentCountsCounter?: Record<string, number>;
  /**
   * Counter of service providers grouped by provider name
   * @example {"DHL Express":10,"FedEx Corporation":8,"UPS":5,"Maersk Line":3}
   */
  serviceProvidersCounter?: Record<string, number>;
  /**
   * Counter of modalities grouped by modality type
   * @example {"AIR":15,"SEA":8,"LAND":3}
   */
  modalitiesCounter?: Record<string, number>;
  /**
   * Counter of PO numbers grouped by PO number
   * @example {"PO-2023-001":4,"PO-2023-002":3,"PO-2023-003":2}
   */
  poNumbersCounter?: Record<string, number>;
  /**
   * List of unique transaction dates in month-year format (e.g., '01-2023')
   * @example ["01-2023","02-2023","03-2023"]
   */
  transactionDates?: string[];
}

export interface ResponseDtoCreditTransactionMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Metadata DTO containing aggregated statistics and counters for credit transactions */
  data?: CreditTransactionMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface CreatingContractReq {
  /**
   * The ID of the shipping service
   * @format uuid
   */
  shippingServiceId: string;
  /** The code of the contract */
  code?: string;
  /**
   * The start date of the contract
   * @format date
   */
  startDate: string;
  /**
   * The end date of the contract
   * @format date
   */
  endDate: string;
  /**
   * The ID of the contract flow to copy the charges from, if applicable.
   * @format uuid
   */
  sourceContractFlowId?: string;
  /** The file path for the contract document */
  filePath?: string;
  /** This is optional, used for setting custom contract flow code */
  contractFlowCode?: string;
}

/** The data returned by the operation, if any */
export interface PageContractDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: ContractDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageContractDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageContractDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Request object for retrieving filtered contracts with pagination support */
export interface ContractRequestDto {
  /**
   * Filter by service provider IDs
   * @uniqueItems true
   * @example [10,20,30]
   */
  serviceProviderIds?: number[];
  /**
   * Filter by contract start dates
   * @uniqueItems true
   * @example ["2024-01-01","2024-06-01"]
   */
  startDates?: string[];
  /**
   * Filter by contract end dates
   * @uniqueItems true
   * @example ["2024-12-31","2025-12-31"]
   */
  endDates?: string[];
  /**
   * Filter by zone count
   * @uniqueItems true
   * @example [1,2,3]
   */
  zoneCounts?: number[];
  /**
   * Filter by route count
   * @uniqueItems true
   * @example [5,10,15]
   */
  routeCounts?: number[];
  /**
   * Filter by flow count
   * @uniqueItems true
   * @example [2,4,6]
   */
  contractFlowCounts?: number[];
  /**
   * Filter by shipment count
   * @uniqueItems true
   * @example [100,200,300]
   */
  shipmentCounts?: number[];
  /** Request object for pagination, sorting, and filtering of API responses */
  paginationRequest: PaginationRequest;
}

/** The data returned by the operation, if any */
export interface ContractMetadataDto {
  /** Service provider IDs of contracts */
  serviceProviderIds?: Record<string, number>;
  /** Start dates of contracts */
  startDates?: Record<string, number>;
  /** End dates of contracts */
  endDates?: Record<string, number>;
  /** Zone mapping counts per contract (key: contractId) */
  zoneMappingCounts?: Record<string, number>;
  /** Route mapping counts per contract (key: contractId) */
  routeMappingCounts?: Record<string, number>;
  /** Contract flow (rate card) counts per contract (key: contractId) */
  contractFlowCounts?: Record<string, number>;
  /** Shipment counts per contract (key: contractId) */
  shipmentCounts?: Record<string, number>;
}

export interface ResponseDtoContractMetadataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ContractMetadataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface CreateContractPercentageChargesRequest {
  serviceProviderCode: string;
  legType: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  chargeDomain:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain: string;
  currency?: string;
  eligibleChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  eligibleChargeSubDomain?: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  value: number;
  minimumPrice?: number;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  services?: string[];
  routeStartWiths?: string[];
}

export interface ResponseDtoListString {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: string[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ShipmentSearchRequestDto {
  /** The sorting criteria for the shipment search */
  sorting?: ShipmentSortDto;
  /** Page. */
  page?: PageDto;
  /** Request DTO for analytic search queries */
  searchRequest?: AnalyticSearchRequestDto;
}

/** The sorting criteria for the shipment search */
export interface ShipmentSortDto {
  /**
   * * SHIPMENT_NUMBER - The unique identifier for the shipment.
   * * INVOICE_DATE - The date the invoice was issued.
   * * INVOICE_DUE_DATE - The due date for the invoice payment.
   * * PICKUP_DATE - The date the shipment was picked up.
   * * DELIVERY_DATE - The date the shipment was delivered.
   * * SUBMISSION_DATE - The date the shipment was submitted.
   * * INVOICE_CHARGES_COUNT - The total number of charges in the invoice.
   * * TOTAL_AMOUNT_INVOICE_CURRENCY - The total amount in the invoice currency.
   * * TOTAL_AMOUNT - The total amount for the shipment.
   * * GROSS_WEIGHT - The gross weight of the shipment.
   * * CHARGEABLE_WEIGHT - The chargeable weight of the shipment.
   * * VOLUME - The volume of the shipment.
   * * CO2_EMISSION - The CO2 emissions associated with the shipment.
   * * SERVICE_PROVIDER - The service provider handling the shipment.
   * * MODALITY - The mode of transportation for the shipment.
   * * VEHICLE_ID - The identifier for the vehicle used in the shipment.
   * * SHIPPER_NAME - The name of the shipper.
   * * POL - The port of loading for the shipment.
   * * SHIPPER_COUNTRY - The country of the shipper.
   * * CONSIGNEE_NAME - The name of the consignee.
   * * POD - The port of discharge for the shipment.
   * * CONSIGNEE_COUNTRY - The country of the consignee.
   * * GOOD_NAME - The name of the goods being shipped.
   * * PACKAGE_COUNT - The number of packages in the shipment.
   * * PACKAGE_UNIT - The unit of measurement for the packages.
   * * SERVICE_TYPE - The type of service provided for the shipment.
   * * INVOICE_NUMBER - The number of the invoice.
   * * INVOICE_STATUS - The status of the invoice.
   * * SHIPMENT_CURRENT_DEVIATION_WORKFLOW - The current deviation workflow(s) for the shipment.
   * * BILLED_ENTITY - The entity being billed for the shipment.
   * * TOTAL_CHARGE_AMOUNT_LEG_1 - The total charge amount for leg 1 of the shipment.
   * * TOTAL_CHARGE_AMOUNT_LEG_2 - The total charge amount for leg 2 of the shipment.
   * * TOTAL_CHARGE_AMOUNT_LEG_3 - The total charge amount for leg 3 of the shipment.
   * * LEAD_TIME - The lead time for the shipment.
   * * SHIPMENT_STATUS - The resolved/unresolved shipment status for analytics.
   * * SHIPMENT_STATUS_REASON - The reason for the shipment status for analytics.
   */
  field?:
    | 'SHIPMENT_NUMBER'
    | 'INVOICE_DATE'
    | 'INVOICE_DUE_DATE'
    | 'PICKUP_DATE'
    | 'DELIVERY_DATE'
    | 'SUBMISSION_DATE'
    | 'INVOICE_CHARGES_COUNT'
    | 'TOTAL_AMOUNT_INVOICE_CURRENCY'
    | 'TOTAL_AMOUNT'
    | 'GROSS_WEIGHT'
    | 'CHARGEABLE_WEIGHT'
    | 'VOLUME'
    | 'CO2_EMISSION'
    | 'SERVICE_PROVIDER'
    | 'MODALITY'
    | 'VEHICLE_ID'
    | 'SHIPPER_NAME'
    | 'POL'
    | 'SHIPPER_COUNTRY'
    | 'CONSIGNEE_NAME'
    | 'POD'
    | 'CONSIGNEE_COUNTRY'
    | 'GOOD_NAME'
    | 'PACKAGE_COUNT'
    | 'PACKAGE_UNIT'
    | 'SERVICE_TYPE'
    | 'INVOICE_NUMBER'
    | 'INVOICE_STATUS'
    | 'SHIPMENT_CURRENT_DEVIATION_WORKFLOW'
    | 'BILLED_ENTITY'
    | 'TOTAL_CHARGE_AMOUNT_LEG_1'
    | 'TOTAL_CHARGE_AMOUNT_LEG_2'
    | 'TOTAL_CHARGE_AMOUNT_LEG_3'
    | 'LEAD_TIME'
    | 'SHIPMENT_STATUS'
    | 'SHIPMENT_STATUS_REASON';
  /** The direction of sorting: ascending or descending */
  direction?: 'ASC' | 'DESC';
}

export interface ResponseDtoShipmentSearchResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ShipmentSearchResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The list of shipments matching the search criteria */
export interface ShipmentDto {
  /**
   * The unique identifier of the invoice associated with this shipment
   * @format uuid
   */
  invoiceId?: string;
  /** A unique identifier for the shipment, typically a combination of the shipper's code and the service provider's code */
  shipmentNumber?: string;
  /** The Master Bill of Lading (MBL) or Master Air Waybill (MAWB) number for the shipment */
  mbl?: string;
  /** The date when the invoice for this shipment was received */
  submissionDate?: string;
  /** The date when the service provider collects and takes possession of the goods from the shipper for shipment */
  pickupDate?: string;
  /** The date when the shipment is delivered to the consignee */
  deliveryDate?: string;
  /** The due date by which the invoice must be paid */
  invoiceDueDate?: string;
  /** The date when the invoice was issued for this shipment */
  invoiceDate?: string;
  /**
   * The total number of charges included in the invoice(s) for this shipment
   * @format int32
   */
  invoiceChargesCount?: number;
  /** The total billed amount for this shipment */
  totalAmount?: number;
  /** The currency in which the total shipment amount is billed */
  totalAmountCurrency?: string;
  /** The total invoice amount after tax is applied */
  invoiceAmountAfterTax?: number;
  /** The currency used for the invoice amount */
  invoiceCurrency?: string;
  /** The gross weight of the shipment in the specified unit */
  grossWeight?: number;
  /** The chargeable weight of the shipment, used for billing purposes */
  chargeableWeight?: number;
  /** The total volume of the shipment in cubic meters or the specified unit */
  volume?: number;
  /** The total CO2 emissions generated by this shipment */
  co2Emission?: number;
  /** The name of the service provider responsible for transporting the shipment */
  serviceProvider?: string;
  /** The mode of transportation used for the shipment (e.g., air, sea, road, rail) */
  modality?: string;
  /** The unique identifier of the vehicle used for transporting the shipment */
  vehicleId?: string;
  /** The name or identifier of the shipper sending the goods */
  shipper?: string;
  /** The port of loading where the shipment is loaded onto the transport vessel */
  pol?: string;
  /** The country where the shipper is located */
  shipperCountry?: string;
  /** The name or identifier of the consignee receiving the goods */
  consignee?: string;
  /** The port of discharge where the shipment is unloaded from the transport vessel */
  pod?: string;
  /** The country where the consignee is located */
  consigneeCountry?: string;
  /** The name or description of the goods being shipped */
  goodsName?: string;
  /** The total number of packages included in the shipment */
  packageCount?: string;
  /** The unit of measurement for the packages (e.g., cartons, pallets) */
  packageUnit?: string;
  /** The entity or company billed for this shipment */
  billedEntity?: string;
  /** The type of shipment, such as import, export, or domestic */
  shipmentType?: 'IMPORT' | 'EXPORT' | 'MULTI';
  /** The specific service type provided for this shipment (e.g., express, standard) */
  serviceType?: string;
  /** The unique invoice number associated with this shipment */
  invoiceNumber?: string;
  /** The shipment invoice status for analytics resolution (Resolved - Accepted/Rejected, Unresolved) */
  shipmentStatus?: string;
  /** The total charge amount for the 1st leg of the shipment route */
  totalChargeAmountLeg1?: number;
  /** The total charge amount for the 2nd leg of the shipment route */
  totalChargeAmountLeg2?: number;
  /** The total charge amount for the 3rd leg of the shipment route */
  totalChargeAmountLeg3?: number;
  /**
   * Total time duration from the initiation of a shipment or order to its final delivery or completion
   * @format int64
   */
  leadTime?: number;
  /** Indicates whether the shipment is a spot shipment (one-time or ad-hoc shipment) */
  isSpotShipment?: boolean;
  /** The reasons for the shipment status in analytics */
  shipmentStatusReason?: string[];
  /** The current deviation workflow statuses for this shipment, if any */
  shipmentCurrentDeviationWorkflow?: (
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW'
  )[];
}

/** The data returned by the operation, if any */
export interface ShipmentSearchResponseDto {
  /** Page. */
  page?: PageDto;
  /**
   * The total number of shipments matching the search criteria
   * @format int64
   */
  total?: number;
  /** The list of shipments matching the search criteria */
  shipments?: ShipmentDto[];
}

export interface InvoiceAnalyticSearchRequestDto {
  /** The sorting criteria for the invoice analytics search */
  sorting?: InvoiceSortDto;
  /** Page. */
  page?: PageDto;
  /** Request DTO for analytic search queries */
  searchRequest?: AnalyticSearchRequestDto;
}

/** The sorting criteria for the invoice analytics search */
export interface InvoiceSortDto {
  /** The field to sort by, such as invoice status, service provider name, or account number */
  field?:
    | 'INVOICE_NUMBER'
    | 'INVOICE_DATE'
    | 'INVOICE_DUE_DATE'
    | 'PICKUP_DATE'
    | 'DELIVERY_DATE'
    | 'SUBMISSION_DATE'
    | 'RESOLUTION_DATE'
    | 'FAP_REF'
    | 'SHIPMENT_COUNT'
    | 'INVOICE_CHARGES_COUNT'
    | 'BILLED_ENTITY_NAME'
    | 'INVOICE_STATUS'
    | 'TOTAL_AMOUNT'
    | 'INVOICE_TOTAL_AMOUNT'
    | 'SERVICE_PROVIDER_NAME'
    | 'MODALITY'
    | 'ACCOUNT_NUMBER'
    | 'INCOTERM'
    | 'INVOICE_REASON';
  /** The direction of sorting: ascending or descending */
  direction?: 'ASC' | 'DESC';
}

/** A list of invoices matching the search criteria */
export interface InvoiceAnalyticsDto {
  /** Unique invoice number assigned to this invoice */
  invoiceNumber?: string;
  /** Unique shipment number, typically composed of the shipper's code and the service provider's code */
  shipmentNumber?: string;
  /** Indicates if any shipment invoice for this shipment has SPOT_SHIPMENT status. */
  hasSpotShipment?: boolean;
  /** Date when the service provider collects the goods from the shipper (pickup date) */
  pickupDate?: string;
  /** Date when the goods are delivered to the consignee (delivery date) For flights, this is typically the same as the pickup date */
  deliveryDate?: string;
  /** Date when the invoice is issued by   the service provider */
  invoiceDate?: string;
  /** Date by which the invoice must be paid (due date) */
  invoiceDueDate?: string;
  /**
   * Total number of charges associated with this invoice
   * @format int32
   */
  invoiceChargesCount?: number;
  /** Entity billed for the shipment (the invoice management customer) */
  billedEntity?: string;
  /** Current status of the invoice: ready for payment, rejected, flagged) */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Total amount to be paid for this invoice */
  totalAmount?: number;
  /** Currency in which the invoice amount is denominated */
  invoiceCurrency?: string;
  /** Total amount in the reference currency used for filtering */
  totalAmountInReferenceCurrency?: number;
  /** Reference currency for the invoice */
  invoiceReferenceCurrency?: string;
  /** Service provider responsible for shipping goods from the point of loading (POL) to the point of delivery (POD) */
  serviceProvider?: string;
  /** Mode of transportation: air, sea, road, courier) */
  modality?: string;
  /** Reference number of the purchase order for the goods */
  goodsPoRef?: string;
  /** FAP reference (Financial Approval Process reference) */
  fapRef?: string;
  /** Date when the invoice is received (submission date) */
  submissionDate?: string;
  /** Date when the invoice is approved and ready for payment (resolution date) */
  resolutionDate?: string;
  /**
   * Unique identifier of the invoice
   * @format uuid
   */
  invoiceId?: string;
  /** Account number associated with the invoice (the account to which payment should be made) */
  accountNumber?: string;
  /** Type of shipment: import, export, multi) */
  shipmentType?: 'IMPORT' | 'EXPORT' | 'MULTI';
  /** Incoterm associated with the shipment, defining the responsibilities of the buyer and seller in the shipping process */
  incoterm?: string;
  /** The reasons for the shipment status in analytics */
  reasons?: string[];
}

/** The data returned by the operation, if any */
export interface InvoiceAnalyticsSearchResponseDto {
  /** Page. */
  page?: PageDto;
  /**
   * The total number of invoices matching the search criteria
   * @format int64
   */
  total?: number;
  /** A list of invoices matching the search criteria */
  invoices?: InvoiceAnalyticsDto[];
}

export interface ResponseDtoInvoiceAnalyticsSearchResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceAnalyticsSearchResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface InvoiceChargeDataRequestDto {
  /**
   * List of invoice IDs to fetch charge data for
   * @example "['123e4567-e89b-12d3-a456-426614174000']"
   */
  invoiceIds: string[];
}

/** The data returned by the operation, if any */
export interface InvoiceChargeDataResponseDto {
  /**
   * Unique identifier of the invoice
   * @format uuid
   */
  invoiceId?: string;
  /** Invoice number */
  invoiceNumber?: string;
  /** List of reasons explaining the invoice's current status. For Ready for Payment: Straight Through Processing, Approved Deviations, Credit Note, Spot Shipment, Checked Approvals. For Rejected: Wrong Billed Entity, Dispute. For Flagged: NRCF, Deviations, Approvals */
  reasons?: string[];
}

export interface ResponseDtoListInvoiceChargeDataResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceChargeDataResponseDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface InvoiceChargeSearchRequestDto {
  /** The sorting criteria for the invoice charge search response */
  sorting?: InvoiceChargeSortDto;
  /** Page. */
  page?: PageDto;
  /** Request DTO for analytic search queries */
  searchRequest?: AnalyticSearchRequestDto;
}

/** The sorting criteria for the invoice charge search response */
export interface InvoiceChargeSortDto {
  /** The field to sort by, such as invoice currency, leg type and service provider name */
  field?:
    | 'INVOICE_NUMBER'
    | 'SHIPMENT_NUMBER'
    | 'INVOICE_DATE'
    | 'PICKUP_DATE'
    | 'INVOICE_DUE_DATE'
    | 'DELIVERY_DATE'
    | 'SUBMISSION_DATE'
    | 'CHARGE_DOMAIN'
    | 'CHARGE_NAME'
    | 'CHARGE_AMOUNT'
    | 'INVOICE_CURRENCY'
    | 'CHARGE_QUANTITY'
    | 'CHARGE_UNIT_PRICE'
    | 'CHARGE_CURRENCY'
    | 'EXCHANGE_RATE'
    | 'SERVICE_PROVIDER_NAME'
    | 'SERVICE'
    | 'MODALITY'
    | 'POL'
    | 'POD'
    | 'SHIPPER_COUNTRY'
    | 'CONSIGNEE_COUNTRY'
    | 'QUANTITY_UNIT'
    | 'LEG_TYPE'
    | 'CHARGE_AMOUNT_INVOICE_CURRENCY'
    | 'CHARGE_AMOUNT_REFERENCE_CURRENCY'
    | 'DEVIATION_AMOUNT_INVOICE_CURRENCY'
    | 'BILLED_ENTITY'
    | 'CHARGE_STATUS'
    | 'CHARGE_STATUS_REASON';
  /** The direction to sort by: ascending or descending */
  direction?: 'ASC' | 'DESC';
}

/** The list of invoice charge data */
export interface InvoiceChargeDto {
  /**
   * Unique identifier of the invoice associated with this charge
   * @format uuid
   */
  invoiceId?: string;
  /**
   * Unique identifier of this invoice charge
   * @format uuid
   */
  invoiceChargeId?: string;
  /** Shipment identifier, typically a combination of the shipper's and service provider's codes */
  shipmentNumber?: string;
  /** Indicates if the shipment is classified as a spot shipment */
  isSpotShipment?: boolean;
  /** Unique invoice number for identifying the invoice */
  invoiceNumber?: string;
  /** Date the invoice was issued by the service provider */
  invoiceDate?: string;
  /** Date the goods were picked up by the service provider, marking the transfer of possession from shipper */
  pickupDate?: string;
  /** Date the invoice was received */
  submissionDate?: string;
  /** Date the goods were delivered to the destination or consignee For flights, this is usually the same as the pickup date */
  deliveryDate?: string;
  /** Due date for invoice payment */
  invoiceDueDate?: string;
  /** Category of the charge, such as storage or fuel surcharge */
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Detailed description of the charge, providing more specificity than the charge domain */
  chargeName?: string;
  /** Unit price of the charge, expressed in the charge currency */
  chargeUnitPrice?: number;
  /**
   * Quantity or number of times the unit charge is applied (e.g., in m3, kg, or count)
   * @format int32
   */
  chargeQuantity?: number;
  /** Unit of the charge quantity, such as m3, kg, or None */
  quantityUnit?: string;
  /** Total charge amount in the invoice currency */
  chargeAmount?: number;
  /** Currency of the unit charge price, as defined in the rate card */
  chargeCurrency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** Charge amount converted to the invoice currency */
  chargeAmountInInvoiceCurrency?: number;
  /** Difference between the invoice amount and the expected amount, in the invoice currency Calculated based on negotiated rate cards and shipment details */
  deviationAmountInInvoiceCurrency?: number;
  /** Currency in which the invoice is issued Payment may occur in a different currency if specified, using an exchange rate */
  invoiceCurrency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** Charge amount converted to the reference currency using the invoice's exchange rate */
  chargeAmountInReferenceCurrency?: number;
  /** Reference currency used for conversion */
  referenceCurrency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** Exchange rate between the invoice currency and the charge currency */
  exchangeRate?: number;
  /** Service provider responsible for shipping the goods from the point of loading to the point of delivery */
  serviceProvider?: string;
  /** Service type of the shipment */
  service?: string;
  /** Name of the shipper */
  shipper?: string;
  /** Country of the shipper */
  shipperCountry?: string;
  /** Name of the consignee */
  consignee?: string;
  /** Country of the consignee */
  consigneeCountry?: string;
  /** Shipment modality, such as road, sea, air, etc */
  modality?: string;
  /** Port or location where the cargo is loaded onto the vehicle for shipment */
  pol?: string;
  /** Port or location where the cargo is delivered to the consignee */
  pod?: string;
  /** Entity billed for the shipment, typically the client using the invoice management service */
  billedEntity?: string;
  /** Segment of the shipment using a single modality, such as road or sea Shipments may consist of multiple legs, organized chronologically */
  legType?: string;
  /** Status of the charge processing workflow */
  chargeStatus?: string;
  /** Reason for the current charge status */
  chargeStatusReason?: string;
}

/** The data returned by the operation, if any */
export interface InvoiceChargeSearchResponseDto {
  /** Page. */
  page?: PageDto;
  /**
   * The total number of invoice charges matching the search criteria
   * @format int64
   */
  total?: number;
  /** The list of invoice charge data */
  invoiceCharges?: InvoiceChargeDto[];
}

export interface ResponseDtoInvoiceChargeSearchResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceChargeSearchResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface AnalyticFilterColumnRequestDto {
  /** Request DTO for analytic search queries */
  searchRequest?: AnalyticSearchRequestDto;
  /** The value to search for in the analytic filter column */
  searchValue?: string;
  /** Page. */
  page?: PageDto;
}

/** Shipment Analytics Metadata DTO containing distinct values for a specific column */
export interface AnalyticFilterColumnDto {
  /** The column name that was queried */
  columnName?: string;
  /** List of distinct values for the column */
  values?: Record<string, number>;
  /**
   * Total count of distinct values
   * @format int32
   */
  totalCount?: number;
  /** Page. */
  page?: PageDto;
}

export interface ResponseDtoAnalyticFilterColumnDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Shipment Analytics Metadata DTO containing distinct values for a specific column */
  data?: AnalyticFilterColumnDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** A list of aggregated key metric data points, grouped by the specified granularity (daily, weekly, monthly, quarterly and yearly), based on the filters applied by the user */
export interface AggregatedDto {
  /** The value representing the grouping criterion used for data aggregation. For example, if data is grouped by service provider, this will be the service provider's name */
  aggregatedUnit?: string;
  /** Total amount of the invoices received for the filters applied */
  totalAmount?: number;
  /** The total CO2 emissions in tons for the aggregated data */
  totalCo2Emissions?: number;
  /** Chargeable weight (in kg) for the aggregated data. This is the weight used to determine freight charges */
  chargeableWeight?: number;
  /** Gross weight (in kg) for the aggregated data, representing the combined weight of all shipments including packaging and contents */
  grossWeight?: number;
  /** Volume in m3 of all the cargo in the aggregated data */
  volume?: number;
  /**
   * Total number of shipments in the data
   * @format int64
   */
  noShipments?: number;
  /**
   * Total number of charges in the aggregated data
   * @format int64
   */
  noCharges?: number;
  /**
   * Total number of invoices in the aggregated data
   * @format int64
   */
  noInvoices?: number;
}

/** The data returned by the operation, if any */
export interface ChartResponseDto {
  /** A list of aggregated key metric data points, grouped by the specified granularity (daily, weekly, monthly, quarterly and yearly), based on the filters applied by the user */
  aggregated?: AggregatedDto[];
  /** The start and end dates that define the period for which the data is retrieved */
  dateRange?: RangeDto;
  /** Represents the units of the data returned */
  meta?: MetaDto;
}

/** Represents the units of the data returned */
export interface MetaDto {
  /** The currency used to display the financial informations such as the total amount. This can be either USD (by default) or SGD, MYR */
  currency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /** The unit of measurement for gross weight. The default is kg */
  grossWeightUnit?: string;
  /** The unit of measurement for chargeable weight. The default is kg */
  chargeableWeightUnit?: string;
  /** The unit of measurement for CO2 emissions. The default is tons */
  co2EmissionUnit?: string;
  /** The unit of measurement for volume. The default is m3 */
  volumeUnit?: string;
}

/** The start and end dates that define the period for which the data is retrieved */
export interface RangeDto {
  /** The start date of the range in (YYYY-MM-DD) */
  from?: string;
  /** The end date of the range in (YYYY-MM-DD) */
  to?: string;
}

export interface ResponseDtoChartResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ChartResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSetCurrencyEnum {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * The data returned by the operation, if any
   * @uniqueItems true
   */
  data?: (
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW'
  )[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ExchangeRateAmountReCalculationRequest {
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  invoiceIds?: string[];
}

/** Represents the current state and progress of a background job */
export interface JobTrackerResponse {
  /**
   * Unique identifier of the job
   * @format uuid
   */
  id?: string;
  /** Type of background job (e.g. BULK_DELETE, REPROCESS) */
  type?: 'BULK_DELETE' | 'REPROCESS' | 'OPENSEARCH_SYNC';
  /** Current lifecycle status (PENDING, IN_PROGRESS, COMPLETED, FAILED, CANCELLED) */
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
  /** Type-specific input parameters as a raw JSON string. For BULK_DELETE: {"mode":"BY_PROVIDER","serviceProviderCode":"ACME"} */
  params?: string;
  /** Human-readable progress or result summary updated during execution. Example: "Deleted 3000 / 5432 invoices for provider ACME" */
  detail?: string;
  /** Error message if status is FAILED; null otherwise */
  error?: string;
  /**
   * UUID of the user who triggered this job
   * @format uuid
   */
  requestedById?: string;
  /**
   * Timestamp when the job was created
   * @format date-time
   */
  createdOn?: string;
  /**
   * Timestamp of the most recent update to this job record
   * @format date-time
   */
  updatedOn?: string;
}

export interface ResponseDtoJobTrackerResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Represents the current state and progress of a background job */
  data?: JobTrackerResponse;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoBackgroundShipmentPerformResultDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Background Shipment perform result Data Transfer Object DTO. */
  data?: BackgroundShipmentPerformResultDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface UpdatingS3FileMetadataReq {
  /** @format uuid */
  pipelineId: string;
  dataPipelineConfigId?: string;
  /** @format int32 */
  extractedPage?: number;
}

export interface UpdatingResolutionStatusRequest {
  status: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
  message?: string;
  resolutionType: 'ISUSR' | 'ISSYS';
}

export interface ResponseDtoGettingFileResolutionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Getting file resolution Data Transfer Object DTO. */
  data?: GettingFileResolutionDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListWorkflowDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: WorkflowDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListWorkflowRuleDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: WorkflowRuleDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoWorkflowRuleDescriptionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: WorkflowRuleDescriptionDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface WorkflowRuleDescriptionDto {
  /** Invoice conditions for the workflow rule */
  invoiceConditions?: Record<string, string>;
  /** Shipment conditions for the workflow rule */
  shipmentConditions?: Record<string, string>;
  /** Post actions for the workflow rule */
  postActions?: Record<string, string>;
  /** Activity log actions for the workflow rule */
  activityLogActions?: Record<string, string>;
}

export interface ResponseDtoListUserDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: UserDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListUnlocodeMappingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: UnlocodeMappingDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListSystemConfigurationDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: SystemConfigurationDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSystemConfigurationDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: SystemConfigurationDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListRawShipmentDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: RawShipmentDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** No contract Response Data Transfer Object DTO. */
export interface NoContractResponseDto {
  /** Matching Service Data Transfer Object DTO. */
  matchedService?: MatchingServiceDto;
  /** Matching Service Data Transfer Object DTO. */
  unmatchedService?: MatchingServiceDto;
  /** Partial matching services. */
  partialMatchingServices?: PartialMatchingServiceDto[];
}

export interface ResponseDtoNoContractResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** No contract Response Data Transfer Object DTO. */
  data?: NoContractResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Suggestion for charge domain and leg type for a charge */
export interface ChargeCategorizationSuggestionDto {
  /**
   * Charge ID
   * @format uuid
   */
  chargeId?: string;
  /** Original charge name from the invoice */
  chargesName?: string;
  /** Suggested charge domain */
  suggestedChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Suggested leg type */
  suggestedLegType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** Suggested charge sub-domain */
  suggestedChargeSubDomain?: string;
  /** Suggested contract charge unit */
  suggestedContractChargeUnit?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  /** Source of the match: EXACT_MAPPING or HISTORICAL_CHARGE */
  matchSource?: string;
  /**
   * Confidence score: 100 for exact mapping, fuzzy score for historical
   * @format int32
   */
  confidence?: number;
  /** Name of the historical charge that matched (only for HISTORICAL_CHARGE) */
  matchedChargeName?: string;
  /** ID of the historical charge that matched (only for HISTORICAL_CHARGE) */
  matchedChargeId?: string;
}

export interface ResponseDtoListChargeCategorizationSuggestionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ChargeCategorizationSuggestionDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Answer options. */
export interface DeviationQuestionAnswerOptionDto {
  /** @format uuid */
  id?: string;
  name?: string;
  /** @format int32 */
  displayOrder?: number;
  type?:
    | 'YES'
    | 'NO'
    | 'RECURRING'
    | 'ONE_OFF'
    | 'YES_BUT_WITH_CHANGE_RECURRENCE'
    | 'LEG_ONE'
    | 'LEG_TWO'
    | 'LEG_THREE'
    | 'NOT_REQUIRED'
    | 'OTHER'
    | 'RESOLVE_ALL';
  nextQuestions?: DeviationQuestionDto[];
}

/** Deviation question Data Transfer Object DTO. */
export interface DeviationQuestionDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** Name. */
  name?: string;
  /** Deviation Type. */
  deviationType?: 'UNIT_PRICE' | 'QUANTITY' | 'NEW_CHARGE' | 'DOUBLE_CHARGE' | 'APPROVAL_CHECK' | 'DISCOUNT';
  /** Question Type. */
  questionType?: 'TEXT' | 'SELECT' | 'RADIO' | 'DATE' | 'DATE_RANGE' | 'DATE_TIME' | 'DATE_TIME_RANGE' | 'MULTIPLE_SELECT';
  /** Question domain Type. */
  questionDomainType?:
    | 'WAS_SHIPMENT_SPECIAL_INSTRUCTION_GIVEN'
    | 'WHAT_WAS_THE_SHIPMENT_SPECIAL_INSTRUCTION'
    | 'IS_THIS_RECURRING_CHARGE'
    | 'IS_THIS_DUE_TO_MARKET_CONDITION'
    | 'WHAT_IS_THE_NEW_MARKET_CONDITION'
    | 'PERIOD_OF_EXPECTED_RECURRENCE'
    | 'DO_YOU_ACCEPT_THIS_CHARGE_AS_IS'
    | 'CHARGE_REJECTED_REASON_TEXT'
    | 'DO_YOU_ACCEPT_THIS_QUANTITY'
    | 'WHY_DO_YOU_ACCEPT_THIS_QUANTITY'
    | 'WHY_DO_YOU_REJECT_THIS_QUANTITY'
    | 'IS_THERE_REASON_FOR_DOUBLE_CHARGE'
    | 'WHAT_IS_THE_REASON_FOR_DOUBLE_CHARGE'
    | 'DO_YOU_ACCEPT_THIS_DOUBLE_CHARGE'
    | 'WHY_DO_YOU_REJECT_THIS_DOUBLE_CHARGE'
    | 'DO_YOU_ACCEPT_THIS_DEVIATION_FROM_OPERATION'
    | 'DO_YOU_ACCEPT_THIS_DEVIATION'
    | 'WHY_DO_YOU_ACCEPT_THIS_DEVIATION'
    | 'WHY_DO_YOU_ACCEPT_THIS_DEVIATION_WITH_RECURRENCE_CHANGE'
    | 'WHY_DO_YOU_REJECT_THIS_CHARGE'
    | 'MODIFY_RECURRENCE'
    | 'WHY_DO_YOU_REJECT_THIS_DEVIATION'
    | 'CHANGE_LEG_OF_INVOICE_CHARGE'
    | 'DO_YOU_HAVE_ALL_REQUIRED_APPROVALS_FOR_THE_ACCESSORIAL_CHARGES'
    | 'DO_YOU_HAVE_ALL_THE_REQUIRED_APPROVALS_FOR_THIS_SERVICE'
    | 'DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_IT'
    | 'WHY_DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_ONE_OFF'
    | 'WHY_DO_YOU_REJECT_THIS_CHARGE_AS_IT'
    | 'WHY_DO_YOU_ACCEPT_THIS_NEW_CHARGE_AS_RECURRING'
    | 'WHAT_ARE_YOU_MISSING_FOR_THE_APPROVAL_OF_THE_ACCESSORIAL_CHARGES'
    | 'WHAT_ARE_YOU_MISSING_FOR_THE_APPROVAL_OF_THIS_SERVICE'
    | 'WHY_IS_NOT_REQUIRED'
    | 'SELECT_A_CHARGE_NAME'
    | 'WHY_DO_YOU_ACCEPT_REJECT_THESE_CHARGES';
  /** Approval Type. */
  approvalType?: 'ACCESSORIAL_CHARGE' | 'SERVICE_TYPE';
  /** Answer options. */
  answerOptions?: DeviationQuestionAnswerOptionDto[];
}

export interface ResponseDtoMapDeviationWorkflowListDeviationQuestionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, DeviationQuestionDto[]>;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Cross-invoice charge details for a double charge deviation. */
export interface DoubleChargeDetailDto {
  /**
   * The deviation ID this detail belongs to.
   * @format uuid
   */
  deviationId?: string;
  /** Charge line items from current and other invoices involved in the double charge. */
  invoiceLines?: DoubleChargeInvoiceLineDto[];
}

/** A charge line item from an invoice involved in a double charge. */
export interface DoubleChargeInvoiceLineDto {
  /**
   * The charge ID.
   * @format uuid
   */
  chargeId?: string;
  /**
   * The invoice ID this charge belongs to.
   * @format uuid
   */
  invoiceId?: string;
  /**
   * The shipment invoice ID this charge belongs to.
   * @format uuid
   */
  shipmentInvoiceId?: string;
  /** The invoice number for display. */
  invoiceNumber?: string;
  /** The invoice status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** The charge name. */
  chargeName?: string;
  /** The charge quantity. */
  quantity?: number;
  /** The charge unit price. */
  unitPrice?: number;
  /** The charge currency. */
  currency?: string;
  /** Whether this line can be toggled in the resolution UI. True only for FLAGGED invoices that are not the current invoice. */
  editable?: boolean;
  /**
   * The deviation ID on this charge, if one exists (for resolution).
   * @format uuid
   */
  deviationId?: string;
  /** The type of deviation on this charge (e.g., DOUBLE_CHARGE, UNIT_PRICE), if one exists. */
  deviationType?: 'UNIT_PRICE' | 'QUANTITY' | 'NEW_CHARGE' | 'DOUBLE_CHARGE' | 'APPROVAL_CHECK' | 'DISCOUNT';
  /** The current deviation workflow of the shipment invoice. */
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** The status of the deviation on this charge, if one exists. */
  deviationStatus?:
    | 'OPERATION_UNFILLED'
    | 'OPERATION_REJECTED'
    | 'OPERATION_APPROVED'
    | 'PROCUREMENT_REJECTED'
    | 'PROCUREMENT_APPROVED'
    | 'SUPPLY_CHAIN_APPROVED'
    | 'SUPPLY_CHAIN_REJECTED'
    | 'FINANCE_APPROVED'
    | 'FINANCE_REJECTED'
    | 'FINANCE_UNFILLED'
    | 'OPS_ADMIN_UNFILLED'
    | 'OPS_ADMIN_APPROVED'
    | 'OPS_ADMIN_REJECTED'
    | 'OPS_MANAGER_APPROVED'
    | 'OPS_MANAGER_REJECTED';
}

export interface ResponseDtoDoubleChargeDetailDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Cross-invoice charge details for a double charge deviation. */
  data?: DoubleChargeDetailDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Configured Rate Card Detail  */
export interface ConfiguredRateCardDetail {
  /**
   * Represents a transportation service offered by a service provider with specific parameters and pricing.
   *
   * A shipping service defines a transportation offering with a specific set of characteristics that
   * determines the applicable charges and rates. It serves as a mapping mechanism to match shipments
   * with their corresponding service level and associated costs for transportation.
   *
   * Key Concepts:
   * - Each service is linked to specific charges and rates in the system
   * - Used to map shipments to services to determine transportation costs
   * - Optional fields act as wildcards - empty values match any shipment value
   * - Provides granular control over service categorization and pricing
   *
   * Route Architecture:
   * The route field uses a Union type to support two different routing models:
   *
   * 1. Route (Point-to-Point): Specific origin-destination pairs using UN/LOCODE identifiers
   *    - Used when pricing/service is specific to exact location combinations
   *    - Provides precise geographic control over service definitions
   *    - Example: USNYC (New York) to DEHAM (Hamburg)
   *
   * 2. ZoneRoute (Zone-Based): Geographic zones covering multiple location pairs
   *    - Used when same pricing applies to multiple origin-destination combinations
   *    - Simplifies rate management for regional or area-based services
   *    - Example: "EU-WEST" zone covering multiple European city combinations
   *
   * Carrier vs Service Provider:
   * - Service Provider: The entity with whom the contract is signed
   * - Carrier: The actual transportation company handling the international freight leg
   *           (e.g., airline for air, shipping line for sea, trucking company for road)
   */
  shippingService?: ShippingServiceDto;
  /**
   * Start date of the rate card.
   * @format date
   */
  startDate?: string;
  /**
   * End date of the rate card.
   * @format date
   */
  endDate?: string;
  /** Container charges. */
  containerCharges?: ContractContainerCharge[];
  /** Shipment charges. */
  shipmentCharges?: ContractShipmentCharge[];
  /** Declaration charges. */
  declarationCharges?: ContractDeclarationCharge[];
  /** Weight charges. */
  weightCharges?: ContractWeightCharge[];
  /** Percentage charges. */
  percentageCharges?: ContractPercentageCharge[];
}

/** Configured Rate Card Response Data Transfer Object DTO. */
export interface ConfiguredRateCardResponseDto {
  /** Modality of the shipment. */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /** Service Provider Code of the shipment. */
  serviceProviderCode?: string;
  /** Service Provider Name of the shipment. */
  serviceProviderName?: string;
  /** Configured Rate Card Detail  */
  configuredRateCardDetail?: ConfiguredRateCardDetail;
}

/** Container charges. */
export interface ContractContainerCharge {
  /** @format uuid */
  id?: string;
  code?: string;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  containerType?: 'STANDARD' | 'HIGH_CUBE' | 'OPEN_TOP' | 'FLAT_RACK';
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain?: string;
  unitPrice20?: number;
  unitPrice40?: number;
  currency?: string;
  active?: boolean;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  deviationExcluded?: boolean;
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  duplicateCheckFields?: Record<string, object>;
}

/** Declaration charges. */
export interface ContractDeclarationCharge {
  /** @format uuid */
  id?: string;
  code?: string;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain?: string;
  unitPrice?: number;
  currency?: string;
  active?: boolean;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  deviationExcluded?: boolean;
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  duplicateCheckFields?: Record<string, object>;
}

/** Percentage charges. */
export interface ContractPercentageCharge {
  /** @format uuid */
  id?: string;
  code?: string;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain?: string;
  value?: number;
  minimumPrice?: number;
  currency?: string;
  eligibleChargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  eligibleChargeSubDomain?: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  active?: boolean;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  deviationExcluded?: boolean;
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  duplicateCheckFields?: Record<string, object>;
}

/** Shipment charges. */
export interface ContractShipmentCharge {
  /** @format uuid */
  id?: string;
  code?: string;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain?: string;
  currency?: string;
  unitPrice?: number;
  active?: boolean;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  deviationExcluded?: boolean;
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  duplicateCheckFields?: Record<string, object>;
}

/** Weight charges. */
export interface ContractWeightCharge {
  /** @format uuid */
  id?: string;
  code?: string;
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  weightServiceType?: string;
  chargeDomain?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  chargeSubDomain?: string;
  unitPrice?: number;
  currency?: string;
  chargeUnit?: 'KG' | 'CBM' | 'PKG' | 'LBS' | 'REF';
  minimumPrice?: number;
  minimumChargeableWeight?: number;
  maximumChargeableWeight?: number;
  includedQuantity?: number;
  weightMeasurementSystem?: string;
  calculationMethod?:
    | 'MAX_OF_MIN_OR_UNIT_PRICE_UNIQUE'
    | 'MIN_AND_UNIT_PRICE_UNIQUE'
    | 'MAX_OF_MIN_OR_UNIT_PRICE_MAX_CHARGE_UNIT'
    | 'MIN_AND_UNIT_PRICE_MAX_CHARGE_UNIT';
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
  /** End time for this weight charge order */
  startTime?: LocalTime;
  /** End time for this weight charge order */
  endTime?: LocalTime;
  active?: boolean;
  accessorial?: boolean;
  approval?: boolean;
  outlay?: boolean;
  deviationExcluded?: boolean;
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  duplicateCheckFields?: Record<string, object>;
}

export interface ResponseDtoConfiguredRateCardResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Configured Rate Card Response Data Transfer Object DTO. */
  data?: ConfiguredRateCardResponseDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** List of invoice statuses associated with the service provider */
export interface InvoiceStatusCountDto {
  /** Status of the invoice */
  status?: string;
  /**
   * Count of invoices with the given status
   * @format int64
   */
  count?: number;
}

export interface ResponseDtoListServiceProviderDetailsDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ServiceProviderDetailsDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface ServiceProviderDetailsDto {
  /** Full legal or commercial name of the service provider */
  serviceProviderName?: string;
  /** Short internal name, code or acronym as unique identifier for the service provider, used for concise display and quick reference */
  serviceProviderCode?: string;
  /** The dominant modality (e.g., SEA, AIR) for this shipping service */
  modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  /**
   * Unique identifier of the service provider
   * @format int64
   */
  id: number;
  /** List of invoice statuses associated with the service provider */
  invoiceStatuses: InvoiceStatusCountDto[];
  /**
   * Date when the latest invoice was created
   * @format date-time
   */
  latestInvoiceCreatedDate?: string;
  /**
   * Total count of shipping services associated with the service provider
   * @format int64
   */
  totalShippingServiceCount?: number;
  /**
   * Start date of the latest rate card associated with the service provider
   * @format date
   */
  latestRateCardStartDate?: string;
  /**
   * End date of the latest rate card associated with the service provider
   * @format date
   */
  latestRateCardEndDate?: string;
}

export interface ResponseDtoServiceProviderOverViewDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Service Provider over view Data Transfer Object DTO. */
  data?: ServiceProviderOverViewDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListRouteDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: RouteDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Route Data Transfer Object DTO. */
export interface RouteDto {
  /** Route. */
  route?: string;
  /** Zones. */
  zones?: ZoneDto[];
}

/** Data for Overall Report. */
export interface OverallReportDto {
  /**
   * Total number of invoices
   * @format int64
   */
  invoiceCount?: number;
  /**
   * Total number of shipments
   * @format int64
   */
  shipmentCount?: number;
  /** Code of the service provider */
  serviceProviderCode?: string;
  /**
   * Count of flagged shipments
   * @format int64
   */
  flaggedShipmentCount?: number;
  /**
   * Count of NRCF shipments
   * @format int64
   */
  nrcfShipmentCount?: number;
  /**
   * Amount of NRCF shipments
   * @format double
   */
  nrcfShipmentAmount?: number;
  /**
   * Count of deviations
   * @format int64
   */
  deviationCount?: number;
  /**
   * Amount of deviations
   * @format double
   */
  deviationAmount?: number;
  /** Code of the billed entity */
  billedEntityCode?: string;
  /**
   * Total amount of charges
   * @format double
   */
  chargeTotalAmount?: number;
  /**
   * Count of audited shipments
   * @format int64
   */
  auditedShipmentCount?: number;
  /**
   * Amount of audited shipments
   * @format double
   */
  auditedShipmentAmount?: number;
  /**
   * Count of approved shipments
   * @format int64
   */
  approvedShipmentCount?: number;
  /**
   * Amount of approved shipments
   * @format double
   */
  approvedShipmentAmount?: number;
  /**
   * Amount of flagged shipments
   * @format double
   */
  flaggedShipmentAmount?: number;
  /**
   * Count of failed shipments
   * @format int64
   */
  failedShipmentCount?: number;
  /**
   * Amount of failed shipments
   * @format double
   */
  failedShipmentAmount?: number;
  /**
   * Total amount of invoices
   * @format double
   */
  invoiceTotalAmount?: number;
}

export interface ResponseDtoListOverallReportDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: OverallReportDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListMapStringObject {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, object>[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data for Consolidation Report. */
export interface ConsolidationReportDto {
  /**
   * Count of shipments
   * @format int64
   */
  shipmentCount?: number;
  /** Type of service */
  serviceType?: string;
  /** Domain of the charge */
  chargeDomain?: string;
  /** Unit price */
  unitPrice?: number;
  /**
   * Estimated departure date
   * @format date-time
   */
  estimatedDepartureDate?: string;
  /** Name of the charges */
  chargesName?: string;
  /** Minimum price */
  minimumPrice?: number;
  /** Type of charge */
  chargeType?: string;
  /** Currency of the charges */
  chargesCurrency?: string;
  /** Included quantity */
  includedQuantity?: number;
  /** Volume in cubic meters */
  volumeInCbm?: number;
  /** Chargeable weight in kilograms */
  chargeableWeightInKg?: number;
  /** Gross weight in kilograms */
  grossWeightInKg?: number;
  /** Route information */
  route?: string;
  /** Special type of service */
  specialType?: string;
  /** Name of the shipper */
  shipperName?: string;
  /** Name of the consignee */
  consigneeName?: string;
  /** Name of the billing party */
  billingPartyName?: string;
  /** Amount after consolidation */
  amountAfterConsolidation?: number;
  /** Amount of the charge */
  chargeAmount?: number;
}

/** The data returned by the operation, if any */
export interface PageConsolidationReportDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  size?: number;
  content?: ConsolidationReportDto[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ResponseDtoPageConsolidationReportDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: PageConsolidationReportDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListContractChargeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: (ContainerChargeDto | DeclarationChargeDto | PercentageChargeDto | ShipmentChargeDto | WeightChargeDto)[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** No contract report DTO. */
export interface NoContractReportDto {
  /**
   * Total number of records.
   * @format int32
   */
  total?: number;
  /** Service provider name. */
  serviceProvider?: string;
  /** Place of loading. */
  placeOfLoading?: string;
  /** Place of discharge. */
  placeOfDischarge?: string;
  /** Shipper name. */
  shipper?: string;
  /** Consignee name. */
  consignee?: string;
  /** Modality. */
  modality?: string;
  /** Type of service (e.g., 'FCL', 'LCL'). */
  service?: string;
  /** Special service type. */
  type?: string;
  /** Carrier name. */
  carrier?: string;
  /** Incoterm. */
  incoterm?: string;
  /** ETDs (Estimated Time of Departure) in YYYY-MM-DD format. */
  etds?: string;
  /** Comma-separated invoice numbers. */
  invoiceNumbers?: string;
  /** Partial matching services. */
  partialMatchingServices?: string[];
}

export interface ResponseDtoListNoContractReportDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: NoContractReportDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Notification containing invoice processing batch information and status summary */
export interface NotificationDto {
  /**
   * List of service provider code identifiers associated with this notification
   * @uniqueItems true
   */
  serviceProviderCodes?: string[];
  /**
   * Transportation modalities involved in this notification.
   * @uniqueItems true
   */
  modalities?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT')[];
  /**
   * Count of invoices requiring attention due to exceptions or validation issues
   * @format int64
   * @example 3
   */
  flaggedInvoices?: number;
  /**
   * Count of invoices that have been approved in this batch
   * @format int64
   * @example 12
   */
  approvedInvoices?: number;
  /**
   * Count of invoices that have been rejected in this batch
   * @format int64
   * @example 2
   */
  rejectedInvoices?: number;
  /**
   * Count of invoices that are marked as partial in this batch
   * @format int64
   * @example 4
   */
  partialInvoices?: number;
  /**
   * Count number of duplicate files
   * @format int64
   * @example 2
   */
  duplicateFiles?: number;
  /**
   * Count of invoices that encountered errors during processing
   * @format int64
   * @example 1
   */
  errorInvoices?: number;
  /**
   * Count of invoices still being processed in this batch
   * @format int64
   * @example 5
   */
  processingInvoices?: number;
  /**
   * Count of files that are resolved as Not an Invoice
   * @format int64
   * @example 2
   */
  resolvedAsNotAnInvoices?: number;
  /**
   * Count of files that are resolved as Missing Required Field
   * @format int64
   * @example 3
   */
  resolvedAsMissingRequiredFieldInvoices?: number;
  /**
   * Count of files that are resolved as Inconsistent Shipment Data
   * @format int64
   * @example 1
   */
  resolvedAsInconsistentShipmentDataInvoices?: number;
  /**
   * Total number of files in this notification batch
   * @format int64
   * @example 23
   */
  totalFiles?: number;
  /**
   * Whether this notification has been read/seen by the user
   * @example false
   */
  isRead?: boolean;
  /**
   * Unique identifier for the file processing batch
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  batchId?: string;
  /**
   * Unique identifier for this notification
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174111"
   */
  notificationId?: string;
  /**
   * Current status of this notification
   * @example "BATCH_PROCESSED"
   */
  notificationStatus?: 'EMAIL_RECEIVED' | 'BATCH_PROCESSED_WITH_WARNINGS' | 'BATCH_PROCESSED';
  /**
   * The source system or method that generated this notification
   * @example "EMAIL"
   */
  notificationSourceType?: 'EMAIL' | 'GENERAL_CONFIG' | 'SPECIFIC_CONFIG';
  /**
   * Username or identifier of the person who uploaded the batch
   * @example "john.smith@company.com"
   */
  uploadedBy?: string;
  /**
   * Timestamp when the batch was uploaded
   * @format date-time
   */
  uploadedOn?: string;
  /**
   * Set of billed entity IDs associated with this notification
   * @uniqueItems true
   * @example [1001,1002]
   */
  billedEntityIds?: number[];
  /**
   * Set of service provider IDs associated with this notification
   * @uniqueItems true
   * @example [2001,2002]
   */
  serviceProviderIds?: number[];
  /**
   * Count of newly created invoices in this batch
   * @format int64
   * @example 15
   */
  newInvoices?: number;
}

/** Response containing notification details. */
export interface NotificationResponse {
  /** Indicates if there are unread notifications. */
  isRead?: boolean;
  /** List of notifications. */
  notifications?: NotificationDto[];
}

export interface ResponseDtoNotificationResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Response containing notification details. */
  data?: NotificationResponse;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface AdminDashboardMetricDto {
  /**
   * Number of new issues
   * @format int64
   */
  newIssues?: number;
  /**
   * Number of issues under review
   * @format int64
   */
  issuesUnderReview?: number;
  /**
   * Number of file ingestion failures
   * @format int64
   */
  fileIngestionFailures?: number;
  /**
   * Total number of files uploaded
   * @format int64
   */
  totalFilesUploaded?: number;
  /**
   * Number of extracted pages
   * @format int64
   */
  extractedPages?: number;
}

export interface ResponseDtoAdminDashboardMetricDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: AdminDashboardMetricDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface LoggedInUserDto {
  /**
   * Unique identifier of the user
   * @format uuid
   */
  id?: string;
  /** First name of the user */
  firstName?: string;
  /** Middle name of the user */
  middleName?: string;
  /** Last name of the user */
  lastName?: string;
  /** Email address of the user */
  email?: string;
  /** Display role of the user */
  displayRole?: string;
  /**
   * Roles assigned to the user
   * @uniqueItems true
   */
  roles?: string[];
  /**
   * Represents a legal entity that participates in shipping transactions or contractual relationships.
   *
   * Legal entities can serve multiple roles in the shipping ecosystem and can be either internal
   * or external to the organization:
   *
   * Internal Legal Entities:
   * - The organization itself or its subsidiaries
   * - Parent or child entities within the corporate structure
   * - Entities that sign contracts with service providers
   * - Billing entities responsible for transportation costs
   *
   * External Legal Entities:
   * - Business partners and clients
   * - Third-party shippers sending goods
   * - Consignees receiving shipments
   * - Any other external party involved in the supply chain
   *
   * The same legal entity can play different roles in different transactions (e.g., sometimes
   * as a shipper, other times as a consignee, or as the contracting party with service providers).
   */
  billedEntity?: LegalEntityDto;
  admin?: boolean;
  systemAdmin?: boolean;
}

export interface ResponseDtoLoggedInUserDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: LoggedInUserDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSetPermission {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * The data returned by the operation, if any
   * @uniqueItems true
   */
  data?: (
    | 'CAN_GIVE_PROCUREMENT_REVIEW'
    | 'CAN_GIVE_OPERATION_REVIEW'
    | 'CAN_GIVE_FINANCE_REVIEW'
    | 'CAN_GIVE_DISPUTE_REVIEW'
    | 'CAN_GIVE_NO_CONTRACT_REVIEW'
    | 'CAN_UPLOAD_INVOICE_FILE'
    | 'CAN_GIVE_SUPPLY_CHAIN_REVIEW'
    | 'CAN_GIVE_OPS_ADMIN_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L1_REVIEW'
    | 'CAN_GIVE_OPS_MANAGER_L2_REVIEW'
  )[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSetPermissionType {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * The data returned by the operation, if any
   * @uniqueItems true
   */
  data?: (
    | 'OPERATION'
    | 'PROCUREMENT'
    | 'SUPPLY_CHAIN'
    | 'DISPUTE'
    | 'FINANCE'
    | 'AUDIT'
    | 'REPORT'
    | 'PERFORMANCE'
    | 'RATECARD'
    | 'OPS_ADMIN'
    | 'OPS_MANAGER_L1'
    | 'OPS_MANAGER_L2'
  )[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListLocationDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: LocationDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface LegalEntityDetailsDto {
  /**
   * Unique identifier for the legal entity
   * @format int64
   */
  id?: number;
  /** Full legal name of the entity */
  name: string;
  /** Short internal name, code or acronym as unique identifier for the legal entity, used for concise display and quick reference */
  code: string;
  /** Indicates if the legal entity is active */
  active?: boolean;
  /** National currency of the legal entity (e.g., SGD, USD) */
  nationalCurrency?: string;
  /**
   * Identifier for the parent legal entity
   * @format int64
   */
  parentId?: number;
  /** Indicates if the legal entity is a billed entity */
  isBilledEntity?: boolean;
  /** The list of addresses associated with the legal entity */
  addresses?: LegalEntityAddressDto[];
  /** List of name aliases for the legal entity */
  nameAliases?: LegalEntityNameAliasDto[];
  /** List of sub-entities under the legal entity */
  subEntities?: LegalEntityDto[];
  /** List of invoice statuses associated with the service provider */
  invoiceStatuses: InvoiceStatusCountDto[];
}

export interface ResponseDtoListLegalEntityDetailsDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: LegalEntityDetailsDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface LegalEntity {
  /** @format int64 */
  id?: number;
  name?: string;
  code?: string;
  active?: boolean;
  nationalCurrency?: string;
  /** @format int64 */
  parentId?: number;
  isBilledEntity?: boolean;
  nameAliases?: LegalEntityNameAlias[];
  addresses?: LegalEntityAddress[];
  subEntities?: LegalEntity[];
  parentEntity?: LegalEntity;
}

export interface LegalEntityAddress {
  /** @format int64 */
  id?: number;
  legalEntity?: LegalEntity;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
  email?: string;
  fax?: string;
  phone?: string;
  locationName?: string;
  type?: 'PICK_UP' | 'DELIVERY' | 'LEGAL' | 'BILLING' | 'OFFICE' | 'HEAD_OFFICE';
  active?: boolean;
  /** The destination geo-coordinates of the legal entity */
  origin?: GeoCoordinates;
  /** The destination geo-coordinates of the legal entity */
  destination?: GeoCoordinates;
}

export interface LegalEntityNameAlias {
  /** @format int64 */
  id?: number;
  name?: string;
  type?: 'ACCOUNT_NUMBER' | 'NAME' | 'CITY';
  legalEntity?: LegalEntity;
}

export interface ResponseDtoShipment {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** List of shipments associated with the invoice */
  data?: Shipment;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface InvoiceProcessingStagesDto {
  currentStage?: string;
  pendingReviewers?: string[];
  stages?: StageEntryDto[];
}

export interface ResponseDtoInvoiceProcessingStagesDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceProcessingStagesDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface StageEntryDto {
  stage?: string;
  actionCategory?: string;
  action?: string;
  from?: string;
  to?: string;
  /** @format date-time */
  completedAt?: string;
  by?: string;
  comment?: string;
  status?: string;
  /** @format int32 */
  roundNumber?: number;
}

/** Base information structure containing quantity, impacted shipments, and total amount. */
export interface BaseInfo {
  /**
   * Quantity of issues or items.
   * @format int32
   */
  quantity?: number;
  /**
   * Set of shipment identifiers that are impacted.
   * @uniqueItems true
   */
  shipmentImpacted?: string[];
  /** Amount DTO. */
  totalAmount?: Amount;
}

/** Data Transfer Object containing summary information about various invoice issues. */
export interface InvoiceIssueSummaryDto {
  /** Base information structure containing quantity, impacted shipments, and total amount. */
  accessorialMissingApprovals?: BaseInfo;
  /** Base information structure containing quantity, impacted shipments, and total amount. */
  serviceTypeMissingApprovals?: BaseInfo;
  /** Base information structure containing quantity, impacted shipments, and total amount. */
  deviations?: BaseInfo;
  /** Base information structure containing quantity, impacted shipments, and total amount. */
  rejectedNRCFShipments?: BaseInfo;
}

export interface ResponseDtoInvoiceIssueSummaryDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object containing summary information about various invoice issues. */
  data?: InvoiceIssueSummaryDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface InvoiceFileUrlDto {
  /** name of the file */
  fileName?: string;
  /** URL of the file */
  fileUrl?: string;
  /** status of the invoice file processing */
  status?:
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE';
}

export interface ResponseDtoListInvoiceFileUrlDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceFileUrlDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface DeviationActivity {
  deviationType?: 'UNIT_PRICE' | 'QUANTITY' | 'NEW_CHARGE' | 'DOUBLE_CHARGE' | 'APPROVAL_CHECK' | 'DISCOUNT';
  chargeName?: string;
  unitPrice?: number;
  chargesCurrency?: string;
  mappedChargeDomain?: string;
  mappedChargeSubDomain?: string;
  mappedLegType?: string;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
}

/** Email delivery history Data Transfer Object DTO. */
export interface EmailDeliveryHistoryDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /** Type. */
  type?: 'INVOICE_APPROVAL' | 'INVOICE_REJECTION';
  /** Subject. */
  subject?: string;
  /**
   * Delivery Time.
   * @format date-time
   */
  deliveryTime?: string;
  /** Attachment file. */
  attachmentFile?: string;
  /** Receiver. */
  receiver?: string;
  /**
   * Creation timestamp on.
   * @format date-time
   */
  createdOn?: string;
  /** Creation timestamp by. */
  createdBy?: string;
  /**
   * Last update timestamp on.
   * @format date-time
   */
  updatedOn?: string;
}

/** The data returned by the operation, if any */
export interface EntityActivityLogDto {
  activityType?:
    | 'INVOICE_UPLOAD'
    | 'STATUS_UPDATE'
    | 'DISPUTE_UPDATE'
    | 'CREDIT_NOTE_UPDATE'
    | 'DOCUMENT_UPDATE'
    | 'DEVIATION_UPDATE'
    | 'NO_CONTRACT_FOUND_UPDATE'
    | 'RATE_CARD_MAP_UPDATE';
  objectStatus?:
    | 'OBJECT_UPLOADED'
    | 'OBJECT_FLAGGED'
    | 'OBJECT_APPROVED'
    | 'OBJECT_TO_APPROVE'
    | 'OBJECT_TO_REJECT'
    | 'OBJECT_PENDING_DOCUMENT'
    | 'OBJECT_REJECTED'
    | 'OBJECT_NO_CONTRACT_FOUND'
    | 'OBJECT_DOCUMENT_UPDATED'
    | 'OBJECT_DEVIATION_UPDATED'
    | 'OBJECT_RATE_CARD_MAPPED'
    | 'OBJECT_ACCEPTED_AS_SPOT_SHIPMENT';
  actionOnObject?:
    | 'UPLOADED_ON_OPERATION'
    | 'SENT_TO_OPERATION'
    | 'SENT_TO_PROCUREMENT'
    | 'SENT_TO_FINANCE'
    | 'SENT_TO_SUPPLY_CHAIN'
    | 'SENT_TO_OPS_ADMIN'
    | 'SENT_TO_OPS_MANAGER'
    | 'SENT_TO_OPS_MANAGER_L1'
    | 'SENT_TO_OPS_MANAGER_L2'
    | 'DISPUTE_STARTED'
    | 'DISPUTE_RESOLVED'
    | 'DISPUTE_CANCELED'
    | 'CREDIT_NOTE_UPLOADED'
    | 'CREDIT_NOTE_DELETED'
    | 'DOCUMENT_UPLOADED'
    | 'DOCUMENT_DELETED'
    | 'MARKED_PENDING'
    | 'MARKED_TO_REJECT'
    | 'MARKED_TO_APPROVE'
    | 'MARKED_READY_FOR_PAYMENT'
    | 'REJECTED'
    | 'APPROVED'
    | 'ACCEPTED_AS_SPOT_SHIPMENT'
    | 'PENDING_REVIEW'
    | 'NEW_CHARGE_ACCEPTED_ONE_OFF'
    | 'NEW_CHARGE_ACCEPTED_RECURRING'
    | 'NEW_CHARGE_REJECTED'
    | 'NEW_CHARGE_MAPPED_OTHER'
    | 'MAPPED_TO_RATE_CARD'
    | 'PERCENTAGE_CHARGE_RECALCULATED'
    | 'RECURRING_CHARGE_RECALCULATED';
  disputeAgreementType?:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE';
  deviationActivity?: DeviationActivity;
  actionBy?: string;
  /** @format date-time */
  createdOn?: string;
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  /** Email delivery history Data Transfer Object DTO. */
  emailDeliveryHistory?: EmailDeliveryHistoryDto;
  documentName?: string;
  invoiceStatusOverview?: InvoiceStatusOverview;
  shipmentOverview?: ShipmentOverview;
  shipmentLogs?: ShipmentLog[];
}

export interface InvoiceStatusOverview {
  /** @format int32 */
  procurementReview?: number;
  /** @format int32 */
  operationReview?: number;
  /** @format int32 */
  rejected?: number;
  /** @format int32 */
  approved?: number;
  /** @format int32 */
  underReview?: number;
}

export interface ResponseDtoListEntityActivityLogDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: EntityActivityLogDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ShipmentLog {
  /** @format uuid */
  shipmentInvoiceId?: string;
  shipmentNumber?: string;
  status?: 'FLAGGED' | 'APPROVED' | 'SPOT_SHIPMENT' | 'REJECTED' | 'UNDER_REVIEW';
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  /** @format int32 */
  numberOfApprovals?: number;
  /** List of nested activity logs */
  activityLogs?: EntityActivityLogDto[];
}

export interface ShipmentOverview {
  /** @format int64 */
  unitPrice?: number;
  /** @format int64 */
  quantity?: number;
  /** @format int64 */
  newCharge?: number;
  /** @format int64 */
  doubleCharge?: number;
  /** @format int64 */
  approvalCheck?: number;
  /** @format int64 */
  approval?: number;
}

export interface ResponseDtoMapDeviationWorkflowListDeviationQuestionUserResponseDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, DeviationQuestionUserResponseDto[]>;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface EmailRecord {
  /** @format uuid */
  id?: string;
  messageId?: string;
  externalEmailId?: string;
  sender?: string;
  cc?: string;
  bcc?: string;
  recipientTo?: string;
  subject?: string;
  /** @format date-time */
  receiptTime?: string;
  attachmentFile?: string;
  content?: string;
  receiverLegalEntities?: EmailRecordLegalEntity[];
  /** @format date-time */
  createdOn?: string;
  createdBy?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @uniqueItems true */
  legalEntities?: LegalEntity[];
}

export interface EmailRecordLegalEntity {
  /** @format uuid */
  id?: string;
  emailRecord?: EmailRecord;
  legalEntity?: LegalEntity;
  /** @format date-time */
  createdOn?: string;
}

/** The data returned by the operation, if any */
export interface Invoice {
  /** @format uuid */
  id?: string;
  /** @format int64 */
  billedPartyId?: number;
  invoiceNumber?: string;
  /** @format date */
  invoiceDate?: string;
  /** @format date */
  dueDate?: string;
  /** @format date */
  paymentDate?: string;
  terms?: string;
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  currentDeviationWorkflow?:
    | 'OPERATION_REVIEW'
    | 'PROCUREMENT_REVIEW'
    | 'PENDING_REVIEW'
    | 'DISPUTE_REVIEW'
    | 'PROCUREMENT_NO_CONTRACT_REVIEW'
    | 'FINANCE_REVIEW'
    | 'SUPPLY_CHAIN_REVIEW'
    | 'OPS_ADMIN_REVIEW'
    | 'OPS_ADMIN_NO_CONTRACT_REVIEW'
    | 'OPS_MANAGER_REVIEW'
    | 'OPS_MANAGER_L1_REVIEW'
    | 'OPS_MANAGER_L2_REVIEW';
  /** Metadata associated with the invoice */
  meta?: InvoiceMeta;
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  jobNumber?: string;
  preparedBy?: string;
  customerCode?: string;
  customerReference?: string;
  poNumber?: string;
  businessUnit?: string;
  salesPerson?: string;
  companyRegistrationNumber?: string;
  gstRegistrationNumber?: string;
  lotNumber?: string;
  incoterm?: 'EXW' | 'FCA' | 'FAS' | 'FOB' | 'CPT' | 'CIP' | 'CFR' | 'CIF' | 'DAP' | 'DPU' | 'DDP';
  commodity?: string;
  invoiceCurrency?: string;
  totalAmountBeforeTax?: number;
  totalAmountAfterTax?: number;
  totalAmountAfterTaxInWords?: string;
  totalTaxAmount?: number;
  modalities?: string[];
  notes?: string;
  remarks?: string;
  bankDetails?: InvoiceBankDetail[];
  /** @format int64 */
  serviceProviderId?: number;
  fapRef?: string;
  accountNumber?: string;
  invoiceType?: 'UNKNOWN' | 'FREIGHT' | 'PARCELS' | 'TAX';
  creditType?: 'INVOICE_UPLOAD_CREDIT' | 'SHIPMENT_CREDIT';
  sicCode?: string;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string;
  /** @format date-time */
  updatedOn?: string;
  updatedBy?: string;
  transientMailTrackerContext?: MailDeliveryTrackerContext;
  singleModality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
  modalitiesAsEnum?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT')[];
}

export interface InvoiceBankDetail {
  bankName?: string;
  branch?: string;
  swiftCode?: string;
  accountName?: string;
  accountNumber?: string;
}

export interface MailDeliveryTrackerContext {
  detailedReason?: string;
  emailRecord?: EmailRecord;
}

export interface ResponseDtoListInvoice {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Invoice[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Hierarchical grouping of invoice file processing statuses by service provider and invoice */
export interface GroupedInvoiceFileProcessingStatusDto {
  /**
   * The service provider's unique code identifier
   * @example "DHL"
   */
  serviceProviderCode?: string;
  /** List of invoice groups belonging to this service provider.Each group contains files related to a single invoice. */
  invoiceGroups?: InvoiceGroup[];
}

/** Invoice file processing Status Data Transfer Object DTO. */
export interface InvoiceFileProcessingStatusDto {
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Status. */
  status?:
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE';
  /** Invoice Status. */
  invoiceStatus?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /**
   * Invoice file processing Unique identifier.
   * @format uuid
   */
  invoiceFileProcessingId?: string;
  /**
   * Last update timestamp on.
   * @format date-time
   */
  updatedOn?: string;
  /** Is no rate card found. */
  isNoRateCardFound?: boolean;
  /** File Name. */
  fileName?: string;
  /** Invoice Number. */
  invoiceNumber?: string;
  /** Final resolution. */
  finalResolution?:
    | 'NO_CONTRACT_REJECT'
    | 'REJECT_AFTER_DISPUTE'
    | 'UNKNOWN_BILLING_PARTY'
    | 'WRONG_BILLING_PARTY'
    | 'DUPLICATE_INVOICE'
    | 'NO_RATE_CARD_FOUND'
    | 'MISSING_SIC_CODE';
  /**
   * Modality.
   * @uniqueItems true
   */
  modalities?: ('ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT')[];
  /** Service Provider Code. */
  serviceProviderCode?: string;
  /** File resolution Status. */
  fileResolutionStatus?: 'REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED';
  /**
   * Creation timestamp on.
   * @format date-time
   */
  createdOn?: string;
  /** Uploaded by. */
  uploadedBy?: string;
  /**
   * Count of shipments associated with the invoice.
   * @format int64
   */
  shipmentCount?: number;
  /**
   * Count of shipments that are currently being processed.
   * @format int64
   */
  processingShipmentCount?: number;
  /**
   * Count of shipments that are currently under review.
   * @format int64
   */
  underReviewShipmentCount?: number;
  /**
   * Count of shipments that have been resolved.
   * @format int64
   */
  resolvedShipmentCount?: number;
  /**
   * Count of shipments that are currently being audited.
   * @format int64
   */
  flaggedShipmentCount?: number;
}

/** Group of files that belong to the same invoice */
export interface InvoiceGroup {
  /**
   * Unique identifier for the invoice
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  invoiceId?: string;
  /**
   * Human-readable invoice reference number from the service provider
   * @example "INV-2023-12345"
   */
  invoiceNumber?: string;
  /**
   * Current processing status of the invoice
   * @example "APPROVED"
   */
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** List of individual file processing statuses associated with this invoice. Multiple files can be uploaded for the same invoice. */
  invoiceFileProcessingStatusList?: InvoiceFileProcessingStatusDto[];
}

export interface ResponseDtoListGroupedInvoiceFileProcessingStatusDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: GroupedInvoiceFileProcessingStatusDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoMapStringString {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, string>;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListInvoiceDataPipelineConfigDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: InvoiceDataPipelineConfigDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListFileClassificationEmbeddingDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: FileClassificationEmbeddingDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface SseEmitter {
  /** @format int64 */
  timeout?: number;
}

export interface ResponseDtoListSseConnectedClientDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: SseConnectedClientDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface SseConnectedClientDto {
  /** Email of the logged in user */
  email?: string;
  /** String representation of the SSE emitter */
  emitter?: string;
}

/** Domain meta Data Data Transfer Object DTO. */
export interface DomainMetaDataDto {
  /** The default currency used in the system. */
  defaultCurrency?:
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW';
  /**
   * Set of all supported currencies.
   * @uniqueItems true
   */
  currencies?: (
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW'
  )[];
  /**
   * Set of invoice statuses considered as resolved.
   * @uniqueItems true
   */
  resolvedInvoiceStatuses?: ('FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL')[];
  /**
   * Set of invoice statuses considered as unresolved.
   * @uniqueItems true
   */
  unResolvedInvoiceStatuses?: ('FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL')[];
  /**
   * Set of file resolution statuses considered as resolved.
   * @uniqueItems true
   */
  resolvedResolutionStatuses?: ('REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED')[];
  /**
   * Set of file resolution statuses considered as unresolved.
   * @uniqueItems true
   */
  unResolvedResolutionStatuses?: ('REVIEW_REQUIRED' | 'UNDER_REVIEW' | 'NOT_AN_INVOICE' | 'MISSING_REQUIRED_FIELD' | 'INCONSISTENT_SHIPMENT_DATA' | 'FIXED')[];
  /**
   * Set of invoice file processing statuses indicating errors.
   * @uniqueItems true
   */
  errorProcessingStatuses?: (
    | 'BEING_UPLOADED'
    | 'UPLOADED_FILE'
    | 'SENT_TO_PIPELINE'
    | 'PIPELINE_TRIGGER_FAILED'
    | 'COMPLETE'
    | 'OCR_PROCESSING'
    | 'OCR_COMPLETE'
    | 'OCR_ERROR'
    | 'TRANSFORM_ERROR'
    | 'TRANSFORM_COMPLETE'
    | 'LOADING_DATA'
    | 'MESSAGE_PROCESSING_FAILED'
    | 'UPLOAD_FROM_EMAIL_FAILED'
    | 'UPLOAD_FROM_S3_FAILED'
    | 'RESOLVED_AS_NOT_AN_INVOICE'
    | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
    | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
    | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
    | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
    | 'DUPLICATE'
  )[];
  /**
   * Set of allowed file extensions for uploads.
   * @uniqueItems true
   */
  allowedFileExtensions?: string[];
  /**
   * Set of charge categories available in the system.
   * @uniqueItems true
   */
  chargeCategories?: (
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE'
  )[];
  /**
   * Set of leg types available in the system.
   * @uniqueItems true
   */
  legTypes?: ('LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB')[];
}

export interface ResponseDtoDomainMetaDataDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Domain meta Data Data Transfer Object DTO. */
  data?: DomainMetaDataDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListNrcfOption {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ('SET_UP_NEW_SERVICE' | 'ACCEPT_AS_SPOT_SHIPMENT' | 'REJECT_SHIPMENT')[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListDisputeOption {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ('ACCEPT_INVOICE' | 'REJECT_INVOICE' | 'CANCEL_DISPUTE')[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoSetChargeDomain {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * The data returned by the operation, if any
   * @uniqueItems true
   */
  data?: (
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE'
  )[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Contract Charge detail Data Transfer Object DTO. */
export interface ContractChargeDetailDto {
  /** Leg Type. */
  legType?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
  /** Charge category. */
  chargeCategory?:
    | 'COLLECTION'
    | 'CONTAINER_CLEARANCE'
    | 'CONTAINER_MAINTENANCE'
    | 'CUSTOMS_CLEARANCE'
    | 'DELIVERY'
    | 'DOCUMENTATION'
    | 'FREIGHT'
    | 'FUEL_SURCHARGE'
    | 'HANDLING_CHARGE'
    | 'INSPECTION'
    | 'OVERTIME'
    | 'PICK_UP'
    | 'PICK_UP_AND_DROP_OFF'
    | 'PORT_CHARGES'
    | 'SEAL_FEE'
    | 'SPECIAL_HANDLING'
    | 'STORAGE'
    | 'THC'
    | 'TOTAL_ORIGIN_CHARGES'
    | 'VGM_FEE'
    | 'DEFAULT_CHARGE_DOMAIN'
    | 'SCREE';
  /** Charge Name. */
  chargeName?: string;
  /** Charge unit. */
  chargeUnit?: 'KG' | 'CBM' | 'PKG' | 'LBS' | 'REF';
  /** Maximum chargeable weight. */
  maximumChargeableWeight?: number;
  /** Minimum chargeable weight. */
  minimumChargeableWeight?: number;
  /** Unit price. */
  unitPrice?: number;
  /** Currency. */
  currency?: string;
  /** Container Type. */
  containerType?: 'STANDARD' | 'HIGH_CUBE' | 'OPEN_TOP' | 'FLAT_RACK';
  /** Unit price20. */
  unitPrice20?: number;
  /** Unit price40. */
  unitPrice40?: number;
  /** Charge Type. */
  chargeType?: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
  /** Minimum price. */
  minimumPrice?: number;
  /** Percentage value. */
  percentageValue?: number;
  /**
   * Start Date.
   * @format date
   */
  startDate?: string;
  /**
   * End Date.
   * @format date
   */
  endDate?: string;
}

export interface ResponseDtoSetContractChargeDetailDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /**
   * The data returned by the operation, if any
   * @uniqueItems true
   */
  data?: ContractChargeDetailDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** The data returned by the operation, if any */
export interface GettingInvoiceMissingRateCardResponse {
  /** @format int32 */
  total?: number;
  /** @uniqueItems true */
  invoices?: string[];
}

export interface ResponseDtoGettingInvoiceMissingRateCardResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: GettingInvoiceMissingRateCardResponse;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListCurrencyEnum {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: (
    | 'AED'
    | 'AFN'
    | 'ALL'
    | 'AMD'
    | 'ANG'
    | 'AOA'
    | 'ARS'
    | 'AUD'
    | 'AWG'
    | 'AZN'
    | 'BAM'
    | 'BBD'
    | 'BDT'
    | 'BGN'
    | 'BHD'
    | 'BIF'
    | 'BMD'
    | 'BND'
    | 'BOB'
    | 'BOV'
    | 'BRL'
    | 'BSD'
    | 'BTN'
    | 'BWP'
    | 'BYN'
    | 'BYR'
    | 'BZD'
    | 'CAD'
    | 'CDF'
    | 'CHE'
    | 'CHF'
    | 'CHW'
    | 'CLF'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'COU'
    | 'CRC'
    | 'CUC'
    | 'CUP'
    | 'CVE'
    | 'CZK'
    | 'DJF'
    | 'DKK'
    | 'DOP'
    | 'DZD'
    | 'EGP'
    | 'ERN'
    | 'ETB'
    | 'EUR'
    | 'FJD'
    | 'FKP'
    | 'GBP'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GMD'
    | 'GNF'
    | 'GTQ'
    | 'GYD'
    | 'HKD'
    | 'HNL'
    | 'HRK'
    | 'HTG'
    | 'HUF'
    | 'IDR'
    | 'ILS'
    | 'INR'
    | 'IQD'
    | 'IRR'
    | 'ISK'
    | 'JMD'
    | 'JOD'
    | 'JPY'
    | 'KES'
    | 'KGS'
    | 'KHR'
    | 'KMF'
    | 'KPW'
    | 'KRW'
    | 'KWD'
    | 'KYD'
    | 'KZT'
    | 'LAK'
    | 'LBP'
    | 'LKR'
    | 'LRD'
    | 'LSL'
    | 'LYD'
    | 'MAD'
    | 'MDL'
    | 'MGA'
    | 'MKD'
    | 'MMK'
    | 'MNT'
    | 'MOP'
    | 'MRO'
    | 'MUR'
    | 'MVR'
    | 'MWK'
    | 'MXN'
    | 'MXV'
    | 'MYR'
    | 'MZN'
    | 'NAD'
    | 'NGN'
    | 'NIO'
    | 'NOK'
    | 'NPR'
    | 'NZD'
    | 'OMR'
    | 'PAB'
    | 'PEN'
    | 'PGK'
    | 'PHP'
    | 'PKR'
    | 'PLN'
    | 'PYG'
    | 'QAR'
    | 'RON'
    | 'RSD'
    | 'RUB'
    | 'RWF'
    | 'SAR'
    | 'SBD'
    | 'SCR'
    | 'SDG'
    | 'SEK'
    | 'SGD'
    | 'SHP'
    | 'SLL'
    | 'SOS'
    | 'SRD'
    | 'SSP'
    | 'STD'
    | 'SYP'
    | 'SZL'
    | 'THB'
    | 'TJS'
    | 'TMT'
    | 'TND'
    | 'TOP'
    | 'TRY'
    | 'TTD'
    | 'TWD'
    | 'TZS'
    | 'UAH'
    | 'UGX'
    | 'USD'
    | 'USN'
    | 'UYI'
    | 'UYU'
    | 'UZS'
    | 'VEF'
    | 'VND'
    | 'VUV'
    | 'WST'
    | 'XAF'
    | 'XAG'
    | 'XAU'
    | 'XBA'
    | 'XBB'
    | 'XBC'
    | 'XBD'
    | 'XCD'
    | 'XDR'
    | 'XFU'
    | 'XOF'
    | 'XPD'
    | 'XPF'
    | 'XPT'
    | 'XSU'
    | 'XTS'
    | 'XUA'
    | 'XXX'
    | 'YER'
    | 'ZAR'
    | 'ZMW'
  )[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object representing credit details */
export interface CreditDetailsDto {
  /**
   * Total invoice credit purchased for the chosen billed entity
   * @format int64
   */
  totalInvoiceCredit?: number;
  /**
   * Consumed invoice credit for the requested period
   * @format int64
   */
  consumedInvoiceCredit?: number;
  /**
   * Remaining invoice credit available for the chosen billed entity
   * @format int64
   */
  remainingInvoiceCredit?: number;
  /**
   * Invoice credit expiration date
   * @format date
   */
  invoiceCreditExpirationDate?: string;
  /**
   * Total shipment credit purchased for the chosen billed entity
   * @format int64
   */
  totalShipmentCredit?: number;
  /**
   * Consumed shipment credit for the requested period
   * @format int64
   */
  consumedShipmentCredit?: number;
  /**
   * Remaining shipment credit available for the chosen billed entity
   * @format int64
   */
  remainingShipmentCredit?: number;
  /**
   * Shipment credit expiration date
   * @format date
   */
  shipmentCreditExpirationDate?: string;
  /** Billing mode for this billed entity (PRE_PAID or POST_PAID) */
  billingMode?: string;
}

export interface ResponseDtoCreditDetailsDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Data Transfer Object representing credit details */
  data?: CreditDetailsDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoUnsettledCreditSummaryDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Summary of unsettled credit transactions for a billed entity */
  data?: UnsettledCreditSummaryDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Summary of unsettled credit transactions for a billed entity */
export interface UnsettledCreditSummaryDto {
  /**
   * Number of unsettled invoice credit transactions
   * @format int64
   */
  unsettledInvoiceCreditCount?: number;
  /**
   * Total unsettled invoice credit amount (absolute value)
   * @format int64
   */
  unsettledInvoiceCreditAmount?: number;
  /**
   * Number of unsettled shipment credit transactions
   * @format int64
   */
  unsettledShipmentCreditCount?: number;
  /**
   * Total unsettled shipment credit amount (absolute value)
   * @format int64
   */
  unsettledShipmentCreditAmount?: number;
  /** List of unsettled credit transactions */
  unsettledTransactions?: CreditTransactionDto[];
}

export interface ResponseDtoListCreditTransactionDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: CreditTransactionDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Courier Invoice dispute Data Transfer Object DTO. */
export interface CourierInvoiceDisputeDto {
  /**
   * Unique identifier.
   * @format uuid
   */
  id?: string;
  /**
   * Invoice Unique identifier.
   * @format uuid
   */
  invoiceId?: string;
  /** Currency. */
  currency?: string;
  /** Lump sum Amount. */
  lumpSumAmount?: number;
  /** Lump sum Amount before tax. */
  lumpSumAmountBeforeTax?: number;
  /** Amount DTO. */
  expectedTotalAmount?: Amount;
  /** Amount DTO. */
  creditNoteAmount?: Amount;
  /** Resolution description. */
  resolutionDescription?: string;
  /** Status. */
  status?: 'DRAFT' | 'PENDING_DOCUMENT' | 'DONE' | 'CANCELED';
  /** Credit note file Data Transfer Object DTO. */
  creditNoteFile?: CreditNoteFileDto;
  /** Shipment deviations. */
  shipmentDeviations?: CourierShipmentDeviationsResolutionsDto[];
  /** Next Workflow action. */
  nextWorkflowAction?:
    | 'SEND_TO_OPERATION'
    | 'SEND_TO_PROCUREMENT'
    | 'SEND_TO_FINANCE'
    | 'SEND_TO_SUPPLY_CHAIN'
    | 'START_DISPUTE'
    | 'CANCEL_DISPUTE'
    | 'MARK_INVOICE_TO_REJECT'
    | 'MARK_INVOICE_TO_APPROVE'
    | 'ACCEPT_CREDIT_NOTE'
    | 'ACCEPT_APPROVAL'
    | 'READY_FOR_PAYMENT'
    | 'REJECT_INVOICE'
    | 'ACCEPT_INVOICE'
    | 'ACCEPT_AS_SPOT_SHIPMENT'
    | 'SEND_TO_OPS_ADMIN'
    | 'SEND_TO_OPS_MANAGER'
    | 'SEND_TO_OPS_MANAGER_L1'
    | 'SEND_TO_OPS_MANAGER_L2';
  /** Agreement resolution. */
  agreementResolution?:
    | 'ACCEPT_INVOICE_AS_IS'
    | 'AMEND_INVOICE_CREDIT_NOTE'
    | 'REJECT_INVOICE'
    | 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE'
    | 'ACCEPT_INVOICE_WITH_CREDIT_NOTE';
  /** Deviation resolution Type. */
  deviationResolutionType?: 'BREAK_DOWN_PER_DEVIATION' | 'LUMP_SUM';
  /** Amount DTO. */
  amountToBePaid?: Amount;
}

/** Courier Shipment deviations resolutions Data Transfer Object DTO. */
export interface CourierShipmentDeviationsResolutionsDto {
  /**
   * Shipment Unique identifier.
   * @format uuid
   */
  shipmentId?: string;
  /** Shipment Number. */
  shipmentNumber?: string;
  /**
   * Number of deviations.
   * @format int32
   */
  numberOfDeviations?: number;
  /** Deviations. */
  deviations?: DeviationDto[];
  /** Deviation resolution. */
  deviationResolution?: DisputeDeviationResolutionDto[];
  /** Enumeration representing different shipment status values. */
  status?: 'UNFILLED' | 'REJECTED' | 'APPROVED';
}

export interface ResponseDtoCourierInvoiceDisputeDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Courier Invoice dispute Data Transfer Object DTO. */
  data?: CourierInvoiceDisputeDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Invoice courier Shipment detail Data Transfer Object DTO. */
export interface InvoiceCourierShipmentDetailDto {
  /**
   * Shipment Unique identifier.
   * @format uuid
   */
  shipmentId?: string;
  /** Shipment Number. */
  shipmentNumber?: string;
  /** Status. */
  status?: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
  /** Amount DTO. */
  shipmentAmount?: Amount;
  /** Amount DTO. */
  deviationAmount?: Amount;
  /** Shipping Service Type. */
  shippingServiceType?: string;
  /** Shipper. */
  shipper?: string;
  /** Place to pickup. */
  placeToPickup?: string;
  /**
   * Departure Date.
   * @format date
   */
  departureDate?: string;
  /** Consignee. */
  consignee?: string;
  /** Delivery place. */
  deliveryPlace?: string;
  /**
   * Arrival Date.
   * @format date
   */
  arrivalDate?: string;
  /** Total chargeable weight. */
  totalChargeableWeight?: number;
  /**
   * Package Count.
   * @format int32
   */
  packageCount?: number;
  /** Volume. */
  volume?: number;
  /** Total co2 emission. */
  totalCo2Emission?: number;
  /** Deviations. */
  deviations?: DeviationDto[];
}

export interface ResponseDtoInvoiceCourierShipmentDetailDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** Invoice courier Shipment detail Data Transfer Object DTO. */
  data?: InvoiceCourierShipmentDetailDto;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListContractDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ContractDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListContractZoneDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ContractZoneDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListContractRouteDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ContractRouteDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListChartReportDto {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: ChartReportDto[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoJsonNode {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  data?: JsonNode;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoMapStringObject {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: Record<string, object>;
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

export interface ResponseDtoListJobTrackerResponse {
  /** Indicates whether the operation was successful or not */
  success?: boolean;
  /** A message providing additional information about the response */
  message?: string;
  /** The data returned by the operation, if any */
  data?: JobTrackerResponse[];
  /**
   * The HTTP status code of the response
   * @format int32
   */
  statusCode?: number;
}

/** Data Transfer Object (DTO) for deleting invoices. */
export interface DeleteInvoiceDto {
  /** List of invoice numbers to be deleted. */
  invoiceNumbers?: string[];
  /** List of batch IDs associated with the invoices to be deleted. */
  batchIds?: string[];
  /** List of file names associated with the invoices to be deleted. */
  fileNames?: string[];
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (securityData: SecurityDataType | null) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'http://uct-dev-ecs-nlb-620127c07f33c9c4.elb.ap-southeast-1.amazonaws.com',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({ secure, path, type, query, format, body, ...params }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://uct-dev-ecs-nlb-620127c07f33c9c4.elb.ap-southeast-1.amazonaws.com
 */
export class TFinancialApi<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  api = {
    /**
     * @description Updates an existing user or inserts a new user. Accessible only to SYSTEM_ADMIN.
     *
     * @tags User, Upsert
     * @name UpsertUser
     * @summary Upsert user
     * @request PUT:/api/users
     * @response `200` `ResponseDtoUserDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertUser: (data: UserDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUserDto, ResponseDtoObject>({
        path: `/api/users`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new user with the provided details.
     *
     * @tags User, Create
     * @name CreateUser
     * @summary Create a new user
     * @request POST:/api/users
     * @response `200` `ResponseDtoUserDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createUser: (data: UserCreateRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUserDto, ResponseDtoObject>({
        path: `/api/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves the permissions of the logged-in user.
     *
     * @tags User, Permissions
     * @name GetUserPermissions
     * @summary Get user permissions
     * @request GET:/api/users/permissions
     * @response `200` `ResponseDtoListUserDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUserPermissions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListUserDto, ResponseDtoObject>({
        path: `/api/users/permissions`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Updates or inserts user permissions. Accessible only to SYSTEM_ADMIN.
     *
     * @tags User, Permissions, Upsert
     * @name UpsertUserPermission
     * @summary Upsert user permission
     * @request PUT:/api/users/permissions
     * @response `200` `ResponseDtoUserPermissionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertUserPermission: (data: UserPermissionDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUserPermissionDto, ResponseDtoObject>({
        path: `/api/users/permissions`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates the permissions for a user.
     *
     * @tags User, Permissions, Create, Update
     * @name CreateUserPermission
     * @summary Create or update user permissions
     * @request POST:/api/users/permissions
     * @response `200` `ResponseDtoListUserPermissionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createUserPermission: (data: UserEntityPermissionDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListUserPermissionDto, ResponseDtoObject>({
        path: `/api/users/permissions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves unlocode mappings matching the given criteria (case-insensitive, partial match). If no parameters are provided, returns all mappings. Requires SYSTEM_ADMIN authority.
     *
     * @tags unlocode-controller
     * @name Search
     * @summary Search unlocode mappings
     * @request GET:/api/unlocode-mappings
     * @response `200` `ResponseDtoListUnlocodeMappingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    search: (
      query?: {
        /**
         * The port name to search for (optional)
         * @example "Singapore"
         */
        portName?: string;
        /**
         * The unlocode to search for (optional)
         * @example "SGSIN"
         */
        unlocode?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListUnlocodeMappingDto, ResponseDtoObject>({
        path: `/api/unlocode-mappings`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Creates or updates an unlocode mapping by ID. Requires SYSTEM_ADMIN authority.
     *
     * @tags unlocode-controller
     * @name Upsert
     * @summary Upsert an unlocode mapping
     * @request PUT:/api/unlocode-mappings
     * @response `200` `ResponseDtoUnlocodeMappingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsert: (data: UnlocodeMappingDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUnlocodeMappingDto, ResponseDtoObject>({
        path: `/api/unlocode-mappings`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves all system configurations. Requires SYSTEM_ADMIN authority.
     *
     * @tags system-configuration-controller
     * @name GetAll
     * @summary Get all system configurations
     * @request GET:/api/system-configurations
     * @response `200` `ResponseDtoListSystemConfigurationDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAll: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListSystemConfigurationDto, ResponseDtoObject>({
        path: `/api/system-configurations`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Creates or updates multiple system configurations. Requires SYSTEM_ADMIN authority.
     *
     * @tags system-configuration-controller
     * @name UpsertConfigurations
     * @summary Upsert system configurations
     * @request PUT:/api/system-configurations
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertConfigurations: (data: SystemConfigurationDto[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/system-configurations`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Replaces all user assignments for a SIC code
     *
     * @tags SIC Code Assignments
     * @name BulkReplaceAssignments
     * @summary Bulk replace SIC code assignments
     * @request PUT:/api/sic-code-assignments/bulk
     * @response `200` `ResponseDtoListSicCodeManagerAssignmentDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    bulkReplaceAssignments: (data: BulkReplaceSicCodeAssignmentRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListSicCodeManagerAssignmentDto, ResponseDtoObject>({
        path: `/api/sic-code-assignments/bulk`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing shipping service with the provided details. This endpoint requires ADMIN permissions.
     *
     * @tags shipping-services, admin
     * @name UpdateShippingService
     * @summary Update a shipping service
     * @request PUT:/api/shipping-services/{id}
     * @response `200` `ResponseDtoShippingServiceDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateShippingService: (id: string, data: CreatingAndUpdatingShippingServiceReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShippingServiceDto, ResponseDtoObject>({
        path: `/api/shipping-services/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a shipping service by ID. Requires ADMIN authority.
     *
     * @tags shipping-services, admin
     * @name DeleteShippingService
     * @summary Delete a shipping service
     * @request DELETE:/api/shipping-services/{id}
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteShippingService: (
      id: string,
      query?: {
        /**
         * Force deletion shipping service even if it is being linked to a contract flow. Also delete all contract flow and its contract_flow_xxx_charge, and all contract_xxx_charge when they are not linked to other contract flows.
         * @default false
         * @example false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/shipping-services/${id}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipping-service-contract-migration-controller
     * @name CleanDuplicatedShippingServices
     * @request PUT:/api/shipping-service-contract-migration/shipping-services/duplicate-removal
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    cleanDuplicatedShippingServices: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/shipping-service-contract-migration/shipping-services/duplicate-removal`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipping-service-contract-migration-controller
     * @name CleanDuplicatedContracts
     * @request PUT:/api/shipping-service-contract-migration/contracts/duplicate-removal
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    cleanDuplicatedContracts: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/shipping-service-contract-migration/contracts/duplicate-removal`,
        method: 'PUT',
        ...params,
      }),

    /**
     * @description Fetches a list of raw shipment DTOs based on the provided shipment number.
     *
     * @tags shipment-controller
     * @name GetShipmentByShipmentNumber
     * @summary Retrieve shipments by shipment number
     * @request GET:/api/shipments
     * @response `200` `ResponseDtoListRawShipmentDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getShipmentByShipmentNumber: (
      query: {
        shipmentNumber: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListRawShipmentDto, ResponseDtoObject>({
        path: `/api/shipments`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Updates a shipment entity based on the provided RawShipmentDto request.
     *
     * @tags shipment-controller
     * @name UpdateShipment
     * @summary Update shipment
     * @request PUT:/api/shipments
     * @response `200` `ResponseDtoRawShipmentDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateShipment: (data: RawShipmentDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoRawShipmentDto, ResponseDtoObject>({
        path: `/api/shipments`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name PerformDeviationWorkflowActionOnShipmentInvoice
     * @request PUT:/api/shipments/shipment-invoices/{shipmentInvoiceId}/{deviationWorkflowAction}
     * @response `200` `ResponseDtoShipmentInActionDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    performDeviationWorkflowActionOnShipmentInvoice: (
      shipmentInvoiceId: string,
      deviationWorkflowAction:
        | 'SEND_TO_OPERATION'
        | 'SEND_TO_PROCUREMENT'
        | 'SEND_TO_FINANCE'
        | 'SEND_TO_SUPPLY_CHAIN'
        | 'START_DISPUTE'
        | 'CANCEL_DISPUTE'
        | 'MARK_INVOICE_TO_REJECT'
        | 'MARK_INVOICE_TO_APPROVE'
        | 'ACCEPT_CREDIT_NOTE'
        | 'ACCEPT_APPROVAL'
        | 'READY_FOR_PAYMENT'
        | 'REJECT_INVOICE'
        | 'ACCEPT_INVOICE'
        | 'ACCEPT_AS_SPOT_SHIPMENT'
        | 'SEND_TO_OPS_ADMIN'
        | 'SEND_TO_OPS_MANAGER'
        | 'SEND_TO_OPS_MANAGER_L1'
        | 'SEND_TO_OPS_MANAGER_L2',
      data: DeviationWorkflowActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoShipmentInActionDetailDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/${deviationWorkflowAction}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name RejectShipmentInvoice
     * @request PUT:/api/shipments/shipment-invoices/{shipmentInvoiceId}/reject
     * @response `200` `ResponseDtoShipmentInActionDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    rejectShipmentInvoice: (shipmentInvoiceId: string, data: DeviationWorkflowActionBodyDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipmentInActionDetailDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/reject`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Asynchronously recalculates deviations for the specified shipment invoice. Returns immediately without waiting for completion.
     *
     * @tags shipment-controller
     * @name RecalculateDeviationsForShipment
     * @summary Recalculate deviations for a shipment invoice (async)
     * @request PUT:/api/shipments/shipment-invoices/{shipmentInvoiceId}/recalculate-deviations
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    recalculateDeviationsForShipment: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/recalculate-deviations`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name ConfirmShipmentInvoice
     * @request PUT:/api/shipments/shipment-invoices/{shipmentInvoiceId}/confirm
     * @response `200` `ResponseDtoShipmentInActionDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    confirmShipmentInvoice: (shipmentInvoiceId: string, data: DeviationWorkflowActionBodyDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipmentInActionDetailDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/confirm`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Reprocesses a specific shipment invoice with updated shipment message data. This operation requires SYSTEM_ADMIN authority.
     *
     * @tags shipment-controller
     * @name ReProcessShipmentInvoice
     * @summary Reprocess shipment invoice
     * @request PUT:/api/shipments/shipment-invoices/reprocess
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    reProcessShipmentInvoice: (data: string[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/reprocess`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Resolves shipment container information for shipments based on the provided modality, service provider ID, and service type. This operation requires SYSTEM_ADMIN authority.
     *
     * @tags shipment-controller
     * @name ResolveShipmentContainers
     * @summary Resolve shipment containers
     * @request PUT:/api/shipments/resolve-shipment-containers
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    resolveShipmentContainers: (data: ResolveShipmentContainersRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/shipments/resolve-shipment-containers`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches detailed information about service providers.
     *
     * @tags service-provider-controller
     * @name GetServiceProviderDetails
     * @summary Retrieve service provider details
     * @request GET:/api/service-providers
     * @response `200` `ResponseDtoListServiceProviderDetailsDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getServiceProviderDetails: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListServiceProviderDetailsDto, ResponseDtoObject>({
        path: `/api/service-providers`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Creates new service providers or updates existing ones in batch operations. This endpoint supports comprehensive provider management by allowing simultaneous updates of service providers, their addresses, and their aliases in a single API call. If the 'id' field is null, a new provider will be created; if provided, the existing provider will be updated. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name UpsertServiceProviders
     * @summary Upsert service providers with addresses and aliases
     * @request PUT:/api/service-providers
     * @response `200` `ResponseDtoListServiceProviderOverViewDto` Successfully upserted service providers. Returns the complete list of processed providers with their updated information including any newly assigned IDs for created providers.
     * @response `400` `ResponseDtoListServiceProviderOverViewDto` Bad Request - Invalid request payload. This occurs when validation fails on the service provider data, addresses, or aliases. Common issues include missing required fields, invalid data formats, or constraint violations. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoListServiceProviderOverViewDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to perform service provider upsert operations.
     */
    upsertServiceProviders: (data: ServiceProviderOverViewDto[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoListServiceProviderOverViewDto, ResponseDtoListServiceProviderOverViewDto | ResponseDtoObject>({
        path: `/api/service-providers`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new service provider alias or updates an existing one based on the provided request. Aliases serve as alternative names or identifiers for service providers to handle variations in how provider names appear on invoices and documents. If the alias ID is null, a new alias will be created; if provided, the existing alias will be updated. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name UpsertServiceProviderAlias
     * @summary Upsert a service provider alias
     * @request PUT:/api/service-providers/aliases
     * @response `200` `ResponseDtoServiceProviderNameAliasDto` Successfully upserted the service provider alias.
     * @response `400` `ResponseDtoServiceProviderNameAliasDto` Bad Request - Invalid request payload.
     * @response `401` `ResponseDtoServiceProviderNameAliasDto` Unauthorized - Invalid or expired authentication token.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role.
     * @response `404` `ResponseDtoServiceProviderNameAliasDto` Not Found - The specified service provider does not exist.
     */
    upsertServiceProviderAlias: (data: ServiceProviderNameAliasDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoServiceProviderNameAliasDto, ResponseDtoServiceProviderNameAliasDto | ResponseDtoObject>({
        path: `/api/service-providers/aliases`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new service provider address or updates an existing one based on the provided request. If the address ID is null, a new address will be created and linked to the specified service provider. If the address ID is provided, the existing address will be updated with the new information. This endpoint manages physical addresses, billing addresses, and other location-based information associated with service providers. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name UpsertServiceProviderAddress
     * @summary Upsert a service provider address
     * @request PUT:/api/service-providers/addresses
     * @response `200` `ResponseDtoServiceProviderAddressDto` Successfully upserted the service provider address.
     * @response `400` `ResponseDtoServiceProviderAddressDto` Bad Request - Invalid request payload.
     * @response `401` `ResponseDtoServiceProviderAddressDto` Unauthorized - Invalid or expired authentication token.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role.
     * @response `404` `ResponseDtoServiceProviderAddressDto` Not Found - The specified service provider does not exist.
     */
    upsertServiceProviderAddress: (data: ServiceProviderAddressDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoServiceProviderAddressDto, ResponseDtoServiceProviderAddressDto | ResponseDtoObject>({
        path: `/api/service-providers/addresses`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a list of service provider addresses based on their IDs.
     *
     * @tags service-provider-controller
     * @name DeleteServiceProviderAddresses
     * @summary Delete service provider addresses
     * @request DELETE:/api/service-providers/addresses
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteServiceProviderAddresses: (data: number[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/service-providers/addresses`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a percentage discount associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertPercentageDiscount
     * @summary Upsert Percentage Discount for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/percentage-discount
     * @response `200` `ResponseDtoPercentageDiscountDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertPercentageDiscount: (contractFlowId: string, data: PercentageDiscountDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPercentageDiscountDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/percentage-discount`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a weight-based charge associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertWeightCharge
     * @summary Upsert Weight Charge for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/contract-charge-unit/weight
     * @response `200` `ResponseDtoWeightChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertWeightCharge: (contractFlowId: string, data: WeightChargeDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoWeightChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/contract-charge-unit/weight`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a shipment charge associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertShipmentCharge
     * @summary Upsert Shipment Charge for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/contract-charge-unit/shipment
     * @response `200` `ResponseDtoShipmentChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertShipmentCharge: (contractFlowId: string, data: ShipmentChargeDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipmentChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/contract-charge-unit/shipment`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a percentage-based charge associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertPercentageCharge
     * @summary Upsert Percentage Charge for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/contract-charge-unit/percentage
     * @response `200` `ResponseDtoPercentageChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertPercentageCharge: (contractFlowId: string, data: PercentageChargeDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPercentageChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/contract-charge-unit/percentage`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a declaration charge associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertDeclarationCharge
     * @summary Upsert Declaration Charge for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/contract-charge-unit/declaration
     * @response `200` `ResponseDtoDeclarationChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertDeclarationCharge: (contractFlowId: string, data: DeclarationChargeDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoDeclarationChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/contract-charge-unit/declaration`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a container charge associated with the specified contract flow. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name UpsertContainerCharge
     * @summary Upsert Container Charge for a Contract Flow
     * @request PUT:/api/rate-cards/contract-flows/{contractFlowId}/contract-charge-unit/container
     * @response `200` `ResponseDtoContainerChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertContainerCharge: (contractFlowId: string, data: ContainerChargeDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContainerChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/contract-charge-unit/container`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags notification-controller
     * @name MarkNotificationAsRead
     * @summary Mark all notifications as read
     * @request PUT:/api/notifications/mark-as-read
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    markNotificationAsRead: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/notifications/mark-as-read`,
        method: 'PUT',
        ...params,
      }),

    /**
     * @description Migrates a legal entity from the specified old legal entity ID to the new legal entity ID.
     *
     * @tags migration-controller
     * @name MigrateALegalEntityToAnotherOne
     * @summary Migrate a legal entity to another one
     * @request PUT:/api/migrations/legal-entities
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    migrateALegalEntityToAnotherOne: (
      query: {
        /** @format int64 */
        oldLegalEntityId: number;
        /** @format int64 */
        newLegalEntityId: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/migrations/legal-entities`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves all match score configurations. Only accessible by system administrators.
     *
     * @tags match-score-config-controller
     * @name GetAll1
     * @summary Get all match score configurations
     * @request GET:/api/match-score-configs
     * @response `200` `ResponseDtoListMatchScoreConfigDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAll1: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListMatchScoreConfigDto, ResponseDtoObject>({
        path: `/api/match-score-configs`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Updates multiple match score configurations in a single request. Only accessible by system administrators.
     *
     * @tags match-score-config-controller
     * @name BatchUpdateConfigurations
     * @summary Batch update match score configurations
     * @request PUT:/api/match-score-configs
     * @response `200` `ResponseDtoListMatchScoreConfigDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    batchUpdateConfigurations: (data: MatchScoreConfigDto[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoListMatchScoreConfigDto, ResponseDtoObject>({
        path: `/api/match-score-configs`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update an existing location by ID.
     *
     * @tags location-controller
     * @name UpdateLocation
     * @summary Update location
     * @request PUT:/api/locations/{id}
     * @response `200` `ResponseDtoLocationDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateLocation: (id: string, data: LocationDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLocationDto, ResponseDtoObject>({
        path: `/api/locations/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates new legal entities or updates existing ones in batch operations. This endpoint supports comprehensive entity management by allowing simultaneous updates of legal entities, their addresses, and their aliases in a single API call. If the 'id' field is null, a new entity will be created; if provided, the existing entity will be updated. Requires SYSTEM_ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name UpsertLegalEntities
     * @summary Upsert legal entities with addresses and aliases
     * @request PUT:/api/legal-entities
     * @response `200` `ResponseDtoListLegalEntityDto` Successfully upserted legal entities. Returns the complete list of processed entities with their updated information including any newly assigned IDs for created entities.
     * @response `400` `ResponseDtoListLegalEntityDto` Bad Request - Invalid request payload. This occurs when validation fails on the legal entity data, addresses, or aliases. Common issues include missing required fields, invalid data formats, or constraint violations. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoListLegalEntityDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to perform legal entity upsert operations.
     */
    upsertLegalEntities: (data: LegalEntityDto[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoListLegalEntityDto, ResponseDtoListLegalEntityDto | ResponseDtoObject>({
        path: `/api/legal-entities`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new legal entity. The fields isBilledEntity, nameAliases, and parentId are ignored even if provided — isBilledEntity and parentId are always set to null, and a default alias is auto-generated from the entity name. Requires ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name CreateLegalEntity
     * @summary Create a legal entity
     * @request POST:/api/legal-entities
     * @response `200` `ResponseDtoLegalEntityDto` Successfully created the legal entity
     * @response `400` `ResponseDtoLegalEntityDto` Bad Request - id must be null, or name/code validation failed
     * @response `401` `ResponseDtoLegalEntityDto` Unauthorized - Invalid or expired authentication token
     * @response `403` `ResponseDtoObject` Forbidden - Requires ADMIN role
     */
    createLegalEntity: (data: LegalEntityDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLegalEntityDto, ResponseDtoLegalEntityDto | ResponseDtoObject>({
        path: `/api/legal-entities`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new legal entity alias or updates an existing one based on the provided request. Aliases serve as alternative names or identifiers for legal entities to handle variations in how entity names appear on invoices and documents. Supports both NAME type aliases (alternative spellings, abbreviations) and ACCOUNT_NUMBER type aliases (customer codes, account numbers). If the alias ID is null, a new alias will be created; if provided, the existing alias will be updated. Requires SYSTEM_ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name UpsertLegalEntityAlias
     * @summary Upsert a legal entity alias
     * @request PUT:/api/legal-entities/aliases
     * @response `200` `ResponseDtoLegalEntityNameAliasDto` Successfully upserted the legal entity alias. Returns the complete alias information including the assigned ID for newly created aliases and the updated alias details.
     * @response `400` `ResponseDtoLegalEntityNameAliasDto` Bad Request - Invalid request payload. This occurs when validation fails on the alias data, such as missing required fields (legal entity ID, alias name, alias type), invalid alias type values, duplicate alias names for the same entity, or constraint violations. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoLegalEntityNameAliasDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to perform legal entity alias management operations.
     * @response `404` `ResponseDtoLegalEntityNameAliasDto` Not Found - The specified legal entity does not exist, or the alias ID provided for update does not exist in the system.
     */
    upsertLegalEntityAlias: (data: UpsertLegalEntityAliasRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLegalEntityNameAliasDto, ResponseDtoLegalEntityNameAliasDto | ResponseDtoObject>({
        path: `/api/legal-entities/aliases`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new legal entity address or updates an existing one based on the provided request. If the address ID is null, a new address will be created and linked to the specified legal entity. If the address ID is provided, the existing address will be updated with the new information. This endpoint manages physical addresses, billing addresses, and other location-based information associated with legal entities. Requires SYSTEM_ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name UpsertLegalEntityAddress
     * @summary Upsert a legal entity address
     * @request PUT:/api/legal-entities/addresses
     * @response `200` `ResponseDtoLegalEntityAddressDto` Successfully upserted the legal entity address. Returns the complete address information including the assigned ID for newly created addresses and updated field values.
     * @response `400` `ResponseDtoLegalEntityAddressDto` Bad Request - Invalid request payload. This occurs when validation fails on the address data, such as missing required fields (legal entity ID, address components), invalid formats, or constraint violations. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoLegalEntityAddressDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to perform legal entity address management operations.
     * @response `404` `ResponseDtoLegalEntityAddressDto` Not Found - The specified legal entity does not exist, or the address ID provided for update does not exist in the system.
     */
    upsertLegalEntityAddress: (data: LegalEntityAddressDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLegalEntityAddressDto, ResponseDtoLegalEntityAddressDto | ResponseDtoObject>({
        path: `/api/legal-entities/addresses`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a list of legal entity addresses based on their IDs.
     *
     * @tags legal-entity-controller
     * @name DeleteLegalEntityAddresses
     * @summary Delete legal entity addresses
     * @request DELETE:/api/legal-entities/addresses
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteLegalEntityAddresses: (data: number[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/legal-entities/addresses`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Triggers the email reading task manually.
     *
     * @tags jobs, admin, demo
     * @name TriggerEmailReadingTask
     * @summary Trigger email reading task
     * @request PUT:/api/jobs/email-reading/trigger
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    triggerEmailReadingTask: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/jobs/email-reading/trigger`,
        method: 'PUT',
        ...params,
      }),

    /**
     * @description Performs a deviation workflow action on the specified invoice. Supports API versioning through X-API-Version header.
     *
     * @tags invoice-controller
     * @name PerformDeviationWorkflowAction
     * @summary Perform Deviation Workflow Action
     * @request PUT:/api/invoices/{invoiceId}/{deviationWorkflowAction}
     * @response `200` `ResponseDtoInvoiceSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    performDeviationWorkflowAction: (
      invoiceId: string,
      deviationWorkflowAction:
        | 'SEND_TO_OPERATION'
        | 'SEND_TO_PROCUREMENT'
        | 'SEND_TO_FINANCE'
        | 'SEND_TO_SUPPLY_CHAIN'
        | 'START_DISPUTE'
        | 'CANCEL_DISPUTE'
        | 'MARK_INVOICE_TO_REJECT'
        | 'MARK_INVOICE_TO_APPROVE'
        | 'ACCEPT_CREDIT_NOTE'
        | 'ACCEPT_APPROVAL'
        | 'READY_FOR_PAYMENT'
        | 'REJECT_INVOICE'
        | 'ACCEPT_INVOICE'
        | 'ACCEPT_AS_SPOT_SHIPMENT'
        | 'SEND_TO_OPS_ADMIN'
        | 'SEND_TO_OPS_MANAGER'
        | 'SEND_TO_OPS_MANAGER_L1'
        | 'SEND_TO_OPS_MANAGER_L2',
      data: DeviationWorkflowActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoInvoiceSummaryDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/${deviationWorkflowAction}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Automatically determines and performs the appropriate reject action on the invoice based on current workflow state.
     *
     * @tags invoice-controller
     * @name RejectInvoice
     * @summary Reject Invoice
     * @request PUT:/api/invoices/{invoiceId}/reject
     * @response `200` `ResponseDtoInvoiceSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    rejectInvoice: (invoiceId: string, data: DeviationWorkflowActionBodyDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSummaryDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/reject`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Processes the charges and deviations of an invoice identified by its ID.
     *
     * @tags admin-controller
     * @name ProcessInvoice
     * @summary Process invoice
     * @request PUT:/api/invoices/{invoiceId}/processing
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    processInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/processing`,
        method: 'PUT',
        ...params,
      }),

    /**
     * @description Automatically determines and performs the appropriate confirm action on the invoice based on current workflow state.
     *
     * @tags invoice-controller
     * @name ConfirmInvoice
     * @summary Confirm Invoice
     * @request PUT:/api/invoices/{invoiceId}/confirm
     * @response `200` `ResponseDtoInvoiceSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    confirmInvoice: (invoiceId: string, data: DeviationWorkflowActionBodyDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSummaryDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/confirm`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves user responses for approval questionnaires associated with the specified shipment invoice
     *
     * @tags invoice-controller
     * @name GetUserResponse
     * @summary Get Approval Questionnaire User Response
     * @request GET:/api/invoices/shipment-invoices/{shipmentInvoiceId}/approval-questionnaire-user-response
     * @response `200` `ResponseDtoMapDeviationWorkflowListDeviationQuestionUserResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUserResponse: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapDeviationWorkflowListDeviationQuestionUserResponseDto, ResponseDtoObject>({
        path: `/api/invoices/shipment-invoices/${shipmentInvoiceId}/approval-questionnaire-user-response`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Saves user responses for approval questionnaires associated with the specified shipment invoice
     *
     * @tags invoice-controller
     * @name PostUserResponse
     * @summary Save Approval Questionnaire User Response
     * @request PUT:/api/invoices/shipment-invoices/{shipmentInvoiceId}/approval-questionnaire-user-response
     * @response `200` `ResponseDtoListDeviationQuestionUserResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    postUserResponse: (shipmentInvoiceId: string, data: DeviationQuestionUserResponseDto[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoListDeviationQuestionUserResponseDto, ResponseDtoObject>({
        path: `/api/invoices/shipment-invoices/${shipmentInvoiceId}/approval-questionnaire-user-response`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint retrieves the details of a specific invoice dispute by its ID.
     *
     * @tags invoice-dispute-controller
     * @name GetInvoiceDisputeDetail
     * @summary Get details of an invoice dispute
     * @request GET:/api/invoices/dispute/{invoiceDisputeId}
     * @response `200` `ResponseDtoInvoiceDisputeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceDisputeDetail: (invoiceDisputeId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceDisputeDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description This endpoint allows updating the details of an existing invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name UpdateInvoiceDispute
     * @summary Update an existing invoice dispute
     * @request PUT:/api/invoices/dispute/{invoiceDisputeId}
     * @response `200` `ResponseDtoInvoiceDisputeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateInvoiceDispute: (invoiceDisputeId: string, data: InvoiceDisputeUpdateRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceDisputeDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint allows performing a deviation workflow action on an invoice dispute. The action can be one of the predefined actions such as 'APPROVE', 'REJECT', etc. The request body can contain additional information required for the action.
     *
     * @tags invoice-dispute-controller
     * @name PerformDeviationWorkflowAction1
     * @summary Perform a deviation workflow action on an invoice dispute
     * @request PUT:/api/invoices/dispute/{invoiceDisputeId}/{deviationWorkflowAction}
     * @response `200` `ResponseDtoInvoiceDisputeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    performDeviationWorkflowAction1: (
      invoiceDisputeId: string,
      deviationWorkflowAction:
        | 'SEND_TO_OPERATION'
        | 'SEND_TO_PROCUREMENT'
        | 'SEND_TO_FINANCE'
        | 'SEND_TO_SUPPLY_CHAIN'
        | 'START_DISPUTE'
        | 'CANCEL_DISPUTE'
        | 'MARK_INVOICE_TO_REJECT'
        | 'MARK_INVOICE_TO_APPROVE'
        | 'ACCEPT_CREDIT_NOTE'
        | 'ACCEPT_APPROVAL'
        | 'READY_FOR_PAYMENT'
        | 'REJECT_INVOICE'
        | 'ACCEPT_INVOICE'
        | 'ACCEPT_AS_SPOT_SHIPMENT'
        | 'SEND_TO_OPS_ADMIN'
        | 'SEND_TO_OPS_MANAGER'
        | 'SEND_TO_OPS_MANAGER_L1'
        | 'SEND_TO_OPS_MANAGER_L2',
      data: DeviationWorkflowActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoInvoiceDisputeDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/${deviationWorkflowAction}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint retrieves the credit note details associated with a specific invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name GetInvoiceDisputeCreditNote
     * @summary Get credit note details for an invoice dispute
     * @request GET:/api/invoices/dispute/{invoiceDisputeId}/credit-note
     * @response `200` `ResponseDtoCreditNoteDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceDisputeCreditNote: (invoiceDisputeId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoCreditNoteDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description This endpoint allows updating the credit note details associated with a specific invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name UpdateInvoiceDisputeCreditNote
     * @summary Update credit note details for an invoice dispute
     * @request PUT:/api/invoices/dispute/{invoiceDisputeId}/credit-note
     * @response `200` `ResponseDtoCreditNoteDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateInvoiceDisputeCreditNote: (invoiceDisputeId: string, data: CreditNoteDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoCreditNoteDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint allows updating the credit note upload URL for a specific invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name GetUploadCreditNoteUrl
     * @summary Update the credit note upload URL for an invoice dispute
     * @request PUT:/api/invoices/dispute/{invoiceDisputeId}/credit-note-upload-url
     * @response `200` `ResponseDtoCreditNoteFileDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUploadCreditNoteUrl: (invoiceDisputeId: string, data: UploadCreditNoteUrlRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoCreditNoteFileDto, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note-upload-url`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint allows deleting the credit note upload URL for a specific invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name DeleteCreditNotes
     * @summary Delete the credit note upload URL for an invoice dispute
     * @request DELETE:/api/invoices/dispute/{invoiceDisputeId}/credit-note-upload-url
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteCreditNotes: (invoiceDisputeId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note-upload-url`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-ocr-message-controller
     * @name ReImport
     * @request PUT:/api/invoice-ocr-message
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    reImport: (data: InvoiceMessageDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoice-ocr-message`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing invoice OCR message. Only accessible by system administrators.
     *
     * @tags invoice-ocr-message-controller
     * @name UpdateInvoiceOcrMessage
     * @summary Update Invoice OCR Message
     * @request PUT:/api/invoice-ocr-message/{id}
     * @response `200` `ResponseDtoInvoiceOcrMessageDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateInvoiceOcrMessage: (id: string, data: InvoiceOcrMessageDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceOcrMessageDto, ResponseDtoObject>({
        path: `/api/invoice-ocr-message/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name UpdateStatusInvoiceFileProcessing
     * @request PUT:/api/invoice-file-processing/{invoiceFileProcessingId}/{status}
     * @response `200` `ResponseDtoInvoiceFileProcessingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateStatusInvoiceFileProcessing: (
      invoiceFileProcessingId: string,
      status:
        | 'BEING_UPLOADED'
        | 'UPLOADED_FILE'
        | 'SENT_TO_PIPELINE'
        | 'PIPELINE_TRIGGER_FAILED'
        | 'COMPLETE'
        | 'OCR_PROCESSING'
        | 'OCR_COMPLETE'
        | 'OCR_ERROR'
        | 'TRANSFORM_ERROR'
        | 'TRANSFORM_COMPLETE'
        | 'LOADING_DATA'
        | 'MESSAGE_PROCESSING_FAILED'
        | 'UPLOAD_FROM_EMAIL_FAILED'
        | 'UPLOAD_FROM_S3_FAILED'
        | 'RESOLVED_AS_NOT_AN_INVOICE'
        | 'RESOLVED_AS_MISSING_REQUIRED_FIELD'
        | 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'
        | 'MARKED_MISSING_REQUIRED_FIELD_FOR_REVIEW'
        | 'MARKED_INCONSISTENT_DATA_FOR_REVIEW'
        | 'DUPLICATE',
      data: InvoiceFileProcessingStatusUpdateReq,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoInvoiceFileProcessingDto, ResponseDtoObject>({
        path: `/api/invoice-file-processing/${invoiceFileProcessingId}/${status}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name BillInvoiceFileProcessings
     * @request PUT:/api/invoice-file-processing/bill
     * @response `200` `ResponseDtoBillInvoiceFileProcessingResultDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    billInvoiceFileProcessings: (data: BillInvoiceFileProcessingRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBillInvoiceFileProcessingResultDto, ResponseDtoObject>({
        path: `/api/invoice-file-processing/bill`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name BillByBilledEntity
     * @request PUT:/api/invoice-file-processing/bill-by-entity
     * @response `200` `ResponseDtoBillInvoiceFileProcessingResultDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    billByBilledEntity: (
      query: {
        /** @format int64 */
        billedEntityId: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoBillInvoiceFileProcessingResultDto, ResponseDtoObject>({
        path: `/api/invoice-file-processing/bill-by-entity`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * @description Upserts (inserts or updates) a list of InvoiceChargeDomainMappings. This endpoint is accessible only to users with the SYSTEM_ADMIN role.
     *
     * @tags invoice-charge-domain-mappings
     * @name UpsertInvoiceChargeDomainMapping
     * @summary Upsert InvoiceChargeDomainMappings
     * @request PUT:/api/invoice-charge-domain-mappings
     * @response `200` `ResponseDtoListInvoiceChargeDomainMappingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertInvoiceChargeDomainMapping: (data: UpsertInvoiceChargeDomainMappingReq[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoListInvoiceChargeDomainMappingDto, ResponseDtoObject>({
        path: `/api/invoice-charge-domain-mappings`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a list of InvoiceChargeDomainMappings by their IDs. This endpoint is accessible only to users with the SYSTEM_ADMIN role.
     *
     * @tags invoice-charge-domain-mappings
     * @name DeleteInvoiceChargeDomainMappingByIds
     * @summary Delete InvoiceChargeDomainMappings by IDs
     * @request DELETE:/api/invoice-charge-domain-mappings
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteInvoiceChargeDomainMappingByIds: (data: number[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoice-charge-domain-mappings`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves user responses for a deviation questionnaire, organized by deviation workflow.
     *
     * @tags deviations, questionnaires, responses
     * @name GetUserResponse1
     * @summary Get user responses
     * @request GET:/api/deviations/{id}/user-response
     * @response `200` `ResponseDtoMapDeviationWorkflowListDeviationQuestionUserResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUserResponse1: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapDeviationWorkflowListDeviationQuestionUserResponseDto, ResponseDtoObject>({
        path: `/api/deviations/${id}/user-response`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Saves user responses for a deviation questionnaire and returns the updated response data.
     *
     * @tags deviations, questionnaires, responses
     * @name PostUserResponse1
     * @summary Save user responses
     * @request PUT:/api/deviations/{id}/user-response
     * @response `200` `ResponseDtoListDeviationQuestionUserResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    postUserResponse1: (id: string, data: DeviationQuestionnaireQuestionUserResponseDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListDeviationQuestionUserResponseDto, ResponseDtoObject>({
        path: `/api/deviations/${id}/user-response`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags deviation-migration-controller
     * @name UpdateMatchingContractIdOnDeviation
     * @request PUT:/api/deviation-migration/update-matching-contract-id
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateMatchingContractIdOnDeviation: (
      query: {
        invoiceStatus: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/deviation-migration/update-matching-contract-id`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags deviation-migration-controller
     * @name UpdateMatchingContractIdOnDeviationForShipmentInvoice
     * @request PUT:/api/deviation-migration/shipment-invoices/{shipmentInvoiceId}/update-matching-contract-id
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateMatchingContractIdOnDeviationForShipmentInvoice: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/deviation-migration/shipment-invoices/${shipmentInvoiceId}/update-matching-contract-id`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags deviation-migration-controller
     * @name ReTrigger
     * @request PUT:/api/deviation-migration/invoices/re-trigger
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    reTrigger: (data: InvoiceReTriggerRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/deviation-migration/invoices/re-trigger`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks all unsettled credit transactions as settled, optionally filtered by date range.
     *
     * @tags credit, sysadmin
     * @name SettleCredits
     * @summary Settle credit transactions for a billed entity
     * @request PUT:/api/credits/settle
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    settleCredits: (
      query: {
        /**
         * The billed entity ID
         * @format int64
         */
        billedEntityId: number;
        /**
         * Optional start date filter (inclusive)
         * @format date
         * @example "2026-01-01"
         */
        startDate?: string;
        /**
         * Optional end date filter (inclusive)
         * @format date
         * @example "2026-01-31"
         */
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/credits/settle`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * @description Allows a system administrator to amend the amount of credit in a credit account. Optionally, a new expiration date for the credit can be provided.
     *
     * @tags credit, sysadmin
     * @name AmendCredit
     * @summary Amend credit in a specified credit account, for admin use only
     * @request PUT:/api/credits/amend
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    amendCredit: (
      query: {
        /**
         * The unique identifier of the credit account
         * @format uuid
         */
        creditId: string;
        /**
         * The new amount of credit
         * @format int64
         */
        amount: number;
        /**
         * The optional new expiration date for the credit
         * @format date
         */
        expirationDate?: string;
        /** The purchase order number associated with the credit amendment */
        poNumber?: string;
        /**
         * The purchase order date associated with the credit amendment
         * @format date
         */
        poDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/credits/amend`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * @description Updates an existing contract if the ID is provided; otherwise, creates a new contract.
     *
     * @tags contract-controller
     * @name UpsertContract
     * @summary Update or create a contract
     * @request PUT:/api/contracts
     * @response `200` `ResponseDtoContractDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertContract: (data: ContractUpsertRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractDto, ResponseDtoObject>({
        path: `/api/contracts`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new contract based on the provided request payload.
     *
     * @tags contract-controller
     * @name CreateContract
     * @summary Create a new contract
     * @request POST:/api/contracts
     * @response `200` `ResponseDtoContractDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createContract: (data: CreatingContractReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractDto, ResponseDtoObject>({
        path: `/api/contracts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a contract zone mapping for a given contract.
     *
     * @tags contract-zone-controller
     * @name UpsertContractZone
     * @summary Upsert contract zone
     * @request PUT:/api/contract-zones
     * @response `200` `ResponseDtoContractZoneDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertContractZone: (data: ContractZoneDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractZoneDto, ResponseDtoObject>({
        path: `/api/contract-zones`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a contract route mapping. Include an ID in the request body to update an existing route; omit it to create a new one.
     *
     * @tags Contract Routes
     * @name UpsertContractRoute
     * @summary Upsert contract route
     * @request PUT:/api/contract-routes
     * @response `200` `ResponseDtoContractRouteDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertContractRoute: (data: ContractRouteDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractRouteDto, ResponseDtoObject>({
        path: `/api/contract-routes`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a contract flow by its ID. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name GetContractFlow
     * @summary Get contract flow by ID
     * @request GET:/api/contract-flows/{contractFlowId}
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractFlow: (contractFlowId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows/${contractFlowId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Update an existing contract flow. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name UpdateContractFlow
     * @summary Update a contract flow
     * @request PUT:/api/contract-flows/{contractFlowId}
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateContractFlow: (contractFlowId: string, data: CreatingAndUpdatingContractFlowReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows/${contractFlowId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete an existing contract flow by its id. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name DeleteContractFlow
     * @summary Delete a contract flow
     * @request DELETE:/api/contract-flows/{contractFlowId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteContractFlow: (
      contractFlowId: string,
      query?: {
        /**
         * Force deletion contract flow even if it has been linked to ContractContainerCharge, ContractShipmentCharge, ContractWeightCharge, ContractDeclarationCharge or ContractPercentageCharge. Also its contract_flow_xxx_charge, and all contract_xxx_charge when they are not linked to other contract flows.
         * @default false
         * @example false
         */
        force?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/contract-flows/${contractFlowId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Remove rate cards from a contract flow. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name RemoveRateCardsToContractFlow
     * @summary Remove rate cards from a contract flow
     * @request PUT:/api/contract-flows/{contractFlowId}/rate-cards/removal
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    removeRateCardsToContractFlow: (contractFlowId: string, data: AddingOrRemovingRateCardToContractFlowReq[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows/${contractFlowId}/rate-cards/removal`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add rate cards to a contract flow. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name AddRateCardsToContractFlow
     * @summary Add rate cards to a contract flow
     * @request PUT:/api/contract-flows/{contractFlowId}/rate-cards/addition
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    addRateCardsToContractFlow: (contractFlowId: string, data: AddingOrRemovingRateCardToContractFlowReq[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows/${contractFlowId}/rate-cards/addition`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches a list of chart reports. Optionally filters by the specified chart report type.
     *
     * @tags chart-report-controller
     * @name GetChartReports
     * @summary Retrieve chart reports
     * @request GET:/api/chart-report
     * @response `200` `ResponseDtoListChartReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getChartReports: (
      query?: {
        type?: 'REPORT_ANALYTIC' | 'PERFORMANCE_ASSESSMENT';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListChartReportDto, ResponseDtoObject>({
        path: `/api/chart-report`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Updates an existing chart report with the provided request data.
     *
     * @tags chart-report-controller
     * @name UpdateChartReport
     * @summary Update an existing chart report
     * @request PUT:/api/chart-report
     * @response `200` `ResponseDtoChartReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateChartReport: (data: ChartReportRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoChartReportDto, ResponseDtoObject>({
        path: `/api/chart-report`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new chart report based on the provided request data.
     *
     * @tags chart-report-controller
     * @name CreateChartReport
     * @summary Create a new chart report
     * @request POST:/api/chart-report
     * @response `200` `ResponseDtoChartReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createChartReport: (data: ChartReportRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoChartReportDto, ResponseDtoObject>({
        path: `/api/chart-report`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves the OCR output for a given invoice file processing ID. Accessible by SYSTEM_ADMIN.
     *
     * @tags aws-controller
     * @name GetOcrOutput
     * @summary Retrieve OCR output
     * @request GET:/api/aws/s3/ocr-output/invoice-file-processing/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoJsonNode` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getOcrOutput: (invoiceFileProcessingId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoJsonNode, ResponseDtoObject>({
        path: `/api/aws/s3/ocr-output/invoice-file-processing/${invoiceFileProcessingId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Updates the OCR output for a given invoice file processing ID, then transformer will be triggered. Accessible by SYSTEM_ADMIN.
     *
     * @tags aws-controller
     * @name UpdateOcrOutput
     * @summary Update OCR output
     * @request PUT:/api/aws/s3/ocr-output/invoice-file-processing/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateOcrOutput: (invoiceFileProcessingId: string, data: JsonNode, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/aws/s3/ocr-output/invoice-file-processing/${invoiceFileProcessingId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description In case the ADMIN wants to stop the recalculation process.
     *
     * @tags jobs, admin
     * @name StopMigration
     * @summary Stop the recalculation process
     * @request PUT:/api/admin/recalculate-exchange-price/migration/stop
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    stopMigration: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/recalculate-exchange-price/migration/stop`,
        method: 'PUT',
        ...params,
      }),

    /**
     * @description This API endpoint allows the ADMIN to retrieve the batch size for processing during the migration.
     *
     * @tags jobs, admin
     * @name GetBatchSize
     * @summary Retrieve the batch size for recalculation process
     * @request GET:/api/admin/recalculate-exchange-price/migration/batch-size
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getBatchSize: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/recalculate-exchange-price/migration/batch-size`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description This API endpoint allows the ADMIN to set the batch size for processing during the migration.
     *
     * @tags jobs, admin
     * @name SetBatchSize
     * @summary Update the batch size for recalculation process
     * @request PUT:/api/admin/recalculate-exchange-price/migration/batch-size
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    setBatchSize: (
      query: {
        request: MigrationBatchSizeRequest;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/recalculate-exchange-price/migration/batch-size`,
        method: 'PUT',
        query: query,
        ...params,
      }),

    /**
     * @description Returns a list of all workflows
     *
     * @tags workflow-controller
     * @name GetAllWorkflows
     * @summary Get all workflows
     * @request GET:/api/workflows
     * @response `200` `ResponseDtoListWorkflowDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllWorkflows: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListWorkflowDto, ResponseDtoObject>({
        path: `/api/workflows`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Creates a new workflow or updates an existing one based on the provided request
     *
     * @tags workflow-controller
     * @name CreateOrUpdateWorkflow
     * @summary Create or update a workflow
     * @request POST:/api/workflows
     * @response `200` `ResponseDtoWorkflowDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createOrUpdateWorkflow: (data: WorkflowDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoWorkflowDto, ResponseDtoObject>({
        path: `/api/workflows`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a list of all workflow rules
     *
     * @tags workflow-rule-controller
     * @name GetAllWorkflowRules
     * @summary Get all workflow rules
     * @request GET:/api/workflow-rules
     * @response `200` `ResponseDtoListWorkflowRuleDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllWorkflowRules: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListWorkflowRuleDto, ResponseDtoObject>({
        path: `/api/workflow-rules`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Creates a new workflow rule or updates an existing one based on the provided request
     *
     * @tags workflow-rule-controller
     * @name CreateOrUpdateWorkflowRule
     * @summary Create or update a workflow rule
     * @request POST:/api/workflow-rules
     * @response `200` `ResponseDtoWorkflowRuleDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createOrUpdateWorkflowRule: (data: WorkflowRulePostRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoWorkflowRuleDto, ResponseDtoObject>({
        path: `/api/workflow-rules`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Queries workflow rules based on the provided request parameters
     *
     * @tags workflow-rule-controller
     * @name QueryWorkflowRules
     * @summary Query workflow rules
     * @request POST:/api/workflow-rules/query
     * @response `200` `ResponseDtoListWorkflowRule` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    queryWorkflowRules: (data: WorkflowRuleQueryRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListWorkflowRule, ResponseDtoObject>({
        path: `/api/workflow-rules/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Validates a JSON object based on the specified validation type. If no type is provided, default validation is applied.
     *
     * @tags validation-controller
     * @name ValidateJson
     * @summary Validate a JSON object
     * @request POST:/api/validation/validate-json
     * @response `200` `JsonNode` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    validateJson: (
      data: JsonNode,
      query?: {
        /** The type of validation to perform (optional) */
        type?: 'SHIPMENT' | 'CHARGE' | 'INVOICE';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<JsonNode, ResponseDtoObject>({
        path: `/api/validation/validate-json`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Queries users based on the provided criteria.
     *
     * @tags User, Query
     * @name QueryUsers
     * @summary Query users
     * @request POST:/api/users/query
     * @response `200` `ResponseDtoPageUserDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    queryUsers: (data: UserDetailsRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageUserDto, ResponseDtoObject>({
        path: `/api/users/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves metadata for users based on the provided criteria.
     *
     * @tags User, Metadata
     * @name GetUsersMetadata
     * @summary Get user metadata
     * @request POST:/api/users/metadata
     * @response `200` `ResponseDtoUserDetailsMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUsersMetadata: (data: UserDetailsRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUserDetailsMetadataDto, ResponseDtoObject>({
        path: `/api/users/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new user issue resolution in the system.
     *
     * @tags user-resolutions
     * @name CreateUserIssue
     * @summary Create a user issue
     * @request POST:/api/user-resolutions
     * @response `200` `ResponseDtoUserIssueDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createUserIssue: (data: UserIssueRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUserIssueDto, ResponseDtoObject>({
        path: `/api/user-resolutions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Lists all SIC code user assignments
     *
     * @tags SIC Code Assignments
     * @name GetAssignments
     * @summary List SIC code assignments
     * @request GET:/api/sic-code-assignments
     * @response `200` `ResponseDtoListSicCodeManagerAssignmentDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAssignments: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListSicCodeManagerAssignmentDto, ResponseDtoObject>({
        path: `/api/sic-code-assignments`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Assigns a user to a SIC code
     *
     * @tags SIC Code Assignments
     * @name CreateAssignment
     * @summary Create SIC code assignment
     * @request POST:/api/sic-code-assignments
     * @response `200` `ResponseDtoSicCodeManagerAssignmentDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createAssignment: (data: CreateSicCodeManagerAssignmentRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoSicCodeManagerAssignmentDto, ResponseDtoObject>({
        path: `/api/sic-code-assignments`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new shipping service with the provided details. This endpoint requires ADMIN permissions.
     *
     * @tags shipping-services, admin
     * @name CreateShippingService
     * @summary Create a new shipping service
     * @request POST:/api/shipping-services
     * @response `200` `ResponseDtoShippingServiceDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createShippingService: (data: CreatingAndUpdatingShippingServiceReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShippingServiceDto, ResponseDtoObject>({
        path: `/api/shipping-services`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a paginated list of shipping services based on the provided service provider and modality. This endpoint requires ADMIN permissions.
     *
     * @tags shipping-services, admin
     * @name GetShippingService
     * @summary Query shipping services by service provider and modality
     * @request POST:/api/shipping-services/query
     * @response `200` `ResponseDtoPageShippingServiceDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getShippingService: (data: ShippingServiceRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageShippingServiceDto, ResponseDtoObject>({
        path: `/api/shipping-services/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves metadata for shipping services, including service providers and modalities.
     *
     * @tags shipping-services
     * @name GetShippingServiceMetadata
     * @summary Get metadata for shipping services
     * @request POST:/api/shipping-services/metadata
     * @response `200` `ResponseDtoShippingServiceMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getShippingServiceMetadata: (data: ShippingServiceRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShippingServiceMetadataDto, ResponseDtoObject>({
        path: `/api/shipping-services/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the matching shipping service based on the provided criteria
     *
     * @tags shipping-services
     * @name GetMatchingShippingService
     * @summary Get the matching shipping service
     * @request POST:/api/shipping-services/matching
     * @response `200` `ResponseDtoShippingServiceDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getMatchingShippingService: (data: GetMatchingShippingServiceRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShippingServiceDto, ResponseDtoObject>({
        path: `/api/shipping-services/matching`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name CalculateShipmentCo2Emission
     * @request POST:/api/shipments/{shipmentId}/calculate-co2e
     * @response `200` `ResponseDtoSeaRoutesResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    calculateShipmentCo2Emission: (shipmentId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoSeaRoutesResponseDto, ResponseDtoObject>({
        path: `/api/shipments/${shipmentId}/calculate-co2e`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name CreateShippingServiceAndContract
     * @request POST:/api/shipments/shipment-invoices/{shipmentInvoiceId}/new-service-contract
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createShippingServiceAndContract: (shipmentInvoiceId: string, data: NewShippingServiceAndContractRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/new-service-contract`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Recalculates new charge deviations for a specific shipment invoice and returns the updated deviation list.
     *
     * @tags shipment-invoices, deviations
     * @name RecalculateInvoiceDeviations
     * @summary Recalculate invoice deviations
     * @request POST:/api/shipment-invoices/{shipmentInvoiceId}/recalculate-new-charge
     * @response `200` `ResponseDtoListDeviation` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    recalculateInvoiceDeviations: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListDeviation, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/recalculate-new-charge`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Retrieves the active no-contract draft for the specified shipment invoice ID.
     *
     * @tags no-contract-draft-controller
     * @name GetActiveNoContractDraft
     * @summary Get the active no-contract draft for a shipment invoice
     * @request GET:/api/shipment-invoices/{shipmentInvoiceId}/no-contract-drafts
     * @response `200` `ResponseDtoNoContractDraft` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getActiveNoContractDraft: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoNoContractDraft, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/no-contract-drafts`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Creates or updates a no-contract draft associated with the given shipment invoice ID.
     *
     * @tags no-contract-draft-controller
     * @name CreateOrUpdateNoContractDraft
     * @summary Create or update a no-contract draft for a shipment invoice
     * @request POST:/api/shipment-invoices/{shipmentInvoiceId}/no-contract-drafts
     * @response `200` `ResponseDtoNoContractDraft` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createOrUpdateNoContractDraft: (shipmentInvoiceId: string, data: NoContractDraftRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoNoContractDraft, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/no-contract-drafts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Discards the active no-contract draft for the specified shipment invoice ID.
     *
     * @tags no-contract-draft-controller
     * @name DiscardNoContractDraft
     * @summary Discard the active no-contract draft for a shipment invoice
     * @request POST:/api/shipment-invoices/{shipmentInvoiceId}/no-contract-drafts/discard
     * @response `200` `ResponseDtoNoContractDraft` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    discardNoContractDraft: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoNoContractDraft, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/no-contract-drafts/discard`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Fetches all service providers with pagination and filtering options based on the provided request. This endpoint supports multiple filtering criteria including service provider IDs, names, codes, modalities, currencies, and parent service provider relationships. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name GetAllServiceProviders
     * @summary Query all service providers
     * @request POST:/api/service-providers/query
     * @response `200` `ResponseDtoPageServiceProviderOverViewDto` Successfully retrieved service providers with pagination information
     * @response `400` `ResponseDtoPageServiceProviderOverViewDto` Bad Request - Invalid request payload. This occurs when required fields are missing or invalid, particularly when the paginationRequest object is null or contains invalid values. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoPageServiceProviderOverViewDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to access this endpoint.
     */
    getAllServiceProviders: (data: ServiceProviderRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageServiceProviderOverViewDto, ResponseDtoPageServiceProviderOverViewDto | ResponseDtoObject>({
        path: `/api/service-providers/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches metadata information for all service providers, including counts and statistics based on filtering criteria. This endpoint aggregates various counters (IDs, names, codes, modalities, currencies, parent relationships) for service providers matching the provided request criteria. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name GetAllServiceProvidersMetaData
     * @summary Retrieve service providers metadata
     * @request POST:/api/service-providers/metadata
     * @response `200` `ResponseDtoServiceProviderMetadataDto` Successfully retrieved service provider metadata with aggregated statistics
     * @response `401` `ResponseDtoServiceProviderMetadataDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to access this endpoint.
     */
    getAllServiceProvidersMetaData: (data: ServiceProviderRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoServiceProviderMetadataDto, ResponseDtoServiceProviderMetadataDto | ResponseDtoObject>({
        path: `/api/service-providers/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags universal-search-controller
 * @name PerformUniversalSearch
 * @summary Search invoice universe by invoice number and shipment number via searchKey.
If isApprovedInvoice is true, only approved invoices will be included in the search results.
If isApprovedInvoice is null, all invoices will be included in the search results.
The page number and page size are used for pagination.
The search key must be at least 3 characters long.
 * @request POST:/api/search
 * @response `200` `ResponseDtoUniversalSearchResponseDto` OK
 * @response `403` `ResponseDtoObject` Forbidden
 */
    performUniversalSearch: (data: UniversalSearchRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoUniversalSearchResponseDto, ResponseDtoObject>({
        path: `/api/search`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Exports consolidation report data showing potential consolidation opportunities to a CSV or Excel file.
     *
     * @tags quick-report-controller
     * @name ExportConsolidationData
     * @summary Export Consolidation Report
     * @request POST:/api/reporting/consolidation/export
     * @response `200` `ResponseDtoExportJobResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    exportConsolidationData: (
      query: {
        'file-name'?: string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoExportJobResponse, ResponseDtoObject>({
        path: `/api/reporting/consolidation/export`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * @description Triggers the refresh of materialized views
     *
     * @tags admin
     * @name RefreshMaterializedViews
     * @summary Triggers the refresh of materialized views
     * @request POST:/api/refresh-materialized-views
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    refreshMaterializedViews: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/refresh-materialized-views`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Compares total expected costs for shipment invoices for 2 selected periods by applying both earlier and later period rate cards to the same set of invoices. If webhookUrl is provided, the analysis will be processed asynchronously and results sent to the webhook.
     *
     * @tags Rate & Cost Impact Analysis
     * @name PeriodOverPeriodAnalysis
     * @summary Perform rate & cost impact analysis
     * @request POST:/api/rate-cost-analysis/rate-cost-period-over-period-analysis
     * @response `200` `JsonNode` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    periodOverPeriodAnalysis: (data: RateCostAnalysisRequestDto, params: RequestParams = {}) =>
      this.http.request<JsonNode, ResponseDtoObject>({
        path: `/api/rate-cost-analysis/rate-cost-period-over-period-analysis`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Calculates the expected invoice amount for a specific shipment invoice ID and rate date. This endpoint provides an estimate of the total charges for a shipment based on current rate cards.
     *
     * @tags rate-card-controller
     * @name CalculateExpectedShipmentInvoiceWithCurrency
     * @summary Calculate Expected Shipment Invoice Amount
     * @request POST:/api/rate-cards/expected-shipment-invoice-amount
     * @response `200` `ResponseDtoExpectedShipmentInvoiceResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    calculateExpectedShipmentInvoiceWithCurrency: (data: ExpectedShipmentInvoiceRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExpectedShipmentInvoiceResponseDto, ResponseDtoObject>({
        path: `/api/rate-cards/expected-shipment-invoice-amount`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Calculates the expected charge for a specific shipment ID and rate date. This endpoint is used to estimate the total charges associated with a shipment based on current rate cards.
     *
     * @tags rate-card-controller
     * @name CalculateExpectedChargeForShipment
     * @summary Calculate Expected Charge for Shipment
     * @request POST:/api/rate-cards/expected-shipment-charge-amount
     * @response `200` `ResponseDtoExpectedChargeForShipmentResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    calculateExpectedChargeForShipment: (data: ExpectedChargeForShipmentRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExpectedChargeForShipmentResponseDto, ResponseDtoObject>({
        path: `/api/rate-cards/expected-shipment-charge-amount`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Calculates the expected charge amount for a specific charge ID and rate date. This endpoint is used to estimate charges based on current rate cards.
     *
     * @tags rate-card-controller
     * @name CalculateExpectedChargeAmountWithCurrency
     * @summary Calculate Expected Charge Amount for a Unit
     * @request POST:/api/rate-cards/expected-charge-amount
     * @response `200` `ResponseDtoExpectedChargeForUnitResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    calculateExpectedChargeAmountWithCurrency: (data: ExpectedChargeForUnitRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExpectedChargeForUnitResponseDto, ResponseDtoObject>({
        path: `/api/rate-cards/expected-charge-amount`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves paginated volumetric performance data organized by month with filtering and pagination support
     *
     * @tags performance-assessment-controller
     * @name GetVolumetricTableDataByMonthWithFilter
     * @summary Get volumetric performance data per month
     * @request POST:/api/performance-assessment/volumetric/per-months
     * @response `200` `ResponseDtoPerformanceVolumetricTableResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getVolumetricTableDataByMonthWithFilter: (data: PerformanceAssessmentVolumetricTableRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPerformanceVolumetricTableResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/volumetric/per-months`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Downloads all volumetric performance data organized by month in the specified file format (CSV, Excel, etc.)
     *
     * @tags performance-assessment-controller
     * @name GetVolumetricTableDataDownload
     * @summary Download volumetric performance data per month
     * @request POST:/api/performance-assessment/volumetric/per-months/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getVolumetricTableDataDownload: (
      query: {
        /** The name of the file to be downloaded */
        'file-name': string;
        /** The file format for the download (CSV, EXCEL, etc.) */
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: PerformanceAssessmentVolumetricTableRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/performance-assessment/volumetric/per-months/download`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated volumetric metrics including volumes, weights, and counts based on the provided filter criteria
     *
     * @tags performance-assessment-controller
     * @name GetKeyMetricsVolumesWithFilter
     * @summary Get key metrics for volumetric performance
     * @request POST:/api/performance-assessment/volumes/metric
     * @response `200` `ResponseDtoVolumetricResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsVolumesWithFilter: (data: PerformanceAssessmentKeyMetricRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVolumetricResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/volumes/metric`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated volumetric metrics for all entities including volumes, weights, and counts based on the provided filter criteria
     *
     * @tags performance-assessment-controller
     * @name GetKeyMetricsVolumesForAll
     * @summary Get key metrics for volumetric performance across all entities
     * @request POST:/api/performance-assessment/volumes/metric/all
     * @response `200` `ResponseDtoListServiceProviderVolumetricResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsVolumesForAll: (data: PerformanceAssessmentKeyMetricForAllRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListServiceProviderVolumetricResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/volumes/metric/all`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves paginated savings performance data organized by month with filtering and pagination support
     *
     * @tags performance-assessment-controller
     * @name GetSavingsTableDataByMonthWithFilter
     * @summary Get savings performance data per month
     * @request POST:/api/performance-assessment/savings/per-months
     * @response `200` `ResponseDtoPerformanceSavingsTableResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getSavingsTableDataByMonthWithFilter: (data: PerformanceAssessmentSavingsTableRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPerformanceSavingsTableResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/savings/per-months`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Downloads all savings performance data organized by month in the specified file format (CSV, Excel, etc.)
     *
     * @tags performance-assessment-controller
     * @name GetSavingsTableDataDownload
     * @summary Download savings performance data per month
     * @request POST:/api/performance-assessment/savings/per-months/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getSavingsTableDataDownload: (
      query: {
        /** The name of the file to be downloaded */
        'file-name': string;
        /** The file format for the download (CSV, EXCEL, etc.) */
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: PerformanceAssessmentSavingsTableRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/performance-assessment/savings/per-months/download`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated savings metrics including amounts, shipments, invoices, and charge lines based on the provided filter criteria
     *
     * @tags performance-assessment-controller
     * @name GetKeyMetricsSavingsWithFilter
     * @summary Get key metrics for savings performance
     * @request POST:/api/performance-assessment/savings/metric
     * @response `200` `ResponseDtoSavingsMetricResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsSavingsWithFilter: (data: PerformanceAssessmentKeyMetricRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoSavingsMetricResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/savings/metric`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated savings metrics for all entities including amounts, shipments, invoices, and charge lines based on the provided filter criteria
     *
     * @tags performance-assessment-controller
     * @name GetKeyMetricsSavingsForAll
     * @summary Get key metrics for savings performance across all entities
     * @request POST:/api/performance-assessment/savings/metric/all
     * @response `200` `ResponseDtoListServiceProviderSavingsMetricResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsSavingsForAll: (data: PerformanceAssessmentKeyMetricForAllRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListServiceProviderSavingsMetricResponseDto, ResponseDtoObject>({
        path: `/api/performance-assessment/savings/metric/all`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Search for locations by country, type, location, or unlocode. Type to be chosen among "Port","Rail Terminal","Road Terminal" or "Multimodal Functions". You can combine multiple filters (country, type, location) using AND logic for more precise results. For example: country=FR&location=par will return locations in France that contain "par" in their name. Providing only a substring of locations will provide a list of potential candidates. UNLOCODE must be exactly 5 characters long.
     *
     * @tags location-controller
     * @name GetLocations
     * @summary Search locations
     * @request GET:/api/locations
     * @response `200` `ResponseDtoListLocationDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getLocations: (
      query?: {
        country?: string;
        type?: string;
        location?: string;
        unlocode?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListLocationDto, ResponseDtoObject>({
        path: `/api/locations`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Create a new location entry.
     *
     * @tags location-controller
     * @name CreateLocation
     * @summary Create location
     * @request POST:/api/locations
     * @response `200` `ResponseDtoLocationDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createLocation: (data: LocationDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLocationDto, ResponseDtoObject>({
        path: `/api/locations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches all legal entities with pagination and filtering options based on the provided request. This endpoint supports multiple filtering criteria including entity IDs, names, codes, national currencies, billing status, and parent entity relationships. Requires ADMIN or SYSTEM_ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name GetAllLegalEntities
     * @summary Query all legal entities
     * @request POST:/api/legal-entities/query
     * @response `200` `ResponseDtoPageLegalEntityDto` Successfully retrieved legal entities with pagination information
     * @response `400` `ResponseDtoPageLegalEntityDto` Bad Request - Invalid request payload. This occurs when required fields are missing or invalid, particularly when the paginationRequest object is null or contains invalid values. The 'message' field in the response will describe the specific validation error.
     * @response `401` `ResponseDtoPageLegalEntityDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required ADMIN or SYSTEM_ADMIN role to access this endpoint.
     */
    getAllLegalEntities: (data: LegalEntityRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageLegalEntityDto, ResponseDtoPageLegalEntityDto | ResponseDtoObject>({
        path: `/api/legal-entities/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches metadata information for all legal entities, including counts and statistics.
     *
     * @tags legal-entity-controller
     * @name GetAllLegalEntitiesMetaData
     * @summary Retrieve legal entities metadata
     * @request POST:/api/legal-entities/metadata
     * @response `200` `ResponseDtoLegalEntityMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllLegalEntitiesMetaData: (data: LegalEntityRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoLegalEntityMetadataDto, ResponseDtoObject>({
        path: `/api/legal-entities/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves key metrics data based on the specified use type and filter criteria.
     *
     * @tags key-metrics, analytics
     * @name GetKeyMetricsWithFilter
     * @summary Get key metrics with filter
     * @request POST:/api/key-metrics/{useType}
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsWithFilter: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', data: AnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/${useType}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns shipment count, volume, gross weight, chargeable weight, and CO2 emissions with full AnalyticSearchRequestDto support.
     *
     * @tags key-metrics, analytics
     * @name GetKeyMetricsShipmentData
     * @summary Get shipment-only key metrics (R&A)
     * @request POST:/api/key-metrics/{useType}/shipment-data
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsShipmentData: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', data: AnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/${useType}/shipment-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns invoice count and totals before/after tax with full AnalyticSearchRequestDto support.
     *
     * @tags key-metrics, analytics
     * @name GetKeyMetricsInvoiceData
     * @summary Get invoice-only key metrics (R&A)
     * @request POST:/api/key-metrics/{useType}/invoice-data
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsInvoiceData: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', data: AnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/${useType}/invoice-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns charge count and total deviation amount before/after tax with full AnalyticSearchRequestDto support.
     *
     * @tags key-metrics, analytics
     * @name GetKeyMetricsChargeData
     * @summary Get charge-only key metrics (R&A)
     * @request POST:/api/key-metrics/{useType}/charge-data
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsChargeData: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', data: AnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/${useType}/charge-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves key metrics invoice data based on the provided invoice search criteria.
     *
     * @tags key-metrics, invoices
     * @name GetKeyMetricsAuditInvoiceData
     * @summary Get key metrics invoice data
     * @request POST:/api/key-metrics/invoice-data
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsAuditInvoiceData: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/invoice-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves key metrics invoice charge data based on the provided invoice search criteria.
     *
     * @tags key-metrics, invoices
     * @name GetKeyMetricsAuditChargeData
     * @summary Get key metrics invoice charge data
     * @request POST:/api/key-metrics/charge-data
     * @response `200` `ResponseDtoKeyMetricsResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getKeyMetricsAuditChargeData: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoKeyMetricsResponseDto, ResponseDtoObject>({
        path: `/api/key-metrics/charge-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Verifies if the validity period for an existing shipping service is valid for the given invoice
     *
     * @tags invoice-controller
     * @name IsValidityPeriodValid
     * @summary Verify Validity Period
     * @request POST:/api/invoices/{invoiceId}/verify-validity-period
     * @response `200` `ResponseDtoMapStringBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    isValidityPeriodValid: (invoiceId: string, data: NewShippingServiceDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapStringBoolean, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/verify-validity-period`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Resends the ready for payment email for the specified invoice. Only accessible by SYSTEM ADMIN users.
     *
     * @tags invoice-controller
     * @name ResendReadyForPaymentEmail
     * @summary Resend Ready for Payment Email
     * @request POST:/api/invoices/{invoiceId}/resend-ready-for-payment-email
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    resendReadyForPaymentEmail: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/resend-ready-for-payment-email`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Searches for invoices based on the provided criteria including filters, pagination, and sorting
     *
     * @tags invoice-controller
     * @name GetInvoiceList
     * @summary Search Invoices
     * @request POST:/api/invoices/search
     * @response `200` `ResponseDtoInvoiceSearchResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceList: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSearchResponse, ResponseDtoObject>({
        path: `/api/invoices/search`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves invoice statistics and allowed currencies based on filters
     *
     * @tags invoice-controller
     * @name GetInvoiceMetadata
     * @summary Get invoice metadata
     * @request POST:/api/invoices/search/metadata
     * @response `200` `ResponseDtoInvoiceMetadataResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceMetadata: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceMetadataResponseDto, ResponseDtoObject>({
        path: `/api/invoices/search/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches for invoice data based on the provided criteria including filters, pagination, and sorting
     *
     * @tags invoice-controller
     * @name SearchInvoiceData
     * @summary Search Invoice Data
     * @request POST:/api/invoices/search/invoice-data
     * @response `200` `ResponseDtoInvoiceSearchResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    searchInvoiceData: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSearchResponse, ResponseDtoObject>({
        path: `/api/invoices/search/invoice-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated counts for invoice search filters including status, billed entity, incoterm, shipper, consignee, service, and trade lane
     *
     * @tags invoice-controller
     * @name GetInvoiceSearchMetadata
     * @summary Get invoice search metadata
     * @request POST:/api/invoices/search/filter/metadata
     * @response `200` `ResponseDtoInvoiceSearchMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceSearchMetadata: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSearchMetadataDto, ResponseDtoObject>({
        path: `/api/invoices/search/filter/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves aggregated counts for a single invoice search filter column. This is more efficient than fetching all columns when only one is needed.
     *
     * @tags invoice-controller
     * @name GetInvoiceSearchMetadataByColumn
     * @summary Get invoice search metadata for a specific column
     * @request POST:/api/invoices/search/filter/metadata/{column}
     * @response `200` `ResponseDtoInvoiceSearchSingleColumnMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceSearchMetadataByColumn: (
      column:
        | 'INVOICE_NUMBER'
        | 'STATUS'
        | 'BILLED_ENTITY'
        | 'INCOTERM'
        | 'SHIPPER'
        | 'CONSIGNEE'
        | 'SERVICE'
        | 'SHIPMENT_TYPE'
        | 'TRADE_LANE'
        | 'SHIPMENT_NUMBER'
        | 'DATE',
      data: InvoiceSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoInvoiceSearchSingleColumnMetadataDto, ResponseDtoObject>({
        path: `/api/invoices/search/filter/metadata/${column}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches for charge data based on the provided criteria including filters, pagination, and sorting
     *
     * @tags invoice-controller
     * @name SearchInvoiceChargeData
     * @summary Search Charge Data
     * @request POST:/api/invoices/search/charge-data
     * @response `200` `ResponseDtoListInvoiceSearchResult` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    searchInvoiceChargeData: (data: InvoiceSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListInvoiceSearchResult, ResponseDtoObject>({
        path: `/api/invoices/search/charge-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates pre-signed URLs for uploading invoice files to cloud storage.
     *
     * @tags invoices, upload
     * @name GetInvoicePreSignedUrLs
     * @summary Get invoice pre-signed URLs
     * @request POST:/api/invoices/invoice-upload-pre-signed-urls
     * @response `200` `ResponseDtoInvoiceUploadSignedUrlResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoicePreSignedUrLs: (data: InvoiceUploadSignedUrlRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceUploadSignedUrlResponseDto, ResponseDtoObject>({
        path: `/api/invoices/invoice-upload-pre-signed-urls`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates pre-signed URLs for uploading invoice attachments to cloud storage.
     *
     * @tags invoices, upload, attachments
     * @name GetAttachmentPreSignedUrLs
     * @summary Get attachment pre-signed URLs
     * @request POST:/api/invoices/invoice-attachment-pre-signed-urls
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAttachmentPreSignedUrLs: (data: InvoiceAttachmentUploadSignedUrlRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/invoice-attachment-pre-signed-urls`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Assigns a Finance Approval Process (FAP) reference to the selected invoices
     *
     * @tags invoice-controller
     * @name AssignFapRef
     * @summary Assign FAP Reference
     * @request POST:/api/invoices/fap-ref
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    assignFapRef: (data: SetFapRefRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/fap-ref`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-ocr-message-controller
     * @name S3BatchImport
     * @request POST:/api/invoice-ocr-message/s3-batch-import
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    s3BatchImport: (
      query: {
        bucketName: string;
        prefix: string;
        /** @format uuid */
        batchId?: string;
        /**
         * @format int32
         * @default 1
         */
        maxConcurrentMessages?: number;
        /**
         * @format int32
         * @default 300
         */
        timeLimitInSeconds?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoice-ocr-message/s3-batch-import`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-ocr-message-controller
     * @name InterruptS3BatchImport
     * @request POST:/api/invoice-ocr-message/s3-batch-import/interrupt
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    interruptS3BatchImport: (
      query: {
        /** @format uuid */
        batchId: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoice-ocr-message/s3-batch-import/interrupt`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name Query
     * @request POST:/api/invoice-file-processing/query
     * @response `200` `ResponseDtoInternalDashboardTableResponseDtoInvoiceFileProcessingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    query: (data: SearchingInvoiceFileProcessingRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInternalDashboardTableResponseDtoInvoiceFileProcessingDto, ResponseDtoObject>({
        path: `/api/invoice-file-processing/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves all invoice data pipeline configurations based on the provided filters.
     *
     * @tags Invoice Data Pipeline Config, Get
     * @name GetAllInvoiceDataPipelineConfigs
     * @summary Get all invoice data pipeline configs
     * @request GET:/api/invoice-data-pipeline-configs
     * @response `200` `ResponseDtoListInvoiceDataPipelineConfigDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllInvoiceDataPipelineConfigs: (
      query?: {
        dataPipelineConfigId?: string;
        modelId?: string;
        active?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListInvoiceDataPipelineConfigDto, ResponseDtoObject>({
        path: `/api/invoice-data-pipeline-configs`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new invoice data pipeline config with the provided details.
     *
     * @tags Invoice Data Pipeline Config, Create
     * @name CreateInvoiceDataPipelineConfig
     * @summary Create a new invoice data pipeline config
     * @request POST:/api/invoice-data-pipeline-configs
     * @response `200` `ResponseDtoInvoiceDataPipelineConfigDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createInvoiceDataPipelineConfig: (data: InvoiceDataPipelineConfigDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceDataPipelineConfigDto, ResponseDtoObject>({
        path: `/api/invoice-data-pipeline-configs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a list of invoice data pipeline configurations based on the provided filters.
     *
     * @tags Invoice Data Pipeline Config, Get
     * @name GetInvoiceDataPipelineConfigs
     * @summary Get invoice data pipeline configs
     * @request POST:/api/invoice-data-pipeline-configs/query
     * @response `200` `ResponseDtoPageInvoiceDataPipelineConfigDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceDataPipelineConfigs: (data: InvoiceDataPipelineConfigRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageInvoiceDataPipelineConfigDto, ResponseDtoObject>({
        path: `/api/invoice-data-pipeline-configs/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves metadata for invoice data pipeline configurations.
     *
     * @tags Invoice Data Pipeline Config, Get
     * @name GetInvoiceDataPipelineConfigMetaData
     * @summary Get invoice data pipeline config metadata
     * @request POST:/api/invoice-data-pipeline-configs/meta-data
     * @response `200` `ResponseDtoInvoiceDataPipelineConfigMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceDataPipelineConfigMetaData: (data: InvoiceDataPipelineConfigRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceDataPipelineConfigMetadataDto, ResponseDtoObject>({
        path: `/api/invoice-data-pipeline-configs/meta-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a list of InvoiceChargeDomainMappings for a given service provider. This endpoint is accessible only to users with the SYSTEM_ADMIN role.
     *
     * @tags invoice-charge-domain-mappings
     * @name GetInvoiceChargeDomainMappings
     * @summary Retrieve a list of InvoiceChargeDomainMappings
     * @request POST:/api/invoice-charge-domain-mappings/query
     * @response `200` `ResponseDtoPageInvoiceChargeDomainMappingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceChargeDomainMappings: (data: FilterInvoiceChargeDomainMappingReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageInvoiceChargeDomainMappingDto, ResponseDtoObject>({
        path: `/api/invoice-charge-domain-mappings/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves metadata for InvoiceChargeDomainMappings based on the provided filter criteria. This endpoint is accessible only to users with the SYSTEM_ADMIN role.
     *
     * @tags invoice-charge-domain-mappings
     * @name GetInvoiceChargeDomainMappingMetadata
     * @summary Retrieve metadata for InvoiceChargeDomainMappings
     * @request POST:/api/invoice-charge-domain-mappings/metadata
     * @response `200` `ResponseDtoInvoiceChargeDomainMappingMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceChargeDomainMappingMetadata: (data: FilterInvoiceChargeDomainMappingReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceChargeDomainMappingMetadataDto, ResponseDtoObject>({
        path: `/api/invoice-charge-domain-mappings/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Gets filter metadata based on the specified use type and filter request parameters. This endpoint allows clients to obtain available filter options and their configurations for different use cases within the financial application.
     *
     * @tags filter-controller
     * @name GetFiltersMetadata
     * @summary Retrieve filters metadata
     * @request POST:/api/filters/{useType}
     * @response `200` `ResponseDtoFiltersDataDto` Successfully retrieved filters metadata
     * @response `400` `ResponseDtoFiltersDataDto` Invalid request parameters
     * @response `403` `ResponseDtoObject` Forbidden
     * @response `500` `ResponseDtoFiltersDataDto` Internal server error
     */
    getFiltersMetadata: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', data: FiltersRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoFiltersDataDto, ResponseDtoFiltersDataDto | ResponseDtoObject>({
        path: `/api/filters/${useType}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves file resolutions based on filter criteria. This endpoint requires SYSTEM_ADMIN permissions.
     *
     * @tags file-resolutions, system_admin
     * @name GetFileResolutions
     * @summary Get file resolutions
     * @request POST:/api/file-resolutions/query
     * @response `200` `ResponseDtoInternalDashboardTableResponseDtoGettingFileResolutionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getFileResolutions: (data: FilterFileResolutionRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInternalDashboardTableResponseDtoGettingFileResolutionDto, ResponseDtoObject>({
        path: `/api/file-resolutions/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Inserts a new file classification embedding entry or updates an existing one (upsert functionality)
     *
     * @tags file-classification-controller
     * @name UpsertEmbedding
     * @summary Create or update file classification embedding
     * @request POST:/api/file-classification/embedding
     * @response `200` `ResponseDtoFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    upsertEmbedding: (data: FileClassificationEmbeddingCreateRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches all file classification embeddings with pagination and filtering options based on the provided request. This endpoint supports multiple filtering criteria including embedding IDs, invoice file processing IDs, model names, tokenizer names, page numbers, data pipeline config IDs, and creation/update date ranges.
     *
     * @tags file-classification-controller
     * @name GetAllFileClassificationEmbeddings
     * @summary Query all file classification embeddings
     * @request POST:/api/file-classification/embedding/query
     * @response `200` `ResponseDtoPageFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllFileClassificationEmbeddings: (data: FileClassificationEmbeddingRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches all file classification embeddings with pagination and filtering options based on the provided request. This endpoint supports multiple filtering criteria including embedding IDs, invoice file processing IDs, model names, tokenizer names, page numbers, data pipeline config IDs, and creation/update date ranges.
     *
     * @tags file-classification-controller
     * @name GetAllFileClassificationEmbeddingsLite
     * @summary Query all file classification embeddings without vectors
     * @request POST:/api/file-classification/embedding/query/lite
     * @response `200` `ResponseDtoPageFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllFileClassificationEmbeddingsLite: (data: FileClassificationEmbeddingRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding/query/lite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches metadata information for all file classification embeddings, including counts and statistics based on the provided filtering criteria.
     *
     * @tags file-classification-controller
     * @name GetAllFileClassificationEmbeddingsMetadata
     * @summary Retrieve file classification embeddings metadata
     * @request POST:/api/file-classification/embedding/metadata
     * @response `200` `ResponseDtoFileClassificationEmbeddingMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllFileClassificationEmbeddingsMetadata: (data: FileClassificationEmbeddingRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoFileClassificationEmbeddingMetadataDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a specific file classification embedding entry to the associated classificationLabel dataset
     *
     * @tags file-classification-controller
     * @name AddEmbeddingToDataset
     * @summary Add embedding to dataset
     * @request POST:/api/file-classification/dataset/{classificationLabel}/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    addEmbeddingToDataset: (classificationLabel: string, id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/file-classification/dataset/${classificationLabel}/${id}`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Removes the association between a specific file classification embedding and a classificationLabel
     *
     * @tags file-classification-controller
     * @name RemoveEmbeddingFromDataset
     * @summary Remove embedding from dataset
     * @request DELETE:/api/file-classification/dataset/{classificationLabel}/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    removeEmbeddingFromDataset: (classificationLabel: string, id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/file-classification/dataset/${classificationLabel}/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Adds file classification embeddings to the dataset by invoice file processing ID with optional model, tokenizer, and page number filters
     *
     * @tags file-classification-controller
     * @name AddEmbeddingsToDatasetByFileProcessingId
     * @summary Add embeddings to dataset by file ID
     * @request POST:/api/file-classification/dataset/{classificationLabel}/by-file/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    addEmbeddingsToDatasetByFileProcessingId: (
      classificationLabel: string,
      invoiceFileProcessingId: string,
      query?: {
        modelNames?: string[];
        tokenizerNames?: string[];
        pageNumbers?: number[];
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/file-classification/dataset/${classificationLabel}/by-file/${invoiceFileProcessingId}`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * @description Removes file classification embeddings from the dataset by invoice file processing ID with optional model, tokenizer, and page number filters
     *
     * @tags file-classification-controller
     * @name RemoveEmbeddingsFromDatasetByFileProcessingId
     * @summary Remove embeddings from dataset by processing ID
     * @request DELETE:/api/file-classification/dataset/{classificationLabel}/by-file/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    removeEmbeddingsFromDatasetByFileProcessingId: (
      classificationLabel: string,
      invoiceFileProcessingId: string,
      query?: {
        modelNames?: string[];
        tokenizerNames?: string[];
        pageNumbers?: number[];
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/file-classification/dataset/${classificationLabel}/by-file/${invoiceFileProcessingId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Saves or updates an exchange rate.
     *
     * @tags exchange-rates-controller
     * @name SaveOrUpdateExchangeRate
     * @summary Save or update exchange rate
     * @request POST:/api/exchange-rates
     * @response `200` `ResponseDtoExchangeRateDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    saveOrUpdateExchangeRate: (data: ExchangeRateDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExchangeRateDto, ResponseDtoObject>({
        path: `/api/exchange-rates`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a paginated list of exchange rates based on the provided request. Requires ADMIN authority.
     *
     * @tags exchange-rates-controller
     * @name GetExchangeRates
     * @summary Get exchange rates
     * @request POST:/api/exchange-rates/query
     * @response `200` `ResponseDtoPageExchangeRateDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getExchangeRates: (data: ExchangeRateRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageExchangeRateDto, ResponseDtoObject>({
        path: `/api/exchange-rates/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves metadata for exchange rates based on the provided request. Requires ADMIN authority.
     *
     * @tags exchange-rates-controller
     * @name GetExchangeRatesMetadata
     * @summary Get exchange rates metadata
     * @request POST:/api/exchange-rates/metadata
     * @response `200` `ResponseDtoExchangeRateMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getExchangeRatesMetadata: (data: ExchangeRateRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExchangeRateMetadataDto, ResponseDtoObject>({
        path: `/api/exchange-rates/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags event-stream-controller
     * @name SimulateSendingNotification
     * @summary Simulate sending a notification
     * @request POST:/api/events/simulate/notification
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    simulateSendingNotification: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/events/simulate/notification`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Fetches discount contract mappings with pagination, sorting, and optional filters by contractIds, services, and eligibleChargeDomains.
     *
     * @tags discount-contract-mapping-controller
     * @name QueryDiscountContractMappings
     * @summary Query discount contract mappings
     * @request POST:/api/discount-contract-mappings/query
     * @response `200` `ResponseDtoPageDiscountContractMappingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    queryDiscountContractMappings: (data: DiscountContractMappingRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageDiscountContractMappingDto, ResponseDtoObject>({
        path: `/api/discount-contract-mappings/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the charge mapping and recalculates deviations for affected shipments asynchronously.
     *
     * @tags admin-controller
     * @name UpdateChargeMappingAndRecalculateDeviations
     * @summary Update charge mapping and recalculate deviations
     * @request POST:/api/deviations/update-charge-mapping-and-recalculate
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateChargeMappingAndRecalculateDeviations: (data: UpdateChargeMappingAndRecalculateDeviationsRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/deviations/update-charge-mapping-and-recalculate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates mock invoice json data with the same format as extractor output. We can use this to import data to our system directly or can be used to generate invoice pdf.
     *
     * @tags demo-controller
     * @name GenerateMockInvoiceData
     * @summary Generate Mock Invoice Data
     * @request POST:/api/demo/generate-mock-invoice-data
     * @response `200` `ResponseDtoListInvoiceMessageDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    generateMockInvoiceData: (data: MockInvoiceDataRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListInvoiceMessageDto, ResponseDtoObject>({
        path: `/api/demo/generate-mock-invoice-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates an invoice as a PDF from the provided invoice message DTO and writes it to the HTTP response.
     *
     * @tags demo-controller
     * @name GenerateInvoiceFile
     * @summary Get Invoice
     * @request POST:/api/demo/generate-invoice-file
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    generateInvoiceFile: (data: InvoiceMessageDto, params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/demo/generate-invoice-file`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates an invoice as a PDF from the provided invoice message DTO and uploads in to s3 bucket to trigger ocr processing.
     *
     * @tags demo-controller
     * @name GenerateAndUploadDemoInvoice
     * @summary Generate and Upload Invoice
     * @request POST:/api/demo/generate-and-upload-invoice-file
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    generateAndUploadDemoInvoice: (
      data: InvoiceMessageDto,
      query?: {
        /** @default false */
        doCreateNotification?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/demo/generate-and-upload-invoice-file`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates an invoice as a PDF from the provided invoice message DTO, and uploads it to s3 bucket without trigger ocr processing then imports ocr message directly to our system.
     *
     * @tags demo-controller
     * @name GenerateAndImportInvoice
     * @summary Generate and Import Invoice
     * @request POST:/api/demo/generate-and-import-invoice-file
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    generateAndImportInvoice: (
      data: InvoiceMessageDto,
      query?: {
        /** @default false */
        doCreateNotification?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/demo/generate-and-import-invoice-file`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Allows a system administrator to add specified amounts of invoice and shipment credits. If creditId is not provided, uses getTopmostParentCredit to find appropriate credits for each type.
     *
     * @tags credit, sysadmin
     * @name AddCredit
     * @summary Add credit with separate invoice and shipment amounts, for admin use only.
     * @request POST:/api/credits/add
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    addCredit: (data: AddCreditRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/credits/add`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches credit transactions with comprehensive filtering options including credit type, transaction type, date ranges, amounts, invoice numbers, shipment numbers, service providers, modalities, and PO numbers. Returns paginated results with detailed transaction information including all required fields. Requires SYSTEM_ADMIN or CREDIT_VIEWER role for access.
     *
     * @tags credit-transaction-controller
     * @name GetAllCreditTransactions
     * @summary Retrieve credit transactions with filtering
     * @request POST:/api/credit-transactions/query
     * @response `200` `ResponseDtoPageCreditTransactionDto` Successfully retrieved credit transactions with filtering applied
     * @response `401` `ResponseDtoPageCreditTransactionDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to access this endpoint.
     */
    getAllCreditTransactions: (data: CreditTransactionRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageCreditTransactionDto, ResponseDtoPageCreditTransactionDto | ResponseDtoObject>({
        path: `/api/credit-transactions/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Perform migration for credit transactions by creating credit transactions for existing invoice file processing records. Accessible by system admin users only.
     *
     * @tags credit-transaction-controller
     * @name MigrateCreditTransactions
     * @summary Perform migration for credit transactions
     * @request POST:/api/credit-transactions/migrate
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    migrateCreditTransactions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/credit-transactions/migrate`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Fetches metadata information for all credit transactions, including counts and statistics based on filtering criteria. This endpoint aggregates various counters (transaction IDs, credit types, transaction types, billed entities, invoice numbers, shipment numbers, service providers, modalities, PO numbers) for credit transactions matching the provided request criteria. Also provides total amounts and transaction counts. Requires SYSTEM_ADMIN or CREDIT_VIEWER role for access.
     *
     * @tags credit-transaction-controller
     * @name GetAllCreditTransactionsMetaData
     * @summary Retrieve credit transactions metadata
     * @request POST:/api/credit-transactions/metadata
     * @response `200` `ResponseDtoCreditTransactionMetadataDto` Successfully retrieved credit transaction metadata with aggregated statistics
     * @response `401` `ResponseDtoCreditTransactionMetadataDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to access this endpoint.
     */
    getAllCreditTransactionsMetaData: (data: CreditTransactionRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoCreditTransactionMetadataDto, ResponseDtoCreditTransactionMetadataDto | ResponseDtoObject>({
        path: `/api/credit-transactions/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches contracts for a specific service provider with pagination support.
     *
     * @tags contract-controller
     * @name GetContractsByServiceProvider
     * @summary Query contracts by service provider ID
     * @request POST:/api/contracts/service-provider/{serviceProviderId}/query
     * @response `200` `ResponseDtoPageContractDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractsByServiceProvider: (serviceProviderId: number, data: PaginationRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageContractDto, ResponseDtoObject>({
        path: `/api/contracts/service-provider/${serviceProviderId}/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches all contracts with pagination and filtering options based on the provided request.
     *
     * @tags contract-controller
     * @name GetAllContracts
     * @summary Query all contracts
     * @request POST:/api/contracts/query
     * @response `200` `ResponseDtoPageContractDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllContracts: (data: ContractRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoPageContractDto, ResponseDtoObject>({
        path: `/api/contracts/query`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches metadata information for all contracts, including counts and statistics based on filtering criteria.
     *
     * @tags contract-controller
     * @name GetAllContractsMetaData
     * @summary Retrieve contracts metadata
     * @request POST:/api/contracts/metadata
     * @response `200` `ResponseDtoContractMetadataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllContractsMetaData: (data: ContractRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractMetadataDto, ResponseDtoObject>({
        path: `/api/contracts/metadata`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a new contract flow. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name CreateContractFlow
     * @summary Create a new contract flow
     * @request POST:/api/contract-flows
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createContractFlow: (data: CreatingAndUpdatingContractFlowReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates percentage charges and links them to all contract flows of the specified service provider whose contracts fully contain the charge date ranges. Processes asynchronously.
     *
     * @tags contract-charge-controller
     * @name CreatePercentageCharges
     * @summary Create percentage charges for contract flows
     * @request POST:/api/contract-charges/percentage-charges
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createPercentageCharges: (data: CreateContractPercentageChargesRequest[], params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/contract-charges/percentage-charges`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Migrates files to AWS S3. Accessible by SYSTEM_ADMIN.
     *
     * @tags aws-controller
     * @name Migration
     * @summary Trigger file migration to AWS S3
     * @request POST:/api/aws/s3/migration
     * @response `200` `ResponseDtoListString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    migration: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListString, ResponseDtoObject>({
        path: `/api/aws/s3/migration`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description Fetches shipment data based on the provided search parameters.
     *
     * @tags analytics, shipments
     * @name FetchShipmentData
     * @summary Fetch shipment data
     * @request POST:/api/analytics/shipments-data
     * @response `200` `ResponseDtoShipmentSearchResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    fetchShipmentData: (data: ShipmentSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipmentSearchResponseDto, ResponseDtoObject>({
        path: `/api/analytics/shipments-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a report for shipment data in the specified file format based on the provided search parameters. The report generation is handled asynchronously.
     *
     * @tags analytics, shipments, export
     * @name ExportShipmentData
     * @summary Export shipment data report
     * @request POST:/api/analytics/shipments-data/export
     * @response `200` `ResponseDtoExportJobResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    exportShipmentData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: ShipmentSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoExportJobResponse, ResponseDtoObject>({
        path: `/api/analytics/shipments-data/export`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Downloads shipment data in the specified file format based on the provided search parameters.
     *
     * @tags analytics, shipments, download
     * @name DownloadShipmentData
     * @summary Download shipment data
     * @request POST:/api/analytics/shipments-data/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    downloadShipmentData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: ShipmentSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/analytics/shipments-data/download`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches invoice data based on the provided search parameters.
     *
     * @tags analytics, invoices
     * @name FetchInvoiceColumns
     * @summary Fetch invoice data
     * @request POST:/api/analytics/invoice-data
     * @response `200` `ResponseDtoInvoiceAnalyticsSearchResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    fetchInvoiceColumns: (data: InvoiceAnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceAnalyticsSearchResponseDto, ResponseDtoObject>({
        path: `/api/analytics/invoice-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a report for invoice data in the specified file format based on the provided search parameters. The report generation is handled asynchronously.
     *
     * @tags analytics, invoices, export
     * @name ExportInvoiceData
     * @summary Export invoice data report
     * @request POST:/api/analytics/invoice-data/export
     * @response `200` `ResponseDtoExportJobResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    exportInvoiceData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: InvoiceAnalyticSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoExportJobResponse, ResponseDtoObject>({
        path: `/api/analytics/invoice-data/export`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Downloads invoice data in the specified file format based on the provided search parameters.
     *
     * @tags analytics, invoices, download
     * @name DownloadInvoiceData
     * @summary Download invoice data
     * @request POST:/api/analytics/invoice-data/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    downloadInvoiceData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: InvoiceAnalyticSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/analytics/invoice-data/download`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches invoice charge data along with reasons for the invoice's current status based on the provided search parameters.
     *
     * @tags analytics, invoices, charges, reasons
     * @name GetInvoiceChargeData
     * @summary Fetch invoice charge data with reasons
     * @request POST:/api/analytics/invoice-data/charge-data
     * @response `200` `ResponseDtoListInvoiceChargeDataResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceChargeData: (data: InvoiceChargeDataRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListInvoiceChargeDataResponseDto, ResponseDtoObject>({
        path: `/api/analytics/invoice-data/charge-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches invoice charge data based on the provided search parameters.
     *
     * @tags analytics, invoices, charges
     * @name FetchInvoiceChargeColumns
     * @summary Fetch invoice charge data
     * @request POST:/api/analytics/invoice-charges-data
     * @response `200` `ResponseDtoInvoiceChargeSearchResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    fetchInvoiceChargeColumns: (data: InvoiceChargeSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceChargeSearchResponseDto, ResponseDtoObject>({
        path: `/api/analytics/invoice-charges-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a report for invoice charge data in the specified file format based on the provided search parameters. The report generation is handled asynchronously.
     *
     * @tags analytics, invoices, charges, export
     * @name ExportInvoiceChargesData
     * @summary Export invoice charge data report
     * @request POST:/api/analytics/invoice-charges-data/export
     * @response `200` `ResponseDtoExportJobResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    exportInvoiceChargesData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: InvoiceChargeSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoExportJobResponse, ResponseDtoObject>({
        path: `/api/analytics/invoice-charges-data/export`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Downloads invoice charge data in the specified file format based on the provided search parameters.
     *
     * @tags analytics, invoices, charges, download
     * @name DownloadInvoiceChargesData
     * @summary Download invoice charge data
     * @request POST:/api/analytics/invoice-charges-data/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    downloadInvoiceChargesData: (
      query: {
        'file-name': string;
        'file-type': 'PDF' | 'CSV' | 'EXCEL' | 'ZIP' | 'XLS' | 'JSON';
      },
      data: InvoiceChargeSearchRequestDto,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/analytics/invoice-charges-data/download`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Fetches distinct values for a specific column in data to support filtering. Allowed columns: modality, billedEntity, serviceProvider, shipper, consignee, pol, pod, vehicleId, tradeLane
     *
     * @tags analytic-controller
     * @name GetFilterColumnData
     * @summary Fetch filter column data
     * @request POST:/api/analytics/filter/metadata/{table}/{columnName}
     * @response `200` `ResponseDtoAnalyticFilterColumnDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getFilterColumnData: (table: 'SHIPMENTS' | 'INVOICES' | 'CHARGES', columnName: string, data: AnalyticFilterColumnRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoAnalyticFilterColumnDto, ResponseDtoObject>({
        path: `/api/analytics/filter/metadata/${table}/${columnName}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Searches for chart data based on the provided analytic search parameters.
     *
     * @tags analytics, charts
     * @name SearchChartData
     * @summary Search chart data
     * @request POST:/api/analytics/chart-data
     * @response `200` `ResponseDtoChartResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    searchChartData: (data: AnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoChartResponseDto, ResponseDtoObject>({
        path: `/api/analytics/chart-data`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves the allowed currencies for invoice analytics based on the provided parameters.
     *
     * @tags analytics, currencies
     * @name GetAllowedCurrencies
     * @summary Get allowed currencies
     * @request POST:/api/analytics/allowed-currencies
     * @response `200` `ResponseDtoSetCurrencyEnum` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllowedCurrencies: (data: InvoiceAnalyticSearchRequestDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoSetCurrencyEnum, ResponseDtoObject>({
        path: `/api/analytics/allowed-currencies`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Due to historical reasons, some invoices may have been entered with incorrect currencies or with currencies that lack corresponding exchange rates in the database. This API endpoint deletes the existing exchange rate amounts and recalculates them using the current exchange rate table. It is useful in cases where incorrect exchange rates were provided by the client or when exchange rates were missing at the time of entry. The process is asynchronous; therefore, the user must use a separate API endpoint to check whether the recalculation has been completed. The number of invoices to be processed is limited by the batch size, which can be configured using a separate API endpoint.
     *
     * @tags jobs, admin
     * @name StartMigration
     * @summary Recalculate exchange rate amounts between 2 dates or for specific invoices
     * @request POST:/api/admin/recalculate-exchange-price
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    startMigration: (data: ExchangeRateAmountReCalculationRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/recalculate-exchange-price`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Triggers a full reindex of all analytics data from PostgreSQL to OpenSearch. Set deleteIndices=true to delete and recreate indices before reindexing (useful when mappings change).
     *
     * @tags admin, opensearch
     * @name ReindexOpenSearch
     * @summary Trigger OpenSearch full reindex
     * @request POST:/api/admin/opensearch/reindex
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    reindexOpenSearch: (
      query?: {
        /** @default false */
        deleteIndices?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/opensearch/reindex`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * @description Pass a JSON array of service provider codes to delete invoices for those providers only. Omit the body (or send an empty array) to truncate all invoice data. Returns 202 with the job ID — poll status at GET /api/admin/jobs/{id}.
     *
     * @tags admin, job-tracker
     * @name CreateBulkDeleteJob
     * @summary Create a bulk invoice deletion job
     * @request POST:/api/admin/jobs/bulk-delete
     * @response `200` `ResponseDtoJobTrackerResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    createBulkDeleteJob: (data: string[], params: RequestParams = {}) =>
      this.http.request<ResponseDtoJobTrackerResponse, ResponseDtoObject>({
        path: `/api/admin/jobs/bulk-delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates existing Non-Rate Contract Freight (NRCF) invoices based on shipping service parameters
     *
     * @tags invoice-controller
     * @name UpdateNrcfInvoices
     * @summary Update NRCF Invoices
     * @request PATCH:/api/invoices/nrcf-update
     * @response `200` `ResponseDtoBackgroundShipmentPerformResultDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateNrcfInvoices: (
      query: {
        /** @format uuid */
        shippingServiceId: string;
        /** @format int64 */
        serviceProviderId: number;
        modality: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoBackgroundShipmentPerformResultDto, ResponseDtoObject>({
        path: `/api/invoices/nrcf-update`,
        method: 'PATCH',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name UpdateMetadataOfFile
     * @request PATCH:/api/invoice-file-processing/metadata
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateMetadataOfFile: (data: UpdatingS3FileMetadataReq, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoice-file-processing/metadata`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the status of a file resolution by ID. This endpoint requires SYSTEM_ADMIN permissions.
     *
     * @tags file-resolutions, system_admin
     * @name UpdateStatus
     * @summary Update file resolution status
     * @request PATCH:/api/file-resolutions/{id}/status
     * @response `200` `ResponseDtoGettingFileResolutionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    updateStatus: (id: number, data: UpdatingResolutionStatusRequest, params: RequestParams = {}) =>
      this.http.request<ResponseDtoGettingFileResolutionDto, ResponseDtoObject>({
        path: `/api/file-resolutions/${id}/status`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Assigns a file resolution to the current user. This endpoint requires SYSTEM_ADMIN permissions.
     *
     * @tags file-resolutions, system_admin
     * @name AssignToMe
     * @summary Assign file resolution to me
     * @request PATCH:/api/file-resolutions/{id}/assign/me
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    assignToMe: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/file-resolutions/${id}/assign/me`,
        method: 'PATCH',
        ...params,
      }),

    /**
     * @description Returns a workflow by its ID
     *
     * @tags workflow-controller
     * @name GetWorkflowById
     * @summary Get a workflow by ID
     * @request GET:/api/workflows/{id}
     * @response `200` `ResponseDtoWorkflowDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getWorkflowById: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoWorkflowDto, ResponseDtoObject>({
        path: `/api/workflows/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Deletes a workflow by its ID
     *
     * @tags workflow-controller
     * @name DeleteWorkflowById
     * @summary Delete a workflow by ID
     * @request DELETE:/api/workflows/{id}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteWorkflowById: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/workflows/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Returns a workflow rule by its ID
     *
     * @tags workflow-rule-controller
     * @name GetWorkflowRuleById
     * @summary Get a workflow rule by ID
     * @request GET:/api/workflow-rules/{id}
     * @response `200` `ResponseDtoWorkflowRuleDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getWorkflowRuleById: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoWorkflowRuleDto, ResponseDtoObject>({
        path: `/api/workflow-rules/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Deletes a workflow rule by its ID
     *
     * @tags workflow-rule-controller
     * @name DeleteWorkflowRule
     * @summary Delete a workflow rule
     * @request DELETE:/api/workflow-rules/{id}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteWorkflowRule: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/workflow-rules/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Returns a list of all workflow rule descriptions
     *
     * @tags workflow-rule-controller
     * @name GetAllDescriptions
     * @summary Get all workflow rule descriptions
     * @request GET:/api/workflow-rules/descriptions
     * @response `200` `ResponseDtoWorkflowRuleDescriptionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllDescriptions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoWorkflowRuleDescriptionDto, ResponseDtoObject>({
        path: `/api/workflow-rules/descriptions`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves a system configuration by its ID. Requires SYSTEM_ADMIN authority.
     *
     * @tags system-configuration-controller
     * @name GetById
     * @summary Get a system configuration by ID
     * @request GET:/api/system-configurations/{id}
     * @response `200` `ResponseDtoSystemConfigurationDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoSystemConfigurationDto, ResponseDtoObject>({
        path: `/api/system-configurations/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Deletes a system configuration by ID. Requires SYSTEM_ADMIN authority.
     *
     * @tags system-configuration-controller
     * @name Delete1
     * @summary Delete a system configuration
     * @request DELETE:/api/system-configurations/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    delete1: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/system-configurations/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name GetShipment
     * @request GET:/api/shipments/shipment-invoices/{shipmentInvoiceId}
     * @response `200` `ResponseDtoShipmentInActionDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getShipment: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipmentInActionDetailDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name GetMatchingServicesForNoContractInvoice
     * @request GET:/api/shipments/shipment-invoices/{shipmentInvoiceId}/matching-services
     * @response `200` `ResponseDtoNoContractResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getMatchingServicesForNoContractInvoice: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoNoContractResponseDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/matching-services`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description For each charge in the shipment invoice, suggests chargeDomain, legType, chargeSubDomain, and contractChargeUnit using exact mapping lookup first, then fuzzy matching (pg_trgm) against historical charges as fallback.
     *
     * @tags shipments
     * @name SuggestChargeCategorization
     * @summary Suggest charge domain and leg type for charges in a shipment invoice
     * @request GET:/api/shipments/shipment-invoices/{shipmentInvoiceId}/charge-categorization-suggestions
     * @response `200` `ResponseDtoListChargeCategorizationSuggestionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    suggestChargeCategorization: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListChargeCategorizationSuggestionDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/charge-categorization-suggestions`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name IsShipmentAsyncProcessing
     * @request GET:/api/shipments/shipment-invoices/{shipmentInvoiceId}/async-processing
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    isShipmentAsyncProcessing: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/async-processing`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipment-controller
     * @name GetApprovalQuestionnaire
     * @request GET:/api/shipments/shipment-invoices/{shipmentInvoiceId}/approval-questionnaire
     * @response `200` `ResponseDtoMapDeviationWorkflowListDeviationQuestionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getApprovalQuestionnaire: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapDeviationWorkflowListDeviationQuestionDto, ResponseDtoObject>({
        path: `/api/shipments/shipment-invoices/${shipmentInvoiceId}/approval-questionnaire`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Returns cross-invoice charge lines for a DOUBLE_CHARGE deviation, including editability flags for the resolution UI.
     *
     * @tags shipment-controller
     * @name GetDoubleChargeDetail
     * @summary Get double charge detail for a deviation
     * @request GET:/api/shipments/deviations/{deviationId}/double-charge-details
     * @response `200` `ResponseDtoDoubleChargeDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getDoubleChargeDetail: (deviationId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoDoubleChargeDetailDto, ResponseDtoObject>({
        path: `/api/shipments/deviations/${deviationId}/double-charge-details`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves all deviations associated with a specific shipment invoice by its unique identifier.
     *
     * @tags shipment-invoices, deviations
     * @name GetInvoiceDeviations
     * @summary Get invoice deviations
     * @request GET:/api/shipment-invoices/{shipmentInvoiceId}/deviations
     * @response `200` `ResponseDtoListDeviation` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceDeviations: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListDeviation, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/deviations`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Generates a configured rate card as a PDF and writes it to the HTTP response.
     *
     * @tags report-controller
     * @name GetConfiguredRateCard
     * @summary Get Configured Rate Card
     * @request GET:/api/shipment-invoices/{shipmentInvoiceId}/configured-rate-card
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getConfiguredRateCard: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/configured-rate-card`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Generates a configured rate card as a PDF and writes it to the HTTP response.
     *
     * @tags report-controller
     * @name GetConfiguredRateCardByShipmentInvoice
     * @summary Get Configured Rate Card
     * @request GET:/api/shipment-invoices/{shipmentInvoiceId}/configured-rate-card/json
     * @response `200` `ResponseDtoConfiguredRateCardResponseDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getConfiguredRateCardByShipmentInvoice: (shipmentInvoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoConfiguredRateCardResponseDto, ResponseDtoObject>({
        path: `/api/shipment-invoices/${shipmentInvoiceId}/configured-rate-card/json`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches a single service provider based on the provided ID or code with unrestricted access to the complete provider database. This endpoint accepts either an ID (numeric identifier) or a code (alphanumeric identifier) as search criteria. At least one parameter (id or code) must be provided. If both are provided, the search will prioritize the ID parameter. This restricted endpoint has no filtering limitations and can access any service provider in the system. Requires SYSTEM_ADMIN role for access.
     *
     * @tags service-provider-controller
     * @name GetServiceProviderByIdOrCode
     * @summary Retrieve a service provider by ID or code
     * @request GET:/api/service-providers/search
     * @response `200` `ResponseDtoServiceProviderOverViewDto` Successfully retrieved the service provider. Returns the complete service provider information including all associated data such as addresses and aliases.
     * @response `400` `ResponseDtoServiceProviderOverViewDto` Bad Request - Invalid request parameters. This occurs when neither ID nor code parameters are provided, when both parameters are null/empty, or when the provided values have invalid formats.
     * @response `401` `ResponseDtoServiceProviderOverViewDto` Unauthorized - Invalid or expired authentication token.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role.
     * @response `404` `ResponseDtoServiceProviderOverViewDto` Not Found - No service provider found with the specified ID or code.
     */
    getServiceProviderByIdOrCode: (
      query?: {
        /** @format int64 */
        id?: number;
        code?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoServiceProviderOverViewDto, ResponseDtoServiceProviderOverViewDto | ResponseDtoObject>({
        path: `/api/service-providers/search`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetches detailed information about service providers specifically for rate cards.
     *
     * @tags service-provider-controller
     * @name GetServiceProviderDetailsForRateCard
     * @summary Retrieve service provider details for rate cards
     * @request GET:/api/service-providers/rate-card
     * @response `200` `ResponseDtoListServiceProviderDetailsDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getServiceProviderDetailsForRateCard: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListServiceProviderDetailsDto, ResponseDtoObject>({
        path: `/api/service-providers/rate-card`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches a list of service provider overviews.
     *
     * @tags service-provider-controller
     * @name GetAllServiceProvider
     * @summary Retrieves an overview of all service providers
     * @request GET:/api/service-providers/overview
     * @response `200` `ResponseDtoListServiceProviderOverViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllServiceProvider: (
      query?: {
        /** An optional filter to retrieve service providers by their modality */
        modality?: 'ROAD' | 'SEA' | 'RAIL' | 'AIR' | 'COURIER' | 'CT';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListServiceProviderOverViewDto, ResponseDtoObject>({
        path: `/api/service-providers/overview`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves the list of RouteDto objects for the given service provider ID.
     *
     * @tags routes, rate-card-management, admin, service-provider, list-zone
     * @name GetContractRoute
     * @summary Get list route by service provider ID
     * @request GET:/api/routes
     * @response `200` `ResponseDtoListRouteDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractRoute: (
      query: {
        /** @format int64 */
        serviceProviderId: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListRouteDto, ResponseDtoObject>({
        path: `/api/routes`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves overall report data with aggregated invoice, shipment, charge, and deviation information grouped by billing entity and service provider.
     *
     * @tags quick-report-controller
     * @name GetOverallReport
     * @summary Get Overall Report
     * @request GET:/api/reporting/overall
     * @response `200` `ResponseDtoListOverallReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getOverallReport: (
      query?: {
        currency?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListOverallReportDto, ResponseDtoObject>({
        path: `/api/reporting/overall`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves deviation report data with aggregated information.
     *
     * @tags quick-report-controller
     * @name GetDeviationReport
     * @summary Get Deviation Report
     * @request GET:/api/reporting/deviations
     * @response `200` `ResponseDtoListMapStringObject` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getDeviationReport: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListMapStringObject, ResponseDtoObject>({
        path: `/api/reporting/deviations`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves consolidation report data showing potential consolidation opportunities based on shipment groupings and contract rates.
     *
     * @tags quick-report-controller
     * @name GetConsolidationReport
     * @summary Get Consolidation Report
     * @request GET:/api/reporting/consolidation
     * @response `200` `ResponseDtoPageConsolidationReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getConsolidationReport: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @default 20
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoPageConsolidationReportDto, ResponseDtoObject>({
        path: `/api/reporting/consolidation`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetches all rate cards filtered by the specified contract charge unit type. This endpoint allows administrators to view existing rate configurations for different charge types.
     *
     * @tags rate-card-controller
     * @name GetRateCards
     * @summary Retrieve rate cards by contract charge unit
     * @request GET:/api/rate-cards
     * @response `200` `ResponseDtoListContractChargeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getRateCards: (
      query: {
        contractChargeUnit: 'SHIPMENT' | 'DECLARATION' | 'CONTAINER' | 'WEIGHT' | 'PERCENTAGE';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListContractChargeDto, ResponseDtoObject>({
        path: `/api/rate-cards`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-controller
     * @name GetNrcfReport
     * @request GET:/api/nrcf-report
     * @response `200` `ResponseDtoListNoContractReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getNrcfReport: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListNoContractReportDto, ResponseDtoObject>({
        path: `/api/nrcf-report`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin-controller
     * @name ExportCsv
     * @request GET:/api/nrcf-report/export
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    exportCsv: (params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/nrcf-report/export`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags notification-controller
     * @name GetNotifications
     * @summary Get all notifications from the view date
     * @request GET:/api/notifications
     * @response `200` `ResponseDtoNotificationResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getNotifications: (
      query?: {
        /** @format date */
        viewDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoNotificationResponse, ResponseDtoObject>({
        path: `/api/notifications`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves metrics and statistics for the admin dashboard. This endpoint requires SYSTEM_ADMIN permissions.
     *
     * @tags metrics, system_admin
     * @name GetAdminDashboardMetrics
     * @summary Get admin dashboard metrics
     * @request GET:/api/metrics/admin-dashboard
     * @response `200` `ResponseDtoAdminDashboardMetricDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAdminDashboardMetrics: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoAdminDashboardMetricDto, ResponseDtoObject>({
        path: `/api/metrics/admin-dashboard`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-permission-controller
     * @name GetLoggedInUserDetails
     * @request GET:/api/logged-in-user
     * @response `200` `ResponseDtoLoggedInUserDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getLoggedInUserDetails: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoLoggedInUserDto, ResponseDtoObject>({
        path: `/api/logged-in-user`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-permission-controller
     * @name GetLoggedInUserPermissions
     * @request GET:/api/logged-in-user/permissions
     * @response `200` `ResponseDtoSetPermission` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getLoggedInUserPermissions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoSetPermission, ResponseDtoObject>({
        path: `/api/logged-in-user/permissions`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-permission-controller
     * @name GetLoggedInUserPermissionTypes
     * @request GET:/api/logged-in-user/permission-types
     * @response `200` `ResponseDtoSetPermissionType` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getLoggedInUserPermissionTypes: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoSetPermissionType, ResponseDtoObject>({
        path: `/api/logged-in-user/permission-types`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches the legal entity tree for the logged-in user and maps it to a LegalEntityDto object.
     *
     * @tags legal-entity-controller
     * @name GetLegalEntityTreeOfCurrentUser
     * @summary Retrieve the legal entity tree for the current user
     * @request GET:/api/legal-entities/tree
     * @response `200` `ResponseDtoLegalEntityDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getLegalEntityTreeOfCurrentUser: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoLegalEntityDto, ResponseDtoObject>({
        path: `/api/legal-entities/tree`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Search for legal entities by alias name. The search is case-insensitive, matches partial strings, and requires ADMIN permission.
     *
     * @tags legal-entity-controller
     * @name SearchLegalEntitiesByAlias
     * @summary Search for legal entities by alias
     * @request GET:/api/legal-entities/search_by_alias
     * @response `200` `ResponseDtoListLegalEntityDto` Legal entities retrieved successfully.
     * @response `400` `ResponseDtoListLegalEntityDto` Invalid or missing alias parameter.
     * @response `401` `ResponseDtoListLegalEntityDto` Authentication token is missing or invalid.
     * @response `403` `ResponseDtoObject` Access denied. The user does not have the required 'ADMIN' permission.
     * @response `500` `ResponseDtoListLegalEntityDto` An unexpected error occurred.
     */
    searchLegalEntitiesByAlias: (
      query: {
        alias: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListLegalEntityDto, ResponseDtoListLegalEntityDto | ResponseDtoObject>({
        path: `/api/legal-entities/search_by_alias`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetches a single legal entity based on the provided ID or code with unrestricted access to the complete entity database. This endpoint accepts either an ID (numeric identifier) or a code (alphanumeric identifier) as search criteria. At least one parameter (id or code) must be provided. If both are provided, the search will prioritize the ID parameter. This restricted endpoint has no filtering limitations and can access any legal entity in the system. Requires SYSTEM_ADMIN role for access.
     *
     * @tags legal-entity-controller
     * @name GetLegalEntityByIdOrCode
     * @summary Retrieve a legal entity by ID or code
     * @request GET:/api/legal-entities/search
     * @response `200` `ResponseDtoLegalEntityDto` Successfully retrieved the legal entity. Returns the complete legal entity information including all associated data such as addresses and aliases.
     * @response `400` `ResponseDtoLegalEntityDto` Bad Request - Invalid request parameters. This occurs when neither ID nor code parameters are provided, when both parameters are null/empty, or when the provided values have invalid formats. The 'message' field in the response will describe the specific parameter error.
     * @response `401` `ResponseDtoLegalEntityDto` Unauthorized - Invalid or expired authentication token. The request must include a valid JWT token in the Authorization header.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role to access legal entity data without restrictions.
     * @response `404` `ResponseDtoLegalEntityDto` Not Found - No legal entity found with the specified ID or code. The entity may not exist in the system or may have been deleted.
     */
    getLegalEntityByIdOrCode: (
      query?: {
        /** @format int64 */
        id?: number;
        code?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoLegalEntityDto, ResponseDtoLegalEntityDto | ResponseDtoObject>({
        path: `/api/legal-entities/search`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetches all legal entities that are marked as billed entities and maps them to LegalEntityDto objects.
     *
     * @tags legal-entity-controller
     * @name GetListBilledEntity
     * @summary Retrieve billed legal entities
     * @request GET:/api/legal-entities/billed-entities
     * @response `200` `ResponseDtoListLegalEntityDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getListBilledEntity: (
      query?: {
        /** @default "RATECARD" */
        permissionType?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListLegalEntityDto, ResponseDtoObject>({
        path: `/api/legal-entities/billed-entities`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetches billed legal entities accessible to the logged-in user, excluding entities with billed parent entities.
     *
     * @tags legal-entity-controller
     * @name GetListBilledEntityForFilter
     * @summary Retrieve filtered billed legal entities
     * @request GET:/api/legal-entities/billed-entities/filter
     * @response `200` `ResponseDtoListLegalEntityDetailsDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getListBilledEntityForFilter: (
      query?: {
        /** @default "AUDIT" */
        permissionType?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListLegalEntityDetailsDto, ResponseDtoObject>({
        path: `/api/legal-entities/billed-entities/filter`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves the version information for the specified invoice
     *
     * @tags invoice-controller
     * @name GetVersion
     * @summary Get Invoice Version
     * @request GET:/api/invoices/{invoiceId}/version
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getVersion: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/version`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves the non-courier shipment associated with the specified invoice
     *
     * @tags invoice-controller
     * @name GetInvoiceShipment
     * @summary Get Invoice Shipment
     * @request GET:/api/invoices/{invoiceId}/shipment
     * @response `200` `ResponseDtoShipment` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceShipment: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoShipment, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/shipment`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Generates a ZIP file containing the invoice report PDF and all invoice files.
     *
     * @tags report-controller
     * @name GenerateInvoiceReportZip
     * @summary Generate Invoice Report Package
     * @request GET:/api/invoices/{invoiceId}/reports/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    generateInvoiceReportZip: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/reports/download`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Returns the current stage, pending reviewers, and the full action history grouped by processing stage.
     *
     * @tags invoices, activity-logs
     * @name GetProcessingStages
     * @summary Get invoice processing stages
     * @request GET:/api/invoices/{invoiceId}/processing-stages
     * @response `200` `ResponseDtoInvoiceProcessingStagesDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getProcessingStages: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceProcessingStagesDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/processing-stages`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves a summary of all issues associated with the specified invoice
     *
     * @tags invoice-controller
     * @name GetInvoiceIssueSummary
     * @summary Get Invoice Issue Summary
     * @request GET:/api/invoices/{invoiceId}/invoice-issue-summary
     * @response `200` `ResponseDtoInvoiceIssueSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceIssueSummary: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceIssueSummaryDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/invoice-issue-summary`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Generates a ZIP file containing all invoice files without the invoice report PDF.
     *
     * @tags report-controller
     * @name DownloadInvoiceFilesZip
     * @summary Download Invoice Files
     * @request GET:/api/invoices/{invoiceId}/files/download
     * @response `200` `void` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    downloadInvoiceFilesZip: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<void, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/files/download`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves signed URLs for all files associated with the specified invoice
     *
     * @tags invoice-controller
     * @name GetFileUrls
     * @summary Get Invoice File URLs
     * @request GET:/api/invoices/{invoiceId}/file-urls
     * @response `200` `ResponseDtoListInvoiceFileUrlDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getFileUrls: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListInvoiceFileUrlDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/file-urls`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves a signed URL for downloading a specific invoice attachment
     *
     * @tags invoice-controller
     * @name GetFileUrlAttachment
     * @summary Get Attachment File URL
     * @request GET:/api/invoices/{invoiceId}/file-url/{attachmentId}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getFileUrlAttachment: (invoiceId: string, attachmentId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/file-url/${attachmentId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Checks if the specified invoice is being processed asynchronously and returns a boolean value.
     *
     * @tags invoice-controller
     * @name IsInvoiceAsyncProcessing
     * @summary Check Invoice Async Processing
     * @request GET:/api/invoices/{invoiceId}/async-processing
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    isInvoiceAsyncProcessing: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/async-processing`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves all activity logs associated with a specific invoice by its unique identifier.
     *
     * @tags invoices, activity-logs
     * @name GetInvoiceActivityLogs
     * @summary Get invoice activity logs
     * @request GET:/api/invoices/{invoiceId}/activity-logs
     * @response `200` `ResponseDtoListEntityActivityLogDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceActivityLogs: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListEntityActivityLogDto, ResponseDtoObject>({
        path: `/api/invoices/${invoiceId}/activity-logs`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Finds Non-Rate Contract Freight (NRCF) invoices that match the specified shipping service parameters
     *
     * @tags invoice-controller
     * @name FindNrcfInvoicesMatchingShippingService
     * @summary Find Matching NRCF Invoices
     * @request GET:/api/invoices/match-shipping-service
     * @response `200` `ResponseDtoListInvoice` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    findNrcfInvoicesMatchingShippingService: (
      query: {
        /** @format uuid */
        shippingServiceId: string;
        /** @format int64 */
        serviceProviderId: number;
        modality: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListInvoice, ResponseDtoObject>({
        path: `/api/invoices/match-shipping-service`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves a comprehensive summary of the specified invoice including all relevant details
     *
     * @tags invoice-controller
     * @name GetInvoiceSummary
     * @summary Get Invoice Summary
     * @request GET:/api/invoices/invoice-summary/{invoiceId}
     * @response `200` `ResponseDtoInvoiceSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceSummary: (invoiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceSummaryDto, ResponseDtoObject>({
        path: `/api/invoices/invoice-summary/${invoiceId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description This endpoint retrieves a signed URL for uploading a credit note file associated with an invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name GetUploadCreditNoteUrl1
     * @summary Get the signed URL for uploading a credit note file
     * @request GET:/api/invoices/dispute/{invoiceDisputeId}/credit-note-upload-url/{filename}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUploadCreditNoteUrl1: (invoiceDisputeId: string, filename: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note-upload-url/${filename}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description This endpoint retrieves a signed URL for downloading the credit note file associated with an invoice dispute.
     *
     * @tags invoice-dispute-controller
     * @name GetCreditNoteFileUrl
     * @summary Get the signed URL for downloading the credit note file
     * @request GET:/api/invoices/dispute/{invoiceDisputeId}/credit-note-file-url
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getCreditNoteFileUrl: (invoiceDisputeId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/dispute/${invoiceDisputeId}/credit-note-file-url`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-ocr-message-controller
     * @name GetOcrMessageByInvoiceFileProcessingId
     * @request GET:/api/invoice-ocr-message/file-processing/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoInvoiceOcrMessageDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getOcrMessageByInvoiceFileProcessingId: (invoiceFileProcessingId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceOcrMessageDto, ResponseDtoObject>({
        path: `/api/invoice-ocr-message/file-processing/${invoiceFileProcessingId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name GetListInvoiceFileProcessing
     * @request GET:/api/invoice-file-processing
     * @response `200` `ResponseDtoListGroupedInvoiceFileProcessingStatusDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getListInvoiceFileProcessing: (
      query?: {
        invoiceIds?: string[];
        batchId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListGroupedInvoiceFileProcessingStatusDto, ResponseDtoObject>({
        path: `/api/invoice-file-processing`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name GetMetadata
     * @request GET:/api/invoice-file-processing/{invoiceFileProcessingId}/metadata
     * @response `200` `ResponseDtoMapStringString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getMetadata: (invoiceFileProcessingId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapStringString, ResponseDtoObject>({
        path: `/api/invoice-file-processing/${invoiceFileProcessingId}/metadata`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name GetFileUrl
     * @request GET:/api/invoice-file-processing/{invoiceFileProcessingId}/file-url
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getFileUrl: (invoiceFileProcessingId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoice-file-processing/${invoiceFileProcessingId}/file-url`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice-file-processing-controller
     * @name GetAllInvoiceDataConfigId
     * @request GET:/api/invoice-file-processing/pipeline-config/all
     * @response `200` `ResponseDtoListString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllInvoiceDataConfigId: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListString, ResponseDtoObject>({
        path: `/api/invoice-file-processing/pipeline-config/all`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves a specific file classification embedding by its ID
     *
     * @tags file-classification-controller
     * @name GetEmbeddingById
     * @summary Get file classification embedding by ID
     * @request GET:/api/file-classification/embedding/{id}
     * @response `200` `ResponseDtoFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getEmbeddingById: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves file classification embeddings by invoice file processing ID with optional page number filter
     *
     * @tags file-classification-controller
     * @name GetEmbeddingsByFileProcessingId
     * @summary Get embeddings by invoice file processing ID
     * @request GET:/api/file-classification/embedding/by-file/{invoiceFileProcessingId}
     * @response `200` `ResponseDtoListFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getEmbeddingsByFileProcessingId: (
      invoiceFileProcessingId: string,
      query?: {
        modelNames?: string[];
        tokenizerNames?: string[];
        pageNumbers?: number[];
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/embedding/by-file/${invoiceFileProcessingId}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves the list of embeddings where the specified classificationLabel column is set to true
     *
     * @tags file-classification-controller
     * @name GetEmbeddingsByClassificationLabel
     * @summary Get embeddings by classification label
     * @request GET:/api/file-classification/dataset/{classificationLabel}
     * @response `200` `ResponseDtoListFileClassificationEmbeddingDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getEmbeddingsByClassificationLabel: (
      classificationLabel: string,
      query: {
        model: string;
        tokenizer: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListFileClassificationEmbeddingDto, ResponseDtoObject>({
        path: `/api/file-classification/dataset/${classificationLabel}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves the status of an export job by its ID.
     *
     * @tags export-controller
     * @name GetExportJob
     * @summary Get export job status
     * @request GET:/api/export-jobs/{jobId}
     * @response `200` `ResponseDtoExportJobResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getExportJob: (jobId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoExportJobResponse, ResponseDtoObject>({
        path: `/api/export-jobs/${jobId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Generates a signed URL for downloading the exported file associated with the given export job ID.
     *
     * @tags export-controller
     * @name GetExportedFileDownloadUrl
     * @summary Get signed download URL for export job file
     * @request GET:/api/export-jobs/{jobId}/download-url
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getExportedFileDownloadUrl: (jobId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/export-jobs/${jobId}/download-url`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags event-stream-controller
     * @name StreamNotifications
     * @summary Stream events using Server-Sent Events (SSE)
     * @request GET:/api/events/stream
     * @response `200` `SseEmitter` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    streamNotifications: (params: RequestParams = {}) =>
      this.http.request<SseEmitter, ResponseDtoObject>({
        path: `/api/events/stream`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags event-stream-controller
     * @name GetConnectedEmitters
     * @summary Get the list of connected SSE clients
     * @request GET:/api/events/emitters
     * @response `200` `ResponseDtoListSseConnectedClientDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getConnectedEmitters: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListSseConnectedClientDto, ResponseDtoObject>({
        path: `/api/events/emitters`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves domain meta data including invoice statuses, currencies, resolution statuses, and error processing statuses.
     *
     * @tags domain-meta-data-controller
     * @name GetDomainMetaData
     * @summary Get Domain Meta Data
     * @request GET:/api/domain-meta-data
     * @response `200` `ResponseDtoDomainMetaDataDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getDomainMetaData: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoDomainMetaDataDto, ResponseDtoObject>({
        path: `/api/domain-meta-data`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves NRCF options from system configuration, optionally filtered by billed entity ID.
     *
     * @tags domain-meta-data-controller
     * @name GetNrcfOptions
     * @summary Get NRCF Options
     * @request GET:/api/domain-meta-data/nrcf-options
     * @response `200` `ResponseDtoListNrcfOption` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getNrcfOptions: (
      query?: {
        /** @format int64 */
        billedEntityId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListNrcfOption, ResponseDtoObject>({
        path: `/api/domain-meta-data/nrcf-options`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves dispute options from system configuration, optionally filtered by billed entity ID.
     *
     * @tags domain-meta-data-controller
     * @name GetDisputeOptions
     * @summary Get Dispute Options
     * @request GET:/api/domain-meta-data/dispute-options
     * @response `200` `ResponseDtoListDisputeOption` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getDisputeOptions: (
      query?: {
        /** @format int64 */
        billedEntityId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListDisputeOption, ResponseDtoObject>({
        path: `/api/domain-meta-data/dispute-options`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves all charge domain options.
     *
     * @tags domain-meta-data-controller
     * @name GetChargeDomainOptions
     * @summary Get Charge Domain Options
     * @request GET:/api/domain-meta-data/charge-domain-option
     * @response `200` `ResponseDtoSetChargeDomain` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getChargeDomainOptions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoSetChargeDomain, ResponseDtoObject>({
        path: `/api/domain-meta-data/charge-domain-option`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Returns a list of file extensions allowed to be uploaded to the system.
     *
     * @tags domain-meta-data-controller
     * @name GetAllowedFileExtensions
     * @summary Get Allowed File Extensions
     * @request GET:/api/domain-meta-data/allowed-file-extensions
     * @response `200` `ResponseDtoListString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getAllowedFileExtensions: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListString, ResponseDtoObject>({
        path: `/api/domain-meta-data/allowed-file-extensions`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves the questionnaire questions for a specific deviation, organized by deviation workflow.
     *
     * @tags deviations, questionnaires
     * @name GetQuestionnaire
     * @summary Get deviation questionnaire
     * @request GET:/api/deviations/{id}/questionnaire
     * @response `200` `ResponseDtoMapDeviationWorkflowListDeviationQuestionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getQuestionnaire: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapDeviationWorkflowListDeviationQuestionDto, ResponseDtoObject>({
        path: `/api/deviations/${id}/questionnaire`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves charge domains for a deviation filtered by leg type.
     *
     * @tags deviations, charges
     * @name GetChargeDomains
     * @summary Get charge domains
     * @request GET:/api/deviations/{id}/charge-domains
     * @response `200` `ResponseDtoSetChargeDomain` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getChargeDomains: (
      id: string,
      query?: {
        /**
         * Leg type to filter charge domains
         * @example "LEG_ONE"
         */
        'leg-type'?: 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoSetChargeDomain, ResponseDtoObject>({
        path: `/api/deviations/${id}/charge-domains`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Calculates sub-charge domains for a deviation based on leg type and charge domain parameters.
     *
     * @tags deviations, charges, calculations
     * @name CalculateSubChargeDomain
     * @summary Calculate sub charge domain
     * @request GET:/api/deviations/{id}/calculate-sub-charge-domain
     * @response `200` `ResponseDtoSetContractChargeDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    calculateSubChargeDomain: (
      id: string,
      query: {
        'leg-type': 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
        'charge-domain':
          | 'COLLECTION'
          | 'CONTAINER_CLEARANCE'
          | 'CONTAINER_MAINTENANCE'
          | 'CUSTOMS_CLEARANCE'
          | 'DELIVERY'
          | 'DOCUMENTATION'
          | 'FREIGHT'
          | 'FUEL_SURCHARGE'
          | 'HANDLING_CHARGE'
          | 'INSPECTION'
          | 'OVERTIME'
          | 'PICK_UP'
          | 'PICK_UP_AND_DROP_OFF'
          | 'PORT_CHARGES'
          | 'SEAL_FEE'
          | 'SPECIAL_HANDLING'
          | 'STORAGE'
          | 'THC'
          | 'TOTAL_ORIGIN_CHARGES'
          | 'VGM_FEE'
          | 'DEFAULT_CHARGE_DOMAIN'
          | 'SCREE';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoSetContractChargeDetailDto, ResponseDtoObject>({
        path: `/api/deviations/${id}/calculate-sub-charge-domain`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags deviation-migration-controller
     * @name GetInvoiceMissionMatchingRateCard
     * @request GET:/api/deviation-migration/invoices/missing-rate-card
     * @response `200` `ResponseDtoGettingInvoiceMissingRateCardResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceMissionMatchingRateCard: (
      query: {
        invoiceStatus: 'FLAGGED' | 'APPROVED' | 'TO_APPROVE' | 'PENDING_DOCUMENT' | 'REJECTED' | 'TO_REJECT' | 'PARTIAL';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoGettingInvoiceMissingRateCardResponse, ResponseDtoObject>({
        path: `/api/deviation-migration/invoices/missing-rate-card`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves available currencies based on the use type, including global and national currencies.
     *
     * @tags currencies
     * @name GetCurrencies
     * @summary Get currencies
     * @request GET:/api/currencies/{useType}
     * @deprecated
     * @response `200` `ResponseDtoListCurrencyEnum` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getCurrencies: (useType: 'DASHBOARD' | 'REPORT' | 'PERFORMANCE_ASSESSMENT', params: RequestParams = {}) =>
      this.http.request<ResponseDtoListCurrencyEnum, ResponseDtoObject>({
        path: `/api/currencies/${useType}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves the credit details, including total, consumed, and remaining credits, for a specified billed entity.
     *
     * @tags credit
     * @name GetCreditDetails
     * @summary Get credit details for a specified billed entity
     * @request GET:/api/credits
     * @response `200` `ResponseDtoCreditDetailsDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getCreditDetails: (
      query: {
        /**
         * The billed entity ID to retrieve credit details for
         * @format int64
         */
        billedEntityId: number;
        /**
         * The start date for calculating consumed credits
         * @format date
         * @example "2023-01-01"
         */
        fromDate?: string;
        /**
         * List of transaction dates to filter consumed credits, in YYYY-MM-DD, YYYY-'Q'Q, YYYY-MM, or YYYY format
         * @example ["2023-01-01","2023-02"]
         */
        transactionDates?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoCreditDetailsDto, ResponseDtoObject>({
        path: `/api/credits`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Returns the count and total amount of unsettled credit transactions, grouped by credit type, along with the transaction list.
     *
     * @tags credit
     * @name GetUnsettledCreditSummary
     * @summary Get unsettled credit summary for a billed entity
     * @request GET:/api/credits/unsettled
     * @response `200` `ResponseDtoUnsettledCreditSummaryDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getUnsettledCreditSummary: (
      query: {
        /**
         * The billed entity ID
         * @format int64
         */
        billedEntityId: number;
        /**
         * Optional start date filter (inclusive)
         * @format date
         * @example "2026-01-01"
         */
        startDate?: string;
        /**
         * Optional end date filter (inclusive)
         * @format date
         * @example "2026-01-31"
         */
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoUnsettledCreditSummaryDto, ResponseDtoObject>({
        path: `/api/credits/unsettled`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Get all credit transactions for a specified billed entity. Accessible by admin users only.
     *
     * @tags credit, admin
     * @name GetCreditTransactions
     * @summary Get all credit transactions
     * @request GET:/api/credit-transactions
     * @response `200` `ResponseDtoListCreditTransactionDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getCreditTransactions: (
      query: {
        /**
         * The ID of the billed entity to retrieve credit transactions for
         * @format int64
         */
        billedEntityId: number;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListCreditTransactionDto, ResponseDtoObject>({
        path: `/api/credit-transactions`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a courier invoice dispute by its unique identifier.
     *
     * @tags courier-invoices, disputes
     * @name GetCourierInvoiceDisputeDetail
     * @summary Get courier invoice dispute detail
     * @request GET:/api/courier-invoice/dispute/{invoiceDisputeId}
     * @response `200` `ResponseDtoCourierInvoiceDisputeDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getCourierInvoiceDisputeDetail: (invoiceDisputeId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoCourierInvoiceDisputeDto, ResponseDtoObject>({
        path: `/api/courier-invoice/dispute/${invoiceDisputeId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieves detailed information about an invoice courier shipment by its unique identifier.
     *
     * @tags shipments, courier
     * @name GetInvoiceCourierShipmentDetail
     * @summary Get invoice courier shipment detail
     * @request GET:/api/courier-invoice-shipment-detail/{shipmentId}
     * @response `200` `ResponseDtoInvoiceCourierShipmentDetailDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getInvoiceCourierShipmentDetail: (shipmentId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoInvoiceCourierShipmentDetailDto, ResponseDtoObject>({
        path: `/api/courier-invoice-shipment-detail/${shipmentId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches all contracts associated with the given shipping service ID.
     *
     * @tags contract-controller
     * @name GetContractByShippingService
     * @summary Get contracts by shipping service ID
     * @request GET:/api/contracts/shipping-service/{shippingServiceId}
     * @response `200` `ResponseDtoListContractDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractByShippingService: (shippingServiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListContractDto, ResponseDtoObject>({
        path: `/api/contracts/shipping-service/${shippingServiceId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches contract zones with zone mapping data for the specified contract.
     *
     * @tags contract-zone-controller
     * @name GetContractZones
     * @summary Get contract zones by contract ID
     * @request GET:/api/contract-zones/{contractId}
     * @response `200` `ResponseDtoListContractZoneDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractZones: (contractId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListContractZoneDto, ResponseDtoObject>({
        path: `/api/contract-zones/${contractId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Fetches all route mappings associated with the given contract, including resolved POL/POD location names.
     *
     * @tags Contract Routes
     * @name GetContractRoutes
     * @summary Get contract routes by contract ID
     * @request GET:/api/contract-routes/{contractId}
     * @response `200` `ResponseDtoListContractRouteDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractRoutes: (contractId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoListContractRouteDto, ResponseDtoObject>({
        path: `/api/contract-routes/${contractId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Retrieve a contract flow by contract ID and shipping service ID. Requires ADMIN authority.
     *
     * @tags contract-flow-controller
     * @name GetContractFlowByContractIdAndShippingServiceId
     * @summary Get contract flow by contract and shipping service IDs
     * @request GET:/api/contract-flows/contract/{contractId}/shipping-service/{shippingServiceId}
     * @response `200` `ResponseDtoContractFlowInfoViewDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getContractFlowByContractIdAndShippingServiceId: (contractId: string, shippingServiceId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoContractFlowInfoViewDto, ResponseDtoObject>({
        path: `/api/contract-flows/contract/${contractId}/shipping-service/${shippingServiceId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Checks for missing files in AWS S3. Accessible by SYSTEM_ADMIN.
     *
     * @tags aws-controller
     * @name CheckMissingFiles
     * @summary Check for missing files in AWS S3
     * @request GET:/api/aws/s3/check-missing-files
     * @response `200` `ResponseDtoListString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    checkMissingFiles: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoListString, ResponseDtoObject>({
        path: `/api/aws/s3/check-missing-files`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description The process is asynchronous; therefore, the user must use this API endpoint to check whether the recalculation has been completed.
     *
     * @tags jobs, admin
     * @name GetStatus
     * @summary Check the status of the recalculation process
     * @request GET:/api/admin/recalculate-exchange-price/migration-status
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getStatus: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/admin/recalculate-exchange-price/migration-status`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Checks OpenSearch connectivity, cluster health, and index status.
     *
     * @tags admin, opensearch
     * @name GetOpenSearchHealth
     * @summary Check OpenSearch health
     * @request GET:/api/admin/opensearch/health
     * @response `200` `ResponseDtoMapStringObject` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getOpenSearchHealth: (params: RequestParams = {}) =>
      this.http.request<ResponseDtoMapStringObject, ResponseDtoObject>({
        path: `/api/admin/opensearch/health`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Returns the 20 most recent jobs ordered by creation time descending. Pass an optional 'type' query parameter to filter by job type (e.g. BULK_DELETE).
     *
     * @tags admin, job-tracker
     * @name ListJobs
     * @summary List recent jobs
     * @request GET:/api/admin/jobs
     * @response `200` `ResponseDtoListJobTrackerResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    listJobs: (
      query?: {
        type?: 'BULK_DELETE' | 'REPROCESS' | 'OPENSEARCH_SYNC';
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoListJobTrackerResponse, ResponseDtoObject>({
        path: `/api/admin/jobs`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Returns the current status, progress detail, and error (if any) for any job type.
     *
     * @tags admin, job-tracker
     * @name GetJob
     * @summary Get a job by ID
     * @request GET:/api/admin/jobs/{id}
     * @response `200` `ResponseDtoJobTrackerResponse` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    getJob: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoJobTrackerResponse, ResponseDtoObject>({
        path: `/api/admin/jobs/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Deletes the specified user permission.
     *
     * @tags User, Permissions, Delete
     * @name DeleteUserPermission
     * @summary Delete user permission
     * @request DELETE:/api/users/permissions/{userPermissionId}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteUserPermission: (userPermissionId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/users/permissions/${userPermissionId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes an unlocode mapping by ID. Requires SYSTEM_ADMIN authority.
     *
     * @tags unlocode-controller
     * @name Delete
     * @summary Delete an unlocode mapping
     * @request DELETE:/api/unlocode-mappings/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    delete: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/unlocode-mappings/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Removes a SIC code user assignment
     *
     * @tags SIC Code Assignments
     * @name DeleteAssignment
     * @summary Delete SIC code assignment
     * @request DELETE:/api/sic-code-assignments/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteAssignment: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/sic-code-assignments/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes a service provider by its ID. Only accessible by SYSTEM ADMIN users.
     *
     * @tags service-provider-controller
     * @name DeleteServiceProvider
     * @summary Delete a service provider
     * @request DELETE:/api/service-providers/{id}
     * @response `200` `ResponseDtoBoolean` Successfully deleted the service provider.
     * @response `401` `ResponseDtoBoolean` Unauthorized - Invalid or expired authentication token.
     * @response `403` `ResponseDtoObject` Forbidden - Access denied. The authenticated user does not have the required SYSTEM_ADMIN role.
     * @response `404` `ResponseDtoBoolean` Not Found - The specified service provider does not exist.
     */
    deleteServiceProvider: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoBoolean | ResponseDtoObject>({
        path: `/api/service-providers/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes a service provider alias based on the provided ID.
     *
     * @tags service-provider-controller
     * @name DeleteServiceProviderAlias
     * @summary Delete a service provider alias
     * @request DELETE:/api/service-providers/aliases/{id}
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteServiceProviderAlias: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/service-providers/aliases/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Removes a percentage discount from the specified contract flow and deletes it if not used by other flows. This operation is restricted to users with ADMIN authority.
     *
     * @tags rate-card-controller
     * @name DeletePercentageDiscount
     * @summary Delete Percentage Discount from a Contract Flow
     * @request DELETE:/api/rate-cards/contract-flows/{contractFlowId}/percentage-discount/{percentageDiscountId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deletePercentageDiscount: (contractFlowId: string, percentageDiscountId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/rate-cards/contract-flows/${contractFlowId}/percentage-discount/${percentageDiscountId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes a legal entity alias based on the provided ID.
     *
     * @tags legal-entity-controller
     * @name DeleteLegalEntityAlias
     * @summary Delete a legal entity alias
     * @request DELETE:/api/legal-entities/aliases/{id}
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteLegalEntityAlias: (id: number, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/legal-entities/aliases/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes invoices based on the provided invoice numbers, batch IDs, and file names.
     *
     * @tags invoices, admin, demo
     * @name DeleteInvoices
     * @summary Delete invoices
     * @request DELETE:/api/invoices
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteInvoices: (data: DeleteInvoiceDto, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/invoices`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a specific attachment from the system by its unique identifier.
     *
     * @tags invoices, attachments
     * @name DeleteAttachment
     * @summary Delete attachment
     * @request DELETE:/api/invoices/attachment/{attachmentId}
     * @response `200` `ResponseDtoString` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteAttachment: (attachmentId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoString, ResponseDtoObject>({
        path: `/api/invoices/attachment/${attachmentId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes an invoice data pipeline config by its ID.
     *
     * @tags Invoice Data Pipeline Config, Delete
     * @name DeleteInvoiceDataPipelineConfig
     * @summary Delete an invoice data pipeline config
     * @request DELETE:/api/invoice-data-pipeline-configs/{configId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteInvoiceDataPipelineConfig: (configId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/invoice-data-pipeline-configs/${configId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes an exchange rate by ID. Requires ADMIN authority.
     *
     * @tags exchange-rates-controller
     * @name DeleteExchangeRate
     * @summary Delete an exchange rate
     * @request DELETE:/api/exchange-rates/{id}
     * @response `200` `ResponseDtoBoolean` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteExchangeRate: (id: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoBoolean, ResponseDtoObject>({
        path: `/api/exchange-rates/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes the contract identified by the given ID. Optionally forces deletion of associated contract flows.
     *
     * @tags contract-controller
     * @name DeleteContract
     * @summary Delete a contract
     * @request DELETE:/api/contracts/{id}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteContract: (
      id: string,
      query?: {
        /** @default false */
        forceDeleteContractFlow?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/contracts/${id}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Deletes a contract zone and removes the zone mapping if it is not linked to any other contract.
     *
     * @tags contract-zone-controller
     * @name DeleteContractZone
     * @summary Delete contract zone
     * @request DELETE:/api/contract-zones/{contractZoneId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteContractZone: (contractZoneId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/contract-zones/${contractZoneId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes a contract route and removes the underlying route mapping if it is not linked to any other contract.
     *
     * @tags Contract Routes
     * @name DeleteContractRoute
     * @summary Delete contract route
     * @request DELETE:/api/contract-routes/{contractRouteId}
     * @response `200` `ResponseDtoVoid` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteContractRoute: (contractRouteId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoVoid, ResponseDtoObject>({
        path: `/api/contract-routes/${contractRouteId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deletes the chart report with the specified ID.
     *
     * @tags chart-report-controller
     * @name DeleteChartReport
     * @summary Delete a chart report
     * @request DELETE:/api/chart-report/{chartReportId}
     * @response `200` `ResponseDtoChartReportDto` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    deleteChartReport: (chartReportId: string, params: RequestParams = {}) =>
      this.http.request<ResponseDtoChartReportDto, ResponseDtoObject>({
        path: `/api/chart-report/${chartReportId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  health = {
    /**
     * @description A simple endpoint to check if the service is running.
     *
     * @tags health
     * @name Healthcheck
     * @summary Healthcheck endpoint
     * @request GET:/health
     * @response `200` `string` OK
     * @response `403` `ResponseDtoObject` Forbidden
     */
    healthcheck: (params: RequestParams = {}) =>
      this.http.request<string, ResponseDtoObject>({
        path: `/health`,
        method: 'GET',
        ...params,
      }),
  };
}
